'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var dateFns = require('date-fns');
var xor = _interopDefault(require('lodash/xor'));
var reduce = _interopDefault(require('lodash/reduce'));
var concat = _interopDefault(require('lodash/concat'));
var components = require('@deal/components');
var hoistNonReactStatic = _interopDefault(require('hoist-non-react-statics'));
var Waypoint = _interopDefault(require('react-waypoint'));
var Measure = _interopDefault(require('react-measure'));
var Scrolllock = require('react-scrolllock');
var Scrolllock__default = _interopDefault(Scrolllock);
var lodash = require('lodash');
var classnames = _interopDefault(require('classnames'));
var chatFirebaseClient = require('@deal/chat-firebase-client');
var reactRouterDom = require('react-router-dom');
var copy = _interopDefault(require('copy-text-to-clipboard'));
var Linkify = _interopDefault(require('linkify-it'));
var VideoUrlParser = _interopDefault(require('js-video-url-parser'));
var ReactPlayer = _interopDefault(require('react-player'));
var cropUrl = _interopDefault(require('crop-url'));
var gql = _interopDefault(require('graphql-tag'));
var ApolloReactComponents = require('@apollo/react-components');
var ApolloReactHooks = require('@apollo/react-hooks');
var eventEmitter3 = _interopDefault(require('eventemitter3'));
var experimentJs = require('@deal/experiment-js');
var numeral = _interopDefault(require('numeral'));
var TextArea = _interopDefault(require('react-autosize-textarea'));
var isEqual = _interopDefault(require('lodash/isEqual'));
var ReactDOM = _interopDefault(require('react-dom'));
var reactSpring = require('react-spring');
var times = _interopDefault(require('lodash/times'));
var json2mq = _interopDefault(require('json2mq'));
var Tenor = _interopDefault(require('react-tenor'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var styles = {"loader":"styles_loader__WKA0s flex flex-auto items-center justify-center"};

var Loader = function Loader(props) {
  return React__default.createElement("div", {
    className: styles.loader
  }, React__default.createElement(components.CircleLoader, __assign({}, props)));
};

(function (Application) {
  Application[Application["BUSINESS"] = 0] = "BUSINESS";
  Application[Application["CONSUMER"] = 1] = "CONSUMER";
  Application[Application["OPERATIONS"] = 2] = "OPERATIONS";
})(exports.Application || (exports.Application = {}));

var ApplicationContext = React__default.createContext(undefined);
var ApplicationContextProvider = ApplicationContext.Provider;
var ApplicationContextConsumer = ApplicationContext.Consumer;

var useApplicationContext = function useApplicationContext() {
  var applicationContext = React.useContext(ApplicationContext);

  if (!applicationContext) {
    throw new Error('Invoked application context without intital application defintion');
  }

  return applicationContext;
};

var ChatContext = React__default.createContext({
  customMessageComponents: [],
  applicationContext: exports.Application.CONSUMER
});
var ChatContextProvider = ChatContext.Provider;
var ChatContextConsumer = ChatContext.Consumer;

var useChatContext = function useChatContext() {
  return React.useContext(ChatContext);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withChat(WrappedComponent) {
  var WithChat =
  /** @class */
  function (_super) {
    __extends(WithChat, _super);

    function WithChat() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    WithChat.prototype.render = function () {
      var _this = this;

      return React__default.createElement(ChatContextConsumer, null, function (_a) {
        var client = _a.client,
            customMessageComponents = _a.customMessageComponents,
            authenticatedUserId = _a.authenticatedUserId,
            impersonating = _a.impersonating;
        return React__default.createElement(WrappedComponent, __assign({
          chatClient: client,
          authenticatedUserId: authenticatedUserId,
          customMessageComponents: customMessageComponents,
          impersonating: impersonating
        }, _this.props));
      });
    };

    WithChat.displayName = "WithChat(" + getDisplayName(WrappedComponent) + ")";
    return WithChat;
  }(React.Component);

  return hoistNonReactStatic(WithChat, WrappedComponent);
}

var ChatActionsContext = React__default.createContext({
  messageAction: undefined
}); // Consumer

var ChatActionsConsumer = ChatActionsContext.Consumer; // Provider

var ChatActionsProvider = function ChatActionsProvider(_a) {
  var children = _a.children,
      messageAction = _a.messageAction;
  return React__default.createElement(ChatActionsContext.Provider, {
    value: {
      messageAction: messageAction
    }
  }, children);
};

var ScrollContext = React__default.createContext({
  scrollToTarget: function scrollToTarget() {},
  isScrolledToBottom: true
});
var ScrollConsumer = ScrollContext.Consumer;

var Scrollable =
/** @class */
function (_super) {
  __extends(Scrollable, _super);

  function Scrollable(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isScrolledToBottom: true,
      hasInitialScrollCompleted: false,
      scrollBottom: 0,
      scrollTop: 0
    };
    _this.addScrollListener = _this.addScrollListener.bind(_this);
    _this.removeScrollListener = _this.removeScrollListener.bind(_this);
    /**
     *  Only update the `isScrolledToBottom` state at most once per animation frame, but
     *  fire an event on initial change to kick off the state change. This ensures that the state will be appropriately set when the waypoint is entered
     */

    _this.handleScroll = lodash.debounce(_this.handleScroll.bind(_this), 0, {
      leading: true
    });
    /**
     *  Only reset scroll position at most once per animation frame, but
     * - Make sure the first event is fired to reposition before the waypoint/fetchMore is fired again
     * - Make sure the last event is fired to capture the most up-to-date scrollHeight
     */

    _this.scrollToTarget = lodash.debounce(_this.scrollToTarget.bind(_this), 0, {
      trailing: true,
      leading: true
    });
    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
    _this.scrollToReset = _this.scrollToReset.bind(_this);
    return _this;
  }

  Scrollable.prototype.componentDidMount = function () {
    if (this.props.element.current) {
      this.addScrollListener(this.props.element.current);
    }
  };

  Scrollable.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.conversationId !== prevProps.conversationId) {
      this.scrollToBottom();
    }
    /**
     * HACK: The `element` ref is mutable and can change out from underneath us without the actual `current` reference
     *   changing. Thus, we have to blindly replace the scroll listener every time the component is updated. This is
     *   horribly inefficient in cases where the element has not in fact changed.
     *
     * TODO: Replace this whole <Scrollable> implementation with something more robust that doesn't rely on trying to
     *   observe the lifecycle of a DOM ref via React. Something like this looks promising, at least as inspiration:
     *   https://www.npmjs.com/package/react-stay-scrolled
     */


    if (this.props.element.current) {
      this.addScrollListener(this.props.element.current);
    }

    if (prevProps.element.current && prevProps.element.current !== this.props.element.current) {
      this.removeScrollListener(prevProps.element.current);
    }
  };

  Scrollable.prototype.componentWillUnmount = function () {
    this.props.element.current && this.removeScrollListener(this.props.element.current);
  }; // TODO: Use RAF to improve perf


  Scrollable.prototype.handleScroll = function (_event) {
    var element = this.props.element;

    if (this.state.hasInitialScrollCompleted && element.current) {
      var newScrollBottom = this.getScrollBottom();
      /**
       *  Can only set isScrolledToBottom = true if the user scrolled up.
       *  Otherwise, there is a race condition where isScrolledBottom is set to true after new messages load, but before it
       *  has been scrolled to the bottom again
       */

      var didUserScroll = this.state.scrollTop > element.current.scrollTop;
      var isScrolledToBottom = newScrollBottom === 0;
      this.setState({
        isScrolledToBottom: didUserScroll ? isScrolledToBottom : this.state.isScrolledToBottom,
        scrollBottom: newScrollBottom,
        scrollTop: element.current.scrollTop
      });
    }
  };

  Scrollable.prototype.addScrollListener = function (element) {
    element.addEventListener('scroll', this.handleScroll.bind(this));
  };

  Scrollable.prototype.removeScrollListener = function (element) {
    element.removeEventListener('scroll', this.handleScroll.bind(this));
  };

  Scrollable.prototype.getScrollBottom = function () {
    var element = this.props.element.current;

    if (element) {
      return element.scrollHeight - (element.scrollTop + element.clientHeight);
    }
  };

  Scrollable.prototype.scrollToBottom = function () {
    var element = this.props.element.current;

    if (element) {
      element.scrollTop = element.scrollHeight;
      this.setState({
        isScrolledToBottom: true,
        hasInitialScrollCompleted: true
      });
    }
  };

  Scrollable.prototype.scrollToReset = function () {
    var element = this.props.element.current;

    if (element) {
      element.scrollTop = element.scrollHeight - (element.clientHeight + this.state.scrollBottom);
    }
  };

  Scrollable.prototype.scrollToTarget = function () {
    if (this.state.isScrolledToBottom) {
      this.scrollToBottom();
    } else {
      this.scrollToReset();
    }
  };

  Scrollable.prototype.render = function () {
    return React__default.createElement(ScrollContext.Provider, {
      value: {
        scrollToTarget: this.scrollToTarget,
        isScrolledToBottom: this.state.isScrolledToBottom
      }
    }, this.props.children);
  };

  return Scrollable;
}(React.Component);

var styles$1 = {"list-wrapper":"styles_list-wrapper__1t7xO flex flex-auto flex-column","message-list":"styles_message-list__dkon3 block flex-auto justify-start m0 px1","flat":"styles_flat__2n2fx px2","listWrapper":"styles_list-wrapper__1t7xO flex flex-auto flex-column","messageList":"styles_message-list__dkon3 block flex-auto justify-start m0 px1"};

var Conversation = function Conversation(_a) {
  var children = _a.children,
      loading = _a.loading,
      hasMore = _a.hasMore,
      className = _a.className,
      scrollableElementRef = _a.scrollableElementRef,
      onInfiniteLoad = _a.onInfiniteLoad,
      props = __rest(_a, ["children", "loading", "hasMore", "className", "scrollableElementRef", "onInfiniteLoad"]);

  var _b = React.useContext(ScrollContext),
      isScrolledToBottom = _b.isScrolledToBottom,
      scrollToTarget = _b.scrollToTarget;

  return (
    /**
     * We need to scroll to bottom when either the scroll container resizes (like when suggested actions are rendered)
     * or when the content within the scroll container changes size (messages change size or a new message is added)
     * Unfortunately, react-measure has a bug that prevents it from referencing the same element as a different ref
     * i.e. we can't do ref={scrollableElementRef(e); measureRef(e)} on just the one scroll container
     * https://github.com/souporserious/react-measure/issues/90
     */
    React__default.createElement(Measure, {
      bounds: true,
      onResize: scrollToTarget
    }, function (_a) {
      var measureRef = _a.measureRef;
      return React__default.createElement("div", {
        ref: measureRef,
        className: styles$1.listWrapper
      }, React__default.createElement(Scrolllock.TouchScrollable, null, React__default.createElement("div", __assign({
        className: classnames(className, styles$1.messageList, styles$1.flat),
        ref: scrollableElementRef
      }, props), React__default.createElement(Waypoint // Offset of -400 to preload new messages when user is 400px from top of container
      , {
        // Offset of -400 to preload new messages when user is 400px from top of container
        topOffset: -400,
        scrollableAncestor: scrollableElementRef.current,
        onEnter: function onEnter() {
          // Only load more messages when:
          //
          //  - We have already loaded some messages, and more messages exist to fetch
          //  - We aren't already loading messages
          //  - We aren't scrolled to the bottom of the conversation (this prevents fetching messages on initial load)
          //  - We have a callback to fetch more messages
          if (children && !loading && hasMore && !isScrolledToBottom && onInfiniteLoad) {
            onInfiniteLoad();
          }
        }
      }), React__default.createElement(Measure, {
        bounds: true,
        onResize: scrollToTarget
      }, function (_a) {
        var measureRef = _a.measureRef;
        return React__default.createElement("div", {
          ref: measureRef
        }, children);
      }))));
    })
  );
};

var styles$2 = {"row":"styles_row__2iSCM flex items-center","indicator":"styles_indicator__1nwU9 flex items-center justify-around mr1","dot":"styles_dot__3wmnC","blink":"styles_blink__3Ow5s","paused":"styles_paused__2soLN styles_indicator__1nwU9 flex items-center justify-around mr1","typing":"styles_typing__3fEY1 styles_indicator__1nwU9 flex items-center justify-around mr1"};

var TypingIndicator =
/** @class */
function (_super) {
  __extends(TypingIndicator, _super);

  function TypingIndicator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TypingIndicator.prototype.render = function () {
    var typing = this.props.typing;
    var names = typing.map(function (identity) {
      return identity.displayName;
    });
    var activity;

    switch (names.length) {
      case 0:
        activity = null;
        break;

      case 1:
        activity = names[0] + " is typing...";
        break;

      case 2:
      case 3:
        activity = names.slice(0, -1).join(', ') + " and " + names.slice(1)[0] + " are typing...";
        break;

      default:
        activity = names.length + " people are typing...";
    }

    if (activity) {
      return React__default.createElement("div", {
        className: styles$2.row
      }, React__default.createElement("div", {
        className: styles$2.typing
      }, React__default.createElement("div", {
        className: styles$2.dot
      }), React__default.createElement("div", {
        className: styles$2.dot
      }), React__default.createElement("div", {
        className: styles$2.dot
      })), activity);
    } else {
      return null;
    }
  };

  return TypingIndicator;
}(React.Component);

var ConversationQuery =
/** @class */
function (_super) {
  __extends(ConversationQuery, _super);

  function ConversationQuery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      loading: !!_this.props.conversationId
    };
    _this.load = _this.load.bind(_this);
    _this.cleanup = _this.cleanup.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.handleConversationChanged = _this.handleConversationChanged.bind(_this);
    return _this;
  }

  ConversationQuery.prototype.componentDidMount = function () {
    this.load();
  };

  ConversationQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available
    if (!this.props.chatClient) {
      this.cleanup();
    } // Client, ConversationId, recipient list, or authentication state has changed


    if (prevProps.chatClient !== this.props.chatClient || prevProps.conversationId !== this.props.conversationId || prevProps.authenticatedUserId !== this.props.authenticatedUserId || xor(prevProps.recipientIds || [], this.props.recipientIds || []).length > 0) {
      this.load();
    }
  };

  ConversationQuery.prototype.componentWillUnmount = function () {
    this.cleanup();
  };

  ConversationQuery.prototype.load = function () {
    var _a = this.props,
        chatClient = _a.chatClient,
        conversationId = _a.conversationId,
        recipientIds = _a.recipientIds,
        authenticatedUserId = _a.authenticatedUserId; // At a minimum we need a chat client to load the Conversation

    if (!chatClient) {
      return;
    }

    var isLocalConversationId = conversationId && chatFirebaseClient.LocalConversationId.isLocalConversationId(conversationId); // We also need something to look up by:
    //   For local conversations: either a set of recipients or a ConversationId
    //   For persisted conversations: just a ConversationId and an authenticated Firebase session

    if (isLocalConversationId && conversationId) {
      this.cleanup();
      this.conversation = chatClient.getConversation(conversationId);
    } else if (!isLocalConversationId && conversationId && authenticatedUserId) {
      this.cleanup();
      this.conversation = chatClient.getConversation(conversationId);
    } else if (recipientIds && recipientIds.length > 0) {
      this.cleanup();
      this.conversation = chatClient.getLocalConversationByRecipients(recipientIds);
    } else {
      return;
    }

    this.setState({
      loading: true
    });

    if (this.conversation.initialized) {
      this.handleConversationLoaded();
    } else {
      this.conversation.once('initialized', this.handleConversationLoaded, this);
    }

    this.conversation.on('changed', this.handleConversationChanged, this);
  };

  ConversationQuery.prototype.cleanup = function () {
    if (this.conversation) {
      this.conversation.off('initialized', this.handleConversationLoaded, this);
      this.conversation.off('changed', this.handleConversationChanged, this);
      delete this.conversation;
    }
  };

  ConversationQuery.prototype.handleConversationLoaded = function () {
    if (this.props.onCompleted) {
      this.props.onCompleted({
        conversation: this.conversation
      });
    }

    this.setState({
      loading: false
    });
  };

  ConversationQuery.prototype.handleConversationChanged = function () {
    this.forceUpdate();
  };

  ConversationQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the `query` is in flight. We also consider the conversation
     *   as being in a loading state until it is initialized. If there is no conversationId provided to
     *   the query, then it is never in a loading state.
     */
    var conversationIsLoading = this.conversation ? !this.conversation.initialized : !!this.props.conversationId;
    var loading = this.state.loading || conversationIsLoading;
    return this.props.children({
      loading: loading,
      conversation: this.conversation
    });
  };

  return ConversationQuery;
}(React.Component);

var ConversationQuery$1 = withChat(ConversationQuery);

var TypingIndicatorContainer =
/** @class */
function (_super) {
  __extends(TypingIndicatorContainer, _super);

  function TypingIndicatorContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      typing: []
    };
    _this.handleTypingStateChange = _this.handleTypingStateChange.bind(_this);
    return _this;
  }

  TypingIndicatorContainer.prototype.handleTypingStateChange = function (evt) {
    this.props.onTypingStatusChange();

    switch (evt.event) {
      case 'typingStarted':
        this.setState(function (prevState) {
          return {
            typing: prevState.typing.concat([evt.user])
          };
        });
        break;

      case 'typingStopped':
        this.setState(function (prevState) {
          return {
            typing: prevState.typing.filter(function (user) {
              return user.userId !== evt.user.userId;
            })
          };
        });
        break;
    }
  };

  TypingIndicatorContainer.prototype.componentDidMount = function () {
    if (this.props.conversation) {
      this.addTypingListener(this.props.conversation);
    }
  };

  TypingIndicatorContainer.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.conversation && !nextProps.conversation) {
      this.removeTypingListener(this.props.conversation);
    }

    if (!this.props.conversation && nextProps.conversation) {
      this.addTypingListener(nextProps.conversation);
    }

    if (this.props.conversation && nextProps.conversation && nextProps.conversation.conversationId !== this.props.conversation.conversationId) {
      this.setState({
        typing: []
      });
      this.removeTypingListener(this.props.conversation);
      this.addTypingListener(nextProps.conversation);
    }
  };

  TypingIndicatorContainer.prototype.componentWillUnmount = function () {
    if (this.props.conversation) {
      this.removeTypingListener(this.props.conversation);
    }
  };

  TypingIndicatorContainer.prototype.addTypingListener = function (conversation) {
    conversation.on('typingStarted', this.handleTypingStateChange);
    conversation.on('typingStopped', this.handleTypingStateChange);
  };

  TypingIndicatorContainer.prototype.removeTypingListener = function (conversation) {
    conversation.off('typingStarted', this.handleTypingStateChange);
    conversation.off('typingStopped', this.handleTypingStateChange);
  };

  TypingIndicatorContainer.prototype.render = function () {
    return React__default.createElement(TypingIndicator, {
      typing: this.state.typing
    });
  };

  return TypingIndicatorContainer;
}(React.Component);

var TypingIndicator$1 = (function (props) {
  var client = React.useContext(ChatContext).client;
  var scrollToTarget = React.useContext(ScrollContext).scrollToTarget;

  if (client && client.myself) {
    return React__default.createElement(ConversationQuery$1, {
      conversationId: props.conversationId
    }, function (_a) {
      var conversation = _a.conversation;
      return React__default.createElement(TypingIndicatorContainer, {
        client: client,
        conversation: conversation,
        onTypingStatusChange: scrollToTarget
      });
    });
  } else {
    return null;
  }
});

var styles$3 = {"messages":"styles_messages__eqrAq flex list-reset","divider":"styles_divider__1QA2_","label":"styles_label__12haw my2 center","date":"styles_date__3I8sb bold","flat":"styles_flat__1M1Or","time":"styles_time__3aNkc"};

/**
 * A set of messages sent in quick succession. Each exchange in a conversation is headed by a date & time.
 */

var Exchange = function Exchange(_a) {
  var startedAt = _a.startedAt,
      children = _a.children; // TODO: This component should be stateful to track the current date.
  //   The method is impure because it uses `new Date`.

  var now = new Date();
  var date = null;
  var time = dateFns.format(startedAt, 'h:mm a');

  if (dateFns.isSameDay(startedAt, now)) {
    date = 'Today';
  } else if (dateFns.isSameDay(startedAt, dateFns.subDays(now, 1))) {
    date = 'Yesterday';
  } else if (dateFns.isSameWeek(startedAt, now)) {
    date = dateFns.format(startedAt, 'iiii');
  } else if (dateFns.isSameYear(startedAt, now)) {
    date = dateFns.format(startedAt, 'iii, MMM d');
  } else {
    date = dateFns.format(startedAt, 'iii, MMM d, yyyy');
  }

  return React__default.createElement("div", null, React__default.createElement("div", {
    className: classnames(styles$3.label, styles$3.flat)
  }, React__default.createElement("hr", {
    className: styles$3.divider
  }), React__default.createElement("span", {
    className: styles$3.date
  }, date), React__default.createElement("span", {
    className: styles$3.time
  }, time), React__default.createElement("hr", {
    className: styles$3.divider
  })), React__default.createElement("ul", {
    className: styles$3.messages
  }, children));
};

var styles$4 = {"square":"styles_square__7F2In"};

/**
 * Displays a chat participants photo/avatar, or a consistently colored circle with their initials
 */

var ChatAvatar = function ChatAvatar(_a) {
  var _b;

  var sender = _a.sender,
      className = _a.className,
      shape = _a.shape,
      props = __rest(_a, ["sender", "className", "shape"]);

  return React__default.createElement(components.Avatar, __assign({
    name: sender.displayName,
    hash: sender.userId,
    src: sender.avatarUrl,
    className: classnames(className, (_b = {}, _b[styles$4.square] = shape === 'square', _b))
  }, props));
};

var styles$5 = {"group":"styles_group__2CKex mb2","-webkit-columns":"styles_columns__2qeGK","-moz-columns":"styles_columns__2qeGK","columns":"styles_columns__2qeGK","avatar":"styles_avatar__S6zxH self-start","messages":"styles_messages__26m-S","sender":"styles_sender__1eQ5c flex items-center bold","sent-at":"styles_sent-at__23MLg","metadata":"styles_metadata__3vo1C flex items-center bold","flat":"styles_flat__3evyX","teammate":"styles_teammate__3kEqQ","automessage":"styles_automessage__3FE1R","webkitColumns":"styles_columns__2qeGK","mozColumns":"styles_columns__2qeGK","sentAt":"styles_sent-at__23MLg"};

function formatChannel(channel) {
  switch (channel) {
    case chatFirebaseClient.MessageChannel.SMS:
      return 'SMS';

    case chatFirebaseClient.MessageChannel.EMAIL:
      return 'Email';

    case chatFirebaseClient.MessageChannel.FACEBOOK:
      return 'Facebook Messenger';
  }
}

var MessageGroup = function MessageGroup(_a) {
  var _b, _c, _d;

  var sender = _a.sender,
      sentAt = _a.sentAt,
      channels = _a.channels,
      children = _a.children,
      persona = _a.persona,
      type = _a.type,
      metadata = _a.metadata,
      chatClient = _a.chatClient,
      impersonating = _a.impersonating;

  var _e = React.useState(false),
      copied = _e[0],
      setCopied = _e[1];

  var client = chatClient;
  var myself = client && client.myself;
  var isTeammate = !!(sender && myself && (sender.type === 'BUSINESS_USER' && myself.type === 'BUSINESS_USER' && myself !== sender || sender.type === 'SUPPORT' && myself.type === 'OPERATOR' && myself !== sender));
  var uniqChannels = lodash.uniq(channels).filter(function (c) {
    return c !== null;
  });
  var formattedChannels = uniqChannels.length ? "via " + uniqChannels.map(formatChannel).join(' and ') : null; // For inbound messages, we show what channel(s) the messages were sent from.
  // For outbound messages, we show whether the message was an auto message (except for consumers).

  var formattedMetadata = formattedChannels;
  var labelAsAutoMessage = false;

  if (metadata && metadata.type === 'auto-message' && myself && myself.type !== 'USER' && myself.type !== 'GUEST') {
    labelAsAutoMessage = true;

    if (impersonating) {
      formattedMetadata = React__default.createElement("span", {
        title: metadata.campaign,
        onDoubleClick: function onDoubleClick() {
          if (metadata.campaign) {
            copy(metadata.campaign);
            setCopied(true);
            setTimeout(function () {
              setCopied(false);
            }, 1500);
          }
        }
      }, copied ? React__default.createElement("em", null, "copied to clipboard") : 'via auto message');
    } else {
      formattedMetadata = 'via auto message';
    }
  }

  var isSenderClickable = sender && sender.vanityId;
  return React__default.createElement("li", {
    className: classnames(styles$5.group, styles$5.flat, (_b = {}, _b[styles$5.teammate] = isTeammate && type === 'message', _b[styles$5.automessage] = labelAsAutoMessage, _b))
  }, React__default.createElement("div", {
    className: styles$5.columns
  }, sender && (isSenderClickable ? React__default.createElement(reactRouterDom.Link, {
    to: "/experts/" + sender.vanityId
  }, React__default.createElement(ChatAvatar, {
    sender: sender,
    size: "medium",
    className: classnames(styles$5.avatar, (_c = {}, _c[styles$5.clickable] = isSenderClickable, _c))
  })) : React__default.createElement(ChatAvatar, {
    sender: sender,
    size: "medium",
    className: classnames(styles$5.avatar, (_d = {}, _d[styles$5.clickable] = isSenderClickable, _d))
  })), React__default.createElement("div", {
    className: styles$5.messages
  }, children, sender && (isSenderClickable ? React__default.createElement(reactRouterDom.Link, {
    to: "/experts/" + sender.vanityId
  }, React__default.createElement("span", {
    className: classnames(styles$5.sender)
  }, sender && sender.displayName, sentAt && React__default.createElement("time", {
    className: styles$5.sentAt,
    dateTime: sentAt.toISOString()
  }, dateFns.format(sentAt, 'h:mm aaaa')), React__default.createElement("span", {
    className: styles$5.metadata
  }, formattedMetadata))) : React__default.createElement("span", {
    className: classnames(styles$5.sender)
  }, sender && sender.displayName, " ", persona && "(" + persona + ")", sentAt && React__default.createElement("time", {
    className: styles$5.sentAt,
    dateTime: sentAt.toISOString()
  }, dateFns.format(sentAt, 'h:mm aaaa')), React__default.createElement("span", {
    className: styles$5.metadata
  }, formattedMetadata))))));
};

var MessageGroup$1 = withChat(MessageGroup);

var styles$6 = {"row":"styles_row__LvrZ1","sent":"styles_sent__NP84S","status":"styles_status__1Enkc","flat":"styles_flat__15Erh"};

var MessageStatus;

(function (MessageStatus) {
  MessageStatus[MessageStatus["Unknown"] = 0] = "Unknown";
  MessageStatus[MessageStatus["Pending"] = 1] = "Pending";
  MessageStatus[MessageStatus["Sent"] = 2] = "Sent";
  MessageStatus[MessageStatus["Delivered"] = 3] = "Delivered";
  MessageStatus[MessageStatus["Read"] = 4] = "Read";
})(MessageStatus || (MessageStatus = {}));

var MessageRow =
/** @class */
function (_super) {
  __extends(MessageRow, _super);

  function MessageRow(props) {
    var _this = _super.call(this, props) || this;

    _this.handleMessageStatusChange = _this.handleMessageStatusChange.bind(_this);
    _this.addMessageStatusListener = _this.addMessageStatusListener.bind(_this);
    _this.removeMessageStatusListener = _this.removeMessageStatusListener.bind(_this);
    return _this;
  }

  MessageRow.prototype.handleMessageStatusChange = function () {
    this.forceUpdate();
  };

  MessageRow.prototype.componentDidMount = function () {
    this.addMessageStatusListener(this.props.message);
  };

  MessageRow.prototype.componentWillReceiveProps = function (incomingProps) {
    if (incomingProps.message !== this.props.message) {
      this.removeMessageStatusListener(this.props.message);
      this.addMessageStatusListener(incomingProps.message);
    } // Also subscribe to changes to the next message (from "us"), since that status is
    //   used to determine whether to render this message's status (see `render`)


    if (incomingProps.nextMessageBySameParticipant !== this.props.nextMessageBySameParticipant) {
      if (this.props.nextMessageBySameParticipant) this.removeMessageStatusListener(this.props.nextMessageBySameParticipant);
      if (incomingProps.nextMessageBySameParticipant) this.addMessageStatusListener(incomingProps.nextMessageBySameParticipant);
    }
  };

  MessageRow.prototype.componentWillUnmount = function () {
    this.removeMessageStatusListener(this.props.message);
  };

  MessageRow.prototype.addMessageStatusListener = function (message) {
    message.on('read', this.handleMessageStatusChange, this);
    message.on('delivered', this.handleMessageStatusChange, this);
    message.on('sent', this.handleMessageStatusChange, this);
    message.on('initialized', this.handleMessageStatusChange, this);
  };

  MessageRow.prototype.removeMessageStatusListener = function (message) {
    message.off(undefined, this.handleMessageStatusChange, this);
  };

  MessageRow.prototype.getMessageStatus = function (message) {
    // Generate an array of ReceiptStates for this message, excluding the message sender
    var receiptStatuses = Object.keys(message.receipts).filter(function (key) {
      return key !== message.sentBy.userId;
    }).map(function (key) {
      return message.receipts[key];
    });

    if (receiptStatuses.some(function (status) {
      return status === chatFirebaseClient.MessageReceiptType.READ;
    })) {
      // The message has been read by at least one user
      return MessageStatus.Read;
    } else if (receiptStatuses.some(function (status) {
      return status === chatFirebaseClient.MessageReceiptType.DELIVERED;
    })) {
      // The message has been delivered to at least one user
      return MessageStatus.Delivered;
    } else if (receiptStatuses.some(function (status) {
      return status === chatFirebaseClient.MessageReceiptType.SENT;
    })) {
      // The message has been sent to at least one user
      return MessageStatus.Sent;
    } else if (message.pending) {
      // The message only exists locally
      return MessageStatus.Pending;
    } else {
      // This should not happen
      return MessageStatus.Unknown;
    }
  };

  MessageRow.prototype.renderStatus = function (status) {
    switch (status) {
      case MessageStatus.Pending:
        return 'Pending';

      case MessageStatus.Sent:
        return 'Sent';

      case MessageStatus.Delivered:
        return 'Delivered';

      case MessageStatus.Read:
        return 'Read';

      default:
        return null;
    }
  };

  MessageRow.prototype.render = function () {
    var _a;

    var message = this.props.message;
    var nextMessage = this.props.nextMessageBySameParticipant;
    var messageStatus = this.getMessageStatus(message);
    var nextMessageStatus = nextMessage && this.getMessageStatus(nextMessage);
    var isMyself = message.sentBy.isMyself; // Only render the message status if it's "our" message, AND:
    //   - The following message (sent by us) has a different status
    //   - OR, there is no following message

    var shouldRender = isMyself && (!nextMessage || messageStatus !== nextMessageStatus);
    /**
     * A row in a conversation that contains a single message.
     *
     * Sets the text-alignment to `right` or `left` depending on whether the message is coming from the message owner.
     */

    return React__default.createElement("div", {
      className: classnames(styles$6.row, styles$6.flat, (_a = {}, _a[styles$6.sent] = isMyself, _a))
    }, this.props.children, shouldRender && React__default.createElement("div", {
      className: styles$6.status
    }, this.renderStatus(messageStatus)));
  };

  return MessageRow;
}(React.Component);

var styles$7 = {"media-breakpoint-sm":"(min-width: 40em)","message-bubble":"styles_message-bubble__M_5zY inline-block","flat":"styles_flat__IlM8H","full-width":"styles_full-width__1KNFo","sent":"styles_sent__17d7s","received":"styles_received__LQQLT","mediaBreakpointSm":"(min-width: 40em)","messageBubble":"styles_message-bubble__M_5zY inline-block","fullWidth":"styles_full-width__1KNFo"};

var MessageBubble = function MessageBubble(_a) {
  var _b;

  var className = _a.className,
      message = _a.message,
      onLoaded = _a.onLoaded,
      fullWidth = _a.fullWidth,
      rest = __rest(_a, ["className", "message", "onLoaded", "fullWidth"]);
  /**
   * This ensures that the scroll container is reset to the correct position when rich cards are loaded
   * Previously, the scroll container was only reset for <MessageText/> components
   */


  React.useEffect(function () {
    onLoaded && onLoaded();
  });
  var classes = classnames(className, styles$7.messageBubble, styles$7.flat, (_b = {}, _b[styles$7.fullWidth] = fullWidth, _b));
  return React__default.createElement("div", __assign({
    title: "" + dateFns.format(message.sentAt.toDate(), "iii, MMM do 'at' h:mm a"),
    className: classes
  }, rest));
};

var MessageAudioPart = function MessageAudioPart(_a) {
  var part = _a.part;

  var getMessageFromPart = function getMessageFromPart(part) {
    return part.message;
  };

  var getVideoMessagePartUrl = function getVideoMessagePartUrl(messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  var message = getMessageFromPart(part);
  var sourceUrl = getVideoMessagePartUrl(part);
  return React__default.createElement(MessageBubble, {
    message: message
  }, React__default.createElement("audio", {
    src: sourceUrl,
    controls: true
  }, "Sorry, your browser doesn't support embedded audios, but don't worry, you can", ' ', React__default.createElement("a", {
    href: sourceUrl,
    target: "_blank"
  }, "download it"), ' ', "and listen to it with your favorite audio player!"));
};

var AudioMessage = function AudioMessage(_a) {
  var myself = _a.myself,
      message = _a.message;
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageAudioPart, {
      part: part,
      key: idx,
      myself: myself
    });
  }));
};

AudioMessage.handlesMessage = function (message) {
  return message.parts.length === 1 && message.parts[0].type === 'AUDIO';
};

var styles$8 = {"media-breakpoint-sm":"(min-width: 40em)","text-message-bubble":"styles_text-message-bubble__24J0-","sent":"styles_sent__1KDL3 styles_text-message-bubble__24J0-","received":"styles_received__2MMvK styles_text-message-bubble__24J0-","from-teammate":"styles_from-teammate__2jnpO styles_received__2MMvK styles_text-message-bubble__24J0-","rich-media-wrapper":"styles_rich-media-wrapper__3hYJJ","rich-media":"styles_rich-media__uBNtm","text":"styles_text__3GjcI","flat":"styles_flat__1Yw2o","opt-out":"styles_opt-out__mFCYB","opt-out-bullet-list":"styles_opt-out-bullet-list__3rN62 list-reset m0 p0","opt-out-bullet-item":"styles_opt-out-bullet-item__qu45Z relative","mediaBreakpointSm":"(min-width: 40em)","textMessageBubble":"styles_text-message-bubble__24J0-","fromTeammate":"styles_from-teammate__2jnpO styles_received__2MMvK styles_text-message-bubble__24J0-","richMediaWrapper":"styles_rich-media-wrapper__3hYJJ","richMedia":"styles_rich-media__uBNtm","optOut":"styles_opt-out__mFCYB","optOutBulletList":"styles_opt-out-bullet-list__3rN62 list-reset m0 p0","optOutBulletItem":"styles_opt-out-bullet-item__qu45Z relative"};

var SUPPORTED_VIDEO_PROVIDERS = ['youtube', 'vimeo']; // SMS messages that automatically cause the sender's phone number to be blacklisted
//   See: https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-

var OPT_OUT_KEYWORDS = new Set(['STOP', 'STOPALL', 'UNSUBSCRIBE', 'CANCEL', 'END', 'QUIT']); // Messaging user types that should see an explanation of how we treat opt-out messages

var CURATED_MESSAGING_USER_TYPES = new Set(['BUSINESS_USER', 'SUPPORT', 'OPERATOR']);

var MessageBubbleText =
/** @class */
function (_super) {
  __extends(MessageBubbleText, _super);

  function MessageBubbleText() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.linkifier = new Linkify();
    return _this;
  }

  MessageBubbleText.prototype.matchLinks = function (text) {
    return this.linkifier.match(text);
  };
  /**
   * Extract the first URL in the text that we can show a rich media preview for.
   *
   * @param text
   */


  MessageBubbleText.prototype.extractRichMedia = function (text) {
    var matches = this.matchLinks(text);

    if (!matches) {
      return undefined;
    }

    return matches.find(function (match) {
      var parsedVideoUrl = VideoUrlParser.parse(match.url);

      if (parsedVideoUrl && SUPPORTED_VIDEO_PROVIDERS.includes(parsedVideoUrl.provider)) {
        return true;
      }

      return false;
    });
  };

  MessageBubbleText.prototype.formatText = function (text) {
    var matches = this.matchLinks(text); // If there are no URLs, skip processing altogether

    if (!matches) {
      return text;
    } // Iterate through the matches, replacing each match with a link while preserving the plain text


    return matches.reduce(function (output, match, index, matches) {
      var previousEndingIndex = index ? matches[index - 1].lastIndex : 0; // Preserve the text preceding this match

      output.push(text.slice(previousEndingIndex, match.index)); // Convert the match to a link

      output.push(React__default.createElement("a", {
        href: match.url,
        title: match.url,
        key: match.url,
        target: "_blank"
      }, cropUrl(match.text, 45))); // If there are no more matches, include the remaining text

      if (index === matches.length - 1) {
        output.push(text.slice(match.lastIndex));
      }

      return output;
    }, []);
  };

  MessageBubbleText.prototype.render = function () {
    var _a;

    var isOptOutMessage = typeof this.props.children === 'string' && OPT_OUT_KEYWORDS.has(this.props.children);
    var showOptOutMessageExplanation = isOptOutMessage && this.props.message.sentVia === chatFirebaseClient.MessageChannel.SMS && CURATED_MESSAGING_USER_TYPES.has(this.props.myself.type);

    var _b = this.props,
        children = _b.children,
        message = _b.message,
        myself = _b.myself,
        className = _b.className,
        rest = __rest(_b, ["children", "message", "myself", "className"]);

    var sender = message.sentBy;
    var isTeammate = sender.type === 'BUSINESS_USER' && myself.type === 'BUSINESS_USER' && myself !== sender || sender.type === 'SUPPORT' && myself.type === 'OPERATOR' && myself !== sender;
    var classes = classnames(className, message.sentBy.isMyself ? styles$8.sent : styles$8.received, styles$8.flat, (_a = {}, _a[styles$8.fromTeammate] = isTeammate, _a)); // If there is a video URL in the text, render a video player

    var richMedia = typeof children === 'string' ? this.extractRichMedia(children) : null; // If the video URL is the only text, don't render the raw text

    var isOnlyRichMediaUrl = typeof children === 'string' && richMedia && richMedia.index === 0 && richMedia.lastIndex === children.length;
    return React__default.createElement(MessageBubble, __assign({
      message: message,
      className: classes,
      fullWidth: !!richMedia
    }, rest), richMedia && React__default.createElement("div", {
      className: styles$8.richMediaWrapper
    }, React__default.createElement(ReactPlayer, {
      url: richMedia.url,
      className: styles$8.richMedia,
      width: "100%",
      height: ""
    })), !isOnlyRichMediaUrl && React__default.createElement("div", {
      className: styles$8.text
    }, typeof children === 'string' ? this.formatText(children) : children, showOptOutMessageExplanation && React__default.createElement("div", {
      className: styles$8.optOut
    }, React__default.createElement("strong", null, "We removed this phone number from our text message list since the customer responded with \"", this.formatText(children), "\""), React__default.createElement("ul", {
      className: styles$8.optOutBulletList
    }, React__default.createElement("li", {
      className: styles$8.optOutBulletItem
    }, "Messages will still be sent to this customer via Curated.com and their email."), React__default.createElement("li", {
      className: styles$8.optOutBulletItem
    }, "This customer has chosen to not receive text messages, OR it could be that the customer entered the wrong phone number."), React__default.createElement("li", {
      className: styles$8.optOutBulletItem
    }, "Please continue to help this customer!")))));
  };

  return MessageBubbleText;
}(React__default.Component);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var MenuDots = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "4",
    viewBox: "0 0 18 4"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#FFF",
    d: "M-904-938h3137V832H-904z"
  }), React__default.createElement("path", {
    d: "M-3-10h24v24H-3z"
  }), React__default.createElement("g", {
    fill: "#111",
    fillRule: "nonzero"
  }, React__default.createElement("circle", {
    cx: "9",
    cy: "2",
    r: "2"
  }), React__default.createElement("circle", {
    cx: "2",
    cy: "2",
    r: "2"
  }), React__default.createElement("circle", {
    cx: "16",
    cy: "2",
    r: "2"
  }))));
});

var styles$9 = {"media-breakpoint-sm":"(min-width: 40em)","container":"styles_container__1D7WG flex items-center justify-end","icon":"styles_icon__3Iku1 flex items-center justify-center relative","expert-container":"styles_expert-container__17p5X styles_container__1D7WG flex items-center justify-end","menu":"styles_menu__39hkN","expert-menu":"styles_expert-menu__1QVXz styles_menu__39hkN","user-menu":"styles_user-menu__1YRkh styles_menu__39hkN","flat":"styles_flat__YUbq- relative","mediaBreakpointSm":"(min-width: 40em)","expertContainer":"styles_expert-container__17p5X styles_container__1D7WG flex items-center justify-end","expertMenu":"styles_expert-menu__1QVXz styles_menu__39hkN","userMenu":"styles_user-menu__1YRkh styles_menu__39hkN"};

var ChatActions = function ChatActions(_a) {
  var _b;

  var messagePart = _a.messagePart,
      children = _a.children;
  var messageAction = React.useContext(ChatActionsContext).messageAction;
  var MessageAction = messageAction;
  return messageAction && messageAction.handlesMessagePart(messagePart) ? React__default.createElement("div", {
    className: classnames(styles$9.container, styles$9.flat, (_b = {}, _b[styles$9.expertContainer] = messagePart.message.sentBy.isMyself, _b))
  }, React__default.createElement("div", {
    className: styles$9.icon
  }, React__default.createElement(MenuDots, {
    className: styles$9.menuDots
  }), React__default.createElement("div", {
    className: messagePart.message.sentBy.isMyself ? styles$9.expertMenu : styles$9.userMenu
  }, MessageAction && React__default.createElement(MessageAction, {
    messagePart: messagePart
  }))), children) : React__default.createElement(React__default.Fragment, null, children);
};

var MessageTextPart =
/** @class */
function (_super) {
  __extends(MessageTextPart, _super);

  function MessageTextPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageTextPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageTextPart.prototype.getMessagePartText = function (messagePart) {
    switch (messagePart.type) {
      case 'TEXT':
      case 'SHORTENED_TEMPLATE':
      case 'TEMPLATE':
      case 'TEMPLATE_TEXT':
        return messagePart.body.text;

      default:
        throw new Error('Could not decode message part');
    }
  };

  MessageTextPart.prototype.render = function () {
    var text = this.getMessagePartText(this.props.part);
    var message = this.getMessageFromPart(this.props.part);
    return React__default.createElement(ChatActions, {
      messagePart: this.props.part
    }, React__default.createElement(MessageBubbleText, {
      message: message,
      myself: this.props.myself
    }, text));
  };

  return MessageTextPart;
}(React.Component);

var Link = function Link(_a) {
  var to = _a.to,
      children = _a.children,
      props = __rest(_a, ["to", "children"]); // Try to use react router for links within the same domain for a nice SPA transition


  var origin = window.location ? window.location.protocol + "//" + window.location.hostname : '';
  var isInternalLink = window.location && to.startsWith(origin);

  if (isInternalLink) {
    var absolutePath = to.substring(origin.length) || '/';
    return React__default.createElement(reactRouterDom.Link, __assign({
      to: absolutePath
    }, props), children);
  } else {
    return React__default.createElement("a", __assign({
      href: to,
      target: "_blank"
    }, props), children);
  }
};

var MessageHyperLinkTextPart =
/** @class */
function (_super) {
  __extends(MessageHyperLinkTextPart, _super);

  function MessageHyperLinkTextPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageHyperLinkTextPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageHyperLinkTextPart.prototype.render = function () {
    var body = this.props.part.body;
    var message = this.getMessageFromPart(this.props.part);
    return React__default.createElement(ChatActions, {
      messagePart: this.props.part
    }, React__default.createElement(MessageBubbleText, {
      message: message,
      myself: this.props.myself
    }, React__default.createElement(Link, {
      to: body.link
    }, body.text)));
  };

  return MessageHyperLinkTextPart;
}(React.Component);

var styles$a = {"link":"styles_link__2QFHY flex"};

var MessageBubbleImage = function MessageBubbleImage(_a) {
  var url = _a.url,
      skipHref = _a.skipHref,
      onLoaded = _a.onLoaded,
      rest = __rest(_a, ["url", "skipHref", "onLoaded"]);

  return React__default.createElement(MessageBubble, __assign({}, rest), skipHref && React__default.createElement("img", {
    src: url,
    onLoad: onLoaded
  }), !skipHref && React__default.createElement("a", {
    href: url,
    target: "_blank",
    className: styles$a.link
  }, React__default.createElement("img", {
    src: url,
    onLoad: onLoaded
  })));
};

var MessageImagePart =
/** @class */
function (_super) {
  __extends(MessageImagePart, _super);

  function MessageImagePart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageImagePart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageImagePart.prototype.getImageMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageImagePart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getImageMessagePartUrl(this.props.part);
    return React__default.createElement(MessageBubbleImage, {
      message: message,
      url: sourceUrl,
      onLoaded: this.props.onLoaded
    });
  };

  return MessageImagePart;
}(React.Component);

var styles$b = {"video":"styles_video__1EWEt fit"};

var MessageVideoPart =
/** @class */
function (_super) {
  __extends(MessageVideoPart, _super);

  function MessageVideoPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageVideoPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageVideoPart.prototype.getVideoMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageVideoPart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getVideoMessagePartUrl(this.props.part);
    return React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement("video", {
      src: sourceUrl,
      className: styles$b.video,
      controls: true,
      onLoad: this.props.onLoaded
    }, "Sorry, your browser doesn't support embedded videos, but don't worry, you can", ' ', React__default.createElement("a", {
      href: sourceUrl,
      target: "_blank"
    }, "download it"), ' ', "and watch it with your favorite video player!"));
  };

  return MessageVideoPart;
}(React.Component);

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var AttachmentIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$1({
    width: "38",
    height: "46",
    viewBox: "0 0 38 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "Group 2"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    fillRule: "nonzero"
  }, React__default.createElement("path", {
    d: "M36 46H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h24l12 12v32a2 2 0 0 1-2 2z",
    fill: "#E6E6E6"
  }), React__default.createElement("path", {
    d: "M26 0v10a2 2 0 0 0 2 2h10L26 0z",
    fill: "#B3B3B3"
  })), React__default.createElement("path", {
    d: "M8 15h24v24H8z"
  }), React__default.createElement("path", {
    d: "M30 26.4l-8.8 8.8c-2.5 2.5-6.7 2.5-9.2 0-2.5-2.5-2.5-6.7 0-9.2l7.8-7.8c1.8-1.8 4.6-1.8 6.4 0 1.8 1.8 1.8 4.6 0 6.4L19 31.7c-1 1-2.6 1-3.5 0-1-1-1-2.6 0-3.5l6-6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#3D4E56",
    strokeWidth: "2"
  })));
});

var styles$c = {"file-container":"styles_file-container__2cBgd flex items-center","attachment-icon":"styles_attachment-icon__1wfFa","file-name":"styles_file-name__2lkMt","fileContainer":"styles_file-container__2cBgd flex items-center","attachmentIcon":"styles_attachment-icon__1wfFa","fileName":"styles_file-name__2lkMt"};

var MessageBubbleFile = function MessageBubbleFile(_a) {
  var url = _a.url,
      fileName = _a.fileName,
      onLoad = _a.onLoad,
      rest = __rest(_a, ["url", "fileName", "onLoad"]);

  return React__default.createElement(MessageBubble, __assign({}, rest), React__default.createElement("a", {
    href: url,
    target: "_blank"
  }, React__default.createElement("div", {
    className: styles$c.fileContainer
  }, React__default.createElement(AttachmentIcon, {
    className: styles$c.attachmentIcon
  }), React__default.createElement("span", {
    className: styles$c.fileName
  }, fileName ? fileName : url && url.substring(url.lastIndexOf('/') + 1)))));
};

var MessageFilePart =
/** @class */
function (_super) {
  __extends(MessageFilePart, _super);

  function MessageFilePart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageFilePart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageFilePart.prototype.getFileMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageFilePart.prototype.getFilenameFromPart = function (messagePart) {
    var body = messagePart.body;
    return body.originalFileName;
  };

  MessageFilePart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getFileMessagePartUrl(this.props.part);
    var fileName = this.getFilenameFromPart(this.props.part);
    return React__default.createElement(MessageBubbleFile, {
      fileName: fileName,
      message: message,
      url: sourceUrl
    });
  };

  return MessageFilePart;
}(React.Component);

var styles$d = {"error-message":"styles_error-message__13F3L py1 px2","errorMessage":"styles_error-message__13F3L py1 px2"};

var ErrorMessage = function ErrorMessage(_a) {
  var message = _a.message;
  return React__default.createElement(MessageBubble, {
    message: message,
    className: styles$d.errorMessage
  }, "Unrecognized message type");
};

ErrorMessage.handlesMessage = function () {
  return true;
};

var styles$e = {"carousel-container":"styles_carousel-container__3yZ-f inline-block","carousel":"styles_carousel__2mD-f flex","carouselContainer":"styles_carousel-container__3yZ-f inline-block"};

var CarouselMessage = function CarouselMessage(_a) {
  var message = _a.message,
      onLoaded = _a.onLoaded,
      myself = _a.myself,
      onError = _a.onError;
  return React__default.createElement("div", {
    className: styles$e.carouselContainer
  }, React__default.createElement("div", {
    className: styles$e.carousel
  }, message.parts.map(function (part, idx) {
    switch (part.type) {
      case 'IMAGE':
        return React__default.createElement(MessageImagePart, {
          part: part,
          key: idx,
          onLoaded: onLoaded,
          myself: myself
        });

      case 'VIDEO':
        return React__default.createElement(MessageVideoPart, {
          part: part,
          key: idx,
          onLoaded: onLoaded,
          myself: myself
        });

      case 'AUDIO':
        return React__default.createElement(MessageAudioPart, {
          part: part,
          key: idx,
          myself: myself
        });

      case 'TEXT':
      case 'TEMPLATE':
      case 'SHORTENED_TEMPLATE':
      case 'TEMPLATE_TEXT':
        return React__default.createElement(MessageTextPart, {
          part: part,
          key: idx,
          myself: myself
        });

      case 'HYPERLINK_TEXT':
        return React__default.createElement(MessageHyperLinkTextPart, {
          part: part,
          key: idx,
          myself: myself
        });

      case 'TEMPLATE_CAROUSEL':
        return null;

      case 'FILE':
        return React__default.createElement(MessageFilePart, {
          part: part,
          key: idx,
          myself: myself
        });

      default:
        return React__default.createElement(ErrorMessage, {
          message: message,
          onError: onError,
          onLoaded: onLoaded,
          key: idx,
          myself: myself
        });
    }
  })));
};

CarouselMessage.handlesMessage = function (message) {
  return message.parts.length > 1;
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Check = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0h32v32H0z"
  }), React__default.createElement("g", {
    stroke: "#009F45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    transform: "translate(1 1)"
  }, React__default.createElement("path", {
    d: "M8 16l4 4 10-10"
  }), React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }))));
});

var AcceptEscalationResultStatus;

(function (AcceptEscalationResultStatus) {
  AcceptEscalationResultStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
  AcceptEscalationResultStatus["ACCEPTED"] = "ACCEPTED";
  AcceptEscalationResultStatus["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
  AcceptEscalationResultStatus["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
})(AcceptEscalationResultStatus || (AcceptEscalationResultStatus = {}));

var AcceptRequestMode;

(function (AcceptRequestMode) {
  AcceptRequestMode["ALWAYS"] = "ALWAYS";
  AcceptRequestMode["WHEN_ACTIVATED"] = "WHEN_ACTIVATED";
  AcceptRequestMode["WHEN_ACTIVATED_AND_AS_BACKUP"] = "WHEN_ACTIVATED_AND_AS_BACKUP";
})(AcceptRequestMode || (AcceptRequestMode = {}));

var AirportType;

(function (AirportType) {
  AirportType["LARGE_AIRPORT"] = "LARGE_AIRPORT";
  AirportType["MEDIUM_AIRPORT"] = "MEDIUM_AIRPORT";
  AirportType["SMALL_AIRPORT"] = "SMALL_AIRPORT";
})(AirportType || (AirportType = {}));

var AttributedHtmlTextViewModelAttributeType;

(function (AttributedHtmlTextViewModelAttributeType) {
  /** Denotes this attribute is an image view model */
  AttributedHtmlTextViewModelAttributeType["IMAGE"] = "IMAGE";
})(AttributedHtmlTextViewModelAttributeType || (AttributedHtmlTextViewModelAttributeType = {}));
/**
 * There is a 1:1 correlation between AttributeType and a GraphQL type.
 * The corresponding GraphQL type declaration name is ("AttributeValue" + pascalCaseOf(AttributeType))
 **/


var AttributeType;

(function (AttributeType) {
  AttributeType["INTEGER"] = "INTEGER";
  AttributeType["INTEGER_RANGE"] = "INTEGER_RANGE";
  AttributeType["DECIMAL"] = "DECIMAL";
  AttributeType["DECIMAL_RANGE"] = "DECIMAL_RANGE";
  AttributeType["TEXT"] = "TEXT";
  AttributeType["ENUMERATION"] = "ENUMERATION";
  AttributeType["LOCAL_DATE"] = "LOCAL_DATE";
  AttributeType["LOCAL_DATE_RANGE"] = "LOCAL_DATE_RANGE";
  AttributeType["LOCAL_TIME"] = "LOCAL_TIME";
  AttributeType["LOCAL_TIME_RANGE"] = "LOCAL_TIME_RANGE";
  AttributeType["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
  AttributeType["LOCAL_DATE_TIME_RANGE"] = "LOCAL_DATE_TIME_RANGE";
  AttributeType["ZONE_ID"] = "ZONE_ID";
  AttributeType["ID"] = "ID";
})(AttributeType || (AttributeType = {}));

var AttributeValidationType;

(function (AttributeValidationType) {
  /**
  * Text value must conform to a regular expression
   * Validates TEXT attribute types
  **/
  AttributeValidationType["REGEX"] = "REGEX";
  /**
  * Ensure the amount of attribute values falls between a specified range.
   * Validates all attribute types.
  **/

  AttributeValidationType["VALUE_AMOUNT"] = "VALUE_AMOUNT";
})(AttributeValidationType || (AttributeValidationType = {}));

var AuthenticationMethod;

(function (AuthenticationMethod) {
  AuthenticationMethod["NO_PASSWORD"] = "NO_PASSWORD";
  AuthenticationMethod["PASSWORD"] = "PASSWORD";
  AuthenticationMethod["CHALLENGE"] = "CHALLENGE";
  AuthenticationMethod["LOGIN_TOKEN"] = "LOGIN_TOKEN";
  AuthenticationMethod["EXTERNAL_OAUTH"] = "EXTERNAL_OAUTH";
})(AuthenticationMethod || (AuthenticationMethod = {}));

var AuthenticationResult;

(function (AuthenticationResult) {
  AuthenticationResult["SUCCESS"] = "SUCCESS";
  AuthenticationResult["FAILURE"] = "FAILURE";
  AuthenticationResult["CHALLENGE"] = "CHALLENGE";
})(AuthenticationResult || (AuthenticationResult = {}));

var AwayAutoReplyStatus;

(function (AwayAutoReplyStatus) {
  AwayAutoReplyStatus["PENDING"] = "PENDING";
  AwayAutoReplyStatus["ACTIVE"] = "ACTIVE";
  AwayAutoReplyStatus["EXPIRED"] = "EXPIRED";
})(AwayAutoReplyStatus || (AwayAutoReplyStatus = {}));

var BookingSearchSort;

(function (BookingSearchSort) {
  BookingSearchSort["DEFAULT"] = "DEFAULT";
  BookingSearchSort["ORDER_CREATE_AT"] = "ORDER_CREATE_AT";
})(BookingSearchSort || (BookingSearchSort = {}));

var BookingState;

(function (BookingState) {
  BookingState["TRIP_COMPLETED"] = "TRIP_COMPLETED";
  BookingState["TRIP_UPCOMING"] = "TRIP_UPCOMING";
  BookingState["VERIFYING_PAYMENT"] = "VERIFYING_PAYMENT";
})(BookingState || (BookingState = {}));

var BroadcastOfferType;

(function (BroadcastOfferType) {
  BroadcastOfferType["PRODUCT"] = "PRODUCT";
  BroadcastOfferType["SERVICE"] = "SERVICE";
})(BroadcastOfferType || (BroadcastOfferType = {}));

var BusinessUserActivityType;

(function (BusinessUserActivityType) {
  BusinessUserActivityType["START_RECEIVING_LEADS"] = "START_RECEIVING_LEADS";
  BusinessUserActivityType["STOP_RECEIVING_LEADS"] = "STOP_RECEIVING_LEADS";
  BusinessUserActivityType["START_ON_CALL"] = "START_ON_CALL";
  BusinessUserActivityType["STOP_ON_CALL"] = "STOP_ON_CALL";
})(BusinessUserActivityType || (BusinessUserActivityType = {}));

var BusinessUserState;

(function (BusinessUserState) {
  BusinessUserState["ACTIVE"] = "ACTIVE";
  BusinessUserState["DEACTIVATING"] = "DEACTIVATING";
  BusinessUserState["DEACTIVATED"] = "DEACTIVATED";
  BusinessUserState["PENDING"] = "PENDING";
})(BusinessUserState || (BusinessUserState = {}));

var CallStatus;

(function (CallStatus) {
  CallStatus["QUEUED"] = "QUEUED";
  CallStatus["INITIATED"] = "INITIATED";
  CallStatus["RINGING"] = "RINGING";
  CallStatus["IN_PROGRESS"] = "IN_PROGRESS";
  CallStatus["COMPLETED"] = "COMPLETED";
  CallStatus["BUSY"] = "BUSY";
  CallStatus["NO_ANSWER"] = "NO_ANSWER";
  CallStatus["CANCELLED"] = "CANCELLED";
  CallStatus["FAILED"] = "FAILED";
  CallStatus["OTHER"] = "OTHER";
})(CallStatus || (CallStatus = {}));

var CallType;

(function (CallType) {
  CallType["EXPERT_TO_CONSUMER"] = "EXPERT_TO_CONSUMER";
  CallType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
})(CallType || (CallType = {}));

var CardFieldValidationStatus;

(function (CardFieldValidationStatus) {
  CardFieldValidationStatus["PASS"] = "PASS";
  CardFieldValidationStatus["FAIL"] = "FAIL";
  CardFieldValidationStatus["UNAVAILABLE"] = "UNAVAILABLE";
  CardFieldValidationStatus["UNCHECKED"] = "UNCHECKED";
})(CardFieldValidationStatus || (CardFieldValidationStatus = {}));

var CardFundingType;

(function (CardFundingType) {
  CardFundingType["UNKNOWN"] = "UNKNOWN";
  CardFundingType["CREDIT"] = "CREDIT";
  CardFundingType["DEBIT"] = "DEBIT";
  CardFundingType["PREPAID"] = "PREPAID";
})(CardFundingType || (CardFundingType = {}));

var CartSyncUseCase;

(function (CartSyncUseCase) {
  /** Syncing to display the cart */
  CartSyncUseCase["CART_VIEW"] = "CART_VIEW";
  /** Syncing to display during the checkout flow */

  CartSyncUseCase["CHECKOUT"] = "CHECKOUT";
})(CartSyncUseCase || (CartSyncUseCase = {}));

var CategoryType;

(function (CategoryType) {
  CategoryType["PRODUCT"] = "PRODUCT";
  CategoryType["SERVICE"] = "SERVICE";
})(CategoryType || (CategoryType = {}));

var ChallengeType;

(function (ChallengeType) {
  ChallengeType["OTP"] = "OTP";
  ChallengeType["PASSWORD"] = "PASSWORD";
})(ChallengeType || (ChallengeType = {}));

var ChannelType;

(function (ChannelType) {
  ChannelType["EMAIL"] = "EMAIL";
  ChannelType["SMS"] = "SMS";
  ChannelType["INAPP"] = "INAPP";
  ChannelType["FACEBOOK"] = "FACEBOOK";
  ChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  ChannelType["SLACK"] = "SLACK";
})(ChannelType || (ChannelType = {}));

var ClaimPromotionErrorCode;

(function (ClaimPromotionErrorCode) {
  ClaimPromotionErrorCode["NOT_FIRST_PURCHASE"] = "NOT_FIRST_PURCHASE";
  ClaimPromotionErrorCode["NO_PROMOTION_FOUND"] = "NO_PROMOTION_FOUND";
  ClaimPromotionErrorCode["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
})(ClaimPromotionErrorCode || (ClaimPromotionErrorCode = {}));

var ConditionType;

(function (ConditionType) {
  ConditionType["ALWAYS_TRUE"] = "ALWAYS_TRUE";
  ConditionType["SUBJECT_ID_IN"] = "SUBJECT_ID_IN";
})(ConditionType || (ConditionType = {}));

var ConsumerInitialLeadAction;

(function (ConsumerInitialLeadAction) {
  ConsumerInitialLeadAction["BROWSE"] = "BROWSE";
  ConsumerInitialLeadAction["CHAT"] = "CHAT";
})(ConsumerInitialLeadAction || (ConsumerInitialLeadAction = {}));

var ConsumerReviewSearchSort;

(function (ConsumerReviewSearchSort) {
  ConsumerReviewSearchSort["RELEVANCE"] = "RELEVANCE";
  ConsumerReviewSearchSort["REVIEWED_AT"] = "REVIEWED_AT";
})(ConsumerReviewSearchSort || (ConsumerReviewSearchSort = {}));

var ConsumerReviewSource;

(function (ConsumerReviewSource) {
  ConsumerReviewSource["CURATED"] = "CURATED";
  ConsumerReviewSource["SHOPPER_APPROVED"] = "SHOPPER_APPROVED";
})(ConsumerReviewSource || (ConsumerReviewSource = {}));

var ConsumerSellableReactionRating;

(function (ConsumerSellableReactionRating) {
  ConsumerSellableReactionRating["SKIP"] = "SKIP";
  ConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
  ConsumerSellableReactionRating["LIKE"] = "LIKE";
  ConsumerSellableReactionRating["LOVE"] = "LOVE";
})(ConsumerSellableReactionRating || (ConsumerSellableReactionRating = {}));

var ConsumerSellableReactionReason;

(function (ConsumerSellableReactionReason) {
  ConsumerSellableReactionReason["PRICE"] = "PRICE";
  ConsumerSellableReactionReason["BRAND"] = "BRAND";
  ConsumerSellableReactionReason["STYLE"] = "STYLE";
  ConsumerSellableReactionReason["FEATURES"] = "FEATURES";
})(ConsumerSellableReactionReason || (ConsumerSellableReactionReason = {}));

var ConsumerSellableReactionSource;

(function (ConsumerSellableReactionSource) {
  ConsumerSellableReactionSource["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
  ConsumerSellableReactionSource["FAVORITES_PAGE"] = "FAVORITES_PAGE";
  ConsumerSellableReactionSource["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  ConsumerSellableReactionSource["PRODUCT_DETAILS"] = "PRODUCT_DETAILS";
})(ConsumerSellableReactionSource || (ConsumerSellableReactionSource = {}));

var ContactType;

(function (ContactType) {
  ContactType["PHONE"] = "PHONE";
  ContactType["EMAIL"] = "EMAIL";
  ContactType["FACEBOOK"] = "FACEBOOK";
  ContactType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(ContactType || (ContactType = {}));

var DatePathFlowQuestionType;

(function (DatePathFlowQuestionType) {
  DatePathFlowQuestionType["DATE"] = "DATE";
  DatePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DatePathFlowQuestionType || (DatePathFlowQuestionType = {}));

var DateRangeFilterField;

(function (DateRangeFilterField) {
  DateRangeFilterField["LAST_PAID_DATE"] = "LAST_PAID_DATE";
  DateRangeFilterField["CREATED_DATE"] = "CREATED_DATE";
  DateRangeFilterField["LAST_ACTIVITY_DATE"] = "LAST_ACTIVITY_DATE";
  DateRangeFilterField["ORDER_PAID_DATE"] = "ORDER_PAID_DATE";
  DateRangeFilterField["STARTED_DATE"] = "STARTED_DATE";
  DateRangeFilterField["COMPLETED_DATE"] = "COMPLETED_DATE";
  DateRangeFilterField["DUE_DATE"] = "DUE_DATE";
})(DateRangeFilterField || (DateRangeFilterField = {}));

var DateRangePathFlowQuestionType;

(function (DateRangePathFlowQuestionType) {
  DateRangePathFlowQuestionType["DATE"] = "DATE";
  DateRangePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DateRangePathFlowQuestionType || (DateRangePathFlowQuestionType = {}));

var DealState;

(function (DealState) {
  DealState["ACTIVE"] = "ACTIVE";
  DealState["INACTIVE"] = "INACTIVE";
})(DealState || (DealState = {}));

var DealTermsType;

(function (DealTermsType) {
  DealTermsType["PRODUCT"] = "PRODUCT";
  DealTermsType["SERVICE"] = "SERVICE";
})(DealTermsType || (DealTermsType = {}));

var DepartmentNavigationLabelStyle;

(function (DepartmentNavigationLabelStyle) {
  DepartmentNavigationLabelStyle["BOLD"] = "BOLD";
})(DepartmentNavigationLabelStyle || (DepartmentNavigationLabelStyle = {}));

var DepartmentNavigationResponsiveFullSizeOptions;

(function (DepartmentNavigationResponsiveFullSizeOptions) {
  DepartmentNavigationResponsiveFullSizeOptions["SHOW"] = "SHOW";
})(DepartmentNavigationResponsiveFullSizeOptions || (DepartmentNavigationResponsiveFullSizeOptions = {}));

var DepartmentNavigationResponsiveSmallSizeOptions;

(function (DepartmentNavigationResponsiveSmallSizeOptions) {
  /** Show element in persistent element attached to the chrome. */
  DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_PERSISTENT_HEADER"] = "SHOW_IN_PERSISTENT_HEADER";
  /** Show element in flyout panel that expands from the side of the page */

  DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_FLYOUT_PANEL"] = "SHOW_IN_FLYOUT_PANEL";
})(DepartmentNavigationResponsiveSmallSizeOptions || (DepartmentNavigationResponsiveSmallSizeOptions = {}));
/**
 * Best effort enumeration of available departments for easy type safe comparisons.
 * There is no guarantee all departments will have a department type. The departments that are not assigned an
 * explicit type will be assigned `OTHER`.
 **/


var DepartmentType;

(function (DepartmentType) {
  DepartmentType["CYCLING"] = "CYCLING";
  DepartmentType["CAMPING"] = "CAMPING";
  DepartmentType["CURATED_INTERNAL"] = "CURATED_INTERNAL";
  DepartmentType["GOLF"] = "GOLF";
  DepartmentType["JEWELRY"] = "JEWELRY";
  DepartmentType["JET_CHARTERS"] = "JET_CHARTERS";
  DepartmentType["OTHER"] = "OTHER";
  DepartmentType["WINTER_SPORTS"] = "WINTER_SPORTS";
  DepartmentType["YACHT_CHARTERS"] = "YACHT_CHARTERS";
})(DepartmentType || (DepartmentType = {}));

var DurationUnit;

(function (DurationUnit) {
  DurationUnit["NANOS"] = "NANOS";
  DurationUnit["MILLIS"] = "MILLIS";
  DurationUnit["SECONDS"] = "SECONDS";
  DurationUnit["MINUTES"] = "MINUTES";
  DurationUnit["HOURS"] = "HOURS";
  DurationUnit["DAYS"] = "DAYS";
})(DurationUnit || (DurationUnit = {}));

var EditableUserSourceType;

(function (EditableUserSourceType) {
  EditableUserSourceType["ORGANIC"] = "ORGANIC";
  EditableUserSourceType["INVESTOR"] = "INVESTOR";
})(EditableUserSourceType || (EditableUserSourceType = {}));

var EscalationItemCondition;

(function (EscalationItemCondition) {
  EscalationItemCondition["NEW"] = "NEW";
  EscalationItemCondition["GOOD"] = "GOOD";
  EscalationItemCondition["OKAY"] = "OKAY";
})(EscalationItemCondition || (EscalationItemCondition = {}));

var ExperimentState;

(function (ExperimentState) {
  ExperimentState["ACTIVE"] = "ACTIVE";
  ExperimentState["ARCHIVED"] = "ARCHIVED";
})(ExperimentState || (ExperimentState = {}));

var ExpertApplicationFolderItemChangeType;

(function (ExpertApplicationFolderItemChangeType) {
  ExpertApplicationFolderItemChangeType["ADD"] = "ADD";
  ExpertApplicationFolderItemChangeType["REMOVE"] = "REMOVE";
  ExpertApplicationFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertApplicationFolderItemChangeType || (ExpertApplicationFolderItemChangeType = {}));

var ExpertApplicationFolderType;

(function (ExpertApplicationFolderType) {
  ExpertApplicationFolderType["PIPELINE"] = "PIPELINE";
  ExpertApplicationFolderType["FOLDERS"] = "FOLDERS";
})(ExpertApplicationFolderType || (ExpertApplicationFolderType = {}));

var ExpertApplicationRating;

(function (ExpertApplicationRating) {
  ExpertApplicationRating["YES"] = "YES";
  ExpertApplicationRating["NO"] = "NO";
})(ExpertApplicationRating || (ExpertApplicationRating = {}));

var ExpertApplicationSearchSort;

(function (ExpertApplicationSearchSort) {
  ExpertApplicationSearchSort["DEFAULT"] = "DEFAULT";
  ExpertApplicationSearchSort["APPLICATION_SUBMITTED_AT"] = "APPLICATION_SUBMITTED_AT";
})(ExpertApplicationSearchSort || (ExpertApplicationSearchSort = {}));

var ExpertApplicationState;

(function (ExpertApplicationState) {
  ExpertApplicationState["REJECTED"] = "REJECTED";
  ExpertApplicationState["ONBOARDED"] = "ONBOARDED";
  ExpertApplicationState["SCHEDULING"] = "SCHEDULING";
  ExpertApplicationState["FINAL_EVALUATION"] = "FINAL_EVALUATION";
  ExpertApplicationState["ONBOARDING"] = "ONBOARDING";
  ExpertApplicationState["APPROVED"] = "APPROVED";
  ExpertApplicationState["PENDING"] = "PENDING";
})(ExpertApplicationState || (ExpertApplicationState = {}));

var ExpertApplicationSubscriptionChangeType;

(function (ExpertApplicationSubscriptionChangeType) {
  ExpertApplicationSubscriptionChangeType["ADD"] = "ADD";
  ExpertApplicationSubscriptionChangeType["REMOVE"] = "REMOVE";
})(ExpertApplicationSubscriptionChangeType || (ExpertApplicationSubscriptionChangeType = {}));

var ExpertApplicationTaskState;

(function (ExpertApplicationTaskState) {
  ExpertApplicationTaskState["NOT_STARTED"] = "NOT_STARTED";
  ExpertApplicationTaskState["IN_PROGRESS"] = "IN_PROGRESS";
  ExpertApplicationTaskState["ERROR"] = "ERROR";
  ExpertApplicationTaskState["COMPLETED"] = "COMPLETED";
})(ExpertApplicationTaskState || (ExpertApplicationTaskState = {}));

var ExpertApplicationTaskType;

(function (ExpertApplicationTaskType) {
  ExpertApplicationTaskType["CALL_APPLICANT"] = "CALL_APPLICANT";
  ExpertApplicationTaskType["APPROVE_PROFILE"] = "APPROVE_PROFILE";
  ExpertApplicationTaskType["SIGN_CONTRACT"] = "SIGN_CONTRACT";
  ExpertApplicationTaskType["SETUP_PAYROLL"] = "SETUP_PAYROLL";
  ExpertApplicationTaskType["COMPLETE_TRAINING"] = "COMPLETE_TRAINING";
  ExpertApplicationTaskType["SETUP_7SHIFT"] = "SETUP_7SHIFT";
  ExpertApplicationTaskType["SETUP_SLACK"] = "SETUP_SLACK";
  ExpertApplicationTaskType["COMPLETE_HOMEWORK"] = "COMPLETE_HOMEWORK";
  ExpertApplicationTaskType["WAIT_FOR_SCHEDULING"] = "WAIT_FOR_SCHEDULING";
  ExpertApplicationTaskType["ADD_AVAILABILITY"] = "ADD_AVAILABILITY";
  ExpertApplicationTaskType["SCHEDULE_SHIFT"] = "SCHEDULE_SHIFT";
  ExpertApplicationTaskType["COMPLETE_FIRST_SHIFT"] = "COMPLETE_FIRST_SHIFT";
  ExpertApplicationTaskType["PASS_RESPONSIVE_EVAL"] = "PASS_RESPONSIVE_EVAL";
  ExpertApplicationTaskType["PASS_SKILL_EVAL"] = "PASS_SKILL_EVAL";
})(ExpertApplicationTaskType || (ExpertApplicationTaskType = {}));

var ExpertCuratedItemNoteState;

(function (ExpertCuratedItemNoteState) {
  /** New note, never submitted with curation */
  ExpertCuratedItemNoteState["DRAFT"] = "DRAFT";
  /** Waiting to be reviewed by operator */

  ExpertCuratedItemNoteState["PENDING"] = "PENDING";
  /** Approved by operator */

  ExpertCuratedItemNoteState["APPROVED"] = "APPROVED";
  /** Rejected by operator */

  ExpertCuratedItemNoteState["REJECTED"] = "REJECTED";
  /** Deactiavted by operator or system. soft delete */

  ExpertCuratedItemNoteState["DEACTIVATED"] = "DEACTIVATED";
})(ExpertCuratedItemNoteState || (ExpertCuratedItemNoteState = {}));

var ExpertCuratedItemPriceOverrideReasonType;

(function (ExpertCuratedItemPriceOverrideReasonType) {
  ExpertCuratedItemPriceOverrideReasonType["PRICE_MATCH"] = "PRICE_MATCH";
  ExpertCuratedItemPriceOverrideReasonType["SPECIAL_DISCOUNT"] = "SPECIAL_DISCOUNT";
  ExpertCuratedItemPriceOverrideReasonType["OTHER"] = "OTHER";
  ExpertCuratedItemPriceOverrideReasonType["SECRET_DEAL"] = "SECRET_DEAL";
})(ExpertCuratedItemPriceOverrideReasonType || (ExpertCuratedItemPriceOverrideReasonType = {}));

var ExpertCuratedItemRankChangeType;

(function (ExpertCuratedItemRankChangeType) {
  ExpertCuratedItemRankChangeType["INCREMENT"] = "INCREMENT";
  ExpertCuratedItemRankChangeType["DECREMENT"] = "DECREMENT";
})(ExpertCuratedItemRankChangeType || (ExpertCuratedItemRankChangeType = {}));

var ExpertCuratedItemRemovedReason;

(function (ExpertCuratedItemRemovedReason) {
  /** Internal reason used when an item is replaced/updated */
  ExpertCuratedItemRemovedReason["REPLACED"] = "REPLACED";
  /** Should be provided by experts to indicate they removed the item (no further reason is required for them) */

  ExpertCuratedItemRemovedReason["REMOVED_BY_EXPERT"] = "REMOVED_BY_EXPERT";
  /** Default reason that should be used if the user isn't prompted for the remaining reasons */

  ExpertCuratedItemRemovedReason["NOT_INTERESTED"] = "NOT_INTERESTED";
  ExpertCuratedItemRemovedReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
  ExpertCuratedItemRemovedReason["LOW_QUALITY"] = "LOW_QUALITY";
  ExpertCuratedItemRemovedReason["UGLY"] = "UGLY";
  ExpertCuratedItemRemovedReason["DONT_NEED"] = "DONT_NEED";
  ExpertCuratedItemRemovedReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
  ExpertCuratedItemRemovedReason["OTHER"] = "OTHER";
})(ExpertCuratedItemRemovedReason || (ExpertCuratedItemRemovedReason = {}));

var ExpertCuratedItemSort;

(function (ExpertCuratedItemSort) {
  /** Use the default sorting; this is the default, and should always be used in the consumer use case. */
  ExpertCuratedItemSort["DEFAULT"] = "DEFAULT";
  /**
  * Sort only by createdAt which guarantees consistent sorting when the expert is modifying expert curated items
   * (e.g.: changing the tags, which typically changes sort order)
  **/

  ExpertCuratedItemSort["CREATED_AT"] = "CREATED_AT";
})(ExpertCuratedItemSort || (ExpertCuratedItemSort = {}));
/** Basic filters based on state. When multiple filters are applied, they are OR-ed together. */


var ExpertCuratedItemStateFilter;

(function (ExpertCuratedItemStateFilter) {
  /** Include items that are in draft state (only valid for experts) */
  ExpertCuratedItemStateFilter["DRAFT"] = "DRAFT";
  /** Include items that are active (not in draft state, not removed) */

  ExpertCuratedItemStateFilter["ACTIVE"] = "ACTIVE";
  /** Include items that are removed */

  ExpertCuratedItemStateFilter["REMOVED"] = "REMOVED";
  /** Include items that not removed */

  ExpertCuratedItemStateFilter["NOT_REMOVED"] = "NOT_REMOVED";
})(ExpertCuratedItemStateFilter || (ExpertCuratedItemStateFilter = {}));

var ExpertCuratedItemTagType;

(function (ExpertCuratedItemTagType) {
  ExpertCuratedItemTagType["SPECIAL_OFFER"] = "SPECIAL_OFFER";
  ExpertCuratedItemTagType["THE_ALTERNATIVE"] = "THE_ALTERNATIVE";
  ExpertCuratedItemTagType["SALE_PRICE"] = "SALE_PRICE";
  ExpertCuratedItemTagType["EXPERT_PICK"] = "EXPERT_PICK";
  ExpertCuratedItemTagType["BUDGET_PICK"] = "BUDGET_PICK";
  ExpertCuratedItemTagType["CUSTOM"] = "CUSTOM";
  ExpertCuratedItemTagType["OTHER"] = "OTHER";
})(ExpertCuratedItemTagType || (ExpertCuratedItemTagType = {}));

var ExpertCuratedOrderClosedReason;

(function (ExpertCuratedOrderClosedReason) {
  ExpertCuratedOrderClosedReason["MANUAL"] = "MANUAL";
  ExpertCuratedOrderClosedReason["REPLACED"] = "REPLACED";
})(ExpertCuratedOrderClosedReason || (ExpertCuratedOrderClosedReason = {}));

var ExpertCuratedOrderSelectErrorCode;

(function (ExpertCuratedOrderSelectErrorCode) {
  /**
  * Expert curated order is not in an active state. This may be due to the curated order being replaced, or manually
   * closed. If being replaced, {@link #getActiveReplacement()} will have the updated curated order.
  **/
  ExpertCuratedOrderSelectErrorCode["NOT_ACTIVE"] = "NOT_ACTIVE";
})(ExpertCuratedOrderSelectErrorCode || (ExpertCuratedOrderSelectErrorCode = {}));

var ExpertCuratedOrderServiceLocationErrorCode;

(function (ExpertCuratedOrderServiceLocationErrorCode) {
  /** An invalid address was supplied. */
  ExpertCuratedOrderServiceLocationErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
})(ExpertCuratedOrderServiceLocationErrorCode || (ExpertCuratedOrderServiceLocationErrorCode = {}));

var ExpertCuratedOrdersForLeadQueryCustomFilter;

(function (ExpertCuratedOrdersForLeadQueryCustomFilter) {
  /** Show custom and not custom */
  ExpertCuratedOrdersForLeadQueryCustomFilter["INCLUDE"] = "INCLUDE";
  /** Only show custom */

  ExpertCuratedOrdersForLeadQueryCustomFilter["ONLY"] = "ONLY";
  /** Show no custom; only non custom */

  ExpertCuratedOrdersForLeadQueryCustomFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryCustomFilter || (ExpertCuratedOrdersForLeadQueryCustomFilter = {}));

var ExpertCuratedOrdersForLeadQueryDraftFilter;

(function (ExpertCuratedOrdersForLeadQueryDraftFilter) {
  /** Show all drafts and non drafts */
  ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE"] = "INCLUDE";
  /** Show drafts that are newly created (not from replacing an existing curated order) and non drafts */

  ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE_CREATED_DRAFT"] = "INCLUDE_CREATED_DRAFT";
  /** Only show drafts (and no non drafts) */

  ExpertCuratedOrdersForLeadQueryDraftFilter["ONLY"] = "ONLY";
  /** Show no drafts; only non drafts */

  ExpertCuratedOrdersForLeadQueryDraftFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryDraftFilter || (ExpertCuratedOrdersForLeadQueryDraftFilter = {}));

var ExpertCuratedOrderState;

(function (ExpertCuratedOrderState) {
  ExpertCuratedOrderState["DRAFT"] = "DRAFT";
  ExpertCuratedOrderState["ACTIVE"] = "ACTIVE";
  ExpertCuratedOrderState["CLOSED"] = "CLOSED";
  ExpertCuratedOrderState["EXPIRED"] = "EXPIRED";
})(ExpertCuratedOrderState || (ExpertCuratedOrderState = {}));

var ExpertGender;

(function (ExpertGender) {
  ExpertGender["MALE"] = "MALE";
  ExpertGender["FEMALE"] = "FEMALE";
  ExpertGender["OTHER"] = "OTHER";
})(ExpertGender || (ExpertGender = {}));

var ExpertLeadFolderGroupType;

(function (ExpertLeadFolderGroupType) {
  ExpertLeadFolderGroupType["INBOX"] = "INBOX";
  ExpertLeadFolderGroupType["INBOX_ASSISTANT"] = "INBOX_ASSISTANT";
  ExpertLeadFolderGroupType["SALES_PIPELINE"] = "SALES_PIPELINE";
  ExpertLeadFolderGroupType["FOLDERS"] = "FOLDERS";
})(ExpertLeadFolderGroupType || (ExpertLeadFolderGroupType = {}));

var ExpertLeadFolderItemChangeType;

(function (ExpertLeadFolderItemChangeType) {
  ExpertLeadFolderItemChangeType["ADD"] = "ADD";
  ExpertLeadFolderItemChangeType["REMOVE"] = "REMOVE";
  ExpertLeadFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertLeadFolderItemChangeType || (ExpertLeadFolderItemChangeType = {}));

var ExpertNewMessageNotificationMode;

(function (ExpertNewMessageNotificationMode) {
  ExpertNewMessageNotificationMode["NONE"] = "NONE";
  ExpertNewMessageNotificationMode["ALWAYS"] = "ALWAYS";
  ExpertNewMessageNotificationMode["WHEN_NOT_ACTIVATED"] = "WHEN_NOT_ACTIVATED";
  ExpertNewMessageNotificationMode["WHEN_NOT_ONLINE"] = "WHEN_NOT_ONLINE";
})(ExpertNewMessageNotificationMode || (ExpertNewMessageNotificationMode = {}));

var ExpertNoteStatsSort;

(function (ExpertNoteStatsSort) {
  /** Number of approved review */
  ExpertNoteStatsSort["APPROVED"] = "APPROVED";
  /** Number of pending review */

  ExpertNoteStatsSort["PENDING"] = "PENDING";
  /** Number of rejected review */

  ExpertNoteStatsSort["REJECTED"] = "REJECTED";
})(ExpertNoteStatsSort || (ExpertNoteStatsSort = {}));

var ExpertNotificationType;

(function (ExpertNotificationType) {
  ExpertNotificationType["LEAD_ESCALATION"] = "LEAD_ESCALATION";
  ExpertNotificationType["PRESENCE_STATUS_CHANGE"] = "PRESENCE_STATUS_CHANGE";
  ExpertNotificationType["SHIFT_ENDED"] = "SHIFT_ENDED";
  ExpertNotificationType["LEAD_SURGE"] = "LEAD_SURGE";
})(ExpertNotificationType || (ExpertNotificationType = {}));

var ExpertPerformanceRating;

(function (ExpertPerformanceRating) {
  ExpertPerformanceRating["NEW"] = "NEW";
  ExpertPerformanceRating["PLATINUM"] = "PLATINUM";
  ExpertPerformanceRating["GOLD"] = "GOLD";
  ExpertPerformanceRating["SILVER"] = "SILVER";
  ExpertPerformanceRating["BRONZE"] = "BRONZE";
})(ExpertPerformanceRating || (ExpertPerformanceRating = {}));

var ExpertPresenceStatus;

(function (ExpertPresenceStatus) {
  ExpertPresenceStatus["OFF_SHIFT"] = "OFF_SHIFT";
  ExpertPresenceStatus["ON_SHIFT"] = "ON_SHIFT";
  ExpertPresenceStatus["ON_CALL"] = "ON_CALL";
  ExpertPresenceStatus["AWAY"] = "AWAY";
})(ExpertPresenceStatus || (ExpertPresenceStatus = {}));

var ExpertProfileState;

(function (ExpertProfileState) {
  ExpertProfileState["DRAFT"] = "DRAFT";
  ExpertProfileState["SUBMITTED"] = "SUBMITTED";
  ExpertProfileState["PUBLISHED"] = "PUBLISHED";
})(ExpertProfileState || (ExpertProfileState = {}));

var ExpertRecommendationStrategy;

(function (ExpertRecommendationStrategy) {
  ExpertRecommendationStrategy["LEAST_WORKLOAD"] = "LEAST_WORKLOAD";
  ExpertRecommendationStrategy["PERFORMANCE_WEIGHTED"] = "PERFORMANCE_WEIGHTED";
})(ExpertRecommendationStrategy || (ExpertRecommendationStrategy = {}));

var ExpertSearchSort;

(function (ExpertSearchSort) {
  ExpertSearchSort["DEFAULT"] = "DEFAULT";
  ExpertSearchSort["PERFORMANCE"] = "PERFORMANCE";
  ExpertSearchSort["FEATURED"] = "FEATURED";
})(ExpertSearchSort || (ExpertSearchSort = {}));

var ExternalAdPlatform;

(function (ExternalAdPlatform) {
  ExternalAdPlatform["FACEBOOK"] = "FACEBOOK";
  ExternalAdPlatform["GOOGLE"] = "GOOGLE";
})(ExternalAdPlatform || (ExternalAdPlatform = {}));

var ExternalAdStatus;

(function (ExternalAdStatus) {
  ExternalAdStatus["ACTIVE"] = "ACTIVE";
  ExternalAdStatus["PAUSED"] = "PAUSED";
  ExternalAdStatus["DELETED"] = "DELETED";
})(ExternalAdStatus || (ExternalAdStatus = {}));

var ExternalInventoryItemSourceType;

(function (ExternalInventoryItemSourceType) {
  ExternalInventoryItemSourceType["SHOPIFY"] = "SHOPIFY";
})(ExternalInventoryItemSourceType || (ExternalInventoryItemSourceType = {}));

var ExternalProfileType;

(function (ExternalProfileType) {
  ExternalProfileType["FACEBOOK_MESSENGER"] = "FACEBOOK_MESSENGER";
  ExternalProfileType["PIPL"] = "PIPL";
})(ExternalProfileType || (ExternalProfileType = {}));

var ExternalVideoIdType;

(function (ExternalVideoIdType) {
  ExternalVideoIdType["YOUTUBE"] = "YOUTUBE";
  ExternalVideoIdType["VIMEO"] = "VIMEO";
})(ExternalVideoIdType || (ExternalVideoIdType = {}));

var FacetImageType;

(function (FacetImageType) {
  /** Facets that are shown as Icons on the UI */
  FacetImageType["ICON"] = "ICON";
  /** BACKGROUND */

  FacetImageType["BACKGROUND"] = "BACKGROUND";
})(FacetImageType || (FacetImageType = {}));

var FlightPlanEditErrorCode;

(function (FlightPlanEditErrorCode) {
  FlightPlanEditErrorCode["EMPTY_LEGS"] = "EMPTY_LEGS";
  FlightPlanEditErrorCode["NO_SUCH_LEG"] = "NO_SUCH_LEG";
  FlightPlanEditErrorCode["MISSING_AIRPORT"] = "MISSING_AIRPORT";
  FlightPlanEditErrorCode["SAME_AIRPORT"] = "SAME_AIRPORT";
  FlightPlanEditErrorCode["OVERLAPPING_LEGS"] = "OVERLAPPING_LEGS";
  FlightPlanEditErrorCode["NOT_DRAFT"] = "NOT_DRAFT";
})(FlightPlanEditErrorCode || (FlightPlanEditErrorCode = {}));

var FlightPlanState;

(function (FlightPlanState) {
  FlightPlanState["DRAFT"] = "DRAFT";
  FlightPlanState["ACTIVE"] = "ACTIVE";
})(FlightPlanState || (FlightPlanState = {}));

var FrontendTaskStatus;

(function (FrontendTaskStatus) {
  FrontendTaskStatus["CREATED"] = "CREATED";
  FrontendTaskStatus["PROCESSING"] = "PROCESSING";
  FrontendTaskStatus["COMPLETED"] = "COMPLETED";
  FrontendTaskStatus["ABORTED"] = "ABORTED";
})(FrontendTaskStatus || (FrontendTaskStatus = {}));

var FulfillmentChannelType;

(function (FulfillmentChannelType) {
  FulfillmentChannelType["WAREHOUSE"] = "WAREHOUSE";
  FulfillmentChannelType["MANUFACTURER"] = "MANUFACTURER";
  FulfillmentChannelType["RETAILER"] = "RETAILER";
  FulfillmentChannelType["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
  FulfillmentChannelType["AD_HOC"] = "AD_HOC";
  FulfillmentChannelType["OFFLINE_PARTNERS"] = "OFFLINE_PARTNERS";
})(FulfillmentChannelType || (FulfillmentChannelType = {}));

var FulfillmentOrderDeliveryStatus;

(function (FulfillmentOrderDeliveryStatus) {
  FulfillmentOrderDeliveryStatus["ATTEMPTED_DELIVERY"] = "ATTEMPTED_DELIVERY";
  FulfillmentOrderDeliveryStatus["CANCELED"] = "CANCELED";
  FulfillmentOrderDeliveryStatus["CONFIRMED"] = "CONFIRMED";
  FulfillmentOrderDeliveryStatus["DELIVERED"] = "DELIVERED";
  FulfillmentOrderDeliveryStatus["FAILURE"] = "FAILURE";
  FulfillmentOrderDeliveryStatus["FULFILLED"] = "FULFILLED";
  FulfillmentOrderDeliveryStatus["IN_TRANSIT"] = "IN_TRANSIT";
  FulfillmentOrderDeliveryStatus["LABEL_PRINTED"] = "LABEL_PRINTED";
  FulfillmentOrderDeliveryStatus["LABEL_PURCHASED"] = "LABEL_PURCHASED";
  FulfillmentOrderDeliveryStatus["LABEL_VOIDED"] = "LABEL_VOIDED";
  FulfillmentOrderDeliveryStatus["MARKED_AS_FULFILLED"] = "MARKED_AS_FULFILLED";
  FulfillmentOrderDeliveryStatus["NOT_DELIVERED"] = "NOT_DELIVERED";
  FulfillmentOrderDeliveryStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
  FulfillmentOrderDeliveryStatus["READY_FOR_PICKUP"] = "READY_FOR_PICKUP";
  FulfillmentOrderDeliveryStatus["SUBMITTED"] = "SUBMITTED";
})(FulfillmentOrderDeliveryStatus || (FulfillmentOrderDeliveryStatus = {}));

var FulfillmentOrderSourceType;

(function (FulfillmentOrderSourceType) {
  FulfillmentOrderSourceType["DEAL"] = "DEAL";
  FulfillmentOrderSourceType["SHOPIFY"] = "SHOPIFY";
  FulfillmentOrderSourceType["EXTERNAL_PARTNER"] = "EXTERNAL_PARTNER";
})(FulfillmentOrderSourceType || (FulfillmentOrderSourceType = {}));

var FulfillmentServiceProvider;

(function (FulfillmentServiceProvider) {
  FulfillmentServiceProvider["DEAL"] = "DEAL";
  FulfillmentServiceProvider["UPS"] = "UPS";
})(FulfillmentServiceProvider || (FulfillmentServiceProvider = {}));

var FulfillmentServiceType;

(function (FulfillmentServiceType) {
  FulfillmentServiceType["THIRD_PARTY_LOGISTICS"] = "THIRD_PARTY_LOGISTICS";
  FulfillmentServiceType["DEAL_WH"] = "DEAL_WH";
})(FulfillmentServiceType || (FulfillmentServiceType = {}));

var FulfillmentStatus;

(function (FulfillmentStatus) {
  FulfillmentStatus["REQUESTED"] = "REQUESTED";
  FulfillmentStatus["CANCELLED"] = "CANCELLED";
  FulfillmentStatus["ERROR"] = "ERROR";
  FulfillmentStatus["FAILED"] = "FAILED";
  FulfillmentStatus["PROCESSING"] = "PROCESSING";
  FulfillmentStatus["PENDING"] = "PENDING";
  FulfillmentStatus["PARTIAL"] = "PARTIAL";
  FulfillmentStatus["COMPLETED"] = "COMPLETED";
})(FulfillmentStatus || (FulfillmentStatus = {}));

var FulfillmentSuggestionStatus;

(function (FulfillmentSuggestionStatus) {
  FulfillmentSuggestionStatus["PENDING"] = "PENDING";
  FulfillmentSuggestionStatus["FULFILLED"] = "FULFILLED";
  FulfillmentSuggestionStatus["SKIPPED"] = "SKIPPED";
  FulfillmentSuggestionStatus["UNAVAILABLE"] = "UNAVAILABLE";
  FulfillmentSuggestionStatus["PRICE_TOO_HIGH"] = "PRICE_TOO_HIGH";
  FulfillmentSuggestionStatus["SHIPPING_TOO_SLOW"] = "SHIPPING_TOO_SLOW";
  FulfillmentSuggestionStatus["FAILED"] = "FAILED";
})(FulfillmentSuggestionStatus || (FulfillmentSuggestionStatus = {}));

var GuestConversationSequenceState;

(function (GuestConversationSequenceState) {
  GuestConversationSequenceState["DRAFT"] = "DRAFT";
  GuestConversationSequenceState["ACTIVE"] = "ACTIVE";
  GuestConversationSequenceState["INACTIVE"] = "INACTIVE";
})(GuestConversationSequenceState || (GuestConversationSequenceState = {}));

var HandleType;

(function (HandleType) {
  HandleType["EMAIL"] = "EMAIL";
  HandleType["PHONE"] = "PHONE";
})(HandleType || (HandleType = {}));

var IdPathFlowQuestionType;

(function (IdPathFlowQuestionType) {
  IdPathFlowQuestionType["MEDIA_ID_IMAGE_UPLOAD"] = "MEDIA_ID_IMAGE_UPLOAD";
  IdPathFlowQuestionType["EXPERT_ID_SELECTION"] = "EXPERT_ID_SELECTION";
  IdPathFlowQuestionType["PRODUCTS_TYPEAHEAD"] = "PRODUCTS_TYPEAHEAD";
  IdPathFlowQuestionType["FLIGHT_PLAN"] = "FLIGHT_PLAN";
})(IdPathFlowQuestionType || (IdPathFlowQuestionType = {}));

var InputTextPathFlowQuestionFieldType;

(function (InputTextPathFlowQuestionFieldType) {
  /** Typeahead for airports only */
  InputTextPathFlowQuestionFieldType["AIRPORT_TYPEAHEAD"] = "AIRPORT_TYPEAHEAD";
  /** Single line "telephone" with SMS text context */

  InputTextPathFlowQuestionFieldType["SMS_TEXT"] = "SMS_TEXT";
  /** Facebook user expectedReference */

  InputTextPathFlowQuestionFieldType["FACEBOOK_USER_REF"] = "FACEBOOK_USER_REF";
  /** FCM Token */

  InputTextPathFlowQuestionFieldType["FCM_TOKEN"] = "FCM_TOKEN";
  /** Single line text entry */

  InputTextPathFlowQuestionFieldType["INPUT_FIELD"] = "INPUT_FIELD";
  /** Multi-line text area */

  InputTextPathFlowQuestionFieldType["TEXT_AREA"] = "TEXT_AREA";
  /** Single line entry (numeric only) */

  InputTextPathFlowQuestionFieldType["NUMERIC"] = "NUMERIC";
  /** Single line "telephone"-like entry (numeric only) */

  InputTextPathFlowQuestionFieldType["TELEPHONE"] = "TELEPHONE";
  /** Single line "telephone" with its own submit action */

  InputTextPathFlowQuestionFieldType["TELEPHONE_SUBMIT"] = "TELEPHONE_SUBMIT";
  /** Single line "email"-like entry (shows @ sign) */

  InputTextPathFlowQuestionFieldType["EMAIL"] = "EMAIL";
  /** Text which is provided programmatically, thus should be hidden from the user */

  InputTextPathFlowQuestionFieldType["HIDDEN"] = "HIDDEN";
})(InputTextPathFlowQuestionFieldType || (InputTextPathFlowQuestionFieldType = {}));

var InputTextPathFlowQuestionValidationType;

(function (InputTextPathFlowQuestionValidationType) {
  InputTextPathFlowQuestionValidationType["LENGTH"] = "LENGTH";
  InputTextPathFlowQuestionValidationType["REGEX"] = "REGEX";
  InputTextPathFlowQuestionValidationType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(InputTextPathFlowQuestionValidationType || (InputTextPathFlowQuestionValidationType = {}));

var InterstitialPathFlowPageMetadataType;

(function (InterstitialPathFlowPageMetadataType) {
  InterstitialPathFlowPageMetadataType["ALMOST_DONE"] = "ALMOST_DONE";
  InterstitialPathFlowPageMetadataType["BROWSE_EXPERTS"] = "BROWSE_EXPERTS";
  InterstitialPathFlowPageMetadataType["CALCULATING"] = "CALCULATING";
  InterstitialPathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
  InterstitialPathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
  /** GENERIC_WITH_BUTTON interstitial uses a button to submit */

  InterstitialPathFlowPageMetadataType["GENERIC_WITH_BUTTON"] = "GENERIC_WITH_BUTTON";
  /** GENERIC_WITH_TITLE interstitial that uses timer to submit */

  InterstitialPathFlowPageMetadataType["GENERIC_WITH_TITLE"] = "GENERIC_WITH_TITLE";
  InterstitialPathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
  InterstitialPathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
  InterstitialPathFlowPageMetadataType["SNOWBOARD_INT_LEARN"] = "SNOWBOARD_INT_LEARN";
  InterstitialPathFlowPageMetadataType["WELCOME"] = "WELCOME";
  InterstitialPathFlowPageMetadataType["GIVE_US_A_SEC"] = "GIVE_US_A_SEC";
  InterstitialPathFlowPageMetadataType["REQUEST_PUSH_NOTIFICATION_PERMISSION"] = "REQUEST_PUSH_NOTIFICATION_PERMISSION";
  InterstitialPathFlowPageMetadataType["WHAT_HAPPENS_NEXT"] = "WHAT_HAPPENS_NEXT";
})(InterstitialPathFlowPageMetadataType || (InterstitialPathFlowPageMetadataType = {}));

var LeadActivityType;

(function (LeadActivityType) {
  LeadActivityType["DELEGATE_EXPERT_CHANGED"] = "DELEGATE_EXPERT_CHANGED";
  LeadActivityType["SNOOZE_CHANGED"] = "SNOOZE_CHANGED";
  LeadActivityType["WOKE_UP_FROM_SNOOZE"] = "WOKE_UP_FROM_SNOOZE";
  LeadActivityType["REASSIGNED"] = "REASSIGNED";
  LeadActivityType["ARCHIVED"] = "ARCHIVED";
  LeadActivityType["CONSUMER_FIRST_MESSAGE_SENT"] = "CONSUMER_FIRST_MESSAGE_SENT";
  LeadActivityType["CONSUMER_CALLED"] = "CONSUMER_CALLED";
  LeadActivityType["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
  LeadActivityType["CONSUMER_PAYMENT_SUCCEEDED"] = "CONSUMER_PAYMENT_SUCCEEDED";
  LeadActivityType["CONSUMER_ORDER_PAID"] = "CONSUMER_ORDER_PAID";
  LeadActivityType["CONSUMER_REVIEW_ADDED"] = "CONSUMER_REVIEW_ADDED";
  LeadActivityType["ESCALATION_STARTED"] = "ESCALATION_STARTED";
  LeadActivityType["ESCALATION_CHANGED"] = "ESCALATION_CHANGED";
  LeadActivityType["QUALITY_CONVERSATION_ESTABLISHED"] = "QUALITY_CONVERSATION_ESTABLISHED";
  LeadActivityType["LEAD_CREATED"] = "LEAD_CREATED";
  LeadActivityType["STOP_REQUESTED"] = "STOP_REQUESTED";
})(LeadActivityType || (LeadActivityType = {}));

var LeadCampaignRecipientSortOrder;

(function (LeadCampaignRecipientSortOrder) {
  LeadCampaignRecipientSortOrder["MOST_RECENT_ACTIVITY"] = "MOST_RECENT_ACTIVITY";
  LeadCampaignRecipientSortOrder["RANDOM"] = "RANDOM";
})(LeadCampaignRecipientSortOrder || (LeadCampaignRecipientSortOrder = {}));

var LeadCampaignState;

(function (LeadCampaignState) {
  LeadCampaignState["DRAFT"] = "DRAFT";
  LeadCampaignState["PREPARING"] = "PREPARING";
  LeadCampaignState["PUBLISHED"] = "PUBLISHED";
  LeadCampaignState["DELIVERING"] = "DELIVERING";
  LeadCampaignState["DEACTIVATED"] = "DEACTIVATED";
})(LeadCampaignState || (LeadCampaignState = {}));

var LeadCampaignTriggerExecutionInterval;

(function (LeadCampaignTriggerExecutionInterval) {
  LeadCampaignTriggerExecutionInterval["EMAIL"] = "EMAIL";
  LeadCampaignTriggerExecutionInterval["SMS_LONG_CODE"] = "SMS_LONG_CODE";
  LeadCampaignTriggerExecutionInterval["SMS_SHORT_CODE"] = "SMS_SHORT_CODE";
})(LeadCampaignTriggerExecutionInterval || (LeadCampaignTriggerExecutionInterval = {}));

var LeadEscalationLevel;

(function (LeadEscalationLevel) {
  LeadEscalationLevel["NOT_STARTED"] = "NOT_STARTED";
  LeadEscalationLevel["ONLINE_TEAM_MEMBERS"] = "ONLINE_TEAM_MEMBERS";
  LeadEscalationLevel["ALL_TEAM_MEMBERS"] = "ALL_TEAM_MEMBERS";
  LeadEscalationLevel["SUPPORT"] = "SUPPORT";
  LeadEscalationLevel["ONLINE_EXPERTS"] = "ONLINE_EXPERTS";
  LeadEscalationLevel["ALL_EXPERTS"] = "ALL_EXPERTS";
  LeadEscalationLevel["ON_CALL_EXPERTS"] = "ON_CALL_EXPERTS";
})(LeadEscalationLevel || (LeadEscalationLevel = {}));

var LeadEscalationStatus;

(function (LeadEscalationStatus) {
  LeadEscalationStatus["OPEN"] = "OPEN";
  LeadEscalationStatus["CLOSED"] = "CLOSED";
})(LeadEscalationStatus || (LeadEscalationStatus = {}));

var LeadEscalationType;

(function (LeadEscalationType) {
  LeadEscalationType["CONSUMER_WAITING_RESPONSE"] = "CONSUMER_WAITING_RESPONSE";
})(LeadEscalationType || (LeadEscalationType = {}));

var LeadExpertRole;

(function (LeadExpertRole) {
  LeadExpertRole["PRIMARY"] = "PRIMARY";
  LeadExpertRole["DELEGATE"] = "DELEGATE";
})(LeadExpertRole || (LeadExpertRole = {}));

var LeadIntentLabel;

(function (LeadIntentLabel) {
  /** Lead predicted to have a high intent for conversion. */
  LeadIntentLabel["HIGH_INTENT_FOR_CONVERSION"] = "HIGH_INTENT_FOR_CONVERSION";
})(LeadIntentLabel || (LeadIntentLabel = {}));

var LeadParticipantType;

(function (LeadParticipantType) {
  LeadParticipantType["EXPERT"] = "EXPERT";
  LeadParticipantType["DELEGATE_EXPERT"] = "DELEGATE_EXPERT";
  LeadParticipantType["CONSUMER"] = "CONSUMER";
  LeadParticipantType["ASSISTANT"] = "ASSISTANT";
  LeadParticipantType["DEAL_BOT"] = "DEAL_BOT";
})(LeadParticipantType || (LeadParticipantType = {}));

var LeadReassignmentReason;

(function (LeadReassignmentReason) {
  LeadReassignmentReason["EXPERT_DEACTIVATED"] = "EXPERT_DEACTIVATED";
  LeadReassignmentReason["ORDER_SUPPORT_ACTION"] = "ORDER_SUPPORT_ACTION";
  LeadReassignmentReason["ESCALATION_ACCEPTED"] = "ESCALATION_ACCEPTED";
  LeadReassignmentReason["SURGE_LEAD_CLAIMED"] = "SURGE_LEAD_CLAIMED";
  LeadReassignmentReason["OTHER"] = "OTHER";
})(LeadReassignmentReason || (LeadReassignmentReason = {}));

var LeadSortOrder;

(function (LeadSortOrder) {
  LeadSortOrder["ACTIVITY_DATE"] = "ACTIVITY_DATE";
  LeadSortOrder["CREATION_DATE"] = "CREATION_DATE";
})(LeadSortOrder || (LeadSortOrder = {}));

var LeadSupportTaskReason;

(function (LeadSupportTaskReason) {
  LeadSupportTaskReason["NEW_UNASSIGNED_LEAD"] = "NEW_UNASSIGNED_LEAD";
  LeadSupportTaskReason["EXPERT_OUT_OF_SLA"] = "EXPERT_OUT_OF_SLA";
  LeadSupportTaskReason["ESCALATION_FAILED"] = "ESCALATION_FAILED";
  LeadSupportTaskReason["ESCALATION_FOR_DELEGATION_FAILED"] = "ESCALATION_FOR_DELEGATION_FAILED";
  LeadSupportTaskReason["ESCALATION_FOR_REASSIGNMENT_FAILED"] = "ESCALATION_FOR_REASSIGNMENT_FAILED";
  LeadSupportTaskReason["UNSNOOZED"] = "UNSNOOZED";
  LeadSupportTaskReason["RESPONDED_TO_SUPPORT"] = "RESPONDED_TO_SUPPORT";
  LeadSupportTaskReason["EVALUATE_CONVERSATION"] = "EVALUATE_CONVERSATION";
  LeadSupportTaskReason["DEFAULT"] = "DEFAULT";
})(LeadSupportTaskReason || (LeadSupportTaskReason = {}));

var ListPathFlowQuestionRenderStyle;

(function (ListPathFlowQuestionRenderStyle) {
  /**
  * The default/stock rendering style that is guaranteed to fit in with the rest of the components, and will have the
   * best support in combining different options that impact rendering. Unless a path with a specific UI treatment is
   * being tested, using DEFAULT is strongly recommended.
  **/
  ListPathFlowQuestionRenderStyle["DEFAULT"] = "DEFAULT";
  /** If images should be rendered as full width (bleeds into edges of select container) */

  ListPathFlowQuestionRenderStyle["FULL_WIDTH_IMAGES"] = "FULL_WIDTH_IMAGES";
  /** If text should be rendered as an overlay of the image in the background */

  ListPathFlowQuestionRenderStyle["OVERLAY_IMAGE"] = "OVERLAY_IMAGE";
  /** Use a simpler radio style select that doesn't render the full cards */

  ListPathFlowQuestionRenderStyle["SIMPLE_RADIO"] = "SIMPLE_RADIO";
})(ListPathFlowQuestionRenderStyle || (ListPathFlowQuestionRenderStyle = {}));

var ListPathFlowQuestionType;

(function (ListPathFlowQuestionType) {
  ListPathFlowQuestionType["SINGLE_SELECT_LIST"] = "SINGLE_SELECT_LIST";
  ListPathFlowQuestionType["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
  ListPathFlowQuestionType["DROP_DOWN"] = "DROP_DOWN";
  ListPathFlowQuestionType["MULTI_SELECT_PILLS"] = "MULTI_SELECT_PILLS";
})(ListPathFlowQuestionType || (ListPathFlowQuestionType = {}));

var LogicalOperator;

(function (LogicalOperator) {
  LogicalOperator["AND"] = "AND";
  LogicalOperator["OR"] = "OR";
})(LogicalOperator || (LogicalOperator = {}));

var LookupReferralCodeError;

(function (LookupReferralCodeError) {
  LookupReferralCodeError["INVALID_CODE"] = "INVALID_CODE";
})(LookupReferralCodeError || (LookupReferralCodeError = {}));

var LtvType;

(function (LtvType) {
  LtvType["LEAD"] = "LEAD";
  LtvType["REQUEST"] = "REQUEST";
  LtvType["RESPONSE"] = "RESPONSE";
  LtvType["VIEW_CURATIONS"] = "VIEW_CURATIONS";
})(LtvType || (LtvType = {}));

var MessageBodyType;

(function (MessageBodyType) {
  MessageBodyType["TEXT"] = "TEXT";
  MessageBodyType["FILE"] = "FILE";
  MessageBodyType["AUDIO"] = "AUDIO";
  MessageBodyType["VIDEO"] = "VIDEO";
  MessageBodyType["IMAGE"] = "IMAGE";
  MessageBodyType["MULTI_MEDIA"] = "MULTI_MEDIA";
  MessageBodyType["OFFER"] = "OFFER";
  MessageBodyType["DEAL"] = "DEAL";
  MessageBodyType["VIDEO_CHAT_REQUESTED"] = "VIDEO_CHAT_REQUESTED";
  MessageBodyType["VIDEO_CHAT_DECLINED"] = "VIDEO_CHAT_DECLINED";
  MessageBodyType["OTHER"] = "OTHER";
})(MessageBodyType || (MessageBodyType = {}));

var MessageRichCardType;

(function (MessageRichCardType) {
  MessageRichCardType["ONBOARDING_REQUEST_CONFIRMATION"] = "ONBOARDING_REQUEST_CONFIRMATION";
  MessageRichCardType["ONBOARDING_HOW_CURATED_WORKS"] = "ONBOARDING_HOW_CURATED_WORKS";
  MessageRichCardType["ONBOARDING_EXPERT_JOINED"] = "ONBOARDING_EXPERT_JOINED";
  MessageRichCardType["NEW_CUSTOM_CURATED_ORDER"] = "NEW_CUSTOM_CURATED_ORDER";
  MessageRichCardType["NEW_BOOKABLE_CURATED_ORDER"] = "NEW_BOOKABLE_CURATED_ORDER";
  MessageRichCardType["NEW_EXPERT_CURATED_ORDER_LIST"] = "NEW_EXPERT_CURATED_ORDER_LIST";
  MessageRichCardType["CONSUMER_INTERESTED_IN_CURATED_ORDER"] = "CONSUMER_INTERESTED_IN_CURATED_ORDER";
  MessageRichCardType["NEW_EXPERT_CURATED_ITEMS"] = "NEW_EXPERT_CURATED_ITEMS";
  MessageRichCardType["NEW_SYSTEM_CURATED_ITEMS"] = "NEW_SYSTEM_CURATED_ITEMS";
  MessageRichCardType["UPDATED_EXPERT_CURATED_ITEMS"] = "UPDATED_EXPERT_CURATED_ITEMS";
  MessageRichCardType["FEEDBACK_REQUEST_FROM_EXPERT"] = "FEEDBACK_REQUEST_FROM_EXPERT";
  MessageRichCardType["REFERRAL_REQUEST_FROM_EXPERT"] = "REFERRAL_REQUEST_FROM_EXPERT";
  MessageRichCardType["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
  MessageRichCardType["SIMPLE_CURATED_ORDER"] = "SIMPLE_CURATED_ORDER";
  MessageRichCardType["CONTACT_COLLECTION_REQUEST"] = "CONTACT_COLLECTION_REQUEST";
  MessageRichCardType["GUEST_CHAT_CREATE_REQUEST"] = "GUEST_CHAT_CREATE_REQUEST";
  MessageRichCardType["PAYMENT_VERIFICATION_REQUEST"] = "PAYMENT_VERIFICATION_REQUEST";
  MessageRichCardType["EXPERT_AWAY_AUTO_REPLY"] = "EXPERT_AWAY_AUTO_REPLY";
  MessageRichCardType["SELLABLE_REQUESTED"] = "SELLABLE_REQUESTED";
  MessageRichCardType["SELLABLE_PRICE_MATCH_REQUESTED"] = "SELLABLE_PRICE_MATCH_REQUESTED";
})(MessageRichCardType || (MessageRichCardType = {}));

var MessageUnsubscribeTag;

(function (MessageUnsubscribeTag) {
  MessageUnsubscribeTag["CURATION"] = "CURATION";
  MessageUnsubscribeTag["ONBOARDING"] = "ONBOARDING";
  MessageUnsubscribeTag["MESSAGE_NOTIFICATION"] = "MESSAGE_NOTIFICATION";
  MessageUnsubscribeTag["POST_PURCHASE"] = "POST_PURCHASE";
  MessageUnsubscribeTag["ABANDONED_ORDER"] = "ABANDONED_ORDER";
  MessageUnsubscribeTag["PATH_ONBOARDING"] = "PATH_ONBOARDING";
  MessageUnsubscribeTag["REFERRAL"] = "REFERRAL";
  MessageUnsubscribeTag["LEAD_CAMPAIGN"] = "LEAD_CAMPAIGN";
})(MessageUnsubscribeTag || (MessageUnsubscribeTag = {}));

var MessagingChannelType;

(function (MessagingChannelType) {
  MessagingChannelType["SMS"] = "SMS";
  MessagingChannelType["EMAIL"] = "EMAIL";
  MessagingChannelType["FACEBOOK"] = "FACEBOOK";
  MessagingChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(MessagingChannelType || (MessagingChannelType = {}));

var MessagingUserType;

(function (MessagingUserType) {
  MessagingUserType["USER"] = "USER";
  MessagingUserType["MERCHANT"] = "MERCHANT";
  MessagingUserType["BUSINESS_USER"] = "BUSINESS_USER";
  MessagingUserType["OPERATOR"] = "OPERATOR";
  MessagingUserType["DEAL_BOT"] = "DEAL_BOT";
  MessagingUserType["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
  MessagingUserType["SUPPORT"] = "SUPPORT";
})(MessagingUserType || (MessagingUserType = {}));

var MonetaryAmountDenominationType;

(function (MonetaryAmountDenominationType) {
  /** Return amount in the default denomination (e.g.: dollars and cents, e.g.: "12.34" for $12.34 */
  MonetaryAmountDenominationType["DEFAULT"] = "DEFAULT";
  /** Return amount in the smallest denomination for the given currency (e.g.: "1234" for $12.34) */

  MonetaryAmountDenominationType["SMALLEST"] = "SMALLEST";
})(MonetaryAmountDenominationType || (MonetaryAmountDenominationType = {}));

var NumericPathFlowQuestionDisplayType;

(function (NumericPathFlowQuestionDisplayType) {
  NumericPathFlowQuestionDisplayType["HEIGHT_IN_INCHES"] = "HEIGHT_IN_INCHES";
  NumericPathFlowQuestionDisplayType["STAR_RATING"] = "STAR_RATING";
})(NumericPathFlowQuestionDisplayType || (NumericPathFlowQuestionDisplayType = {}));

var NumericPathFlowQuestionUnitType;

(function (NumericPathFlowQuestionUnitType) {
  NumericPathFlowQuestionUnitType["INCHES"] = "INCHES";
  NumericPathFlowQuestionUnitType["FEET"] = "FEET";
  NumericPathFlowQuestionUnitType["POUNDS"] = "POUNDS";
  NumericPathFlowQuestionUnitType["CENTIMETERS"] = "CENTIMETERS";
  NumericPathFlowQuestionUnitType["KILOGRAMS"] = "KILOGRAMS";
  NumericPathFlowQuestionUnitType["DOLLARS"] = "DOLLARS";
})(NumericPathFlowQuestionUnitType || (NumericPathFlowQuestionUnitType = {}));

var NumericPathFlowQuestionValueType;

(function (NumericPathFlowQuestionValueType) {
  NumericPathFlowQuestionValueType["INTEGER"] = "INTEGER";
  NumericPathFlowQuestionValueType["DECIMAL"] = "DECIMAL";
})(NumericPathFlowQuestionValueType || (NumericPathFlowQuestionValueType = {}));

var NumericRangeDisplayFacetType;

(function (NumericRangeDisplayFacetType) {
  /** Render the number as is */
  NumericRangeDisplayFacetType["DEFAULT"] = "DEFAULT";
  /** Render the number (represented in cents) as USD currency */

  NumericRangeDisplayFacetType["USD_CURRENCY"] = "USD_CURRENCY";
})(NumericRangeDisplayFacetType || (NumericRangeDisplayFacetType = {}));

var OAuthType;

(function (OAuthType) {
  OAuthType["FACEBOOK"] = "FACEBOOK";
  OAuthType["GOOGLE"] = "GOOGLE";
})(OAuthType || (OAuthType = {}));

var OfferState;

(function (OfferState) {
  OfferState["INITIAL"] = "INITIAL";
  OfferState["GENERATED"] = "GENERATED";
  OfferState["ACCEPTED"] = "ACCEPTED";
  OfferState["EXPIRED"] = "EXPIRED";
  OfferState["WITHDRAWN"] = "WITHDRAWN";
})(OfferState || (OfferState = {}));
/**
 * =============
 * Ops UI permission
 * =============
 **/


var OperatorPermission;

(function (OperatorPermission) {
  OperatorPermission["UI_OPS_MANAGE_CATALOG"] = "UI_OPS_MANAGE_CATALOG";
  OperatorPermission["UI_OPS_MANAGE_LEADS"] = "UI_OPS_MANAGE_LEADS";
  OperatorPermission["UI_OPS_MANAGE_CONSUMERS"] = "UI_OPS_MANAGE_CONSUMERS";
  OperatorPermission["UI_OPS_MANAGE_MERCHANTS"] = "UI_OPS_MANAGE_MERCHANTS";
  OperatorPermission["UI_OPS_MANAGE_EXPERTS"] = "UI_OPS_MANAGE_EXPERTS";
  OperatorPermission["UI_OPS_DEVTOOLS"] = "UI_OPS_DEVTOOLS";
  OperatorPermission["UI_OPS_MANAGE_ALL_ORDERS"] = "UI_OPS_MANAGE_ALL_ORDERS";
  OperatorPermission["UI_OPS_MANAGE_PAYROLL"] = "UI_OPS_MANAGE_PAYROLL";
  OperatorPermission["UI_OPS_MANAGE_ASSIGNED_ORDERS"] = "UI_OPS_MANAGE_ASSIGNED_ORDERS";
  OperatorPermission["UI_OPS_RESEARCH_ORDER_FULFILLMENT"] = "UI_OPS_RESEARCH_ORDER_FULFILLMENT";
  OperatorPermission["UI_OPS_FULFILL_ORDERS"] = "UI_OPS_FULFILL_ORDERS";
  OperatorPermission["UI_OPS_TEST_TRIGGER"] = "UI_OPS_TEST_TRIGGER";
  OperatorPermission["UI_OPS_ASSISTANT"] = "UI_OPS_ASSISTANT";
  OperatorPermission["UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF"] = "UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF";
  OperatorPermission["UI_OPS_ORDER_SUPPORT_EXPERIMENT"] = "UI_OPS_ORDER_SUPPORT_EXPERIMENT";
})(OperatorPermission || (OperatorPermission = {}));

var OperatorRole;

(function (OperatorRole) {
  OperatorRole["CATALOG_MANAGER"] = "CATALOG_MANAGER";
  OperatorRole["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
  OperatorRole["LEAD_SUPPORT"] = "LEAD_SUPPORT";
  OperatorRole["ORDER_SUPPORT"] = "ORDER_SUPPORT";
  OperatorRole["SUPER_ADMIN"] = "SUPER_ADMIN";
  OperatorRole["ADMIN"] = "ADMIN";
  OperatorRole["FULFILLMENT_AGENT"] = "FULFILLMENT_AGENT";
  OperatorRole["PAYROLL_MANAGER"] = "PAYROLL_MANAGER";
  OperatorRole["CONTENT_MARKETING_MANAGER"] = "CONTENT_MARKETING_MANAGER";
  OperatorRole["ORDER_SUPPORT_LEAD"] = "ORDER_SUPPORT_LEAD";
  OperatorRole["ORDER_PAYMENT_MANAGER"] = "ORDER_PAYMENT_MANAGER";
  OperatorRole["ORDER_SUPPORT_EXPERIMENT"] = "ORDER_SUPPORT_EXPERIMENT";
})(OperatorRole || (OperatorRole = {}));

var OrderActivityDetailType;

(function (OrderActivityDetailType) {
  OrderActivityDetailType["OPERATOR_ASSIGNED"] = "OPERATOR_ASSIGNED";
  OrderActivityDetailType["MERCHANT_CLAIMED"] = "MERCHANT_CLAIMED";
  OrderActivityDetailType["TRACKING_UPDATED"] = "TRACKING_UPDATED";
  OrderActivityDetailType["TRACKING_REMOVED"] = "TRACKING_REMOVED";
  OrderActivityDetailType["ORDER_ESCALATED"] = "ORDER_ESCALATED";
  OrderActivityDetailType["ITEM_SHIPPED"] = "ITEM_SHIPPED";
  OrderActivityDetailType["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
  OrderActivityDetailType["DEAL_INVENTORY_REQUESTED"] = "DEAL_INVENTORY_REQUESTED";
  OrderActivityDetailType["DEAL_INVENTORY_REQUEST_FAILED"] = "DEAL_INVENTORY_REQUEST_FAILED";
  OrderActivityDetailType["DEAL_INVENTORY_REQUEST_CANCELED"] = "DEAL_INVENTORY_REQUEST_CANCELED";
  OrderActivityDetailType["DEAL_INVENTORY_CLAIMED"] = "DEAL_INVENTORY_CLAIMED";
  OrderActivityDetailType["DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED"] = "DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED";
  OrderActivityDetailType["ITEM_RETURN_REQUESTED"] = "ITEM_RETURN_REQUESTED";
  OrderActivityDetailType["RETURN_SHIPMENT_TRACKING_UPDATED"] = "RETURN_SHIPMENT_TRACKING_UPDATED";
  OrderActivityDetailType["ITEM_RETURN_SHIPPED"] = "ITEM_RETURN_SHIPPED";
  OrderActivityDetailType["ITEM_RETURN_RECEIVED"] = "ITEM_RETURN_RECEIVED";
  OrderActivityDetailType["RETURN_SHIPMENT_TRACKING_REMOVED"] = "RETURN_SHIPMENT_TRACKING_REMOVED";
  OrderActivityDetailType["FULFILLMENT_PROCESS_UPDATED"] = "FULFILLMENT_PROCESS_UPDATED";
  OrderActivityDetailType["ITEM_RECEIVED"] = "ITEM_RECEIVED";
  OrderActivityDetailType["ITEM_ORDER_VERIFICATION"] = "ITEM_ORDER_VERIFICATION";
  OrderActivityDetailType["REFUND_REQUESTED"] = "REFUND_REQUESTED";
  OrderActivityDetailType["REFUND_STATE_UPDATED"] = "REFUND_STATE_UPDATED";
  OrderActivityDetailType["REFUND_AMOUNT_ADJUSTED"] = "REFUND_AMOUNT_ADJUSTED";
  OrderActivityDetailType["ORDER_ADDRESS_CHANGED"] = "ORDER_ADDRESS_CHANGED";
  OrderActivityDetailType["EXPERT_CONTRIBUTION_CHANGED"] = "EXPERT_CONTRIBUTION_CHANGED";
  OrderActivityDetailType["RETURN_DESTINATION_CHANGED"] = "RETURN_DESTINATION_CHANGED";
  OrderActivityDetailType["MERCHANT_REFUND_UPDATED"] = "MERCHANT_REFUND_UPDATED";
  OrderActivityDetailType["CONFIRMED_RETURN_LABEL_SENT"] = "CONFIRMED_RETURN_LABEL_SENT";
})(OrderActivityDetailType || (OrderActivityDetailType = {}));

var OrderChargeableStatusType;

(function (OrderChargeableStatusType) {
  /** The order can be charged */
  OrderChargeableStatusType["CAN_CHARGE"] = "CAN_CHARGE";
  /** The order has already been charged. */

  OrderChargeableStatusType["ALREADY_CHARGED"] = "ALREADY_CHARGED";
  /** The order is empty. */

  OrderChargeableStatusType["EMPTY"] = "EMPTY";
  /** The order requires a shipping address, but none was provided. Not relevant for OrderChargeableUseCase.CHECKOUT */

  OrderChargeableStatusType["NO_SHIPPING_ADDRESS"] = "NO_SHIPPING_ADDRESS";
  /**
  * The order requires a service address, but none was set by the expert. Orders should never reach the customer in
   * this state as the address should be set by the expert beforehand.
  **/

  OrderChargeableStatusType["NO_SERVICE_LOCATION"] = "NO_SERVICE_LOCATION";
  /** The order is expired; the user must reach out to the expert to renew the order. */

  OrderChargeableStatusType["EXPIRED"] = "EXPIRED";
  /**
  * The order requires a minimum amount (e.g.: Orders shipped to Australia need to have at least $125 in the cart)
   * Use the `message` property on `OrderChargeableStatus` to display a message containing the exact amount the user
   * needs.
  **/

  OrderChargeableStatusType["BELOW_MINIMUM_AMOUNT"] = "BELOW_MINIMUM_AMOUNT";
  /**
  * The order is in a preview state (only available for viewing); the user must reach out to the expert to receive
   * a new purchase-able order.
  **/

  OrderChargeableStatusType["IN_PREVIEW"] = "IN_PREVIEW";
})(OrderChargeableStatusType || (OrderChargeableStatusType = {}));

var OrderChargeableUseCase;

(function (OrderChargeableUseCase) {
  /** Checking if the checkout process can be started */
  OrderChargeableUseCase["CHECKOUT"] = "CHECKOUT";
  /** Checking if the order can be purchased (payment provided to stripe/paypal/etc, and order charged) */

  OrderChargeableUseCase["PURCHASE"] = "PURCHASE";
})(OrderChargeableUseCase || (OrderChargeableUseCase = {}));

var OrderCostComponent;

(function (OrderCostComponent) {
  /** Includes the price for AD_HOC, SELLABLE, and BASE_PRICE source types (the core price of what's being purchased) */
  OrderCostComponent["CORE"] = "CORE";
  /** Tip paid to Deal.com experts */

  OrderCostComponent["EXPERT_TIP"] = "EXPERT_TIP";
  /** Fixed gratuity (e.g.: mandatory crew gratuity for charters) */

  OrderCostComponent["GRATUITY"] = "GRATUITY";
  /** Prepaid incidental charges (e.g.: advanced provisional allowance for yacht charters) */

  OrderCostComponent["PREPAID_INCIDENTAL"] = "PREPAID_INCIDENTAL";
  /** Shipping */

  OrderCostComponent["SHIPMENT"] = "SHIPMENT";
  /** Tax */

  OrderCostComponent["TAX_ADJUSTMENTS"] = "TAX_ADJUSTMENTS";
  /** Discounts through promotions */

  OrderCostComponent["DISCOUNT_ADJUSTMENTS"] = "DISCOUNT_ADJUSTMENTS";
  /** Refunds */

  OrderCostComponent["REFUNDS"] = "REFUNDS";
})(OrderCostComponent || (OrderCostComponent = {}));

var OrderEscalationLabel;

(function (OrderEscalationLabel) {
  OrderEscalationLabel["NEED_CONSUMER_INPUT"] = "NEED_CONSUMER_INPUT";
  OrderEscalationLabel["NEED_MERCHANT_INPUT"] = "NEED_MERCHANT_INPUT";
})(OrderEscalationLabel || (OrderEscalationLabel = {}));

var OrderEscalationPriority;

(function (OrderEscalationPriority) {
  OrderEscalationPriority["HIGH"] = "HIGH";
  OrderEscalationPriority["NORMAL"] = "NORMAL";
})(OrderEscalationPriority || (OrderEscalationPriority = {}));

var OrderEscalationSearchSort;

(function (OrderEscalationSearchSort) {
  OrderEscalationSearchSort["CREATED_AT"] = "CREATED_AT";
  OrderEscalationSearchSort["STATUS"] = "STATUS";
  OrderEscalationSearchSort["ORDER_ID"] = "ORDER_ID";
  OrderEscalationSearchSort["USER_ID"] = "USER_ID";
  OrderEscalationSearchSort["PAID_AT"] = "PAID_AT";
})(OrderEscalationSearchSort || (OrderEscalationSearchSort = {}));

var OrderEscalationSource;

(function (OrderEscalationSource) {
  OrderEscalationSource["CONSUMER"] = "CONSUMER";
  OrderEscalationSource["EXPERT"] = "EXPERT";
  OrderEscalationSource["OPERATIONS"] = "OPERATIONS";
})(OrderEscalationSource || (OrderEscalationSource = {}));

var OrderEscalationStatus;

(function (OrderEscalationStatus) {
  OrderEscalationStatus["NEW"] = "NEW";
  OrderEscalationStatus["IN_PROGRESS"] = "IN_PROGRESS";
  OrderEscalationStatus["COMPLETED"] = "COMPLETED";
})(OrderEscalationStatus || (OrderEscalationStatus = {}));

var OrderEscalationType;

(function (OrderEscalationType) {
  OrderEscalationType["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
  OrderEscalationType["MISSING_SPECS"] = "MISSING_SPECS";
  OrderEscalationType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
  OrderEscalationType["CANCELLATION"] = "CANCELLATION";
  OrderEscalationType["RETURN"] = "RETURN";
  OrderEscalationType["EXCHANGE"] = "EXCHANGE";
  OrderEscalationType["MISSING_ITEM"] = "MISSING_ITEM";
  OrderEscalationType["TRACKING_INQUIRY"] = "TRACKING_INQUIRY";
  OrderEscalationType["ORDER_INFORMATION"] = "ORDER_INFORMATION";
  OrderEscalationType["OTHER"] = "OTHER";
})(OrderEscalationType || (OrderEscalationType = {}));

var OrderFulfillmentState;

(function (OrderFulfillmentState) {
  OrderFulfillmentState["NEW"] = "NEW";
  OrderFulfillmentState["CLAIMED"] = "CLAIMED";
  OrderFulfillmentState["READY"] = "READY";
  OrderFulfillmentState["FULFILLED"] = "FULFILLED";
})(OrderFulfillmentState || (OrderFulfillmentState = {}));

var OrderLabel;

(function (OrderLabel) {
  OrderLabel["UNCLAIMED"] = "UNCLAIMED";
  OrderLabel["TRACKING_NEEDED"] = "TRACKING_NEEDED";
  OrderLabel["TRACKING_OVERDUE"] = "TRACKING_OVERDUE";
})(OrderLabel || (OrderLabel = {}));

var OrderLineItemGroupPriceStrategy;

(function (OrderLineItemGroupPriceStrategy) {
  /** This line item has no price, and is strictly added as a grouping line item with the children having prices. */
  OrderLineItemGroupPriceStrategy["IGNORE_SELF_DEFAULT_CHILDREN"] = "IGNORE_SELF_DEFAULT_CHILDREN";
  /** This line item has a price, with the child line item prices being ignored / not respected. */

  OrderLineItemGroupPriceStrategy["ONLY_SELF_IGNORE_CHILDREN"] = "ONLY_SELF_IGNORE_CHILDREN";
})(OrderLineItemGroupPriceStrategy || (OrderLineItemGroupPriceStrategy = {}));

var OrderLineItemGroupTaxStrategy;

(function (OrderLineItemGroupTaxStrategy) {
  /** All line items will retain their default tax calculation. */
  OrderLineItemGroupTaxStrategy["DEFAULT"] = "DEFAULT";
  /**
  * All line items that are children of the current line item will use the current line item's tax calculation.
   * This is useful when the grouping parent line item is a service (e.g.: charters) that are taxed using the service
   * location - not the shipping address. This strategy will use that same calculation (service location) for all child
   * line items (e.g.: ensure that add-on food line item is taxed like the charter).
  **/

  OrderLineItemGroupTaxStrategy["PROPAGATE_SELF_TO_CHILDREN"] = "PROPAGATE_SELF_TO_CHILDREN";
})(OrderLineItemGroupTaxStrategy || (OrderLineItemGroupTaxStrategy = {}));

var OrderLineItemSourceType;

(function (OrderLineItemSourceType) {
  /** No additional metadata; ad-hoc line item */
  OrderLineItemSourceType["AD_HOC"] = "AD_HOC";
  /** Line item is linked to a sellable */

  OrderLineItemSourceType["SELLABLE"] = "SELLABLE";
  /** Line item is a child line item, indicating the base price of the parent (primarily used for services) */

  OrderLineItemSourceType["BASE_PRICE"] = "BASE_PRICE";
  /** Line item represents a tip to Deal.com experts */

  OrderLineItemSourceType["EXPERT_TIP"] = "EXPERT_TIP";
  /** Fixed gratuity */

  OrderLineItemSourceType["GRATUITY"] = "GRATUITY";
  /** Prepaid incidental charges */

  OrderLineItemSourceType["PREPAID_INCIDENTAL"] = "PREPAID_INCIDENTAL";
  /** Shipment cost line item */

  OrderLineItemSourceType["SHIPMENT"] = "SHIPMENT";
  /** Refund for one or more items in the order */

  OrderLineItemSourceType["REFUND"] = "REFUND";
})(OrderLineItemSourceType || (OrderLineItemSourceType = {}));

var OrderLineItemState;

(function (OrderLineItemState) {
  OrderLineItemState["PENDING_CLAIM"] = "PENDING_CLAIM";
  OrderLineItemState["CLAIMED"] = "CLAIMED";
  OrderLineItemState["NEW"] = "NEW";
  OrderLineItemState["PAID"] = "PAID";
  OrderLineItemState["READY_TO_CLAIM"] = "READY_TO_CLAIM";
  OrderLineItemState["PENDING_SHIPPING"] = "PENDING_SHIPPING";
  OrderLineItemState["READY"] = "READY";
  OrderLineItemState["RECEIVED"] = "RECEIVED";
  OrderLineItemState["RETURN_PENDING_SHIPPING"] = "RETURN_PENDING_SHIPPING";
  OrderLineItemState["RETURN_REQUESTED"] = "RETURN_REQUESTED";
  OrderLineItemState["RETURN_RECEIVED"] = "RETURN_RECEIVED";
  OrderLineItemState["RETURN_SHIPPED"] = "RETURN_SHIPPED";
  OrderLineItemState["SHIPPED"] = "SHIPPED";
  OrderLineItemState["UNAVAILABLE"] = "UNAVAILABLE";
  OrderLineItemState["CUSTOMIZING"] = "CUSTOMIZING";
})(OrderLineItemState || (OrderLineItemState = {}));

var OrderPreSubmitAction;

(function (OrderPreSubmitAction) {
  OrderPreSubmitAction["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
  OrderPreSubmitAction["ADD_TO_CART"] = "ADD_TO_CART";
  OrderPreSubmitAction["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
})(OrderPreSubmitAction || (OrderPreSubmitAction = {}));

var OrderRefundReason;

(function (OrderRefundReason) {
  OrderRefundReason["DIDNT_LIKE"] = "DIDNT_LIKE";
  OrderRefundReason["NOT_EXPECTED"] = "NOT_EXPECTED";
  OrderRefundReason["WRONG_ITEM"] = "WRONG_ITEM";
  OrderRefundReason["BAD_DESCRIPTION"] = "BAD_DESCRIPTION";
  OrderRefundReason["DEFECTIVE"] = "DEFECTIVE";
  OrderRefundReason["DAMAGED_IN_SHIPPING"] = "DAMAGED_IN_SHIPPING";
  OrderRefundReason["NEVER_ARRIVED"] = "NEVER_ARRIVED";
  OrderRefundReason["ARRIVED_LATE"] = "ARRIVED_LATE";
  OrderRefundReason["UNAPPROVED"] = "UNAPPROVED";
  OrderRefundReason["BAD_WEATHER"] = "BAD_WEATHER";
  OrderRefundReason["EQUIPMENT_MALFUNCTION"] = "EQUIPMENT_MALFUNCTION";
  OrderRefundReason["WRONG_AMOUNT"] = "WRONG_AMOUNT";
  OrderRefundReason["WRONG_SIZE"] = "WRONG_SIZE";
  OrderRefundReason["WRONG_COLOR"] = "WRONG_COLOR";
  OrderRefundReason["DAMAGED_SHIPPING_BOX_OK"] = "DAMAGED_SHIPPING_BOX_OK";
  OrderRefundReason["DAMAGED_SHIPPING_BOX_DAMAGED"] = "DAMAGED_SHIPPING_BOX_DAMAGED";
  OrderRefundReason["UNAVAILABLE_INVENTORY"] = "UNAVAILABLE_INVENTORY";
  OrderRefundReason["REPLACED_INVENTORY"] = "REPLACED_INVENTORY";
  OrderRefundReason["LOST_DURING_SHIPPING"] = "LOST_DURING_SHIPPING";
  OrderRefundReason["UNABLE_TO_EXPEDITE_SHIPPING"] = "UNABLE_TO_EXPEDITE_SHIPPING";
  OrderRefundReason["PRICE_MATCH"] = "PRICE_MATCH";
  OrderRefundReason["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
})(OrderRefundReason || (OrderRefundReason = {}));

var OrderRefundStatus;

(function (OrderRefundStatus) {
  OrderRefundStatus["SUCCESS"] = "SUCCESS";
  OrderRefundStatus["PENDING"] = "PENDING";
  OrderRefundStatus["FAILED"] = "FAILED";
  OrderRefundStatus["REJECTED"] = "REJECTED";
  OrderRefundStatus["CANCELLED"] = "CANCELLED";
})(OrderRefundStatus || (OrderRefundStatus = {}));

var OrderSearchSort;

(function (OrderSearchSort) {
  OrderSearchSort["PAID_AT"] = "PAID_AT";
  OrderSearchSort["CREATED_AT"] = "CREATED_AT";
  OrderSearchSort["EFFECTIVE_ORDER_DATE"] = "EFFECTIVE_ORDER_DATE";
  OrderSearchSort["EFFECTIVE_ORDER_DATE_ASC"] = "EFFECTIVE_ORDER_DATE_ASC";
})(OrderSearchSort || (OrderSearchSort = {}));

var OrderState;

(function (OrderState) {
  OrderState["CART"] = "CART";
  OrderState["CREATED"] = "CREATED";
  OrderState["SUBMITTED"] = "SUBMITTED";
  OrderState["CONSUMER_PAYMENT_PENDING"] = "CONSUMER_PAYMENT_PENDING";
  OrderState["CONSUMER_PAYMENT_IN_REVIEW"] = "CONSUMER_PAYMENT_IN_REVIEW";
  OrderState["CONSUMER_PAYMENT_COMPLETED"] = "CONSUMER_PAYMENT_COMPLETED";
  OrderState["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
  OrderState["CONSUMER_PAYMENT_PARTIAL"] = "CONSUMER_PAYMENT_PARTIAL";
  OrderState["CONSUMER_OVERPAID"] = "CONSUMER_OVERPAID";
  OrderState["CONSUMER_PAYMENT_REFUNDED"] = "CONSUMER_PAYMENT_REFUNDED";
  OrderState["CONSUMER_PAYMENT_CANCELED"] = "CONSUMER_PAYMENT_CANCELED";
})(OrderState || (OrderState = {}));

var PathFlowOnCompleteRedirectLocation;

(function (PathFlowOnCompleteRedirectLocation) {
  /** Reload the current page, this is used for paths that happen in-place */
  PathFlowOnCompleteRedirectLocation["RELOAD_CURRENT_PAGE"] = "RELOAD_CURRENT_PAGE";
  /** Expert profile page with selection screen. Only valid for paths completed with a lead. */

  PathFlowOnCompleteRedirectLocation["EXPERT_PROFILE"] = "EXPERT_PROFILE";
  /** Default inbox page */

  PathFlowOnCompleteRedirectLocation["INBOX"] = "INBOX";
  /** Redirect to login page */

  PathFlowOnCompleteRedirectLocation["LOGIN"] = "LOGIN";
  /** Redirect to the completion page after an application is submitted */

  PathFlowOnCompleteRedirectLocation["APPLY_FINISH"] = "APPLY_FINISH";
  /** Redirect to selected department page */

  PathFlowOnCompleteRedirectLocation["DEPARTMENT_PAGE"] = "DEPARTMENT_PAGE";
  /** Redirect to selected category page */

  PathFlowOnCompleteRedirectLocation["CATEGORY"] = "CATEGORY";
  /**
  * For golf experiment only, a redirect that will take the user back into
   * the path system to add their phone number
  **/

  PathFlowOnCompleteRedirectLocation["PHONE_COLLECTION_PATH"] = "PHONE_COLLECTION_PATH";
})(PathFlowOnCompleteRedirectLocation || (PathFlowOnCompleteRedirectLocation = {}));

var PathFlowPageMetadataType;

(function (PathFlowPageMetadataType) {
  PathFlowPageMetadataType["INTERSTITIAL"] = "INTERSTITIAL";
  PathFlowPageMetadataType["CUSTOM"] = "CUSTOM";
  /** Below are deprecated */

  PathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
  PathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
  PathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
  PathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
  PathFlowPageMetadataType["WELCOME"] = "WELCOME";
})(PathFlowPageMetadataType || (PathFlowPageMetadataType = {}));

var PathFlowThemeType;

(function (PathFlowThemeType) {
  PathFlowThemeType["DEFAULT"] = "DEFAULT";
  PathFlowThemeType["SNOWBOARD"] = "SNOWBOARD";
  PathFlowThemeType["CHAT_LIKE"] = "CHAT_LIKE";
})(PathFlowThemeType || (PathFlowThemeType = {}));

var PathValidationErrorTag;

(function (PathValidationErrorTag) {
  /** If this error is produced, the client must have the user login, or change the contact information being used to proceed */
  PathValidationErrorTag["REQUIRES_LOGIN_TO_PROCEED"] = "REQUIRES_LOGIN_TO_PROCEED";
  /** Indicates an internal error, typically surfaced if the API is misused, or some type of developer/administrative error. */

  PathValidationErrorTag["INTERNAL"] = "INTERNAL";
})(PathValidationErrorTag || (PathValidationErrorTag = {}));

var PayComponentType;

(function (PayComponentType) {
  PayComponentType["COMMISSION"] = "COMMISSION";
  PayComponentType["QUALITY_CONVERSATION"] = "QUALITY_CONVERSATION";
  PayComponentType["TIP"] = "TIP";
  PayComponentType["FIRST_SHIFTS_GUARANTEED_PAY"] = "FIRST_SHIFTS_GUARANTEED_PAY";
  PayComponentType["HOURLY_ON_CALL"] = "HOURLY_ON_CALL";
  PayComponentType["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
  PayComponentType["REFERRAL_FIRST_ORDER"] = "REFERRAL_FIRST_ORDER";
})(PayComponentType || (PayComponentType = {}));

var PayLineItemSortField;

(function (PayLineItemSortField) {
  PayLineItemSortField["PAY_COMPONENT_TYPE"] = "PAY_COMPONENT_TYPE";
  PayLineItemSortField["POSTED_AT"] = "POSTED_AT";
  PayLineItemSortField["AMOUNT"] = "AMOUNT";
})(PayLineItemSortField || (PayLineItemSortField = {}));

var PaymentActivityType;

(function (PaymentActivityType) {
  PaymentActivityType["FULL_PAYMENT"] = "FULL_PAYMENT";
  PaymentActivityType["DEPOSIT"] = "DEPOSIT";
  PaymentActivityType["REMAINING_BALANCE"] = "REMAINING_BALANCE";
})(PaymentActivityType || (PaymentActivityType = {}));

var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["CARD"] = "CARD";
  PaymentMethod["PAYPAL"] = "PAYPAL";
  PaymentMethod["THREE_D_SECURE"] = "THREE_D_SECURE";
  PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethod["ANDROID_PAY"] = "ANDROID_PAY";
  PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentMethod["PAY_BY_INSTALLMENT"] = "PAY_BY_INSTALLMENT";
  PaymentMethod["WIRE_TRANSFER"] = "WIRE_TRANSFER";
  PaymentMethod["BANK_CHECK"] = "BANK_CHECK";
})(PaymentMethod || (PaymentMethod = {}));

var PaymentProcessorType;

(function (PaymentProcessorType) {
  PaymentProcessorType["STRIPE"] = "STRIPE";
  PaymentProcessorType["PAYPAL"] = "PAYPAL";
  PaymentProcessorType["AFTERPAY"] = "AFTERPAY";
  PaymentProcessorType["AFFIRM"] = "AFFIRM";
  PaymentProcessorType["DEAL"] = "DEAL";
})(PaymentProcessorType || (PaymentProcessorType = {}));

var PaymentSourceStatus;

(function (PaymentSourceStatus) {
  /** indicates the source is archived, for ex: on expiry, account closure, deleting previously saved card */
  PaymentSourceStatus["ARCHIVED"] = "ARCHIVED";
  PaymentSourceStatus["CANCELED"] = "CANCELED";
  /** Only chargeable Source can be used to create a charge */

  PaymentSourceStatus["CHARGEABLE"] = "CHARGEABLE";
  /** This indicates an older Source that is now detached from the user. */

  PaymentSourceStatus["CONSUMED"] = "CONSUMED";
  PaymentSourceStatus["FAILED"] = "FAILED";
  PaymentSourceStatus["PENDING"] = "PENDING";
})(PaymentSourceStatus || (PaymentSourceStatus = {}));
/**
 * Whether this source should be reusable or not. Some source types may or may not be reusable by construction,
 * while other may leave the option at creation. If an incompatible value is passed, an error will be returned.
 **/


var PaymentSourceUsage;

(function (PaymentSourceUsage) {
  PaymentSourceUsage["REUSABLE"] = "REUSABLE";
  PaymentSourceUsage["SINGLE_USE"] = "SINGLE_USE";
})(PaymentSourceUsage || (PaymentSourceUsage = {}));

var PaymentVerificationMethod;

(function (PaymentVerificationMethod) {
  PaymentVerificationMethod["CODE"] = "CODE";
  PaymentVerificationMethod["AMOUNT"] = "AMOUNT";
})(PaymentVerificationMethod || (PaymentVerificationMethod = {}));

var PayoutSortField;

(function (PayoutSortField) {
  PayoutSortField["POSTED_AT"] = "POSTED_AT";
  PayoutSortField["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
  PayoutSortField["COMMISSION_AMOUNT"] = "COMMISSION_AMOUNT";
  PayoutSortField["QUALITY_CONVERSATION_AMOUNT"] = "QUALITY_CONVERSATION_AMOUNT";
  PayoutSortField["TIP_AMOUNT"] = "TIP_AMOUNT";
  PayoutSortField["FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT"] = "FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT";
  PayoutSortField["HOURLY_ON_CALL_AMOUNT"] = "HOURLY_ON_CALL_AMOUNT";
  PayoutSortField["MANUAL_ADJUSTMENT_AMOUNT"] = "MANUAL_ADJUSTMENT_AMOUNT";
})(PayoutSortField || (PayoutSortField = {}));

var PayoutState;

(function (PayoutState) {
  PayoutState["CREATED"] = "CREATED";
  PayoutState["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  PayoutState["APPROVED"] = "APPROVED";
  PayoutState["ERROR"] = "ERROR";
  PayoutState["PAID"] = "PAID";
  PayoutState["ARCHIVED"] = "ARCHIVED";
})(PayoutState || (PayoutState = {}));

var PayStructureRevisionState;

(function (PayStructureRevisionState) {
  PayStructureRevisionState["DRAFT"] = "DRAFT";
  PayStructureRevisionState["ACTIVE"] = "ACTIVE";
  PayStructureRevisionState["PENDING"] = "PENDING";
  PayStructureRevisionState["DEACTIVATED"] = "DEACTIVATED";
})(PayStructureRevisionState || (PayStructureRevisionState = {}));
/**
 * =============
 * this is used in biz-app, we should migrate to BusinessUserPermission
 * =============
 **/


var Permission;

(function (Permission) {
  Permission["UI_OVERWRITE_SELLABLE_PRICE"] = "UI_OVERWRITE_SELLABLE_PRICE";
  Permission["UI_ON_CALL_EXPERT"] = "UI_ON_CALL_EXPERT";
  Permission["UI_ACCEPT_NEW_LEAD"] = "UI_ACCEPT_NEW_LEAD";
})(Permission || (Permission = {}));

var PostalAddressLocationDisplayType;

(function (PostalAddressLocationDisplayType) {
  PostalAddressLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(PostalAddressLocationDisplayType || (PostalAddressLocationDisplayType = {}));

var PresenceStatus;

(function (PresenceStatus) {
  PresenceStatus["ONLINE"] = "ONLINE";
  PresenceStatus["OFFLINE"] = "OFFLINE";
  PresenceStatus["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  PresenceStatus["SMS"] = "SMS";
})(PresenceStatus || (PresenceStatus = {}));

var ProductCondition;

(function (ProductCondition) {
  ProductCondition["NEW"] = "NEW";
  ProductCondition["EXCELLENT"] = "EXCELLENT";
  ProductCondition["GOOD"] = "GOOD";
  ProductCondition["FAIR"] = "FAIR";
})(ProductCondition || (ProductCondition = {}));

var ProductReturnDestination;

(function (ProductReturnDestination) {
  ProductReturnDestination["WAREHOUSE"] = "WAREHOUSE";
  ProductReturnDestination["MERCHANT"] = "MERCHANT";
  ProductReturnDestination["OFFICE"] = "OFFICE";
})(ProductReturnDestination || (ProductReturnDestination = {}));

var ProfileHighlightIconType;

(function (ProfileHighlightIconType) {
  ProfileHighlightIconType["BEER"] = "BEER";
  ProfileHighlightIconType["CAKE"] = "CAKE";
  ProfileHighlightIconType["CALENDAR"] = "CALENDAR";
  ProfileHighlightIconType["CHAT"] = "CHAT";
  ProfileHighlightIconType["CHECK"] = "CHECK";
  ProfileHighlightIconType["COCKTAIL"] = "COCKTAIL";
  ProfileHighlightIconType["DRINK"] = "DRINK";
  ProfileHighlightIconType["GOLF_CLUB"] = "GOLF_CLUB";
  ProfileHighlightIconType["GOLF_CLUB_SET"] = "GOLF_CLUB_SET";
  ProfileHighlightIconType["GOLF_COURSE"] = "GOLF_COURSE";
  ProfileHighlightIconType["HEART"] = "HEART";
  ProfileHighlightIconType["LOCATION"] = "LOCATION";
  ProfileHighlightIconType["DIPLOMA"] = "DIPLOMA";
  ProfileHighlightIconType["SKIER"] = "SKIER";
  ProfileHighlightIconType["SNOWBOARDER"] = "SNOWBOARDER";
  ProfileHighlightIconType["MOUNTAIN"] = "MOUNTAIN";
  ProfileHighlightIconType["SNOWFLAKE"] = "SNOWFLAKE";
  ProfileHighlightIconType["SMILE"] = "SMILE";
  ProfileHighlightIconType["STAR"] = "STAR";
})(ProfileHighlightIconType || (ProfileHighlightIconType = {}));

var ProfileHighlightSource;

(function (ProfileHighlightSource) {
  ProfileHighlightSource["SYSTEM"] = "SYSTEM";
  ProfileHighlightSource["USER"] = "USER";
})(ProfileHighlightSource || (ProfileHighlightSource = {}));

var ProfileHighlightValueType;

(function (ProfileHighlightValueType) {
  ProfileHighlightValueType["TEXT"] = "TEXT";
  ProfileHighlightValueType["ENUMERATION"] = "ENUMERATION";
  ProfileHighlightValueType["DATE"] = "DATE";
})(ProfileHighlightValueType || (ProfileHighlightValueType = {}));

var PromotionActionType;

(function (PromotionActionType) {
  PromotionActionType["PERCENT_OFF_LINE_ITEMS"] = "PERCENT_OFF_LINE_ITEMS";
  PromotionActionType["AMOUNT_OFF_ORDER"] = "AMOUNT_OFF_ORDER";
})(PromotionActionType || (PromotionActionType = {}));

var PromotionDisabledReason;

(function (PromotionDisabledReason) {
  PromotionDisabledReason["MANUAL"] = "MANUAL";
  PromotionDisabledReason["REPLACED"] = "REPLACED";
  PromotionDisabledReason["EXPIRED"] = "EXPIRED";
  PromotionDisabledReason["REACHED_USAGE_LIMIT"] = "REACHED_USAGE_LIMIT";
})(PromotionDisabledReason || (PromotionDisabledReason = {}));

var PromotionQueryFlagType;

(function (PromotionQueryFlagType) {
  /** Surface items including items with this flag set */
  PromotionQueryFlagType["INCLUDE"] = "INCLUDE";
  /** Only surface items with this flag set */

  PromotionQueryFlagType["ONLY"] = "ONLY";
  /** Exclude items with this flag set */

  PromotionQueryFlagType["NONE"] = "NONE";
})(PromotionQueryFlagType || (PromotionQueryFlagType = {}));

var PromotionRuleComparisonOperator;

(function (PromotionRuleComparisonOperator) {
  PromotionRuleComparisonOperator["GREATER_THAN"] = "GREATER_THAN";
  PromotionRuleComparisonOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
  PromotionRuleComparisonOperator["EQUAL"] = "EQUAL";
  PromotionRuleComparisonOperator["LESS_THAN"] = "LESS_THAN";
  PromotionRuleComparisonOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
})(PromotionRuleComparisonOperator || (PromotionRuleComparisonOperator = {}));

var PromotionRuleFilterStrategy;

(function (PromotionRuleFilterStrategy) {
  /**
  * Filtering reduces the scope of the promotion actions. For example, if the rule is to `FILTER` for sellables in
   * the snowboard category, a subsequent promotion action to take 10% off will only take 10% off of the sellables
   * in the snowboard category - not other items in the cart. If no line items fall into the filter criteria, the
   * promotion will not be applied to the order.
  **/
  PromotionRuleFilterStrategy["FILTER"] = "FILTER";
  /**
  * Excluding forces the promotion to not be the order if any of its criteria are met. For example, if the rule is
   * to `EXCLUDE` sellable X, any order with sellable X will not be eligible for the promotion.
  **/

  PromotionRuleFilterStrategy["EXCLUDE"] = "EXCLUDE";
})(PromotionRuleFilterStrategy || (PromotionRuleFilterStrategy = {}));

var PromotionRuleType;

(function (PromotionRuleType) {
  PromotionRuleType["ORDER_AMOUNT"] = "ORDER_AMOUNT";
  PromotionRuleType["SELLABLE_FILTER"] = "SELLABLE_FILTER";
  PromotionRuleType["SELLABLE_CATEGORY_FILTER"] = "SELLABLE_CATEGORY_FILTER";
  PromotionRuleType["SELLABLE_BRAND_FILTER"] = "SELLABLE_BRAND_FILTER";
  PromotionRuleType["SELLABLE_ATTRIBUTE_FILTER"] = "SELLABLE_ATTRIBUTE_FILTER";
  PromotionRuleType["PURCHASED_ORDER_COUNT"] = "PURCHASED_ORDER_COUNT";
  PromotionRuleType["USER_USAGE_LIMIT"] = "USER_USAGE_LIMIT";
})(PromotionRuleType || (PromotionRuleType = {}));

var PromotionSourceType;

(function (PromotionSourceType) {
  PromotionSourceType["REFERRER"] = "REFERRER";
  PromotionSourceType["REFEREE"] = "REFEREE";
})(PromotionSourceType || (PromotionSourceType = {}));

var PromotionState;

(function (PromotionState) {
  PromotionState["DRAFT"] = "DRAFT";
  PromotionState["ACTIVE"] = "ACTIVE";
  PromotionState["DISABLED"] = "DISABLED";
})(PromotionState || (PromotionState = {}));

var RawSellableAttributeValuePatternFlag;

(function (RawSellableAttributeValuePatternFlag) {
  RawSellableAttributeValuePatternFlag["UNIX_LINES"] = "UNIX_LINES";
  RawSellableAttributeValuePatternFlag["CASE_INSENSITIVE"] = "CASE_INSENSITIVE";
  RawSellableAttributeValuePatternFlag["COMMENTS"] = "COMMENTS";
  RawSellableAttributeValuePatternFlag["MULTILINE"] = "MULTILINE";
  RawSellableAttributeValuePatternFlag["LITERAL"] = "LITERAL";
  RawSellableAttributeValuePatternFlag["DOTALL"] = "DOTALL";
  RawSellableAttributeValuePatternFlag["UNICODE_CASE"] = "UNICODE_CASE";
  RawSellableAttributeValuePatternFlag["CANON_EQ"] = "CANON_EQ";
  RawSellableAttributeValuePatternFlag["UNICODE_CHARACTER_CLASS"] = "UNICODE_CHARACTER_CLASS";
})(RawSellableAttributeValuePatternFlag || (RawSellableAttributeValuePatternFlag = {}));

var RawSellableSourceState;

(function (RawSellableSourceState) {
  RawSellableSourceState["ACTIVE"] = "ACTIVE";
  RawSellableSourceState["INACTIVE"] = "INACTIVE";
})(RawSellableSourceState || (RawSellableSourceState = {}));

var RawSellableSourceType;

(function (RawSellableSourceType) {
  RawSellableSourceType["SCRAPER"] = "SCRAPER";
  RawSellableSourceType["DEAL_INVENTORY"] = "DEAL_INVENTORY";
  RawSellableSourceType["GOOGLE_SHOPPING_FEED"] = "GOOGLE_SHOPPING_FEED";
  RawSellableSourceType["GOOGLE_SHOPPING_SEARCH"] = "GOOGLE_SHOPPING_SEARCH";
  RawSellableSourceType["LEVEL9_FEED"] = "LEVEL9_FEED";
  RawSellableSourceType["SHOPIFY"] = "SHOPIFY";
})(RawSellableSourceType || (RawSellableSourceType = {}));

var RawSellableStandardizationActionType;

(function (RawSellableStandardizationActionType) {
  RawSellableStandardizationActionType["SET_CATEGORY"] = "SET_CATEGORY";
  RawSellableStandardizationActionType["SET_ATTRIBUTE_VALUE"] = "SET_ATTRIBUTE_VALUE";
  RawSellableStandardizationActionType["COPY_ATTRIBUTE_VALUE"] = "COPY_ATTRIBUTE_VALUE";
  RawSellableStandardizationActionType["REMOVE_ATTRIBUTE"] = "REMOVE_ATTRIBUTE";
  RawSellableStandardizationActionType["REPLACE_ATTRIBUTE_VALUE"] = "REPLACE_ATTRIBUTE_VALUE";
  RawSellableStandardizationActionType["MARK_OUT_OF_STOCK"] = "MARK_OUT_OF_STOCK";
  RawSellableStandardizationActionType["DEACTIVATE"] = "DEACTIVATE";
  RawSellableStandardizationActionType["HIDE_FROM_CONSUMER_SEARCH"] = "HIDE_FROM_CONSUMER_SEARCH";
  RawSellableStandardizationActionType["SET_TITLE"] = "SET_TITLE";
  RawSellableStandardizationActionType["SET_VARIATION_GROUP_REFERENCE"] = "SET_VARIATION_GROUP_REFERENCE";
  RawSellableStandardizationActionType["SET_BRAND"] = "SET_BRAND";
  RawSellableStandardizationActionType["SET_MPN"] = "SET_MPN";
  RawSellableStandardizationActionType["SET_ATTRIBUTE_VARIATION_DIMENSION"] = "SET_ATTRIBUTE_VARIATION_DIMENSION";
  RawSellableStandardizationActionType["SET_DESCRIPTION"] = "SET_DESCRIPTION";
  RawSellableStandardizationActionType["RENAME_ATTRIBUTE"] = "RENAME_ATTRIBUTE";
  RawSellableStandardizationActionType["MARK_NONE_VARIANT"] = "MARK_NONE_VARIANT";
})(RawSellableStandardizationActionType || (RawSellableStandardizationActionType = {}));

var RawSellableStandardizationRuleConditionType;

(function (RawSellableStandardizationRuleConditionType) {
  RawSellableStandardizationRuleConditionType["LOGICAL"] = "LOGICAL";
  RawSellableStandardizationRuleConditionType["BINARY"] = "BINARY";
  RawSellableStandardizationRuleConditionType["CONSTANT"] = "CONSTANT";
})(RawSellableStandardizationRuleConditionType || (RawSellableStandardizationRuleConditionType = {}));

var RawSellableStandardizationRuleFieldType;

(function (RawSellableStandardizationRuleFieldType) {
  RawSellableStandardizationRuleFieldType["BOOLEAN"] = "BOOLEAN";
  RawSellableStandardizationRuleFieldType["STRING"] = "STRING";
  RawSellableStandardizationRuleFieldType["STRING_LIST"] = "STRING_LIST";
  RawSellableStandardizationRuleFieldType["ID"] = "ID";
  RawSellableStandardizationRuleFieldType["ID_LIST"] = "ID_LIST";
})(RawSellableStandardizationRuleFieldType || (RawSellableStandardizationRuleFieldType = {}));

var RawSellableStandardizationRuleParameterType;

(function (RawSellableStandardizationRuleParameterType) {
  RawSellableStandardizationRuleParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
  RawSellableStandardizationRuleParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
})(RawSellableStandardizationRuleParameterType || (RawSellableStandardizationRuleParameterType = {}));

var RawSellableStandardizationRuleState;

(function (RawSellableStandardizationRuleState) {
  RawSellableStandardizationRuleState["ACTIVE"] = "ACTIVE";
  RawSellableStandardizationRuleState["INACTIVE"] = "INACTIVE";
})(RawSellableStandardizationRuleState || (RawSellableStandardizationRuleState = {}));

var RawSellableState;

(function (RawSellableState) {
  RawSellableState["ACTIVE"] = "ACTIVE";
  RawSellableState["INACTIVE"] = "INACTIVE";
})(RawSellableState || (RawSellableState = {}));

var RecommendedListType;

(function (RecommendedListType) {
  /**
  * Recommendation list built using  a combination of multiple user Attributes learnt from
   * the Path Deal request. More specifically, it uses Gender, Price, Brand, Primary Attributes and other secondary
   * attributes to build this request.
   * The list built only if brand and primary attributes are present in the users request
   * Accessories are explicitly excluded
  **/
  RecommendedListType["MY_TOP_LIST"] = "MY_TOP_LIST";
  /** This is similar to TOP LIST but enforces a strict matching of user request attributes. */

  RecommendedListType["STRICT_MY_TOP_LIST"] = "STRICT_MY_TOP_LIST";
  /**
  * Recommendation list built using price and primary attributes from users path request attributes
   * Each primary attribute has a separate list
   * The list built only if primary attributes are present in the users request
   * Accessories are explicitly excluded
  **/

  RecommendedListType["PRICE_AND_PRIMARY_ATTRIBUTES"] = "PRICE_AND_PRIMARY_ATTRIBUTES";
  /**
  * Recommendation list built using brands and primary attributes from users path request attributes
   * Each brand has a separate list
   * The list built only if brand attributes are present in the users request
   * Accessories are explicitly excluded
  **/

  RecommendedListType["BRAND_AND_PRIMARY_ATTRIBUTES"] = "BRAND_AND_PRIMARY_ATTRIBUTES";
  /**
  * Recommendation list built using accessories selected by the user in the path request
   * Each Accessory has a separate list
  **/

  RecommendedListType["ACCESSORIES"] = "ACCESSORIES";
  /** Recommended list built using curated lists that were recommended to similar users */

  RecommendedListType["CURATED_LIST_TO_SIMILAR_USERS"] = "CURATED_LIST_TO_SIMILAR_USERS";
  /**
  * This recommendation list is used to build a digest of recommendations based on user intent from the deal request
   * The relevancy favors most recent sellables and also favors sellables with price within users budget
   * that has changed recently.
  **/

  RecommendedListType["PRICE_SENSITIVE_INTENT_BASED_DIGEST"] = "PRICE_SENSITIVE_INTENT_BASED_DIGEST";
  /** the recommended list built from a custom list defined by the operator or expert */

  RecommendedListType["CUSTOM"] = "CUSTOM";
})(RecommendedListType || (RecommendedListType = {}));

var ReferralMedium;

(function (ReferralMedium) {
  ReferralMedium["EMAIL"] = "EMAIL";
  ReferralMedium["FACEBOOK"] = "FACEBOOK";
  ReferralMedium["LINK"] = "LINK";
})(ReferralMedium || (ReferralMedium = {}));

var ReferralType;

(function (ReferralType) {
  ReferralType["CONSUMER_GENERIC"] = "CONSUMER_GENERIC";
  ReferralType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
  ReferralType["EXPERT_DIRECT"] = "EXPERT_DIRECT";
})(ReferralType || (ReferralType = {}));

var RegisterCustomerErrorCode;

(function (RegisterCustomerErrorCode) {
  RegisterCustomerErrorCode["ALREADY_REGISTERED"] = "ALREADY_REGISTERED";
  RegisterCustomerErrorCode["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
  RegisterCustomerErrorCode["INVALID_EMAIL_ADDRESS"] = "INVALID_EMAIL_ADDRESS";
})(RegisterCustomerErrorCode || (RegisterCustomerErrorCode = {}));

var ReportAccessScope;

(function (ReportAccessScope) {
  ReportAccessScope["BUSINESS_USER"] = "BUSINESS_USER";
  ReportAccessScope["TEAM"] = "TEAM";
  ReportAccessScope["DEPARTMENT"] = "DEPARTMENT";
  ReportAccessScope["GLOBAL"] = "GLOBAL";
})(ReportAccessScope || (ReportAccessScope = {}));

var ReportColumnFormat;

(function (ReportColumnFormat) {
  ReportColumnFormat["NONE"] = "NONE";
  ReportColumnFormat["PERCENTAGE"] = "PERCENTAGE";
  ReportColumnFormat["CURRENCY"] = "CURRENCY";
})(ReportColumnFormat || (ReportColumnFormat = {}));

var ReportColumnValueType;

(function (ReportColumnValueType) {
  ReportColumnValueType["STRING"] = "STRING";
  ReportColumnValueType["INTEGER"] = "INTEGER";
  ReportColumnValueType["DOUBLE"] = "DOUBLE";
})(ReportColumnValueType || (ReportColumnValueType = {}));

var ReportSchemaType;

(function (ReportSchemaType) {
  /** The total amount of conversations, and the amount of new conversations in the last week. */
  ReportSchemaType["CONVERSATIONS_COUNT"] = "CONVERSATIONS_COUNT";
  /** Stats about expert ratings; total rating count, and average rating score. */

  ReportSchemaType["EXPERT_RATING_STATS"] = "EXPERT_RATING_STATS";
  /** The total amount of curations, and the amount of new curations in the last week. */

  ReportSchemaType["CURATIONS_COUNT"] = "CURATIONS_COUNT";
  /** Most popular brands recommended by experts, grouped by category */

  ReportSchemaType["RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS";
  /**
  * Most popular brands recommended by experts, grouped and rolled up by category
   * linked to department (e.g.: winter sports, golf, etc)
  **/

  ReportSchemaType["RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS";
})(ReportSchemaType || (ReportSchemaType = {}));

var ReturnPolicyType;

(function (ReturnPolicyType) {
  ReturnPolicyType["NO_RETURNS_ACCEPTED"] = "NO_RETURNS_ACCEPTED";
  ReturnPolicyType["STANDARD"] = "STANDARD";
})(ReturnPolicyType || (ReturnPolicyType = {}));

var ReturnRefundMethod;

(function (ReturnRefundMethod) {
  ReturnRefundMethod["ORIGINAL_PAYMENT"] = "ORIGINAL_PAYMENT";
  ReturnRefundMethod["STORE_CREDIT"] = "STORE_CREDIT";
})(ReturnRefundMethod || (ReturnRefundMethod = {}));

var ReturnShippingPaidBy;

(function (ReturnShippingPaidBy) {
  ReturnShippingPaidBy["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  ReturnShippingPaidBy["MERCHANT"] = "MERCHANT";
  ReturnShippingPaidBy["CUSTOMER"] = "CUSTOMER";
})(ReturnShippingPaidBy || (ReturnShippingPaidBy = {}));

var SavedSellableReason;

(function (SavedSellableReason) {
  SavedSellableReason["PRICE"] = "PRICE";
  SavedSellableReason["STYLE"] = "STYLE";
  SavedSellableReason["HIGH_QUALITY"] = "HIGH_QUALITY";
  SavedSellableReason["BRAND"] = "BRAND";
  SavedSellableReason["FEATURES"] = "FEATURES";
})(SavedSellableReason || (SavedSellableReason = {}));

var ScheduledPaymentState;

(function (ScheduledPaymentState) {
  ScheduledPaymentState["SCHEDULED"] = "SCHEDULED";
  ScheduledPaymentState["EXECUTED"] = "EXECUTED";
  ScheduledPaymentState["CANCELED"] = "CANCELED";
})(ScheduledPaymentState || (ScheduledPaymentState = {}));

var SchedulingUserRole;

(function (SchedulingUserRole) {
  SchedulingUserRole["EXPERT"] = "EXPERT";
  SchedulingUserRole["ON_CALL_EXPERT"] = "ON_CALL_EXPERT";
  SchedulingUserRole["CHARTER_EXPERT"] = "CHARTER_EXPERT";
  SchedulingUserRole["ENTRY_EXPERT"] = "ENTRY_EXPERT";
})(SchedulingUserRole || (SchedulingUserRole = {}));

var ScrapingJobType;

(function (ScrapingJobType) {
  ScrapingJobType["SCRAPINGHUB"] = "SCRAPINGHUB";
})(ScrapingJobType || (ScrapingJobType = {}));

var ScrapingSellablePriceSourceSpider;

(function (ScrapingSellablePriceSourceSpider) {
  ScrapingSellablePriceSourceSpider["EVO"] = "EVO";
  ScrapingSellablePriceSourceSpider["PROGOLFYAKIMA"] = "PROGOLFYAKIMA";
  ScrapingSellablePriceSourceSpider["JENSONUSA"] = "JENSONUSA";
  ScrapingSellablePriceSourceSpider["BIKEBLING"] = "BIKEBLING";
  ScrapingSellablePriceSourceSpider["CHAINREACTIONCYCLES"] = "CHAINREACTIONCYCLES";
  ScrapingSellablePriceSourceSpider["CAMBRIABIKE"] = "CAMBRIABIKE";
})(ScrapingSellablePriceSourceSpider || (ScrapingSellablePriceSourceSpider = {}));

var SellableAttributePromotionRuleReferenceComparison;

(function (SellableAttributePromotionRuleReferenceComparison) {
  SellableAttributePromotionRuleReferenceComparison["EQUAL"] = "EQUAL";
  SellableAttributePromotionRuleReferenceComparison["NOT_EQUAL"] = "NOT_EQUAL";
})(SellableAttributePromotionRuleReferenceComparison || (SellableAttributePromotionRuleReferenceComparison = {}));

var SellableBadge;

(function (SellableBadge) {
  /** Used for items in our warehouse to indicate gurantees on delivery estimates. */
  SellableBadge["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
  /** Used for items drop-shipped by manufacturer */

  SellableBadge["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
  /** Used for items whose Sale price is manually overridden and is lower than any of the known price sources */

  SellableBadge["SECRET_DEAL"] = "SECRET_DEAL";
})(SellableBadge || (SellableBadge = {}));

var SellableCategoryFilterPromotionRuleReferenceTraversalOption;

(function (SellableCategoryFilterPromotionRuleReferenceTraversalOption) {
  SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_PARENTS"] = "INCLUDE_PARENTS";
  SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_CHILDREN"] = "INCLUDE_CHILDREN";
})(SellableCategoryFilterPromotionRuleReferenceTraversalOption || (SellableCategoryFilterPromotionRuleReferenceTraversalOption = {}));

var SellablePriceSourceType;

(function (SellablePriceSourceType) {
  SellablePriceSourceType["DEAL"] = "DEAL";
  SellablePriceSourceType["AMAZON"] = "AMAZON";
  SellablePriceSourceType["EBAY"] = "EBAY";
  SellablePriceSourceType["SCRAPING"] = "SCRAPING";
  SellablePriceSourceType["YADAV"] = "YADAV";
  SellablePriceSourceType["RAW_SELLABLE_SCRAPER"] = "RAW_SELLABLE_SCRAPER";
  SellablePriceSourceType["RAW_SELLABLE_FEED"] = "RAW_SELLABLE_FEED";
  SellablePriceSourceType["RAW_SELLABLE_GOOGLE_PRODUCT"] = "RAW_SELLABLE_GOOGLE_PRODUCT";
  SellablePriceSourceType["RAW_SELLABLE_SHOPIFY"] = "RAW_SELLABLE_SHOPIFY";
  SellablePriceSourceType["DEAL_INVENTORY"] = "DEAL_INVENTORY";
  SellablePriceSourceType["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
})(SellablePriceSourceType || (SellablePriceSourceType = {}));

var SellableSearchFacetsQueryFilter;

(function (SellableSearchFacetsQueryFilter) {
  /**
  * Returns facets that have attributes that are marked as PRIMARY in the specific category.
   * In case there are multiple PRIMARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
  **/
  SellableSearchFacetsQueryFilter["FIRST_PRIMARY_ATTRIBUTE_ONLY"] = "FIRST_PRIMARY_ATTRIBUTE_ONLY";
  /** All facets with PRIMARY attributes are returned, ordered by category specific sorting. */

  SellableSearchFacetsQueryFilter["ALL_PRIMARY_ATTRIBUTES"] = "ALL_PRIMARY_ATTRIBUTES";
  /**
  * Returns facets that have attributes that are marked as SECONDARY in the specific category.
   * In case there are multiple SECONDARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
  **/

  SellableSearchFacetsQueryFilter["FIRST_SECONDARY_ATTRIBUTE_ONLY"] = "FIRST_SECONDARY_ATTRIBUTE_ONLY";
  /** All facets with SECONDARY attributes are returned, ordered by category specific sorting. */

  SellableSearchFacetsQueryFilter["ALL_SECONDARY_ATTRIBUTES"] = "ALL_SECONDARY_ATTRIBUTES";
  /** Returns brand facets for the specific category */

  SellableSearchFacetsQueryFilter["INCLUDE_BRANDS"] = "INCLUDE_BRANDS";
  /** Excludes out of stock sellables while building the facets */

  SellableSearchFacetsQueryFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Include gender facet */

  SellableSearchFacetsQueryFilter["INCLUDE_GENDER"] = "INCLUDE_GENDER";
  /** Include Sale price facet as a range */

  SellableSearchFacetsQueryFilter["INCLUDE_SALE_PRICE_RANGE"] = "INCLUDE_SALE_PRICE_RANGE";
  /** Only includes sellables that have discounts */

  SellableSearchFacetsQueryFilter["INCLUDE_DISCOUNTED_ONLY"] = "INCLUDE_DISCOUNTED_ONLY";
})(SellableSearchFacetsQueryFilter || (SellableSearchFacetsQueryFilter = {}));

var SellableSearchFilter;

(function (SellableSearchFilter) {
  /**
  * Returns sellables that have discounts only
   * In addition if the sorting is by relevancy, it boosts the sellables that have their price updated recently
   * higher in the result set.
  **/
  SellableSearchFilter["DISCOUNTED"] = "DISCOUNTED";
  /** Exclude out of stock sellables */

  SellableSearchFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Only show sellables that are in stock in Deal warehouse */

  SellableSearchFilter["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
  /** Only show sellables that are drop-shipped by manufacturer */

  SellableSearchFilter["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
  /**
  * Only show sellables with a deal.
   * A sellable is considered to have a Secret deal if its salePriceOverride is lower than the salePrice of all known sources
  **/

  SellableSearchFilter["SECRET_DEAL"] = "SECRET_DEAL";
})(SellableSearchFilter || (SellableSearchFilter = {}));

var SellableSearchUseCase;

(function (SellableSearchUseCase) {
  SellableSearchUseCase["CONSUMER_SEARCH"] = "CONSUMER_SEARCH";
  SellableSearchUseCase["EXPERT_SEARCH"] = "EXPERT_SEARCH";
  SellableSearchUseCase["IMPERSONATE_CONSUMER"] = "IMPERSONATE_CONSUMER";
  SellableSearchUseCase["OPS_SEARCH"] = "OPS_SEARCH";
  /** This use case for consumer does not take the user intent into account and is basically a simple brand search query */

  SellableSearchUseCase["CONSUMER_HOME_PAGE_BY_BRANDS"] = "CONSUMER_HOME_PAGE_BY_BRANDS";
})(SellableSearchUseCase || (SellableSearchUseCase = {}));

var SellableServiceLocationDisplayType;

(function (SellableServiceLocationDisplayType) {
  SellableServiceLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(SellableServiceLocationDisplayType || (SellableServiceLocationDisplayType = {}));

var SellableSort;

(function (SellableSort) {
  /** Average sale price is calculated as (min + max)/2 for all variations */
  SellableSort["AVG_SALE_PRICE"] = "AVG_SALE_PRICE";
  /** Best offer price is our secret deal price and should only be shown to the experts. */

  SellableSort["BEST_OFFER_PRICE"] = "BEST_OFFER_PRICE";
  /** Savings = actual price - sale price */

  SellableSort["MAX_PRICE_SAVINGS"] = "MAX_PRICE_SAVINGS";
  /** Percent savings = (actual price - sale price)/actual price */

  SellableSort["MAX_PRICE_PERCENT_SAVINGS"] = "MAX_PRICE_PERCENT_SAVINGS";
  /** Defined as the unique page views in the last 7 days */

  SellableSort["POPULARITY"] = "POPULARITY";
  /** Defined as the number of purchases in the last 30 days */

  SellableSort["BEST_SELLER"] = "BEST_SELLER";
  /** Relevance score computed from sellables that match users intent */

  SellableSort["RELEVANCE"] = "RELEVANCE";
  /** sort by times recommended by expert */

  SellableSort["MOST_RECOMMENDED_BY_EXPERTS"] = "MOST_RECOMMENDED_BY_EXPERTS";
  /** This is the fastest way to get results if ordering is not important */

  SellableSort["INDEX_ORDER"] = "INDEX_ORDER";
  /** An stable way to paginate across all indexed documents */

  SellableSort["DOC_ID_ORDER"] = "DOC_ID_ORDER";
})(SellableSort || (SellableSort = {}));

var SellableSourceExternalIdType;

(function (SellableSourceExternalIdType) {
  SellableSourceExternalIdType["YADAV_DIAMOND"] = "YADAV_DIAMOND";
  SellableSourceExternalIdType["YADAV_SETTING"] = "YADAV_SETTING";
})(SellableSourceExternalIdType || (SellableSourceExternalIdType = {}));

var SellableSourceType;

(function (SellableSourceType) {
  SellableSourceType["URL"] = "URL";
  SellableSourceType["EXTERNAL_ID"] = "EXTERNAL_ID";
  SellableSourceType["STANDARDIZED_SELLABLE_GROUP"] = "STANDARDIZED_SELLABLE_GROUP";
})(SellableSourceType || (SellableSourceType = {}));

var SellableType;

(function (SellableType) {
  SellableType["PRODUCT"] = "PRODUCT";
  SellableType["SERVICE"] = "SERVICE";
})(SellableType || (SellableType = {}));

var ShiftAssignmentMode;

(function (ShiftAssignmentMode) {
  ShiftAssignmentMode["CLAIM"] = "CLAIM";
  ShiftAssignmentMode["RESERVE"] = "RESERVE";
  ShiftAssignmentMode["NONE"] = "NONE";
})(ShiftAssignmentMode || (ShiftAssignmentMode = {}));

var ShiftSlotState;

(function (ShiftSlotState) {
  ShiftSlotState["SHIFTS_RESERVED"] = "SHIFTS_RESERVED";
  ShiftSlotState["SHIFTS_OPEN"] = "SHIFTS_OPEN";
})(ShiftSlotState || (ShiftSlotState = {}));

var ShippingMethod;

(function (ShippingMethod) {
  /** Standard ground (default) */
  ShippingMethod["STANDARD"] = "STANDARD";
  /** Expedited shipping */

  ShippingMethod["EXPEDITED"] = "EXPEDITED";
})(ShippingMethod || (ShippingMethod = {}));

var ShippingPolicy;

(function (ShippingPolicy) {
  ShippingPolicy["NO_SHIPPING"] = "NO_SHIPPING";
  ShippingPolicy["FREE_SHIPPING"] = "FREE_SHIPPING";
  ShippingPolicy["PAID_BY_CUSTOMER"] = "PAID_BY_CUSTOMER";
})(ShippingPolicy || (ShippingPolicy = {}));

var ShippingStatus;

(function (ShippingStatus) {
  ShippingStatus["UNKNOWN"] = "UNKNOWN";
  ShippingStatus["IN_TRANSIT"] = "IN_TRANSIT";
  ShippingStatus["DELIVERED"] = "DELIVERED";
  ShippingStatus["FAILURE"] = "FAILURE";
  ShippingStatus["RETURNED"] = "RETURNED";
})(ShippingStatus || (ShippingStatus = {}));

var SimpleCuratedOrderType;

(function (SimpleCuratedOrderType) {
  SimpleCuratedOrderType["EXPERT_CONSULTATION_FEE"] = "EXPERT_CONSULTATION_FEE";
})(SimpleCuratedOrderType || (SimpleCuratedOrderType = {}));

var SocialMediaType;

(function (SocialMediaType) {
  SocialMediaType["FACEBOOK"] = "FACEBOOK";
  SocialMediaType["TWITTER"] = "TWITTER";
  SocialMediaType["LINKEDIN"] = "LINKEDIN";
  SocialMediaType["INSTAGRAM"] = "INSTAGRAM";
  SocialMediaType["PINTEREST"] = "PINTEREST";
  SocialMediaType["YOUTUBE"] = "YOUTUBE";
  SocialMediaType["STRAVA"] = "STRAVA";
})(SocialMediaType || (SocialMediaType = {}));
/** Common ordering context, each query should define its specific sortable fields as enums. */


var SortOrder;

(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));

var StandardizedSellableGroupCandidateState;

(function (StandardizedSellableGroupCandidateState) {
  StandardizedSellableGroupCandidateState["PENDING"] = "PENDING";
  StandardizedSellableGroupCandidateState["ACCEPTED"] = "ACCEPTED";
  StandardizedSellableGroupCandidateState["REJECTED"] = "REJECTED";
})(StandardizedSellableGroupCandidateState || (StandardizedSellableGroupCandidateState = {}));

var StandardizedSellableGroupState;

(function (StandardizedSellableGroupState) {
  StandardizedSellableGroupState["ACTIVE"] = "ACTIVE";
  StandardizedSellableGroupState["INACTIVE"] = "INACTIVE";
})(StandardizedSellableGroupState || (StandardizedSellableGroupState = {}));

var StandardizedSellableState;

(function (StandardizedSellableState) {
  StandardizedSellableState["ACTIVE"] = "ACTIVE";
  StandardizedSellableState["INACTIVE"] = "INACTIVE";
})(StandardizedSellableState || (StandardizedSellableState = {}));

var StringFieldType;

(function (StringFieldType) {
  StringFieldType["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
  StringFieldType["DURATION"] = "DURATION";
})(StringFieldType || (StringFieldType = {}));

var StripeAuthenticationFlow;

(function (StripeAuthenticationFlow) {
  StripeAuthenticationFlow["REDIRECT"] = "redirect";
  StripeAuthenticationFlow["RECEIVER"] = "receiver";
  StripeAuthenticationFlow["CODE_VERIFICATION"] = "code_verification";
  StripeAuthenticationFlow["NONE"] = "none";
})(StripeAuthenticationFlow || (StripeAuthenticationFlow = {}));

var StripeCodeVerificationStatus;

(function (StripeCodeVerificationStatus) {
  StripeCodeVerificationStatus["PENDING"] = "pending";
  StripeCodeVerificationStatus["AWAITING_VERIFICATION"] = "awaiting_verification";
  StripeCodeVerificationStatus["SUCCEEDED"] = "succeeded";
  StripeCodeVerificationStatus["FAILED"] = "failed";
})(StripeCodeVerificationStatus || (StripeCodeVerificationStatus = {}));

var SuggestedActionType;

(function (SuggestedActionType) {
  SuggestedActionType["SEND_INITIAL_RESPONSE"] = "SEND_INITIAL_RESPONSE";
  SuggestedActionType["RESPOND_TO_NEW_MESSAGE"] = "RESPOND_TO_NEW_MESSAGE";
  SuggestedActionType["FOLLOW_UP"] = "FOLLOW_UP";
  SuggestedActionType["SNOOZE"] = "SNOOZE";
  SuggestedActionType["STAR"] = "STAR";
  SuggestedActionType["ARCHIVE"] = "ARCHIVE";
  SuggestedActionType["REQUEST_EXPERT_REVIEW"] = "REQUEST_EXPERT_REVIEW";
  SuggestedActionType["REQUEST_EXPERT_REFERRAL"] = "REQUEST_EXPERT_REFERRAL";
  SuggestedActionType["SEND_CURATION"] = "SEND_CURATION";
  SuggestedActionType["CLASSIFY_ARCHIVED_LEAD"] = "CLASSIFY_ARCHIVED_LEAD";
  SuggestedActionType["REVIEW_SURVEY"] = "REVIEW_SURVEY";
  SuggestedActionType["FULFILL_PROMISE"] = "FULFILL_PROMISE";
  SuggestedActionType["CURATION_VIEWED_FOLLOW_UP"] = "CURATION_VIEWED_FOLLOW_UP";
  SuggestedActionType["SELLABLE_VIEWED_FOLLOW_UP"] = "SELLABLE_VIEWED_FOLLOW_UP";
  SuggestedActionType["PRODUCT_ADDED_TO_CART_FOLLOW_UP"] = "PRODUCT_ADDED_TO_CART_FOLLOW_UP";
})(SuggestedActionType || (SuggestedActionType = {}));

var SuggestedSellableFilter;

(function (SuggestedSellableFilter) {
  /** Whether to exclude out of stock sellables */
  SuggestedSellableFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Only show sellables that are in stock in Deal warehouse */

  SuggestedSellableFilter["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
  /** Only show sellables that are drop-shipped by manufacturer */

  SuggestedSellableFilter["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
  /**
  * Only show sellables with a deal, a sellable is considered to have a Secret deal if its salePriceOverride is
   * lower than the salePrice of all known sources
  **/

  SuggestedSellableFilter["SECRET_DEAL"] = "SECRET_DEAL";
})(SuggestedSellableFilter || (SuggestedSellableFilter = {}));

var SuggestedSellableReviewAnswer;

(function (SuggestedSellableReviewAnswer) {
  SuggestedSellableReviewAnswer["YES"] = "YES";
  SuggestedSellableReviewAnswer["NOT_SURE"] = "NOT_SURE";
  SuggestedSellableReviewAnswer["NO"] = "NO";
})(SuggestedSellableReviewAnswer || (SuggestedSellableReviewAnswer = {}));

var SuggestedSupportAction;

(function (SuggestedSupportAction) {
  SuggestedSupportAction["SUPPORT_RESPONSE_NEEDED"] = "SUPPORT_RESPONSE_NEEDED";
})(SuggestedSupportAction || (SuggestedSupportAction = {}));

var SuggestExpertCuratedItemNotesSort;

(function (SuggestExpertCuratedItemNotesSort) {
  /** Sort by purchase rate, usage count, note length */
  SuggestExpertCuratedItemNotesSort["DEFAULT"] = "DEFAULT";
  /** Sort by usage count, note length */

  SuggestExpertCuratedItemNotesSort["USAGES"] = "USAGES";
})(SuggestExpertCuratedItemNotesSort || (SuggestExpertCuratedItemNotesSort = {}));

var SupportTaskAction;

(function (SupportTaskAction) {
  SupportTaskAction["CREATE_TASK"] = "CREATE_TASK";
  SupportTaskAction["ASSIGN"] = "ASSIGN";
  SupportTaskAction["UNASSIGN"] = "UNASSIGN";
  SupportTaskAction["DISMISS"] = "DISMISS";
  SupportTaskAction["DELEGATE_LEAD"] = "DELEGATE_LEAD";
  SupportTaskAction["REASSIGN_LEAD"] = "REASSIGN_LEAD";
  SupportTaskAction["SUGGEST_LEAD_ACTIONS"] = "SUGGEST_LEAD_ACTIONS";
  SupportTaskAction["ESCALATE_LEAD_FOR_DELEGATION"] = "ESCALATE_LEAD_FOR_DELEGATION";
  SupportTaskAction["ESCALATE_LEAD_FOR_REASSIGNMENT"] = "ESCALATE_LEAD_FOR_REASSIGNMENT";
  SupportTaskAction["REQUEST_ORDER_SUPPORT_FOR_LEAD"] = "REQUEST_ORDER_SUPPORT_FOR_LEAD";
  SupportTaskAction["SNOOZE"] = "SNOOZE";
  SupportTaskAction["UNSNOOZE"] = "UNSNOOZE";
})(SupportTaskAction || (SupportTaskAction = {}));

var SupportTaskListEventType;

(function (SupportTaskListEventType) {
  SupportTaskListEventType["ADD"] = "ADD";
  SupportTaskListEventType["REMOVE"] = "REMOVE";
})(SupportTaskListEventType || (SupportTaskListEventType = {}));

var SupportTaskState;

(function (SupportTaskState) {
  SupportTaskState["PENDING"] = "PENDING";
  SupportTaskState["ASSIGNED"] = "ASSIGNED";
  SupportTaskState["COMPLETED"] = "COMPLETED";
})(SupportTaskState || (SupportTaskState = {}));

var SupportTaskType;

(function (SupportTaskType) {
  SupportTaskType["LEAD"] = "LEAD";
  SupportTaskType["ORDER"] = "ORDER";
})(SupportTaskType || (SupportTaskType = {}));

var SystemCuratedConsumerSellableReactionRating;

(function (SystemCuratedConsumerSellableReactionRating) {
  SystemCuratedConsumerSellableReactionRating["SKIP"] = "SKIP";
  SystemCuratedConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
  SystemCuratedConsumerSellableReactionRating["LIKE"] = "LIKE";
  SystemCuratedConsumerSellableReactionRating["LOVE"] = "LOVE";
})(SystemCuratedConsumerSellableReactionRating || (SystemCuratedConsumerSellableReactionRating = {}));

var SystemCuratedItemSurveyTerminationReason;

(function (SystemCuratedItemSurveyTerminationReason) {
  SystemCuratedItemSurveyTerminationReason["SKIPPED"] = "SKIPPED";
  SystemCuratedItemSurveyTerminationReason["TERMINATED_EARLY"] = "TERMINATED_EARLY";
  SystemCuratedItemSurveyTerminationReason["REVIEWED_ALL"] = "REVIEWED_ALL";
})(SystemCuratedItemSurveyTerminationReason || (SystemCuratedItemSurveyTerminationReason = {}));

var SystemCuratedItemType;

(function (SystemCuratedItemType) {
  SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER";
  SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED";
  SystemCuratedItemType["TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST"] = "TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST";
  SystemCuratedItemType["SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED"] = "SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED";
})(SystemCuratedItemType || (SystemCuratedItemType = {}));

var TagType;

(function (TagType) {
  TagType["BROADCAST_LEAD_QUALITY"] = "BROADCAST_LEAD_QUALITY";
  TagType["BROADCAST_CONVERSION_STRATEGY"] = "BROADCAST_CONVERSION_STRATEGY";
  TagType["BROADCAST_TRUST_STRATEGY"] = "BROADCAST_TRUST_STRATEGY";
  TagType["REMINDER_TASK_TYPE"] = "REMINDER_TASK_TYPE";
})(TagType || (TagType = {}));

var TemplateChangeType;

(function (TemplateChangeType) {
  TemplateChangeType["CREATED"] = "CREATED";
  TemplateChangeType["PUBLISHED"] = "PUBLISHED";
  TemplateChangeType["DEACTIVATED"] = "DEACTIVATED";
  TemplateChangeType["IMPORTED"] = "IMPORTED";
})(TemplateChangeType || (TemplateChangeType = {}));

var TemplateDataModelType;

(function (TemplateDataModelType) {
  TemplateDataModelType["DATA_OBJECT"] = "DATA_OBJECT";
  TemplateDataModelType["CUSTOM_QUERY"] = "CUSTOM_QUERY";
  TemplateDataModelType["NAMED_QUERIES"] = "NAMED_QUERIES";
})(TemplateDataModelType || (TemplateDataModelType = {}));

var TemplateFragmentParameterType;

(function (TemplateFragmentParameterType) {
  TemplateFragmentParameterType["TEXT"] = "TEXT";
  TemplateFragmentParameterType["BOOLEAN"] = "BOOLEAN";
  TemplateFragmentParameterType["OBJECT"] = "OBJECT";
  TemplateFragmentParameterType["IMAGE_URL"] = "IMAGE_URL";
  TemplateFragmentParameterType["ACTION_URL"] = "ACTION_URL";
  TemplateFragmentParameterType["ENUMERATION"] = "ENUMERATION";
})(TemplateFragmentParameterType || (TemplateFragmentParameterType = {}));

var TemplateFragmentType;

(function (TemplateFragmentType) {
  TemplateFragmentType["BLOCK"] = "BLOCK";
  TemplateFragmentType["HEADER"] = "HEADER";
  TemplateFragmentType["FOOTER"] = "FOOTER";
  TemplateFragmentType["BANNER"] = "BANNER";
  TemplateFragmentType["MODULE"] = "MODULE";
  TemplateFragmentType["PAGE_WRAPPER"] = "PAGE_WRAPPER";
  TemplateFragmentType["NONE"] = "NONE";
})(TemplateFragmentType || (TemplateFragmentType = {}));

var TemplateState;

(function (TemplateState) {
  TemplateState["DRAFT"] = "DRAFT";
  TemplateState["PUBLISHED"] = "PUBLISHED";
  TemplateState["DEACTIVATED"] = "DEACTIVATED";
})(TemplateState || (TemplateState = {}));

var TemplateTagSyntax;

(function (TemplateTagSyntax) {
  TemplateTagSyntax["DEFAULT"] = "DEFAULT";
  TemplateTagSyntax["ALTERNATIVE"] = "ALTERNATIVE";
})(TemplateTagSyntax || (TemplateTagSyntax = {}));

var TemplateTypeGroup;

(function (TemplateTypeGroup) {
  TemplateTypeGroup["ONBOARDING"] = "ONBOARDING";
  TemplateTypeGroup["NURTURING"] = "NURTURING";
  TemplateTypeGroup["FEEDBACK"] = "FEEDBACK";
  TemplateTypeGroup["CURATION"] = "CURATION";
  TemplateTypeGroup["EXPERT_ONBOARDING"] = "EXPERT_ONBOARDING";
  TemplateTypeGroup["MESSAGE_ROUTING"] = "MESSAGE_ROUTING";
  TemplateTypeGroup["EXPERT_NOTIFICATION"] = "EXPERT_NOTIFICATION";
  TemplateTypeGroup["POST_PURCHASE"] = "POST_PURCHASE";
  TemplateTypeGroup["CONSUMER_REQUEST"] = "CONSUMER_REQUEST";
  TemplateTypeGroup["CAMPAIGN"] = "CAMPAIGN";
  TemplateTypeGroup["ABANDONED_CART"] = "ABANDONED_CART";
  TemplateTypeGroup["ABANDONED_CHECKOUT"] = "ABANDONED_CHECKOUT";
  TemplateTypeGroup["PATH_DROPOFF"] = "PATH_DROPOFF";
  TemplateTypeGroup["FULFILLMENT"] = "FULFILLMENT";
  TemplateTypeGroup["REFERRAL"] = "REFERRAL";
})(TemplateTypeGroup || (TemplateTypeGroup = {}));

var ThreeDSecureVerification;

(function (ThreeDSecureVerification) {
  /** 3D Secure is required, and the process must be completed for a charge to be successful. */
  ThreeDSecureVerification["REQUIRED"] = "REQUIRED";
  /**
  * 3D Secure is recommended. The process is not required, but it is highly recommended and
   * has minimal impact to your conversion rate.
  **/

  ThreeDSecureVerification["RECOMMENDED"] = "RECOMMENDED";
  /**
  * 3D Secure is optional. The process is neither required nor recommended, but it can be performed to
   * help reduce the likelihood of fraud.
  **/

  ThreeDSecureVerification["OPTIONAL"] = "OPTIONAL";
  /** 3D Secure is not supported on this card. Proceed with a regular card payment instead. */

  ThreeDSecureVerification["NOT_SUPPORTED"] = "NOT_SUPPORTED";
})(ThreeDSecureVerification || (ThreeDSecureVerification = {}));

var TicketActivityType;

(function (TicketActivityType) {
  TicketActivityType["TICKET_ASSIGNED"] = "TICKET_ASSIGNED";
  TicketActivityType["TICKET_UNASSIGNED"] = "TICKET_UNASSIGNED";
  TicketActivityType["DUE_DATE_CHANGED"] = "DUE_DATE_CHANGED";
  TicketActivityType["FIELD_UPDATED"] = "FIELD_UPDATED";
})(TicketActivityType || (TicketActivityType = {}));

var TicketPriority;

(function (TicketPriority) {
  TicketPriority["NORMAL"] = "NORMAL";
  TicketPriority["HIGH"] = "HIGH";
})(TicketPriority || (TicketPriority = {}));

var TicketSearchSort;

(function (TicketSearchSort) {
  TicketSearchSort["CREATED_AT"] = "CREATED_AT";
  TicketSearchSort["UPDATED_AT"] = "UPDATED_AT";
  TicketSearchSort["DUE_AT"] = "DUE_AT";
})(TicketSearchSort || (TicketSearchSort = {}));

var TicketStatus;

(function (TicketStatus) {
  TicketStatus["NEW"] = "NEW";
  TicketStatus["ASSIGNED"] = "ASSIGNED";
  TicketStatus["IN_PROGRESS"] = "IN_PROGRESS";
  TicketStatus["RESOLVED"] = "RESOLVED";
  TicketStatus["BLOCKED"] = "BLOCKED";
  TicketStatus["CLOSED"] = "CLOSED";
  TicketStatus["WONT_COMPLETE"] = "WONT_COMPLETE";
})(TicketStatus || (TicketStatus = {}));

var TicketType;

(function (TicketType) {
  TicketType["LINE_ITEM_CLAIM"] = "LINE_ITEM_CLAIM";
  TicketType["UPDATE_TRACKING_INFO"] = "UPDATE_TRACKING_INFO";
  TicketType["ORDER_VERIFICATION"] = "ORDER_VERIFICATION";
  TicketType["PRODUCT_RETURN"] = "PRODUCT_RETURN";
  TicketType["CONSUMER_REFUND"] = "CONSUMER_REFUND";
  TicketType["MERCHANT_REFUND"] = "MERCHANT_REFUND";
})(TicketType || (TicketType = {}));

var TipMethodType;

(function (TipMethodType) {
  TipMethodType["PERCENT_OF_AMOUNT"] = "PERCENT_OF_AMOUNT";
  TipMethodType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(TipMethodType || (TipMethodType = {}));

var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["SUCCESS"] = "SUCCESS";
  TransactionStatus["PENDING"] = "PENDING";
  TransactionStatus["IN_REVIEW"] = "IN_REVIEW";
  TransactionStatus["FAILURE"] = "FAILURE";
  TransactionStatus["REFUNDED"] = "REFUNDED";
  TransactionStatus["OFFLINE"] = "OFFLINE";
})(TransactionStatus || (TransactionStatus = {}));

var TransactionType;

(function (TransactionType) {
  TransactionType["CUSTOMER"] = "CUSTOMER";
  TransactionType["MERCHANT"] = "MERCHANT";
})(TransactionType || (TransactionType = {}));

var TriggerChangeType;

(function (TriggerChangeType) {
  TriggerChangeType["CREATED"] = "CREATED";
  TriggerChangeType["PUBLISHED"] = "PUBLISHED";
  TriggerChangeType["DEACTIVATED"] = "DEACTIVATED";
  TriggerChangeType["ARCHIVED"] = "ARCHIVED";
  TriggerChangeType["IMPORTED"] = "IMPORTED";
})(TriggerChangeType || (TriggerChangeType = {}));

var TriggerConditionType;

(function (TriggerConditionType) {
  TriggerConditionType["LOGICAL"] = "LOGICAL";
  TriggerConditionType["BINARY"] = "BINARY";
  TriggerConditionType["EXPERIMENT"] = "EXPERIMENT";
})(TriggerConditionType || (TriggerConditionType = {}));

var TriggerDelayIntervalType;

(function (TriggerDelayIntervalType) {
  TriggerDelayIntervalType["FIXED"] = "FIXED";
  TriggerDelayIntervalType["DYNAMIC"] = "DYNAMIC";
  TriggerDelayIntervalType["WITH_EXPERIMENT"] = "WITH_EXPERIMENT";
})(TriggerDelayIntervalType || (TriggerDelayIntervalType = {}));

var TriggerDurationUnit;

(function (TriggerDurationUnit) {
  TriggerDurationUnit["SECONDS"] = "SECONDS";
  TriggerDurationUnit["MINUTES"] = "MINUTES";
  TriggerDurationUnit["HOURS"] = "HOURS";
  TriggerDurationUnit["DAYS"] = "DAYS";
})(TriggerDurationUnit || (TriggerDurationUnit = {}));
/**
 * =============================
 * Trigger metadata.
 * =============================
 **/


var TriggerFieldType;

(function (TriggerFieldType) {
  TriggerFieldType["BOOLEAN"] = "BOOLEAN";
  TriggerFieldType["INTEGER"] = "INTEGER";
  TriggerFieldType["DECIMAL"] = "DECIMAL";
  TriggerFieldType["STRING"] = "STRING";
  TriggerFieldType["STRING_LIST"] = "STRING_LIST";
  TriggerFieldType["DATE"] = "DATE";
  TriggerFieldType["ID"] = "ID";
  TriggerFieldType["ID_LIST"] = "ID_LIST";
})(TriggerFieldType || (TriggerFieldType = {}));

var TriggerNodeEdgeType;

(function (TriggerNodeEdgeType) {
  TriggerNodeEdgeType["NEXT"] = "NEXT";
  TriggerNodeEdgeType["TRUE"] = "TRUE";
  TriggerNodeEdgeType["FALSE"] = "FALSE";
})(TriggerNodeEdgeType || (TriggerNodeEdgeType = {}));

var TriggerNodeType;

(function (TriggerNodeType) {
  TriggerNodeType["DELAY"] = "DELAY";
  TriggerNodeType["FILTER"] = "FILTER";
  TriggerNodeType["BRANCH"] = "BRANCH";
  TriggerNodeType["ACTION"] = "ACTION";
  TriggerNodeType["WAIT"] = "WAIT";
})(TriggerNodeType || (TriggerNodeType = {}));

var TriggerParameterType;

(function (TriggerParameterType) {
  TriggerParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
  TriggerParameterType["EVENT_PARAMETER"] = "EVENT_PARAMETER";
  TriggerParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
})(TriggerParameterType || (TriggerParameterType = {}));
/**
 * =============================
 * Trigger instance
 * =============================
 **/


var TriggerState;

(function (TriggerState) {
  TriggerState["DRAFT"] = "DRAFT";
  TriggerState["TEST"] = "TEST";
  TriggerState["PUBLISHED"] = "PUBLISHED";
  TriggerState["DEACTIVATED"] = "DEACTIVATED";
  TriggerState["ARCHIVED"] = "ARCHIVED";
})(TriggerState || (TriggerState = {}));

var UnsavedSellableReason;

(function (UnsavedSellableReason) {
  UnsavedSellableReason["NOT_INTERESTED"] = "NOT_INTERESTED";
  UnsavedSellableReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
  UnsavedSellableReason["LOW_QUALITY"] = "LOW_QUALITY";
  UnsavedSellableReason["UGLY"] = "UGLY";
  UnsavedSellableReason["DONT_NEED"] = "DONT_NEED";
  UnsavedSellableReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
})(UnsavedSellableReason || (UnsavedSellableReason = {}));

var UpdateUserSourceToConsumerReferralErrorCode;

(function (UpdateUserSourceToConsumerReferralErrorCode) {
  UpdateUserSourceToConsumerReferralErrorCode["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
  UpdateUserSourceToConsumerReferralErrorCode["REFERRER_NOT_FOUND"] = "REFERRER_NOT_FOUND";
})(UpdateUserSourceToConsumerReferralErrorCode || (UpdateUserSourceToConsumerReferralErrorCode = {}));

var UserActivityType;

(function (UserActivityType) {
  UserActivityType["ADD_SELLABLE"] = "ADD_SELLABLE";
  UserActivityType["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
  UserActivityType["COMPLETE_ORDER"] = "COMPLETE_ORDER";
  UserActivityType["CURATED_LIST_VIEWED"] = "CURATED_LIST_VIEWED";
  UserActivityType["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
  UserActivityType["REMOVE_SELLABLE"] = "REMOVE_SELLABLE";
  UserActivityType["SEARCH_SELLABLES"] = "SEARCH_SELLABLES";
  UserActivityType["VIEW_CART"] = "VIEW_CART";
  UserActivityType["VIEW_SELLABLE"] = "VIEW_SELLABLE";
  UserActivityType["VOICE_CALL"] = "VOICE_CALL";
  UserActivityType["SAVED_SELLABLE"] = "SAVED_SELLABLE";
  UserActivityType["UNSAVED_SELLABLE"] = "UNSAVED_SELLABLE";
})(UserActivityType || (UserActivityType = {}));

var UserEditErrorCode;

(function (UserEditErrorCode) {
  UserEditErrorCode["FIRST_NAME_REQUIRED"] = "FIRST_NAME_REQUIRED";
  UserEditErrorCode["INVALID_CONTACT"] = "INVALID_CONTACT";
})(UserEditErrorCode || (UserEditErrorCode = {}));

var UserJourneyLeadStageStatus;

(function (UserJourneyLeadStageStatus) {
  UserJourneyLeadStageStatus["NO_CURATION"] = "NO_CURATION";
  UserJourneyLeadStageStatus["CURATION_READY"] = "CURATION_READY";
  UserJourneyLeadStageStatus["OLD_CURATION"] = "OLD_CURATION";
})(UserJourneyLeadStageStatus || (UserJourneyLeadStageStatus = {}));

var UserJourneyOrderStageStatus;

(function (UserJourneyOrderStageStatus) {
  UserJourneyOrderStageStatus["PLACED"] = "PLACED";
  UserJourneyOrderStageStatus["IN_TRANSIT"] = "IN_TRANSIT";
  UserJourneyOrderStageStatus["DELIVERED"] = "DELIVERED";
})(UserJourneyOrderStageStatus || (UserJourneyOrderStageStatus = {}));

var UserJourneyStageType;

(function (UserJourneyStageType) {
  UserJourneyStageType["NEW"] = "NEW";
  UserJourneyStageType["LEAD"] = "LEAD";
  UserJourneyStageType["ORDER"] = "ORDER";
})(UserJourneyStageType || (UserJourneyStageType = {}));

var UserSourceType;

(function (UserSourceType) {
  UserSourceType["ADS"] = "ADS";
  UserSourceType["REFERRAL"] = "REFERRAL";
  UserSourceType["EXPERT_REFERRAL"] = "EXPERT_REFERRAL";
  UserSourceType["PHONE_CALL"] = "PHONE_CALL";
  UserSourceType["SMS"] = "SMS";
  UserSourceType["EMAIL"] = "EMAIL";
  UserSourceType["INVESTOR"] = "INVESTOR";
  UserSourceType["PARTNER"] = "PARTNER";
  UserSourceType["ORGANIC"] = "ORGANIC";
})(UserSourceType || (UserSourceType = {}));

var VerifyPendingAccessContactErrorCode;

(function (VerifyPendingAccessContactErrorCode) {
  VerifyPendingAccessContactErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
})(VerifyPendingAccessContactErrorCode || (VerifyPendingAccessContactErrorCode = {}));

var WorkflowFailureResolution;

(function (WorkflowFailureResolution) {
  WorkflowFailureResolution["RETRY_WORKFLOW"] = "RETRY_WORKFLOW";
  WorkflowFailureResolution["AUTO_ESCALATE"] = "AUTO_ESCALATE";
  WorkflowFailureResolution["MANUAL_ESCALATE"] = "MANUAL_ESCALATE";
})(WorkflowFailureResolution || (WorkflowFailureResolution = {}));

var WorkflowType;

(function (WorkflowType) {
  WorkflowType["BASIC"] = "BASIC";
  WorkflowType["FULFILLMENT"] = "FULFILLMENT";
})(WorkflowType || (WorkflowType = {}));

var MonetaryAmountFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment MonetaryAmount on MonetaryAmount {\n  currency\n  amount\n  amountInSmallestDenomination: amount(denominationType: SMALLEST)\n}\n    "], ["\n    fragment MonetaryAmount on MonetaryAmount {\n  currency\n  amount\n  amountInSmallestDenomination: amount(denominationType: SMALLEST)\n}\n    "])));
var CuratedOrderBusinessLineItemFragmentDoc = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment CuratedOrderBusinessLineItem on OrderLineItem {\n  id\n  title\n  quantity\n  isGroup\n  unitPrice {\n    ...MonetaryAmount\n  }\n  source {\n    type\n    ... on OrderLineItemSellableSource {\n      type\n    }\n  }\n}\n    ", ""], ["\n    fragment CuratedOrderBusinessLineItem on OrderLineItem {\n  id\n  title\n  quantity\n  isGroup\n  unitPrice {\n    ...MonetaryAmount\n  }\n  source {\n    type\n    ... on OrderLineItemSellableSource {\n      type\n    }\n  }\n}\n    ", ""])), MonetaryAmountFragmentDoc);
var CuratedOrderConsumerVariationOptionFragmentDoc = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fragment CuratedOrderConsumerVariationOption on ExpertCuratedOrderVariationOption {\n  sellable {\n    id\n    variants {\n      displayValueHtml\n    }\n  }\n}\n    "], ["\n    fragment CuratedOrderConsumerVariationOption on ExpertCuratedOrderVariationOption {\n  sellable {\n    id\n    variants {\n      displayValueHtml\n    }\n  }\n}\n    "])));
var CuratedOrderConsumerLineItemFragmentDoc = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    fragment CuratedOrderConsumerLineItem on OrderLineItem {\n  id\n  title\n  quantity\n  isGroup\n  unitPrice {\n    ...MonetaryAmount\n  }\n  source {\n    type\n    ... on OrderLineItemSellableSource {\n      type\n    }\n  }\n}\n    ", ""], ["\n    fragment CuratedOrderConsumerLineItem on OrderLineItem {\n  id\n  title\n  quantity\n  isGroup\n  unitPrice {\n    ...MonetaryAmount\n  }\n  source {\n    type\n    ... on OrderLineItemSellableSource {\n      type\n    }\n  }\n}\n    ", ""])), MonetaryAmountFragmentDoc);
var CuratedOrderOperationsLineItemFragmentDoc = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    fragment CuratedOrderOperationsLineItem on OrderLineItem {\n  id\n  title\n  quantity\n  isGroup\n  unitPrice {\n    ...MonetaryAmount\n  }\n  source {\n    type\n    ... on OrderLineItemSellableSource {\n      type\n    }\n  }\n}\n    ", ""], ["\n    fragment CuratedOrderOperationsLineItem on OrderLineItem {\n  id\n  title\n  quantity\n  isGroup\n  unitPrice {\n    ...MonetaryAmount\n  }\n  source {\n    type\n    ... on OrderLineItemSellableSource {\n      type\n    }\n  }\n}\n    ", ""])), MonetaryAmountFragmentDoc);
var CategoryMediaFragmentDoc = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    fragment CategoryMedia on Category {\n  id\n  type\n  name\n  singularDisplayName\n  contentAssets {\n    bannerImages {\n      imageUrl\n    }\n  }\n  department {\n    id\n    slug\n  }\n}\n    "], ["\n    fragment CategoryMedia on Category {\n  id\n  type\n  name\n  singularDisplayName\n  contentAssets {\n    bannerImages {\n      imageUrl\n    }\n  }\n  department {\n    id\n    slug\n  }\n}\n    "])));
var RequestAttributesFragmentDoc = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    fragment RequestAttributes on Attribute {\n  formatted {\n    name\n    displayHtml\n    displayHtmlValues\n  }\n}\n    "], ["\n    fragment RequestAttributes on Attribute {\n  formatted {\n    name\n    displayHtml\n    displayHtmlValues\n  }\n}\n    "])));
var OrderForSimpleCuratedOrderFragmentDoc = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    fragment OrderForSimpleCuratedOrder on Order {\n  id\n  state\n  totalCost {\n    ...MonetaryAmount\n  }\n  tip {\n    ...MonetaryAmount\n  }\n  tipMethod {\n    type\n    ... on TipMethodPercentOfAmount {\n      percentOptions: options {\n        rate\n        maximumAmount {\n          ...MonetaryAmount\n        }\n        minimumAmount {\n          ...MonetaryAmount\n        }\n      }\n    }\n    ... on TipMethodFixedAmount {\n      amountOptions: options {\n        ...MonetaryAmount\n      }\n    }\n  }\n}\n    ", ""], ["\n    fragment OrderForSimpleCuratedOrder on Order {\n  id\n  state\n  totalCost {\n    ...MonetaryAmount\n  }\n  tip {\n    ...MonetaryAmount\n  }\n  tipMethod {\n    type\n    ... on TipMethodPercentOfAmount {\n      percentOptions: options {\n        rate\n        maximumAmount {\n          ...MonetaryAmount\n        }\n        minimumAmount {\n          ...MonetaryAmount\n        }\n      }\n    }\n    ... on TipMethodFixedAmount {\n      amountOptions: options {\n        ...MonetaryAmount\n      }\n    }\n  }\n}\n    ", ""])), MonetaryAmountFragmentDoc);
var GuestConversationMessageFragmentDoc = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    fragment GuestConversationMessage on GuestConversationMessage {\n  id\n  sendBy {\n    id\n    displayName\n  }\n  typeAt\n  sendAt\n  parts {\n    type\n    body\n  }\n}\n    "], ["\n    fragment GuestConversationMessage on GuestConversationMessage {\n  id\n  sendBy {\n    id\n    displayName\n  }\n  typeAt\n  sendAt\n  parts {\n    type\n    body\n  }\n}\n    "])));
var GuestConversationFragmentDoc = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    fragment GuestConversation on GuestConversation {\n  messages {\n    ...GuestConversationMessage\n  }\n  signature\n}\n    ", ""], ["\n    fragment GuestConversation on GuestConversation {\n  messages {\n    ...GuestConversationMessage\n  }\n  signature\n}\n    ", ""])), GuestConversationMessageFragmentDoc);
var MediaFileFragmentDoc = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    fragment MediaFile on MediaFile {\n  id\n  url\n  mimeType\n  size\n  persisted\n}\n    "], ["\n    fragment MediaFile on MediaFile {\n  id\n  url\n  mimeType\n  size\n  persisted\n}\n    "])));
var PersistMediaDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    mutation PersistMedia($input: PersistMediaInput!) {\n  persistMedia(input: $input) {\n    mediaFile {\n      ...MediaFile\n    }\n  }\n}\n    ", ""], ["\n    mutation PersistMedia($input: PersistMediaInput!) {\n  persistMedia(input: $input) {\n    mediaFile {\n      ...MediaFile\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
/**
 * __usePersistMediaMutation__
 *
 * To run a mutation, you first call `usePersistMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistMediaMutation, { data, loading, error }] = usePersistMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

function usePersistMediaMutation(baseOptions) {
  return ApolloReactHooks.useMutation(PersistMediaDocument, baseOptions);
}
var UploadMediaDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    mutation UploadMedia($input: UploadMediaInput!) {\n  uploadMedia(input: $input) {\n    mediaFile {\n      ...MediaFile\n    }\n  }\n}\n    ", ""], ["\n    mutation UploadMedia($input: UploadMediaInput!) {\n  uploadMedia(input: $input) {\n    mediaFile {\n      ...MediaFile\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

function useUploadMediaMutation(baseOptions) {
  return ApolloReactHooks.useMutation(UploadMediaDocument, baseOptions);
}
var ContactCollectionBusinessLeadDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    query ContactCollectionBusinessLead($id: LeadId!) {\n  lead(id: $id) {\n    id\n    consumer {\n      id\n      firstName\n      lastName\n      hasPhoneNumber\n    }\n    expert {\n      id\n      shortName\n    }\n  }\n}\n    "], ["\n    query ContactCollectionBusinessLead($id: LeadId!) {\n  lead(id: $id) {\n    id\n    consumer {\n      id\n      firstName\n      lastName\n      hasPhoneNumber\n    }\n    expert {\n      id\n      shortName\n    }\n  }\n}\n    "])));
var ContactCollectionBusinessLeadComponent = function ContactCollectionBusinessLeadComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ContactCollectionBusinessLeadDocument
  }, props));
};
var ContactCollectionConsumerLeadDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    query ContactCollectionConsumerLead($id: LeadId!) {\n  lead(id: $id) {\n    id\n    consumer {\n      id\n      firstName\n      lastName\n      hasPhoneNumber\n    }\n    expert {\n      id\n      shortName\n    }\n  }\n}\n    "], ["\n    query ContactCollectionConsumerLead($id: LeadId!) {\n  lead(id: $id) {\n    id\n    consumer {\n      id\n      firstName\n      lastName\n      hasPhoneNumber\n    }\n    expert {\n      id\n      shortName\n    }\n  }\n}\n    "])));
var ContactCollectionConsumerLeadComponent = function ContactCollectionConsumerLeadComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ContactCollectionConsumerLeadDocument
  }, props));
};
var ContactCollectionUpdatePhoneDocument = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    mutation ContactCollectionUpdatePhone($input: UpdateUserProfileInput!) {\n  updateUserProfile(input: $input) {\n    errors\n    user {\n      id\n      contacts {\n        id\n        type\n        value\n        verified\n      }\n    }\n  }\n}\n    "], ["\n    mutation ContactCollectionUpdatePhone($input: UpdateUserProfileInput!) {\n  updateUserProfile(input: $input) {\n    errors\n    user {\n      id\n      contacts {\n        id\n        type\n        value\n        verified\n      }\n    }\n  }\n}\n    "])));
var ContactCollectionUpdatePhoneComponent = function ContactCollectionUpdatePhoneComponent(props) {
  return React.createElement(ApolloReactComponents.Mutation, __assign({
    mutation: ContactCollectionUpdatePhoneDocument
  }, props));
};
var CuratedOrderListDocument = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    query CuratedOrderList($id: ExpertCuratedOrderListActivationId!) {\n  expertCuratedOrderListActivation(id: $id) {\n    id\n    active {\n      id\n    }\n    lead {\n      id\n      expert {\n        id\n        displayName\n        shortName\n      }\n      category {\n        id\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n    "], ["\n    query CuratedOrderList($id: ExpertCuratedOrderListActivationId!) {\n  expertCuratedOrderListActivation(id: $id) {\n    id\n    active {\n      id\n    }\n    lead {\n      id\n      expert {\n        id\n        displayName\n        shortName\n      }\n      category {\n        id\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n    "])));
var CuratedOrderListComponent = function CuratedOrderListComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: CuratedOrderListDocument
  }, props));
};
var CustomExpertCuratedOrderMessageDocument = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    query CustomExpertCuratedOrderMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    lead {\n      id\n      expert {\n        id\n        shortName\n      }\n    }\n    items {\n      id\n    }\n    category {\n      id\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n    order {\n      id\n    }\n  }\n}\n    "], ["\n    query CustomExpertCuratedOrderMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    lead {\n      id\n      expert {\n        id\n        shortName\n      }\n    }\n    items {\n      id\n    }\n    category {\n      id\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n    order {\n      id\n    }\n  }\n}\n    "])));
var CustomExpertCuratedOrderMessageComponent = function CustomExpertCuratedOrderMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: CustomExpertCuratedOrderMessageDocument
  }, props));
};
var ExpertJoinedBusinessMessageDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    query ExpertJoinedBusinessMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    shortName\n    department {\n      id\n      topLevelCategory {\n        id\n        singularDisplayName\n      }\n    }\n  }\n}\n    "], ["\n    query ExpertJoinedBusinessMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    shortName\n    department {\n      id\n      topLevelCategory {\n        id\n        singularDisplayName\n      }\n    }\n  }\n}\n    "])));
var ExpertJoinedBusinessMessageComponent = function ExpertJoinedBusinessMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ExpertJoinedBusinessMessageDocument
  }, props));
};
var ExpertJoinedConsumerMessageDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    query ExpertJoinedConsumerMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    shortName\n    vanityId\n    expertProfile {\n      id\n      profilePhoto {\n        id\n        url\n      }\n    }\n    expertAttributes {\n      placeholderExpert\n    }\n    department {\n      id\n      topLevelCategory {\n        id\n        singularDisplayName\n      }\n    }\n  }\n}\n    "], ["\n    query ExpertJoinedConsumerMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    shortName\n    vanityId\n    expertProfile {\n      id\n      profilePhoto {\n        id\n        url\n      }\n    }\n    expertAttributes {\n      placeholderExpert\n    }\n    department {\n      id\n      topLevelCategory {\n        id\n        singularDisplayName\n      }\n    }\n  }\n}\n    "])));
var ExpertJoinedConsumerMessageComponent = function ExpertJoinedConsumerMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ExpertJoinedConsumerMessageDocument
  }, props));
};
var FeedbackRequestBusinessMessageDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    query FeedbackRequestBusinessMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    expert {\n      id\n      vanityId\n      displayName\n      shortName\n      expertProfile {\n        id\n        profilePhoto {\n          ...MediaFile\n        }\n      }\n    }\n    category {\n      id\n      singularDisplayName\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n  }\n}\n    ", ""], ["\n    query FeedbackRequestBusinessMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    expert {\n      id\n      vanityId\n      displayName\n      shortName\n      expertProfile {\n        id\n        profilePhoto {\n          ...MediaFile\n        }\n      }\n    }\n    category {\n      id\n      singularDisplayName\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
/**
 * __useFeedbackRequestBusinessMessageQuery__
 *
 * To run a query within a React component, call `useFeedbackRequestBusinessMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackRequestBusinessMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackRequestBusinessMessageQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */

function useFeedbackRequestBusinessMessageQuery(baseOptions) {
  return ApolloReactHooks.useQuery(FeedbackRequestBusinessMessageDocument, baseOptions);
}
var FeedbackRequestConsumerMessageDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    query FeedbackRequestConsumerMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    expert {\n      id\n      displayName\n      shortName\n      expertProfile {\n        id\n        profilePhoto {\n          ...MediaFile\n        }\n      }\n    }\n    consumer {\n      id\n      expertReviews {\n        id\n        expert {\n          id\n        }\n      }\n    }\n    category {\n      id\n      singularDisplayName\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n  }\n}\n    ", ""], ["\n    query FeedbackRequestConsumerMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    expert {\n      id\n      displayName\n      shortName\n      expertProfile {\n        id\n        profilePhoto {\n          ...MediaFile\n        }\n      }\n    }\n    consumer {\n      id\n      expertReviews {\n        id\n        expert {\n          id\n        }\n      }\n    }\n    category {\n      id\n      singularDisplayName\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
/**
 * __useFeedbackRequestConsumerMessageQuery__
 *
 * To run a query within a React component, call `useFeedbackRequestConsumerMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackRequestConsumerMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackRequestConsumerMessageQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */

function useFeedbackRequestConsumerMessageQuery(baseOptions) {
  return ApolloReactHooks.useQuery(FeedbackRequestConsumerMessageDocument, baseOptions);
}
var GuestChatCategoryDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    query GuestChatCategory($categoryId: CategoryId!) {\n  category(categoryId: $categoryId) {\n    id\n    ancestorWithPath {\n      id\n      name\n      slug\n      startPathUrl\n      department {\n        id\n        slug\n      }\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n  }\n}\n    "], ["\n    query GuestChatCategory($categoryId: CategoryId!) {\n  category(categoryId: $categoryId) {\n    id\n    ancestorWithPath {\n      id\n      name\n      slug\n      startPathUrl\n      department {\n        id\n        slug\n      }\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n    }\n  }\n}\n    "])));
var GuestChatCategoryComponent = function GuestChatCategoryComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: GuestChatCategoryDocument
  }, props));
};
var HowCuratedWorksBusinessMessageDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    query HowCuratedWorksBusinessMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    category {\n      id\n      singularDisplayName\n    }\n  }\n}\n    "], ["\n    query HowCuratedWorksBusinessMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    category {\n      id\n      singularDisplayName\n    }\n  }\n}\n    "])));
var HowCuratedWorksBusinessMessageComponent = function HowCuratedWorksBusinessMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: HowCuratedWorksBusinessMessageDocument
  }, props));
};
var HowCuratedWorksConsumerMessageDocument = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    query HowCuratedWorksConsumerMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    category {\n      id\n      singularDisplayName\n      type\n    }\n  }\n}\n    "], ["\n    query HowCuratedWorksConsumerMessage($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    category {\n      id\n      singularDisplayName\n      type\n    }\n  }\n}\n    "])));
var HowCuratedWorksConsumerMessageComponent = function HowCuratedWorksConsumerMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: HowCuratedWorksConsumerMessageDocument
  }, props));
};
var InterestedInOrderBusinessMessageDocument = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    query InterestedInOrderBusinessMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      title\n      primaryImage {\n        ...MediaFile\n      }\n      lineItems {\n        ...CuratedOrderBusinessLineItem\n      }\n      totalCostBeforeTax {\n        ...MonetaryAmount\n      }\n    }\n    variationOptions {\n      selected\n      sellable {\n        id\n        variants {\n          displayValueHtml\n        }\n      }\n    }\n    lead {\n      id\n      consumer {\n        id\n        firstName\n      }\n    }\n  }\n}\n    ", "\n", "\n", ""], ["\n    query InterestedInOrderBusinessMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      title\n      primaryImage {\n        ...MediaFile\n      }\n      lineItems {\n        ...CuratedOrderBusinessLineItem\n      }\n      totalCostBeforeTax {\n        ...MonetaryAmount\n      }\n    }\n    variationOptions {\n      selected\n      sellable {\n        id\n        variants {\n          displayValueHtml\n        }\n      }\n    }\n    lead {\n      id\n      consumer {\n        id\n        firstName\n      }\n    }\n  }\n}\n    ", "\n", "\n", ""])), MediaFileFragmentDoc, CuratedOrderBusinessLineItemFragmentDoc, MonetaryAmountFragmentDoc);
var InterestedInOrderBusinessMessageComponent = function InterestedInOrderBusinessMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: InterestedInOrderBusinessMessageDocument
  }, props));
};
var InterestedInOrderConsumerMessageDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    query InterestedInOrderConsumerMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      title\n      primaryImage {\n        ...MediaFile\n      }\n      lineItems {\n        ...CuratedOrderConsumerLineItem\n      }\n      totalCostBeforeTax {\n        ...MonetaryAmount\n      }\n    }\n    variationOptions {\n      selected\n      sellable {\n        id\n        variants {\n          displayValueHtml\n        }\n      }\n    }\n    curatedFor {\n      id\n      firstName\n    }\n  }\n}\n    ", "\n", "\n", ""], ["\n    query InterestedInOrderConsumerMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      title\n      primaryImage {\n        ...MediaFile\n      }\n      lineItems {\n        ...CuratedOrderConsumerLineItem\n      }\n      totalCostBeforeTax {\n        ...MonetaryAmount\n      }\n    }\n    variationOptions {\n      selected\n      sellable {\n        id\n        variants {\n          displayValueHtml\n        }\n      }\n    }\n    curatedFor {\n      id\n      firstName\n    }\n  }\n}\n    ", "\n", "\n", ""])), MediaFileFragmentDoc, CuratedOrderConsumerLineItemFragmentDoc, MonetaryAmountFragmentDoc);
var InterestedInOrderConsumerMessageComponent = function InterestedInOrderConsumerMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: InterestedInOrderConsumerMessageDocument
  }, props));
};
var InterestedInOrderOperationsMessageDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    query InterestedInOrderOperationsMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      title\n      primaryImage {\n        ...MediaFile\n      }\n      lineItems {\n        ...CuratedOrderOperationsLineItem\n      }\n      totalCostBeforeTax {\n        ...MonetaryAmount\n      }\n    }\n    variationOptions {\n      selected\n      sellable {\n        id\n        variants {\n          displayValueHtml\n        }\n      }\n    }\n    lead {\n      id\n      consumer {\n        id\n        firstName\n      }\n    }\n  }\n}\n    ", "\n", "\n", ""], ["\n    query InterestedInOrderOperationsMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      title\n      primaryImage {\n        ...MediaFile\n      }\n      lineItems {\n        ...CuratedOrderOperationsLineItem\n      }\n      totalCostBeforeTax {\n        ...MonetaryAmount\n      }\n    }\n    variationOptions {\n      selected\n      sellable {\n        id\n        variants {\n          displayValueHtml\n        }\n      }\n    }\n    lead {\n      id\n      consumer {\n        id\n        firstName\n      }\n    }\n  }\n}\n    ", "\n", "\n", ""])), MediaFileFragmentDoc, CuratedOrderOperationsLineItemFragmentDoc, MonetaryAmountFragmentDoc);
var VerifyPaymentTransactionDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    mutation VerifyPaymentTransaction($input: VerifyPaymentTransactionInput!) {\n  verifyPaymentTransaction(input: $input) {\n    order {\n      id\n      state\n    }\n    error\n    verified\n  }\n}\n    "], ["\n    mutation VerifyPaymentTransaction($input: VerifyPaymentTransactionInput!) {\n  verifyPaymentTransaction(input: $input) {\n    order {\n      id\n      state\n    }\n    error\n    verified\n  }\n}\n    "])));
var VerifyPaymentTransactionComponent = function VerifyPaymentTransactionComponent(props) {
  return React.createElement(ApolloReactComponents.Mutation, __assign({
    mutation: VerifyPaymentTransactionDocument
  }, props));
};
var PaymentVerificationMessageDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    query PaymentVerificationMessage($orderId: OrderId!) {\n  order(id: $orderId) {\n    id\n    state\n    paymentVerificationMethod\n  }\n}\n    "], ["\n    query PaymentVerificationMessage($orderId: OrderId!) {\n  order(id: $orderId) {\n    id\n    state\n    paymentVerificationMethod\n  }\n}\n    "])));
var PaymentVerificationMessageComponent = function PaymentVerificationMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: PaymentVerificationMessageDocument
  }, props));
};
var ProductCurationActivationDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    query ProductCurationActivation($activationId: ExpertCuratedItemActivationId!) {\n  expertCuratedItemActivation(id: $activationId) {\n    id\n    items {\n      id\n    }\n    activated {\n      id\n    }\n    activatedBy {\n      id\n      displayName\n      shortName\n    }\n    lead {\n      id\n      consumer {\n        id\n        messagingUser {\n          id\n        }\n        firstName\n        lastName\n        profilePhoto {\n          ...MediaFile\n        }\n      }\n      category {\n        id\n        name\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n        department {\n          id\n          slug\n        }\n      }\n      conversation {\n        id\n        externalId\n      }\n    }\n  }\n}\n    ", ""], ["\n    query ProductCurationActivation($activationId: ExpertCuratedItemActivationId!) {\n  expertCuratedItemActivation(id: $activationId) {\n    id\n    items {\n      id\n    }\n    activated {\n      id\n    }\n    activatedBy {\n      id\n      displayName\n      shortName\n    }\n    lead {\n      id\n      consumer {\n        id\n        messagingUser {\n          id\n        }\n        firstName\n        lastName\n        profilePhoto {\n          ...MediaFile\n        }\n      }\n      category {\n        id\n        name\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n        department {\n          id\n          slug\n        }\n      }\n      conversation {\n        id\n        externalId\n      }\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
var ProductCurationActivationComponent = function ProductCurationActivationComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ProductCurationActivationDocument
  }, props));
};
var ProductCurationNewDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    query ProductCurationNew($leadId: LeadId!) {\n  expertCuratedItemsForLead(leadId: $leadId) {\n    id\n    items {\n      id\n    }\n  }\n  lead(id: $leadId) {\n    id\n    expert {\n      id\n      displayName\n      shortName\n    }\n    consumer {\n      id\n      firstName\n      lastName\n    }\n    category {\n      id\n      name\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n      department {\n        id\n        slug\n      }\n    }\n    conversation {\n      id\n      externalId\n    }\n  }\n}\n    "], ["\n    query ProductCurationNew($leadId: LeadId!) {\n  expertCuratedItemsForLead(leadId: $leadId) {\n    id\n    items {\n      id\n    }\n  }\n  lead(id: $leadId) {\n    id\n    expert {\n      id\n      displayName\n      shortName\n    }\n    consumer {\n      id\n      firstName\n      lastName\n    }\n    category {\n      id\n      name\n      contentAssets {\n        bannerImages {\n          imageUrl\n        }\n      }\n      department {\n        id\n        slug\n      }\n    }\n    conversation {\n      id\n      externalId\n    }\n  }\n}\n    "])));
var ProductCurationNewComponent = function ProductCurationNewComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ProductCurationNewDocument
  }, props));
};
var ProductQuizBusinessLeadDocument = gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    query ProductQuizBusinessLead($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    consumer {\n      id\n      firstName\n    }\n  }\n}\n    "], ["\n    query ProductQuizBusinessLead($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    consumer {\n      id\n      firstName\n    }\n  }\n}\n    "])));
/**
 * __useProductQuizBusinessLeadQuery__
 *
 * To run a query within a React component, call `useProductQuizBusinessLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuizBusinessLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuizBusinessLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */

function useProductQuizBusinessLeadQuery(baseOptions) {
  return ApolloReactHooks.useQuery(ProductQuizBusinessLeadDocument, baseOptions);
}
var ReferralBusinessMessageDocument = gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    query ReferralBusinessMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    displayName\n    expertProfile {\n      id\n      profilePhoto {\n        ...MediaFile\n      }\n    }\n    department {\n      id\n      displayName\n      topLevelCategory {\n        id\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n    ", ""], ["\n    query ReferralBusinessMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    displayName\n    expertProfile {\n      id\n      profilePhoto {\n        ...MediaFile\n      }\n    }\n    department {\n      id\n      displayName\n      topLevelCategory {\n        id\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
var ReferralBusinessMessageComponent = function ReferralBusinessMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ReferralBusinessMessageDocument
  }, props));
};
var ReferralConsumerMessageDocument = gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    query ReferralConsumerMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    vanityId\n    displayName\n    shortName\n    expertProfile {\n      id\n      profilePhoto {\n        ...MediaFile\n      }\n    }\n    expertAttributes {\n      categories {\n        id\n        singularDisplayName\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n    ", ""], ["\n    query ReferralConsumerMessage($vanityIdOrId: String!) {\n  findExpert(vanityIdOrId: $vanityIdOrId) {\n    id\n    vanityId\n    displayName\n    shortName\n    expertProfile {\n      id\n      profilePhoto {\n        ...MediaFile\n      }\n    }\n    expertAttributes {\n      categories {\n        id\n        singularDisplayName\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
/**
 * __useReferralConsumerMessageQuery__
 *
 * To run a query within a React component, call `useReferralConsumerMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralConsumerMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralConsumerMessageQuery({
 *   variables: {
 *      vanityIdOrId: // value for 'vanityIdOrId'
 *   },
 * });
 */

function useReferralConsumerMessageQuery(baseOptions) {
  return ApolloReactHooks.useQuery(ReferralConsumerMessageDocument, baseOptions);
}
var RequestConfirmationLeadDocument = gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    query RequestConfirmationLead($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    consumer {\n      id\n      firstName\n    }\n    category {\n      ...CategoryMedia\n    }\n    latestRequest {\n      id\n      attributes {\n        ...RequestAttributes\n      }\n    }\n  }\n}\n    ", "\n", ""], ["\n    query RequestConfirmationLead($leadId: LeadId!) {\n  lead(id: $leadId) {\n    id\n    consumer {\n      id\n      firstName\n    }\n    category {\n      ...CategoryMedia\n    }\n    latestRequest {\n      id\n      attributes {\n        ...RequestAttributes\n      }\n    }\n  }\n}\n    ", "\n", ""])), CategoryMediaFragmentDoc, RequestAttributesFragmentDoc);
var RequestConfirmationLeadComponent = function RequestConfirmationLeadComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: RequestConfirmationLeadDocument
  }, props));
};
var SellableForPriceMatchDocument = gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    query SellableForPriceMatch($id: SellableId!) {\n  sellable(id: $id) {\n    id\n    friendlyId\n    slug\n    type\n    images {\n      ...MediaFile\n    }\n    title\n  }\n}\n    ", ""], ["\n    query SellableForPriceMatch($id: SellableId!) {\n  sellable(id: $id) {\n    id\n    friendlyId\n    slug\n    type\n    images {\n      ...MediaFile\n    }\n    title\n  }\n}\n    ", ""])), MediaFileFragmentDoc);
var SellableForPriceMatchComponent = function SellableForPriceMatchComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: SellableForPriceMatchDocument
  }, props));
};
var ServiceCurationMessageDocument = gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    query ServiceCurationMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      primaryImage {\n        ...MediaFile\n      }\n    }\n    variationOptions {\n      enabled\n      sellable {\n        id\n        title\n        descriptionText\n        variants {\n          displayValueHtml\n        }\n      }\n      price {\n        ...MonetaryAmount\n      }\n    }\n  }\n}\n    ", "\n", ""], ["\n    query ServiceCurationMessage($id: ExpertCuratedOrderId!) {\n  expertCuratedOrder(id: $id) {\n    id\n    order {\n      id\n      primaryImage {\n        ...MediaFile\n      }\n    }\n    variationOptions {\n      enabled\n      sellable {\n        id\n        title\n        descriptionText\n        variants {\n          displayValueHtml\n        }\n      }\n      price {\n        ...MonetaryAmount\n      }\n    }\n  }\n}\n    ", "\n", ""])), MediaFileFragmentDoc, MonetaryAmountFragmentDoc);
var ServiceCurationMessageComponent = function ServiceCurationMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: ServiceCurationMessageDocument
  }, props));
};
var SimpleCuratedOrderMessageDocument = gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    query SimpleCuratedOrderMessage($id: SimpleCuratedOrderId!) {\n  simpleCuratedOrder(id: $id) {\n    id\n    curatedFor {\n      id\n      firstName\n    }\n    curator {\n      id\n      displayName\n      shortName\n      expertProfile {\n        id\n        profilePhoto {\n          id\n          url\n        }\n      }\n    }\n    lead {\n      id\n      category {\n        id\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n    order {\n      ...OrderForSimpleCuratedOrder\n    }\n  }\n}\n    ", ""], ["\n    query SimpleCuratedOrderMessage($id: SimpleCuratedOrderId!) {\n  simpleCuratedOrder(id: $id) {\n    id\n    curatedFor {\n      id\n      firstName\n    }\n    curator {\n      id\n      displayName\n      shortName\n      expertProfile {\n        id\n        profilePhoto {\n          id\n          url\n        }\n      }\n    }\n    lead {\n      id\n      category {\n        id\n        contentAssets {\n          bannerImages {\n            imageUrl\n          }\n        }\n      }\n    }\n    order {\n      ...OrderForSimpleCuratedOrder\n    }\n  }\n}\n    ", ""])), OrderForSimpleCuratedOrderFragmentDoc);
var SimpleCuratedOrderMessageComponent = function SimpleCuratedOrderMessageComponent(props) {
  return React.createElement(ApolloReactComponents.Query, __assign({
    query: SimpleCuratedOrderMessageDocument
  }, props));
};
var StartGuestConversationDocument = gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    mutation StartGuestConversation($input: StartGuestConversationInput!) {\n  startGuestConversation(input: $input) {\n    conversation {\n      ...GuestConversation\n    }\n  }\n}\n    ", ""], ["\n    mutation StartGuestConversation($input: StartGuestConversationInput!) {\n  startGuestConversation(input: $input) {\n    conversation {\n      ...GuestConversation\n    }\n  }\n}\n    ", ""])), GuestConversationFragmentDoc);
var StartGuestConversationComponent = function StartGuestConversationComponent(props) {
  return React.createElement(ApolloReactComponents.Mutation, __assign({
    mutation: StartGuestConversationDocument
  }, props));
};
/**
 * __useStartGuestConversationMutation__
 *
 * To run a mutation, you first call `useStartGuestConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGuestConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGuestConversationMutation, { data, loading, error }] = useStartGuestConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

function useStartGuestConversationMutation(baseOptions) {
  return ApolloReactHooks.useMutation(StartGuestConversationDocument, baseOptions);
}
var CreateFirebaseTokenDocument = gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    mutation CreateFirebaseToken($messagingUserId: AnyId!) {\n  createFirebaseToken(input: {messagingUserId: $messagingUserId}) {\n    identityToken\n  }\n}\n    "], ["\n    mutation CreateFirebaseToken($messagingUserId: AnyId!) {\n  createFirebaseToken(input: {messagingUserId: $messagingUserId}) {\n    identityToken\n  }\n}\n    "])));
var CreateFirebaseTokenComponent = function CreateFirebaseTokenComponent(props) {
  return React.createElement(ApolloReactComponents.Mutation, __assign({
    mutation: CreateFirebaseTokenDocument
  }, props));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41;

var styles$f = {"media-breakpoint-sm":"(min-width: 40em)","message":"styles_message__3Z2ym relative","phone-form-content":"styles_phone-form-content__1kyA8","success-form-content":"styles_success-form-content__hssKL p2","phone-form-icon":"styles_phone-form-icon__vUxaR","phone-form-header":"styles_phone-form-header__1z3rz","phone":"styles_phone__1_Y2o flex items-center mt1 mb2","terms":"styles_terms__1t0iE","submit":"styles_submit__2Vstb","mediaBreakpointSm":"(min-width: 40em)","phoneFormContent":"styles_phone-form-content__1kyA8","successFormContent":"styles_success-form-content__hssKL p2","phoneFormIcon":"styles_phone-form-icon__vUxaR","phoneFormHeader":"styles_phone-form-header__1z3rz"};

var BusinessContactCollection = function BusinessContactCollection(_a) {
  var message = _a.message,
      myself = _a.myself;
  var leadId = message.parts[0].body.queryVariables.leadId;
  var textPortion = message.parts.find(function (part) {
    return part.type === 'TEXT';
  });
  return React__default.createElement(ContactCollectionBusinessLeadComponent, {
    variables: {
      id: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var _b = data.lead,
          expert = _b.expert,
          consumer = _b.consumer;
      return React__default.createElement(React__default.Fragment, null, textPortion ? React__default.createElement(MessageBubbleText, {
        myself: myself,
        message: message
      }, textPortion.body.text) : React__default.createElement(MessageBubbleText, {
        myself: myself,
        message: message
      }, consumer.firstName ? "Hey " + consumer.firstName + "! " : "Hey! ", " Enjoying your conversation", expert.shortName ? " with " + expert.shortName + "?" : '?', " Get their help on go - anytime you want! You can turn off text alerts anytime by replying STOP"), React__default.createElement(MessageBubble, {
        message: message,
        className: styles$f.message
      }, React__default.createElement(components.Tooltip, {
        placement: "top",
        message: "This message was sent because the lead did not provide us with a phone number.\n                      If they add their phone number, they will receive your messages as texts on\n                      their phone."
      }), consumer.hasPhoneNumber ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles$f.successFormContent
      }, React__default.createElement("div", {
        className: styles$f.phoneFormIcon
      }, React__default.createElement(Check, {
        width: 32,
        height: 32
      })), React__default.createElement("div", {
        className: styles$f.phoneFormHeader
      }, "Success! The user entered their phone number"))) : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles$f.phoneFormContent
      }, React__default.createElement("div", {
        className: styles$f.phoneFormHeader
      }, "Enter your phone number"), React__default.createElement("div", {
        className: styles$f.phone
      }, "Phone number"), React__default.createElement("div", {
        className: styles$f.terms
      }, "Message and data rates may apply. By submitting, you authorize Curated.com to send you automated text messages to alert you of deals and activity from your expert. You can turn off text alerts anytime by replying STOP.")))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

(function (ToastNotificationType) {
  ToastNotificationType[ToastNotificationType["SUCCESS"] = 0] = "SUCCESS";
  ToastNotificationType[ToastNotificationType["ERROR"] = 1] = "ERROR";
})(exports.ToastNotificationType || (exports.ToastNotificationType = {}));

(function (BusinessRichCardEvents) {
  BusinessRichCardEvents[BusinessRichCardEvents["EDIT_PRODUCT_CURATION"] = 0] = "EDIT_PRODUCT_CURATION";
  BusinessRichCardEvents[BusinessRichCardEvents["EDIT_EXPERIENCE_CURATION"] = 1] = "EDIT_EXPERIENCE_CURATION";
  BusinessRichCardEvents[BusinessRichCardEvents["OPEN_RATED_ITEMS_PANEL"] = 2] = "OPEN_RATED_ITEMS_PANEL";
  BusinessRichCardEvents[BusinessRichCardEvents["OPEN_QUICK_CURATION_FLYOUT"] = 3] = "OPEN_QUICK_CURATION_FLYOUT";
})(exports.BusinessRichCardEvents || (exports.BusinessRichCardEvents = {}));

(function (ConsumerRichCardEvents) {
  ConsumerRichCardEvents[ConsumerRichCardEvents["OPEN_REFERRAL_MODAL"] = 0] = "OPEN_REFERRAL_MODAL";
  ConsumerRichCardEvents[ConsumerRichCardEvents["OPEN_EXPERT_RATING_MODAL"] = 1] = "OPEN_EXPERT_RATING_MODAL";
  ConsumerRichCardEvents[ConsumerRichCardEvents["PATH_CREATE_FROM_CATEGORY_WITH_EXPERT"] = 2] = "PATH_CREATE_FROM_CATEGORY_WITH_EXPERT";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_PRODUCT_CURATION"] = 3] = "VIEW_PRODUCT_CURATION";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_EXPERIENCE_CURATION"] = 4] = "VIEW_EXPERIENCE_CURATION";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_EXPERIENCE_ORDER"] = 5] = "VIEW_EXPERIENCE_ORDER";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_ORDER"] = 6] = "VIEW_ORDER";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_ORDER_CHECKOUT"] = 7] = "VIEW_ORDER_CHECKOUT";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_EXPERT_PROFILE"] = 8] = "VIEW_EXPERT_PROFILE";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_ORDER_SUPPORT"] = 9] = "VIEW_ORDER_SUPPORT";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_ACCOUNT_PAGE"] = 10] = "VIEW_ACCOUNT_PAGE";
  ConsumerRichCardEvents[ConsumerRichCardEvents["VIEW_SELLABLE"] = 11] = "VIEW_SELLABLE";
})(exports.ConsumerRichCardEvents || (exports.ConsumerRichCardEvents = {}));

var RichCardEventEmitterContext = React__default.createContext(undefined);
var RichCardEventEmitterContextConsumer = RichCardEventEmitterContext.Consumer;

var RichCardEventEmitterContextProvider = function RichCardEventEmitterContextProvider(_a) {
  var children = _a.children;
  var eventEmitter = new eventEmitter3();
  return React__default.createElement(RichCardEventEmitterContext.Provider, {
    value: {
      addListener: function addListener(event, action) {
        eventEmitter.addListener(event.toString(), function (data) {
          action(data);
        });
      },
      emitEvent: function emitEvent(_a) {
        var type = _a.type,
            payload = __rest(_a, ["type"]);

        if (eventEmitter.listenerCount(type.toString()) === 0) {
          throw new Error("Rich card event emitted [" + event + "] without valid listener");
        }

        eventEmitter.emit(type.toString(), __assign({
          type: type
        }, payload));
      },
      removeListener: function removeListener(event) {
        eventEmitter.removeListener(event.toString());
      }
    }
  }, children);
};

var useRichCardEventEmitter = function useRichCardEventEmitter() {
  var richCardEventEmitter = React.useContext(RichCardEventEmitterContext);
  return richCardEventEmitter;
};

/**
 * Validate a string as a phone number without a leading country code
 *   e.g. 415 690 8264
 */
function isValidPhoneNumber(phoneNumber) {
  return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(phoneNumber);
}

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Check$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0h32v32H0z"
  }), React__default.createElement("g", {
    stroke: "#009F45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    transform: "translate(1 1)"
  }, React__default.createElement("path", {
    d: "M8 16l4 4 10-10"
  }), React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }))));
});

var styles$g = {"media-breakpoint-sm":"(min-width: 40em)","phone-form":"styles_phone-form__QxL5w","phone-form-content":"styles_phone-form-content__3qkEP","success-form-content":"styles_success-form-content__20XMy","phone-form-icon":"styles_phone-form-icon__1614t","phone-form-header":"styles_phone-form-header__29-GM","phone":"styles_phone__1FGyT","follow-up":"styles_follow-up__3vMjO","follow-up-footer":"styles_follow-up-footer__bAYdF","follow-up-link":"styles_follow-up-link__3MOtb","terms":"styles_terms__1SPn-","submit":"styles_submit__HjbL1","mediaBreakpointSm":"(min-width: 40em)","phoneForm":"styles_phone-form__QxL5w","phoneFormContent":"styles_phone-form-content__3qkEP","successFormContent":"styles_success-form-content__20XMy","phoneFormIcon":"styles_phone-form-icon__1614t","phoneFormHeader":"styles_phone-form-header__29-GM","followUp":"styles_follow-up__3vMjO","followUpFooter":"styles_follow-up-footer__bAYdF","followUpLink":"styles_follow-up-link__3MOtb"};

var ContactCollection = function ContactCollection(_a) {
  var message = _a.message,
      myself = _a.myself;

  var _b = useChatContext(),
      analytics = _b.analytics,
      onToastNotification = _b.onToastNotification;

  var richCardEventEmitter = useRichCardEventEmitter();

  var _c = React.useState(undefined),
      phoneNumber = _c[0],
      setPhoneNumber = _c[1];

  var _d = React.useState(false),
      isPhoneNumberValid = _d[0],
      setIsPhoneNumberValid = _d[1];

  React.useEffect(function () {
    phoneNumber && setIsPhoneNumberValid(isValidPhoneNumber(phoneNumber));
  }, [phoneNumber]);
  var leadId = message.parts[0].body.queryVariables.leadId;
  var textPortion = message.parts.find(function (part) {
    return part.type === 'TEXT';
  });
  return React__default.createElement(ContactCollectionConsumerLeadComponent, {
    variables: {
      id: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var _b = data.lead,
          expert = _b.expert,
          consumer = _b.consumer;
      return React__default.createElement(React__default.Fragment, null, textPortion ? React__default.createElement(MessageBubbleText, {
        myself: myself,
        message: message
      }, textPortion.body.text) : React__default.createElement(MessageBubbleText, {
        myself: myself,
        message: message
      }, consumer.firstName ? "Hey " + consumer.firstName + "! " : "Hey! ", " Enjoying your conversation", expert.shortName ? " with " + expert.shortName + "?" : '?', " Get their help on go - anytime you want! You can turn off text alerts anytime by replying STOP"), React__default.createElement("div", {
        className: styles$g.phoneForm
      }, consumer.hasPhoneNumber ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles$g.successFormContent
      }, React__default.createElement("div", {
        className: styles$g.phoneFormIcon
      }, React__default.createElement(Check$1, {
        width: 32,
        height: 32
      })), React__default.createElement("div", {
        className: styles$g.phoneFormHeader
      }, "Success! Text messaging enabled"), React__default.createElement("div", {
        className: styles$g.followUp
      }, "Now you can call or text", ' ', expert.shortName ? expert.shortName : 'your expert', " anytime, anywhere")), React__default.createElement("div", {
        className: styles$g.followUpFooter
      }, "You can update notification preferences and any information directly from your", ' ', React__default.createElement("div", {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_ACCOUNT_PAGE
          });
        },
        className: styles$g.followUpLink
      }, "Curated account"))) : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles$g.phoneFormContent
      }, React__default.createElement("div", {
        className: styles$g.phoneFormHeader
      }, "Enter your phone number"), React__default.createElement("div", {
        className: styles$g.phone
      }, React__default.createElement(components.PhoneField, {
        label: "",
        errorText: phoneNumber && !isPhoneNumberValid ? 'Please enter a valid phone number' : undefined,
        labelHidden: true,
        autoFocus: true,
        onChange: function onChange(event) {
          return setPhoneNumber(event.target.value.replace(/\D/g, ''));
        },
        placeholder: "Phone number"
      })), React__default.createElement("div", {
        className: styles$g.terms
      }, "Message and data rates may apply. By submitting, you authorize Curated.com to send you automated text messages to alert you of deals and activity from your expert. You can turn off text alerts anytime by replying STOP.")), React__default.createElement(ContactCollectionUpdatePhoneComponent, {
        variables: {
          input: {
            phone: phoneNumber
          }
        },
        onCompleted: function onCompleted(response) {
          if (response && response.updateUserProfile && response.updateUserProfile.errors.length > 0) {
            onToastNotification && onToastNotification(exports.ToastNotificationType.ERROR, response.updateUserProfile.errors.join(', '));
            return false;
          }

          analytics === null || analytics === void 0 ? void 0 : analytics.events.contactCollectionCardSubmitted();
          onToastNotification && onToastNotification(exports.ToastNotificationType.SUCCESS, 'Successfully updated phone number.');
        },
        onError: function onError() {
          onToastNotification && onToastNotification(exports.ToastNotificationType.ERROR, 'Error updating your phone number! Please try again.');
        }
      }, function (contactCollectionUpdatePhone, _a) {
        var loading = _a.loading;
        return React__default.createElement(components.Button, {
          className: styles$g.submit,
          onClick: function onClick() {
            return contactCollectionUpdatePhone();
          },
          disabled: !isPhoneNumberValid || loading
        }, "Submit");
      }))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

var ContactCollectionMessage = function ContactCollectionMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.CONSUMER:
      return React__default.createElement(ContactCollection, __assign({}, props));

    case exports.Application.BUSINESS:
    case exports.Application.OPERATIONS:
      return React__default.createElement(BusinessContactCollection, __assign({}, props));
  }
};

ContactCollectionMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.CONTACT_COLLECTION_REQUEST && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId;
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var BoatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16",
    height: "16"
  }, props), React__default.createElement("title", null, "boat"), React__default.createElement("g", {
    className: styles["nc-icon-wrapper"] || "nc-icon-wrapper",
    stroke: "#000",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, React__default.createElement("path", {
    "data-cap": "butt",
    "data-color": "color-2",
    d: "M2.5 6.5v-3h7l2 3"
  }), React__default.createElement("path", {
    "data-cap": "butt",
    d: "M11.5 14.5h-9l-2-6h15z"
  }), React__default.createElement("path", {
    "data-cap": "butt",
    "data-color": "color-2",
    d: "M4.5 1.5v2"
  })));
});

var styles$h = {"hero":"styles_hero__V7scY relative center","hero-image":"styles_hero-image__uREcr","overlay":"styles_overlay__3XIvZ bold absolute top-0 left-0 right-0 bottom-0 flex flex-column items-center justify-center","heroImage":"styles_hero-image__uREcr"};

var HeroWithImage = function HeroWithImage(_a) {
  var imageUrl = _a.imageUrl,
      heroLabel = _a.heroLabel;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: styles$h.hero
  }, imageUrl && React__default.createElement(components.Image, {
    src: imageUrl,
    width: 384,
    height: 134,
    imgixParams: {
      fit: 'crop'
    },
    className: styles$h.heroImage
  }), heroLabel && React__default.createElement("div", {
    className: styles$h.overlay
  }, heroLabel)));
};

var styles$i = {"cta":"styles_cta__1z5hj p2 center bold block","active-cta":"styles_active-cta__1mMnD","activeCta":"styles_active-cta__1mMnD"};

var CallToAction = function CallToAction(_a) {
  var _b;

  var className = _a.className,
      onClick = _a.onClick,
      children = _a.children,
      props = __rest(_a, ["className", "onClick", "children"]);

  return React__default.createElement(components.Button, __assign({
    variant: "primary-light",
    className: classnames(styles$i.cta, (_b = {}, _b[styles$i.activeCta] = !!onClick, _b), className),
    onClick: onClick
  }, props), children);
};

var styles$j = {"hero":"styles_hero__2i6RL relative center","hero-image":"styles_hero-image__9MYQO","title":"styles_title__3FzfQ bold absolute top-0 left-0 right-0 bottom-0","caption":"styles_caption__3O13A p2 flex items-center","curation-icon":"styles_curation-icon__1zOeg mr1","heroImage":"styles_hero-image__9MYQO","curationIcon":"styles_curation-icon__1zOeg mr1"};

var CuratedOrderList = function CuratedOrderList(_a) {
  var message = _a.message,
      myself = _a.myself;
  var application = useApplicationContext().application;
  var richCardEventEmitter = useRichCardEventEmitter();
  var expertCuratedOrderListActivationId = message.parts[0].body.queryVariables.expertCuratedOrderListActivationId;
  return React__default.createElement(CuratedOrderListComponent, {
    variables: {
      id: expertCuratedOrderListActivationId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrderListActivation) {
      var _b = data.expertCuratedOrderListActivation,
          active = _b.active,
          lead_1 = _b.lead;
      var expertName = lead_1.expert.shortName;
      var itemCount = active.length;
      var category = data.expertCuratedOrderListActivation.lead.category;
      var banner = category && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, expertName, "'s Yacht Charter")
      }), React__default.createElement("div", {
        className: styles$j.caption
      }, React__default.createElement(BoatIcon, {
        className: styles$j.curationIcon
      }), " ", itemCount, " boat and itinerary", ' ', itemCount === 1 ? 'option' : 'options', ' '), application === exports.Application.CONSUMER ? React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_EXPERIENCE_CURATION,
            leadId: lead_1.id
          });
        }
      }, "View " + (itemCount > 1 ? 'Charters' : 'Charter')) : application === exports.Application.BUSINESS ? React__default.createElement(CallToAction, {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.BusinessRichCardEvents.EDIT_EXPERIENCE_CURATION,
            leadId: lead_1.id
          });
        }
      }, "View ", itemCount > 1 ? 'Charters' : 'Charter') : React__default.createElement(CallToAction, null, "View " + (itemCount > 1 ? 'Charters' : 'Charter')));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

CuratedOrderList.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.NEW_EXPERT_CURATED_ORDER_LIST && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderListActivationId;
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var RulerPencilIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: "43",
    height: "46",
    viewBox: "0 0 43 46"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-3-1h48v48H-3z"
  }), React__default.createElement("path", {
    d: "M28 34h14M28 9h14m0 25l-7 9-7-9V1h14zM1 11h8m-8 8h6m-6 8h8m-8 8h6M1 1h16v44H1z",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var PlusIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$6({
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("text", {
    transform: "translate(-1 -220)",
    fill: "#3d4e56",
    fillRule: "evenodd",
    fontFamily: "CircularStd-Book, Circular Std",
    fontSize: "24",
    fontWeight: "300"
  }, React__default.createElement("tspan", {
    x: "0",
    y: "233"
  }, "+")));
});

var styles$k = {"caption":"styles_caption__U8wGO p2 flex items-center","curation-icon":"styles_curation-icon__2Vr-M mr1","icon":"styles_icon__1mVXO mb2","plus-icon":"styles_plus-icon__2Dbqg","curationIcon":"styles_curation-icon__2Vr-M mr1","plusIcon":"styles_plus-icon__2Dbqg"};

var CustomExpertCuratedOrderMessage = function CustomExpertCuratedOrderMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var application = useApplicationContext().application;
  var richCardEventEmitter = useRichCardEventEmitter();
  var expertCuratedOrderId = message.parts[0].body.queryVariables.expertCuratedOrderId;
  return React__default.createElement(CustomExpertCuratedOrderMessageComponent, {
    variables: {
      id: expertCuratedOrderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var _b = data.expertCuratedOrder,
          lead = _b.lead,
          items = _b.items,
          category = _b.category,
          id_1 = _b.order.id;
      var expert = lead.expert;
      var banner = category === null || category === void 0 ? void 0 : category.contentAssets.bannerImages[0];
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, React__default.createElement(RulerPencilIcon, {
          width: 48,
          height: 48,
          className: styles$k.icon
        }), React__default.createElement("div", null, expert.shortName + "'s custom order"))
      }), React__default.createElement("div", {
        className: styles$k.caption
      }, React__default.createElement(PlusIcon, {
        className: styles$k.plusIcon
      }), " ", items.length, ' ', items.length === 1 ? 'item' : 'items', " in order"), application === exports.Application.CONSUMER ? React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_ORDER,
            orderId: id_1
          });
        }
      }, "View custom order") : React__default.createElement("button", {
        className: styles$k.cta
      }, "View custom order"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

CustomExpertCuratedOrderMessage.handlesMessage = function (message) {
  return message.parts[0].type == 'TEMPLATE_CAROUSEL' && (message.parts[0].body.type === 'new-custom-expert-curated-order' || message.parts[0].body.richCardType === MessageRichCardType.NEW_CUSTOM_CURATED_ORDER) && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderId;
};

var styles$l = {"container":"styles_container__2jt2M flex flex-column items-center justify-center","message":"styles_message__ZGrNO","name":"styles_name__2sMIx","category":"styles_category__2UF4Z"};

var ExpertJoinedBusinessMessage = function ExpertJoinedBusinessMessage(_a) {
  var message = _a.message;
  var expertId = message.parts[0].body.queryVariables.expertId;
  return React__default.createElement(ExpertJoinedBusinessMessageComponent, {
    variables: {
      vanityIdOrId: expertId
    }
  }, function (_a) {
    var data = _a.data;

    if (data && data.findExpert) {
      var _b = data.findExpert,
          department = _b.department,
          shortName = _b.shortName;
      var category = department.topLevelCategory;
      return React__default.createElement("div", {
        className: styles$l.container
      }, React__default.createElement("div", {
        className: styles$l.message
      }, React__default.createElement("span", {
        className: styles$l.name
      }, shortName), " joined the conversation"), category && React__default.createElement("div", {
        className: styles$l.category
      }, category.singularDisplayName, " Expert"));
    } else {
      return null;
    }
  });
};

var styles$m = {"container":"styles_container__9ot2R flex flex-column items-center justify-center","message":"styles_message__3RqP4","name":"styles_name__1-PEC","category":"styles_category__14EGb"};

var ExpertJoinedConsumerMessage = function ExpertJoinedConsumerMessage(_a) {
  var message = _a.message;
  var richCardEventEmitter = useRichCardEventEmitter();
  var expertId = message.parts[0].body.queryVariables.expertId;
  return React__default.createElement(ExpertJoinedConsumerMessageComponent, {
    variables: {
      vanityIdOrId: expertId
    }
  }, function (_a) {
    var data = _a.data;

    if (data && data.findExpert) {
      var _b = data.findExpert,
          shortName = _b.shortName,
          department = _b.department,
          expertProfile = _b.expertProfile,
          expertAttributes = _b.expertAttributes,
          vanityId_1 = _b.vanityId;
      var isPlaceholderExpert = expertAttributes && expertAttributes.placeholderExpert;
      var category = department.topLevelCategory;
      return React__default.createElement("div", {
        className: styles$m.container
      }, expertProfile && expertProfile.profilePhoto && React__default.createElement("div", {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_EXPERT_PROFILE,
            vanityIdOrId: vanityId_1 || expertId
          });
        }
      }, React__default.createElement(components.Avatar, {
        size: 64,
        name: shortName,
        src: expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles$m.message
      }, isPlaceholderExpert ? React__default.createElement("span", {
        className: styles$m.name
      }, shortName) : React__default.createElement("span", {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_EXPERT_PROFILE,
            vanityIdOrId: vanityId_1 || expertId
          });
        },
        className: styles$m.name
      }, shortName), ' ', "joined the conversation"), !isPlaceholderExpert && React__default.createElement("div", {
        className: styles$m.category
      }, category.singularDisplayName, " expert"));
    } else {
      return null;
    }
  });
};

var ExpertJoinedMessage = function ExpertJoinedMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.CONSUMER:
      return React__default.createElement(ExpertJoinedConsumerMessage, __assign({}, props));

    case exports.Application.BUSINESS:
    case exports.Application.OPERATIONS:
      return React__default.createElement(ExpertJoinedBusinessMessage, __assign({}, props));
  }
};

ExpertJoinedMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_EXPERT_JOINED && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertId;
};

var styles$n = {"name":"styles_name__1RKZ5 bold mb1","category":"styles_category__3o9B1","avatar-container":"styles_avatar-container__2p20M mb2","avatarContainer":"styles_avatar-container__2p20M mb2"};

/**
 * Note: The consumer implementation has it's own flavor of this, it will be overriden
 * by the custom component passed in from that provider
 */

var FeedbackRequest = function FeedbackRequest(_a) {
  var message = _a.message,
      myself = _a.myself;
  var leadId = message.parts[0].body.queryVariables.leadId;

  var _b = useFeedbackRequestBusinessMessageQuery({
    variables: {
      leadId: leadId
    }
  }),
      data = _b.data,
      loading = _b.loading;

  if (loading) {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Loading...");
  } else if (data && data.lead) {
    var _c = data.lead,
        expert = _c.expert,
        category = _c.category;
    var name_1 = expert.displayName;
    var banner = category && category.contentAssets.bannerImages[0];
    var categoryName = category && category.singularDisplayName;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement(HeroWithImage, {
      imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
      heroLabel: React__default.createElement(React__default.Fragment, null, ' ', expert.expertProfile && expert.expertProfile.profilePhoto && React__default.createElement("div", {
        className: styles$n.avatarContainer
      }, React__default.createElement(components.Avatar, {
        size: 80,
        name: name_1,
        src: expert.expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles$n.name
      }, name_1), React__default.createElement("div", {
        className: styles$n.category
      }, "Your ", categoryName, " Expert"), ' ')
    }), React__default.createElement(CallToAction, null, "Give feedback on " + expert.shortName)));
  } else {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Error loading message!");
  }
};

var styles$o = {"name":"styles_name__1dri3 bold mb1","category":"styles_category__Lzneg","avatar-container":"styles_avatar-container__2XcFz mb2","avatarContainer":"styles_avatar-container__2XcFz mb2"};

var FeedbackRequestMessage = function FeedbackRequestMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var leadId = message.parts[0].body.queryVariables.leadId;

  var _b = useFeedbackRequestConsumerMessageQuery({
    variables: {
      leadId: leadId
    }
  }),
      data = _b.data,
      loading = _b.loading;

  if (loading) {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Loading...");
  } else if (data && data.lead) {
    var _c = data.lead,
        expert_1 = _c.expert,
        consumer = _c.consumer,
        category = _c.category;
    var name_1 = expert_1.displayName;
    var banner = category && category.contentAssets.bannerImages[0];
    var categoryName = category && category.singularDisplayName;
    var hasUserReviewedExpert = consumer.expertReviews.find(function (expertReview) {
      return expertReview.expert.id === expert_1.id;
    });
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement(HeroWithImage, {
      imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
      heroLabel: React__default.createElement(React__default.Fragment, null, expert_1.expertProfile && expert_1.expertProfile.profilePhoto && React__default.createElement("div", {
        className: styles$o.avatarContainer
      }, React__default.createElement(components.Avatar, {
        size: 80,
        name: name_1,
        src: expert_1.expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles$o.name
      }, name_1), React__default.createElement("div", {
        className: styles$o.category
      }, "Your ", categoryName, " Expert"))
    }), React__default.createElement(CallToAction, {
      onClick: function onClick() {
        var _a;

        richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
          type: exports.ConsumerRichCardEvents.OPEN_EXPERT_RATING_MODAL,
          businessUserId: (_a = data.lead) === null || _a === void 0 ? void 0 : _a.expert.id,
          entryPoint: 'expert-rating-rich-card'
        });
      }
    }, hasUserReviewedExpert ? "Update your feedback on " + expert_1.shortName : "Give feedback on " + expert_1.shortName)));
  } else {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Error loading message!");
  }
};

var FeedbackRequestMessage$1 = function FeedbackRequestMessage$1(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.CONSUMER:
      return React__default.createElement(FeedbackRequestMessage, __assign({}, props));

    case exports.Application.BUSINESS:
    case exports.Application.OPERATIONS:
      return React__default.createElement(FeedbackRequest, __assign({}, props));
  }
};

FeedbackRequestMessage$1.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.FEEDBACK_REQUEST_FROM_EXPERT && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId;
};

var FileMessage = function FileMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  React.useEffect(function () {
    onLoaded();
  }, []);
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageFilePart, {
      part: part,
      key: idx,
      myself: myself
    });
  }));
};

FileMessage.handlesMessage = function (message) {
  return message.parts.length === 1 && message.parts[0].type === 'FILE';
};

var styles$p = {"caption":"styles_caption__23ULI p2 flex","curation-icon":"styles_curation-icon__3NuRf mr1","category-icon":"styles_category-icon__1Imx5","break":"styles_break__2rGWm mb2","curationIcon":"styles_curation-icon__3NuRf mr1","categoryIcon":"styles_category-icon__1Imx5"};

var GuestChatCreateRequestMessage = function GuestChatCreateRequestMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var _b = message.parts[0].body.queryVariables,
      expertId = _b.expertId,
      categoryId = _b.categoryId;
  return React__default.createElement(GuestChatCategoryComponent, {
    variables: {
      categoryId: categoryId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.category && data.category.ancestorWithPath) {
      var category_1 = data.category.ancestorWithPath;
      var banner = category_1 && category_1.contentAssets.bannerImages[0];
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, ' ', category_1 && category_1.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(components.DepartmentIcon, {
          className: styles$p.categoryIcon,
          departmentSlug: category_1.department.slug
        }), React__default.createElement("div", {
          className: styles$p.break
        })), "Top gear for you")
      }), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.PATH_CREATE_FROM_CATEGORY_WITH_EXPERT,
            expertId: expertId,
            sourceKey: 'guest-chat',
            categorySlug: category_1.slug
          });
        }
      }, "Click here to get your list"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

GuestChatCreateRequestMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.GUEST_CHAT_CREATE_REQUEST;
};

var styles$q = {"message":"styles_message__3CcRS p2","list-title":"styles_list-title__H7Zvn mb1","list":"styles_list__1_2R-","recap":"styles_recap__3inTd mt1","show-more":"styles_show-more__3MLeU","chevron":"styles_chevron__1zjZs","listTitle":"styles_list-title__H7Zvn mb1","showMore":"styles_show-more__3MLeU"};

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChevronUp = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "7",
    viewBox: "0 0 16 7",
    stroke: "#FFF"
  }, props), React__default.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1 6l7-5 7 5"
  }));
});

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChevronDown = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "7",
    viewBox: "0 0 16 7",
    stroke: "#FFF"
  }, props), React__default.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M15 1L8 6 1 1"
  }));
});

var HowCuratedWorksBusinessMessage = function HowCuratedWorksBusinessMessage(_a) {
  var message = _a.message,
      myself = _a.myself;

  var _b = React.useState(true),
      isCollapsed = _b[0],
      setIsCollapsed = _b[1];

  var leadId = message.parts[0].body.queryVariables.leadId;
  return React__default.createElement(HowCuratedWorksBusinessMessageComponent, {
    variables: {
      leadId: leadId
    }
  }, function (_a) {
    var _b;

    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var category = data.lead.category;
      var categoryName = category ? category.singularDisplayName.toLowerCase() : null;
      return React__default.createElement(MessageBubble, {
        message: message,
        className: styles$q.message
      }, React__default.createElement("div", {
        className: classnames((_b = {}, _b[styles$q.listTitle] = !isCollapsed, _b))
      }, "Here's a quick reminder of how Curated works:"), !isCollapsed && React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$q.list
      }, React__default.createElement("li", null, "We'll connect you directly to a vetted\xA0", categoryName, " expert. They will join this conversation."), React__default.createElement("li", null, "Your dedicated expert will put together a curated set of options based on your details, and work with you to find alternatives until it meets your exact requirements."), React__default.createElement("li", null, "When you're 100% happy with your recommendations, you'll be able to buy directly on our site.")), React__default.createElement("div", {
        className: styles$q.recap
      }, "If you want to add any additional details about what you're looking for, feel free to send a message below.")), React__default.createElement("div", {
        className: styles$q.seeMoreRow
      }, !isCollapsed ? React__default.createElement(components.Button, {
        variant: "primary-link",
        size: "xsmall",
        className: styles$q.showMore,
        onClick: function onClick() {
          return setIsCollapsed(true);
        }
      }, "Collapse Details ", React__default.createElement(ChevronUp, {
        className: styles$q.chevron
      })) : React__default.createElement(components.Button, {
        variant: "primary-link",
        size: "xsmall",
        className: styles$q.showMore,
        onClick: function onClick() {
          return setIsCollapsed(false);
        }
      }, React__default.createElement("div", null, "Expand All Details"), " ", React__default.createElement(ChevronDown, {
        className: styles$q.chevron
      }))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

var styles$r = {"message":"styles_message__2cZYQ p2","list-title":"styles_list-title__36uOo mb1","list":"styles_list__c0SeX","recap":"styles_recap__3zY6p mt1","listTitle":"styles_list-title__36uOo mb1"};

var HowCuratedWorksMessageConsumer = function HowCuratedWorksMessageConsumer(_a) {
  var message = _a.message,
      myself = _a.myself;
  var leadId = message.parts[0].body.queryVariables.leadId;
  return React__default.createElement(HowCuratedWorksConsumerMessageComponent, {
    variables: {
      leadId: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var category = data.lead.category;
      var categoryName = category ? category.singularDisplayName.toLowerCase() : null;
      return React__default.createElement(MessageBubble, {
        message: message,
        className: styles$r.message
      }, React__default.createElement("div", null, React__default.createElement("div", {
        className: styles$r.listTitle
      }, "A quick reminder of how Curated works:"), React__default.createElement(experimentJs.Experiment, {
        id: "intro-message-copy",
        default: "v1"
      }, React__default.createElement(experimentJs.Variation, {
        id: "v1"
      }, category && category.type === CategoryType.SERVICE ? React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$r.list
      }, React__default.createElement("li", null, "We'll connect you directly to a vetted ", categoryName, " expert. They will join this conversation."), React__default.createElement("li", null, "Your dedicated expert will help you plan the perfect ", categoryName, ' ', "experience. They will work with you to find alternatives until the experience meets your exact requirements in pricing and style."), React__default.createElement("li", null, "When you're 100% happy with your itinerary, you'll be able to book directly on our site.")), React__default.createElement("div", {
        className: styles$r.recap
      }, "If you want to add any additional details about what you're looking for, feel free to send a message below.")) : React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$r.list
      }, React__default.createElement("li", null, "We'll connect you directly to a vetted ", categoryName, " expert. They will join this conversation."), React__default.createElement("li", null, "Your dedicated expert will send over a list of options based on your details, pulling from various brands and deals to match your product preferences."), React__default.createElement("li", null, "They will work with you to find alternatives until the products meet your exact requirements in pricing and style."), React__default.createElement("li", null, "When you're 100% happy with your recommendations, you'll be able to buy directly on our site.")), React__default.createElement("div", {
        className: styles$r.recap
      }, "If you want to add any additional details about what you're looking for, feel free to send a message below."))), React__default.createElement(experimentJs.Variation, {
        id: "v2"
      }, category && category.type === CategoryType.SERVICE ? React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$r.list
      }, React__default.createElement("li", null, "We'll directly connect you to a vetted ", categoryName, " expert. They will join this conversation."), React__default.createElement("li", null, "Your dedicated expert will help you plan the perfect ", categoryName, ' ', "experience based on your preferences."), React__default.createElement("li", null, "They will personally work with you via email, text, or messaging to create an itinerary that meets your exact preferences.This may take a moment as our experts are real people, not automated messaging."), React__default.createElement("li", null, "When you're 100% happy with your itinerary, you'll be able to book directly on our site.")), React__default.createElement("div", {
        className: styles$r.recap
      }, "If you want to add any additional details about what you're looking for, feel free to send a message below.")) : React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$r.list
      }, React__default.createElement("li", null, "We'll directly connect you to a vetted ", categoryName, " expert. They will join this conversation."), React__default.createElement("li", null, "Your dedicated expert will send over a customized list of products based on your details. This may take a moment as our experts are real people, not automated messaging."), React__default.createElement("li", null, "They will personally work with you via email, text, or messaging to find the products that meet your exact preferences."), React__default.createElement("li", null, "When you're 100% happy with your recommendations, you'll be able to buy directly from our site.")), React__default.createElement("div", {
        className: styles$r.recap
      }, "If you want to add any additional details about what you're looking for, feel free to send a message below."))), React__default.createElement(experimentJs.Variation, {
        id: "v3"
      }, category && category.type === CategoryType.SERVICE ? React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$r.list
      }, React__default.createElement("li", null, "Talk with an expert who\u2019ll get to know your needs."), React__default.createElement("li", null, "Your expert will send a list of recommendations with comments and prices."), React__default.createElement("li", null, "Continue talking with your expert until you find your perfect experience."), React__default.createElement("li", null, "Buy directly from our site knowing you got the best experience and deal for you!")), React__default.createElement("div", {
        className: styles$r.recap
      }, "Feel free to include any other specifics you want your expert to know below. Your expert will join the conversation shortly.")) : React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles$r.list
      }, React__default.createElement("li", null, "Talk with an expert who\u2019ll get to know your needs."), React__default.createElement("li", null, "Your expert will send a list of recommendations with comments and prices."), React__default.createElement("li", null, "Continue talking with your expert until you find your perfect item."), React__default.createElement("li", null, "Buy directly from our site knowing you got the best product and deal for you!")), React__default.createElement("div", {
        className: styles$r.recap
      }, "Feel free to include any other specifics you want your expert to know below. Your expert will join the conversation shortly."))))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

var HowCuratedWorksMessage = function HowCuratedWorksMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.CONSUMER:
      return React__default.createElement(HowCuratedWorksMessageConsumer, __assign({}, props));

    case exports.Application.BUSINESS:
    case exports.Application.OPERATIONS:
      return React__default.createElement(HowCuratedWorksBusinessMessage, __assign({}, props));
  }
};

HowCuratedWorksMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_HOW_CURATED_WORKS && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId;
};

var HyperLinkTextMessage = function HyperLinkTextMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageHyperLinkTextPart, {
      part: part,
      key: idx,
      myself: myself
    });
  }));
};

HyperLinkTextMessage.handlesMessage = function (message) {
  return message.parts.length === 1 && message.parts[0].type === 'HYPERLINK_TEXT';
};

var ImageMessage = function ImageMessage(_a) {
  var message = _a.message,
      onLoaded = _a.onLoaded,
      myself = _a.myself;
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageImagePart, {
      part: part,
      key: idx,
      onLoaded: onLoaded,
      myself: myself
    });
  }));
};

ImageMessage.handlesMessage = function (message) {
  return message.parts.length === 1 && message.parts[0].type === 'IMAGE';
};

var styles$s = {"content":"styles_content__qGg8W p2","user":"styles_user__mSa-8 mb1","sellable-title":"styles_sellable-title__IdgKG mb2 bold","price":"styles_price__Z40t_","line-item":"styles_line-item__30sKd flex py1 justify-between","line-item-title":"styles_line-item-title__3gdBH flex-auto","free":"styles_free__3e3xi bold","security-deposit-line-item":"styles_security-deposit-line-item__39kAm styles_line-item__30sKd flex py1 justify-between","sellableTitle":"styles_sellable-title__IdgKG mb2 bold","lineItem":"styles_line-item__30sKd flex py1 justify-between","lineItemTitle":"styles_line-item-title__3gdBH flex-auto","securityDepositLineItem":"styles_security-deposit-line-item__39kAm styles_line-item__30sKd flex py1 justify-between"};

var SingleLineItem = function SingleLineItem(_a) {
  var lineItem = _a.lineItem,
      duration = _a.duration;

  if (lineItem.isGroup) {
    return null;
  }

  return React__default.createElement("div", {
    key: lineItem.id
  }, React__default.createElement("div", {
    className: styles$s.lineItem
  }, React__default.createElement("span", {
    className: styles$s.lineItemTitle
  }, lineItem.title, lineItem.source.__typename === 'OrderLineItemSellableSource' && duration && "(" + duration + ")"), React__default.createElement("span", {
    className: styles$s.lineItemPrice
  }, lineItem.unitPrice ? numeral(lineItem.unitPrice.amount).format('$0,0.00') : React__default.createElement("span", {
    className: styles$s.free
  }, "Free"), lineItem.quantity > 1 && "x " + lineItem.quantity)));
};

var InterestedInOrderBusinessMessage = function InterestedInOrderBusinessMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var orderId = message.parts[0].body.queryVariables.expertCuratedOrderId;
  var richCardEventEmitter = useRichCardEventEmitter();
  return React__default.createElement(InterestedInOrderBusinessMessageComponent, {
    variables: {
      id: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var _b = data.expertCuratedOrder,
          order = _b.order,
          variationOptions = _b.variationOptions,
          lead_1 = _b.lead;
      var title = order.title,
          primaryImage = order.primaryImage,
          totalCostBeforeTax = order.totalCostBeforeTax,
          lineItems = order.lineItems;
      var selectedVariation_1 = variationOptions.find(function (option) {
        return option.selected;
      });
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.url
      }), React__default.createElement("div", {
        className: styles$s.content
      }, React__default.createElement("div", {
        className: styles$s.user
      }, lead_1.consumer.firstName, " has requested this charter:"), title && React__default.createElement("div", {
        className: styles$s.sellableTitle
      }, title), React__default.createElement("div", null, lineItems.map(function (orderLineItem) {
        return React__default.createElement(SingleLineItem, {
          key: orderLineItem.id,
          lineItem: orderLineItem,
          duration: selectedVariation_1 && selectedVariation_1.sellable.variants[0] && selectedVariation_1.sellable.variants[0].displayValueHtml
        });
      }), React__default.createElement("div", {
        className: styles$s.lineItem
      }, React__default.createElement("div", {
        className: styles$s.lineItemTitle
      }, React__default.createElement("strong", null, "Total")), React__default.createElement("div", {
        className: styles$s.lineItemPrice
      }, React__default.createElement("strong", null, numeral(totalCostBeforeTax.amount).format('$0,0.00')))))), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.BusinessRichCardEvents.EDIT_EXPERIENCE_CURATION,
            leadId: lead_1.id
          });
        }
      }, "View Charter"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

var styles$t = {"content":"styles_content__3mfMu p2","user":"styles_user__3FBlm mb1","sellable-title":"styles_sellable-title__1_15k mb2 bold","price":"styles_price__-8byg","line-item":"styles_line-item__1JUGW flex py1 justify-between","line-item-title":"styles_line-item-title__5ZgGZ flex-auto","free":"styles_free__1Gxaf bold","security-deposit-line-item":"styles_security-deposit-line-item__r_Qyi styles_line-item__1JUGW flex py1 justify-between","sellableTitle":"styles_sellable-title__1_15k mb2 bold","lineItem":"styles_line-item__1JUGW flex py1 justify-between","lineItemTitle":"styles_line-item-title__5ZgGZ flex-auto","securityDepositLineItem":"styles_security-deposit-line-item__r_Qyi styles_line-item__1JUGW flex py1 justify-between"};

var SingleLineItem$1 = function SingleLineItem(_a) {
  var lineItem = _a.lineItem,
      selectedVariation = _a.selectedVariation;

  if (lineItem.isGroup) {
    return null;
  }

  var duration = selectedVariation && selectedVariation.sellable.variants[0] && selectedVariation.sellable.variants[0].displayValueHtml;
  return React__default.createElement("div", {
    key: lineItem.id
  }, React__default.createElement("div", {
    className: styles$t.lineItem
  }, React__default.createElement("span", {
    className: styles$t.lineItemTitle
  }, lineItem.title, lineItem.source.__typename === 'OrderLineItemBasePriceSource' && duration && "(" + duration + ")"), React__default.createElement("span", {
    className: styles$t.lineItemPrice
  }, lineItem.unitPrice ? numeral(lineItem.unitPrice.amount).format('$0,0.00') : React__default.createElement("span", {
    className: styles$t.free
  }, "Free"), lineItem.quantity > 1 && "x " + lineItem.quantity)));
};

var InterestedInOrderConsumerMessage = function InterestedInOrderConsumerMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var orderId = message.parts[0].body.queryVariables.expertCuratedOrderId;
  return React__default.createElement(InterestedInOrderConsumerMessageComponent, {
    variables: {
      id: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var _b = data.expertCuratedOrder,
          order = _b.order,
          variationOptions = _b.variationOptions,
          firstName = _b.curatedFor.firstName;
      var title = order.title,
          primaryImage = order.primaryImage,
          lineItems = order.lineItems,
          totalCostBeforeTax = order.totalCostBeforeTax;
      var selectedVariaiton_1 = variationOptions.find(function (option) {
        return option.selected;
      });
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.url
      }), React__default.createElement("div", {
        className: styles$t.content
      }, React__default.createElement("div", {
        className: styles$t.user
      }, firstName, " has requested this charter:"), title && React__default.createElement("div", {
        className: styles$t.sellableTitle
      }, title), React__default.createElement("div", null, lineItems.map(function (orderLineItem) {
        return React__default.createElement(SingleLineItem$1, {
          key: orderLineItem.id,
          lineItem: orderLineItem,
          selectedVariation: selectedVariaiton_1
        });
      }), React__default.createElement("div", {
        className: styles$t.lineItem
      }, React__default.createElement("div", {
        className: styles$t.lineItemTitle
      }, React__default.createElement("strong", null, "Total")), React__default.createElement("div", {
        className: styles$t.lineItemPrice
      }, React__default.createElement("strong", null, numeral(totalCostBeforeTax.amount).format('$0,0.00')))))), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_EXPERIENCE_ORDER,
            orderId: orderId
          });
        }
      }, "View Charter"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

var styles$u = {"content":"styles_content__3IL4F p2","user":"styles_user__21hZp mb1","sellable-title":"styles_sellable-title__lcjKx mb2 bold","price":"styles_price__1gYPj","line-item":"styles_line-item__9gx8M flex py1 justify-between","line-item-title":"styles_line-item-title__3VJlQ flex-auto","free":"styles_free__1BmUd bold","security-deposit-line-item":"styles_security-deposit-line-item__33cRx styles_line-item__9gx8M flex py1 justify-between","sellableTitle":"styles_sellable-title__lcjKx mb2 bold","lineItem":"styles_line-item__9gx8M flex py1 justify-between","lineItemTitle":"styles_line-item-title__3VJlQ flex-auto","securityDepositLineItem":"styles_security-deposit-line-item__33cRx styles_line-item__9gx8M flex py1 justify-between"};

var SingleLineItem$2 = function SingleLineItem(_a) {
  var lineItem = _a.lineItem,
      duration = _a.duration;

  if (lineItem.isGroup) {
    return null;
  }

  return React__default.createElement("div", {
    key: lineItem.id
  }, React__default.createElement("div", {
    className: styles$u.lineItem
  }, React__default.createElement("span", {
    className: styles$u.lineItemTitle
  }, lineItem.title, lineItem.source.__typename === 'OrderLineItemSellableSource' && duration && "(" + duration + ")"), React__default.createElement("span", {
    className: styles$u.lineItemPrice
  }, lineItem.unitPrice ? numeral(lineItem.unitPrice.amount).format('$0,0.00') : React__default.createElement("span", {
    className: styles$u.free
  }, "Free"), lineItem.quantity > 1 && "x " + lineItem.quantity)));
};

var InterestedInOrderOperationsMessage = function InterestedInOrderOperationsMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var orderId = message.parts[0].body.queryVariables.expertCuratedOrderId;
  return React__default.createElement(InterestedInOrderBusinessMessageComponent, {
    variables: {
      id: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var _b = data.expertCuratedOrder,
          order = _b.order,
          variationOptions = _b.variationOptions,
          lead = _b.lead;
      var title = order.title,
          primaryImage = order.primaryImage,
          totalCostBeforeTax = order.totalCostBeforeTax,
          lineItems = order.lineItems;
      var selectedVariation_1 = variationOptions.find(function (option) {
        return option.selected;
      });
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.url
      }), React__default.createElement("div", {
        className: styles$u.content
      }, React__default.createElement("div", {
        className: styles$u.user
      }, lead.consumer.firstName, " has requested this charter:"), title && React__default.createElement("div", {
        className: styles$u.sellableTitle
      }, title), React__default.createElement("div", null, lineItems.map(function (orderLineItem) {
        return React__default.createElement(SingleLineItem$2, {
          key: orderLineItem.id,
          lineItem: orderLineItem,
          duration: selectedVariation_1 && selectedVariation_1.sellable.variants[0] && selectedVariation_1.sellable.variants[0].displayValueHtml
        });
      }), React__default.createElement("div", {
        className: styles$u.lineItem
      }, React__default.createElement("div", {
        className: styles$u.lineItemTitle
      }, React__default.createElement("strong", null, "Total")), React__default.createElement("div", {
        className: styles$u.lineItemPrice
      }, React__default.createElement("strong", null, numeral(totalCostBeforeTax.amount).format('$0,0.00')))))), React__default.createElement(CallToAction, null, "View Charter"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

var InterestedInOrderMessage = function InterestedInOrderMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.CONSUMER:
      return React__default.createElement(InterestedInOrderConsumerMessage, __assign({}, props));

    case exports.Application.BUSINESS:
      return React__default.createElement(InterestedInOrderBusinessMessage, __assign({}, props));

    case exports.Application.OPERATIONS:
    default:
      return React__default.createElement(InterestedInOrderOperationsMessage, __assign({}, props));
  }
};

InterestedInOrderMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.CONSUMER_INTERESTED_IN_CURATED_ORDER && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderId;
};

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Check$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45",
    height: "48",
    viewBox: "0 0 45 48"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-5 2h48v48H-5z"
  }), React__default.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M11 25h16v10H11zm4 0v-6a4.012 4.012 0 0 1 4-4 4.012 4.012 0 0 1 4 4v6"
  }), React__default.createElement("path", {
    d: "M37 29c0 9.941-8.059 18-18 18S1 38.941 1 29V9l18-4 18 4v20z"
  })), React__default.createElement("path", {
    d: "M27 2h16v16H27z"
  }), React__default.createElement("g", {
    transform: "translate(25)"
  }, React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#009F45",
    fillRule: "nonzero",
    d: "M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM9 13.4L5.6 10 7 8.6l2 2 4-4L14.4 8 9 13.4z"
  }))));
});

var styles$v = {"media-breakpoint-sm":"(min-width: 40em)","message-content":"styles_message-content__2l9Ey","success":"styles_success__1qwWs flex","success-icon":"styles_success-icon__2a7ul","box":"styles_box__2STk3","header":"styles_header__HJA-i","instruction":"styles_instruction__mQbWU","instruction-step-list":"styles_instruction-step-list__36emd","instruction-step":"styles_instruction-step__2xoAJ","form":"styles_form__3N9X9","code":"styles_code__3pI_o","link":"styles_link__Ad9o9","mediaBreakpointSm":"(min-width: 40em)","messageContent":"styles_message-content__2l9Ey","successIcon":"styles_success-icon__2a7ul","instructionStepList":"styles_instruction-step-list__36emd","instructionStep":"styles_instruction-step__2xoAJ"};

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var PrivacyIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "23",
    viewBox: "0 0 20 23"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-2-1h24v24H-2z"
  }), React__default.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M6 11h8v5H6zm2 0V8a2.006 2.006 0 0 1 2-2 2.006 2.006 0 0 1 2 2v3"
  }), React__default.createElement("path", {
    d: "M19 13a9 9 0 0 1-18 0V3l9-2 9 2v10z"
  }))));
});

var styles$w = {"privacy-icon":"styles_privacy-icon__3nAeu","privacyIcon":"styles_privacy-icon__3nAeu"};

var PaymentVerificationForm = function PaymentVerificationForm(_a) {
  var orderId = _a.orderId,
      transactionId = _a.transactionId,
      formClassName = _a.formClassName,
      codeInputClassName = _a.codeInputClassName,
      verificationMethod = _a.verificationMethod;
  var chatContext = useChatContext();

  var _b = React.useState(''),
      code = _b[0],
      setCode = _b[1];

  var _c = React.useState(''),
      amount = _c[0],
      setAmount = _c[1];

  return React__default.createElement(VerifyPaymentTransactionComponent, {
    variables: {
      input: {
        orderId: orderId,
        transactionId: transactionId,
        code: PaymentVerificationMethod.CODE ? code : null,
        amount: verificationMethod === PaymentVerificationMethod.AMOUNT ? {
          currency: 'USD',
          amount: numeral(amount).format('0.00')
        } : null
      }
    },
    onCompleted: function onCompleted(response) {
      if (response && response.verifyPaymentTransaction) {
        if (response.verifyPaymentTransaction.verified) {
          (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(exports.ToastNotificationType.SUCCESS, 'Payment verified successfully!');
        } else if (response.verifyPaymentTransaction.error) {
          (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(exports.ToastNotificationType.ERROR, "Payment verification failed: " + response.verifyPaymentTransaction.error);
        } else {
          (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(exports.ToastNotificationType.ERROR, "Payment verification failed!");
        }
      }
    },
    onError: function onError() {
      (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(exports.ToastNotificationType.ERROR, 'Error verifying your payment! Please try again.');
    }
  }, function (verifyPayment, _a) {
    var loading = _a.loading;
    return React__default.createElement("form", null, React__default.createElement("div", {
      className: formClassName
    }, React__default.createElement("div", {
      className: codeInputClassName
    }, verificationMethod === PaymentVerificationMethod.CODE ? React__default.createElement(components.TextField, {
      value: code,
      label: "",
      labelHidden: true,
      onChange: function onChange(e) {
        return setCode(e.target.value);
      },
      placeholder: "Verification code"
    }) : React__default.createElement(components.CurrencyField, {
      label: "Verification Amount",
      labelHidden: true,
      value: amount,
      placeholder: "Verification amount",
      onChange: function onChange(e) {
        return setAmount(e.target.value);
      }
    })), React__default.createElement(components.Button, {
      onClick: function onClick() {
        return verifyPayment();
      },
      disabled: code === '' && amount === '' || loading
    }, React__default.createElement(PrivacyIcon, {
      className: styles$w.privacyIcon
    }), " Submit")));
  });
};

var PaymentVerificationMessage = function PaymentVerificationMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var orderId = message.parts[0].body.queryVariables.orderId;
  var transactionId = message.parts[0].body.queryVariables.transactionId;
  return React__default.createElement(PaymentVerificationMessageComponent, {
    variables: {
      orderId: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.order) {
      var paymentVerificationMethod = data.order.paymentVerificationMethod;
      return React__default.createElement("div", {
        className: styles$v.messageContent
      }, React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Congratulations on your new purchase! We need to verify your payment information before we can process your order. This is standard fraud protection to make sure you are the cardholder. If you have any questions, don't hesitate to ask your expert or", ' ', React__default.createElement("span", {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_ORDER_SUPPORT
          });
        },
        className: styles$v.link
      }, "contact support"), "!"), data.order.state === OrderState.CONSUMER_PAYMENT_COMPLETED ? React__default.createElement("div", {
        className: styles$v.success
      }, React__default.createElement("div", {
        className: styles$v.successIcon
      }, React__default.createElement(Check$2, null)), React__default.createElement("div", {
        className: styles$v.header
      }, "Payment verified successfully"), React__default.createElement("div", {
        className: styles$v.instruction
      }, "Thank you for verifying that you are the cardholder, we were able to safely process your order!")) : data.order.state !== OrderState.CONSUMER_PAYMENT_IN_REVIEW ? React__default.createElement("div", {
        className: styles$v.success
      }, React__default.createElement("div", {
        className: styles$v.successIcon
      }, React__default.createElement(Check$2, null)), React__default.createElement("div", {
        className: styles$v.header
      }, "Payment verification"), React__default.createElement("div", {
        className: styles$v.instruction
      }, "Your payment is no longer in review!")) : !paymentVerificationMethod ? React__default.createElement("div", {
        className: styles$v.instruction
      }, "You'll be receiving a call from us soon!") : React__default.createElement("div", {
        className: styles$v.box
      }, React__default.createElement("div", {
        className: styles$v.header
      }, "Payment verification required"), paymentVerificationMethod == PaymentVerificationMethod.CODE ? React__default.createElement("div", {
        className: styles$v.instruction
      }, React__default.createElement("div", null, "Please follow these instructions to verify that you are the cardholder:"), React__default.createElement("ol", {
        className: styles$v.instructionStepList
      }, React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Access your credit card statement through your bank website or mobile app")), React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Locate your recent transaction with CURATED.COM")), React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Look for the statement descriptor. It will say CURATED.COM XXXXXX (6 random letters and number)")), React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Enter the 6 random letters and numbers below")))) : React__default.createElement("div", {
        className: styles$v.instruction
      }, React__default.createElement("div", null, "We have placed a temporary hold on your card for an amount slightly higher than your purchase total. Once verified, we will only charge the correct total amount. Please follow the instructions below to verify."), React__default.createElement("ol", {
        className: styles$v.instructionStepList
      }, React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Access your credit card statement through your bank website or mobile app")), React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Locate your recent transaction with CURATED.COM")), React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Locate the amount of the transaction")), React__default.createElement("li", {
        className: styles$v.instructionStep
      }, React__default.createElement("span", null, "Enter the amount shown on your statement below ")))), React__default.createElement(PaymentVerificationForm, {
        orderId: orderId,
        verificationMethod: paymentVerificationMethod,
        transactionId: transactionId,
        formClassName: styles$v.form,
        codeInputClassName: styles$v.code
      })));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

PaymentVerificationMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.PAYMENT_VERIFICATION_REQUEST && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.orderId;
};

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CurationIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "18",
    viewBox: "0 0 20 18"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M5.333 17.667A1.34 1.34 0 0 1 4 16.318a1.34 1.34 0 0 1 1.333-1.348c.74 0 1.334.607 1.334 1.348a1.34 1.34 0 0 1-1.334 1.349zm0-1.334c-.003 0 0-.003 0-.015 0-.011-.003-.015 0-.015.004 0 0 .004 0 .015 0 .012.004.015 0 .015zm7.334 1.334a1.34 1.34 0 0 1-1.334-1.349 1.34 1.34 0 0 1 1.334-1.348c.74 0 1.333.607 1.333 1.348a1.34 1.34 0 0 1-1.333 1.349zm0-1.334c-.004 0 0-.003 0-.015 0-.011-.004-.015 0-.015.003 0 0 .004 0 .015 0 .012.003.015 0 .015zM2.12 3.364H0V2h3.213l.107.548.56 2.861h11.592l-.15.81-1.068 5.725c-.189.972-1.031 1.666-1.987 1.647H5.799c-.968.019-1.81-.675-2-1.646L2.12 3.364zm2.027 3.409l.96 4.906a.674.674 0 0 0 .68.548h6.492a.669.669 0 0 0 .666-.543l.916-4.911H4.147z"
  }), React__default.createElement("circle", {
    cx: "14",
    cy: "6",
    r: "6",
    fill: "#FFF"
  }), React__default.createElement("circle", {
    cx: "14",
    cy: "6",
    r: "5",
    fill: "#222"
  }), React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13.5 3h1v6h-1z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11 6.5v-1h6v1z"
  })));
});

var styles$x = {"caption":"styles_caption__UPq01 p2 flex","curation-icon":"styles_curation-icon__1OC6w mr1","category-icon":"styles_category-icon__2vNE2","break":"styles_break__2LpLa mb2","curationIcon":"styles_curation-icon__1OC6w mr1","categoryIcon":"styles_category-icon__2vNE2"};

var ProductCurationMessage = function ProductCurationMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  var activationId = message.parts[0].body.queryVariables.expertCuratedItemActivationId;
  var curatedByExpert = message.parts[0].body.type !== 'new-system-curated-items';
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;

  if (activationId) {
    return React__default.createElement(ProductCurationActivationComponent, {
      variables: {
        activationId: activationId
      }
    }, function (_a) {
      var data = _a.data,
          loading = _a.loading;

      if (data && data.expertCuratedItemActivation) {
        var expert = data.expertCuratedItemActivation.activatedBy;
        var consumer = data.expertCuratedItemActivation.lead.consumer;
        var itemCount = data.expertCuratedItemActivation.activated.length;
        var category = data.expertCuratedItemActivation.lead && data.expertCuratedItemActivation.lead.category;
        var banner = category && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
        var leadId_1 = data.expertCuratedItemActivation.lead.id;
        return React__default.createElement(MessageBubble, {
          message: message
        }, React__default.createElement(HeroWithImage, {
          imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
          heroLabel: React__default.createElement(React__default.Fragment, null, category && category.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(components.DepartmentIcon, {
            className: styles$x.categoryIcon,
            departmentSlug: category.department.slug
          }), React__default.createElement("div", {
            className: styles$x.break
          })), expert.shortName + "'s picks " + (myself && "for " + consumer.firstName))
        }), curatedByExpert && React__default.createElement("div", {
          className: styles$x.caption
        }, React__default.createElement(CurationIcon, {
          className: styles$x.curationIcon
        }), itemCount === 1 ? 'Hand' : itemCount + " hand", " picked items for you."), application === exports.Application.CONSUMER ? React__default.createElement(CallToAction, {
          onClick: function onClick() {
            return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
              type: exports.ConsumerRichCardEvents.VIEW_PRODUCT_CURATION,
              leadId: leadId_1
            });
          }
        }, curatedByExpert ? 'View Your Options' : 'View Your Recommendations') : application === exports.Application.BUSINESS ? React__default.createElement(CallToAction, {
          onClick: function onClick() {
            return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
              type: exports.BusinessRichCardEvents.EDIT_PRODUCT_CURATION,
              leadId: leadId_1
            });
          }
        }, "Edit Your Recommendations") : React__default.createElement(CallToAction, null, "Edit Your Recommendations"));
      } else if (loading) {
        return React__default.createElement(MessageBubbleText, {
          message: message,
          myself: myself
        }, "Loading...");
      } else {
        return React__default.createElement(MessageBubbleText, {
          message: message,
          myself: myself
        }, "Error loading messages!");
      }
    });
  } else {
    var leadId_2 = message.parts[0].body.queryVariables.leadId; // legacy message where we don't have activation id in the variable list, only has leadId

    return React__default.createElement(ProductCurationNewComponent, {
      variables: {
        leadId: leadId_2
      },
      fetchPolicy: "network-only"
    }, function (_a) {
      var data = _a.data,
          loading = _a.loading;

      if (data && data.expertCuratedItemsForLead && data.lead) {
        var expert = data.lead.expert;
        var consumer = data.lead.consumer;
        var itemCount = data.expertCuratedItemsForLead.items.length;
        var category = data.lead && data.lead.category;
        var banner = category && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
        return React__default.createElement(MessageBubble, {
          message: message
        }, React__default.createElement("div", {
          className: styles$x.hero
        }, banner && React__default.createElement(components.Image, {
          src: banner.imageUrl,
          width: 384,
          height: 134,
          imgixParams: {
            fit: 'crop'
          },
          className: styles$x.heroImage,
          onMounted: onLoaded
        }), React__default.createElement("div", {
          className: styles$x.overlay
        }, category && category.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(components.DepartmentIcon, {
          className: styles$x.categoryIcon,
          departmentSlug: category.department.slug
        }), React__default.createElement("div", {
          className: styles$x.break
        })), expert.shortName + "'s picks " + (myself && "for " + consumer.firstName))), curatedByExpert && React__default.createElement("div", {
          className: styles$x.caption
        }, React__default.createElement(CurationIcon, {
          className: styles$x.curationIcon
        }), itemCount === 1 ? 'Hand' : itemCount + " hand", " picked items for you."), application === exports.Application.CONSUMER ? React__default.createElement("div", {
          onClick: function onClick() {
            return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
              type: exports.ConsumerRichCardEvents.VIEW_PRODUCT_CURATION,
              leadId: leadId_2
            });
          },
          className: styles$x.cta
        }, "Edit Your Recommendations") : React__default.createElement("div", {
          onClick: function onClick() {
            richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
              type: exports.BusinessRichCardEvents.EDIT_PRODUCT_CURATION,
              leadId: leadId_2
            });
          },
          className: styles$x.cta
        }, "Edit Your Recommendations"));
      } else if (loading) {
        return React__default.createElement(MessageBubbleText, {
          message: message,
          myself: myself
        }, "Loading...");
      } else {
        return React__default.createElement(MessageBubbleText, {
          message: message,
          myself: myself
        }, "Error loading messages!");
      }
    });
  }
};

ProductCurationMessage.handlesMessage = function (message) {
  var curatedMessagePartBodyTypes = ['new-expert-curated-items', 'new-system-curated-items', 'updated-expert-curated-items'];
  var richCardTypes = [MessageRichCardType.NEW_EXPERT_CURATED_ITEMS, MessageRichCardType.NEW_SYSTEM_CURATED_ITEMS, MessageRichCardType.UPDATED_EXPERT_CURATED_ITEMS];
  return message.parts.length > 1 && (richCardTypes.includes(message.parts[0].body.richCardType) || curatedMessagePartBodyTypes.includes(message.parts[0].body.type)) && message.parts[0].body.queryVariables && (message.parts[0].body.queryVariables.leadId || message.parts[0].body.queryVariables.expertCuratedItemActivationId);
};

var styles$y = {"messages":"styles_messages__1ONeU flex flex-column","message":"styles_message__2jcT7 p2 relative","title":"styles_title__2Ya3T mb2","text":"styles_text__3g7F3"};

var ProductQuiz = function ProductQuiz(_a) {
  var message = _a.message;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  var leadId = message.parts[0].body.queryVariables.leadId;
  var data = useProductQuizBusinessLeadQuery({
    variables: {
      leadId: leadId
    }
  }).data;
  return (data === null || data === void 0 ? void 0 : data.lead) ? React__default.createElement("div", {
    className: styles$y.messages
  }, React__default.createElement(MessageBubble, {
    message: message
  }, React__default.createElement("div", {
    className: styles$y.message
  }, React__default.createElement(components.Tooltip, {
    placement: "top",
    message: "The user sees a quiz asking them to like / dislike products. The products shown are\n                based on the answers to their quiz. You can see their ratings in the \"Items Rated\"\n                section."
  }), React__default.createElement("div", {
    className: styles$y.title
  }, "Product rating in progress"), React__default.createElement("div", {
    className: styles$y.text
  }, data.lead.consumer.firstName, " is in the process of rating products. View his/her resposes as they come in by clicking the button below.")), application === exports.Application.BUSINESS ? React__default.createElement(CallToAction, {
    onClick: function onClick() {
      return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
        type: exports.BusinessRichCardEvents.OPEN_RATED_ITEMS_PANEL
      });
    }
  }, "View Survey results") : React__default.createElement(CallToAction, {
    onClick: function onClick() {
      return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
        type: exports.BusinessRichCardEvents.OPEN_RATED_ITEMS_PANEL
      });
    }
  }, "View Survey results"))) : null;
};

var ProductQuizMessage = function ProductQuizMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.BUSINESS:
    case exports.Application.OPERATIONS:
      return React__default.createElement(ProductQuiz, __assign({}, props));

    case exports.Application.CONSUMER:
      return null;
  }
};

ProductQuizMessage.handlesMessage = function (message) {
  var body = message.parts[0].body;
  return body.richCardType === MessageRichCardType.SYSTEM_CURATED_ITEM_SURVEY;
};

var styles$z = {"hero":"styles_hero__3ET9b relative center","hero-image":"styles_hero-image__6GXzt","overlay":"styles_overlay__ZdOdV flex flex-column items-center justify-center bold absolute top-0 left-0 right-0 bottom-0","name":"styles_name__3Ye8f bold mb1","category":"styles_category__165gK","avatar-container":"styles_avatar-container__1jhDx mb2","heroImage":"styles_hero-image__6GXzt","avatarContainer":"styles_avatar-container__1jhDx mb2"};

var ReferralConsumerMessage = function ReferralConsumerMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  var expertId = message.parts[0].body.queryVariables.expertId;
  var richCardEventEmitter = useRichCardEventEmitter();

  var _b = useReferralConsumerMessageQuery({
    variables: {
      vanityIdOrId: expertId
    }
  }),
      data = _b.data,
      loading = _b.loading;

  if (loading) {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself,
      onLoaded: onLoaded
    }, "Loading...");
  } else if (data && data.findExpert) {
    var _c = data.findExpert,
        displayName = _c.displayName,
        shortName = _c.shortName,
        id_1 = _c.id,
        expertAttributes = _c.expertAttributes,
        expertProfile = _c.expertProfile;
    data.findExpert.expertAttributes;
    var name_1 = displayName;
    var category = expertAttributes && expertAttributes.categories[0];
    var banner = category && category.contentAssets.bannerImages[0];
    var categoryName = category && category.singularDisplayName;
    return React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement(HeroWithImage, {
      imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
      heroLabel: React__default.createElement(React__default.Fragment, null, ' ', expertProfile && expertProfile.profilePhoto && React__default.createElement("div", {
        className: styles$z.avatarContainer
      }, React__default.createElement(components.Avatar, {
        size: 80,
        name: name_1,
        src: expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles$z.name
      }, name_1), React__default.createElement("div", {
        className: styles$z.category
      }, "Your ", categoryName, " Expert"))
    }), React__default.createElement(CallToAction, {
      onClick: function onClick() {
        return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
          type: exports.ConsumerRichCardEvents.OPEN_REFERRAL_MODAL,
          entryPoint: 'expert-referral-rich-card',
          businessUserId: id_1
        });
      }
    }, "Share " + shortName + "'s profile"));
  } else {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Error loading message!");
  }
};

var styles$A = {"name":"styles_name__2bpac bold mb1","category":"styles_category___3oNN","avatar-container":"styles_avatar-container__3f8lu mb2","avatarContainer":"styles_avatar-container__3f8lu mb2"};

var ReferralBusinessMessage = function ReferralBusinessMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var expertId = message.parts[0].body.queryVariables.expertId;
  return React__default.createElement(ReferralBusinessMessageComponent, {
    variables: {
      vanityIdOrId: expertId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.findExpert) {
      var expert = data.findExpert;
      var name_1 = data.findExpert.displayName;
      var category = expert.department.topLevelCategory;
      var banner = category.contentAssets && category.contentAssets.bannerImages[0];
      var categoryName = expert.department.displayName;
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, expert.expertProfile && expert.expertProfile.profilePhoto && React__default.createElement("div", {
          className: styles$A.avatarContainer
        }, React__default.createElement(components.Avatar, {
          size: 80,
          name: name_1,
          src: expert.expertProfile.profilePhoto.url
        })), React__default.createElement("div", {
          className: styles$A.name
        }, name_1), React__default.createElement("div", {
          className: styles$A.category
        }, "Your ", categoryName, " Expert"))
      }), React__default.createElement(CallToAction, null, "Share " + expert.displayName + "'s profile"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

var ReferralMessage = function ReferralMessage(_a) {
  var props = __rest(_a, []);

  var application = useApplicationContext().application;

  switch (application) {
    case exports.Application.CONSUMER:
      return React__default.createElement(ReferralConsumerMessage, __assign({}, props));

    case exports.Application.BUSINESS:
    case exports.Application.OPERATIONS:
      return React__default.createElement(ReferralBusinessMessage, __assign({}, props));
  }
};

ReferralMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.REFERRAL_REQUEST_FROM_EXPERT && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertId;
};

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChevronUp$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "7",
    viewBox: "0 0 16 7",
    stroke: "#FFF"
  }, props), React__default.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1 6l7-5 7 5"
  }));
});

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChevronDown$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "7",
    viewBox: "0 0 16 7",
    stroke: "#FFF"
  }, props), React__default.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M15 1L8 6 1 1"
  }));
});

var styles$B = {"category-icon":"styles_category-icon__dTDw9","break":"styles_break__2pCz5 mb2","category-name":"styles_category-name__3OXQ3 bold mb2","request-details":"styles_request-details__3C4Mn p2","attribute":"styles_attribute__umiLy mb1","attribute-name":"styles_attribute-name__2wYal","attribute-value":"styles_attribute-value__3dPHn","show-more":"styles_show-more__1Is-w","chevron":"styles_chevron__3Iusr","categoryIcon":"styles_category-icon__dTDw9","categoryName":"styles_category-name__3OXQ3 bold mb2","requestDetails":"styles_request-details__3C4Mn p2","attributeName":"styles_attribute-name__2wYal","attributeValue":"styles_attribute-value__3dPHn","showMore":"styles_show-more__1Is-w"};

var RequestConfirmationMessage = function RequestConfirmationMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  var application = useApplicationContext().application;

  var _b = React.useState(false),
      showAllAttributes = _b[0],
      setShowAllAttributes = _b[1];

  var leadId = message.parts[0].body.queryVariables.leadId;
  React.useEffect(function () {
    onLoaded();
  }, []);
  return React__default.createElement(RequestConfirmationLeadComponent, {
    variables: {
      leadId: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var _b = data.lead,
          consumer = _b.consumer,
          latestRequest = _b.latestRequest; // No point in rendering this card if you don't have a latest request or category

      if (!latestRequest || !data.lead.category) return null;
      var category = data.lead.category;
      var attributes = latestRequest.attributes ? latestRequest.attributes.filter(function (attribute) {
        return !!attribute.formatted;
      }) : [];
      var attributesToShow = showAllAttributes ? attributes : attributes.slice(0, 3);
      var banner = category.contentAssets && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, ' ', category && category.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(components.DepartmentIcon, {
          className: styles$B.categoryIcon,
          departmentSlug: category.department.slug
        }), React__default.createElement("div", {
          className: styles$B.break
        }), consumer.firstName + "'s " + category.singularDisplayName.toLowerCase() + " request"))
      }), React__default.createElement("div", {
        className: styles$B.requestDetails
      }, React__default.createElement("div", {
        className: styles$B.categoryName
      }, category.singularDisplayName, " request details"), application === exports.Application.BUSINESS || application === exports.Application.OPERATIONS ? React__default.createElement(React__default.Fragment, null, attributes.map(function (attribute) {
        return React__default.createElement("div", {
          key: attribute.formatted.name,
          className: styles$B.attribute
        }, React__default.createElement("div", {
          className: styles$B.attributeName
        }, attribute.formatted.name), React__default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: attribute.formatted.displayHtml
          },
          className: styles$B.attributeValue
        }));
      })) : React__default.createElement(React__default.Fragment, null, attributesToShow.map(function (attribute) {
        return React__default.createElement("div", {
          key: attribute.formatted.name,
          className: styles$B.attribute
        }, React__default.createElement("div", {
          className: styles$B.attributeName
        }, attribute.formatted.name), React__default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: attribute.formatted.displayHtml
          },
          className: styles$B.attributeValue
        }));
      }), attributes.length > 3 && React__default.createElement("div", {
        className: styles$B.seeMoreRow
      }, showAllAttributes ? React__default.createElement(components.Button, {
        variant: "primary-link",
        size: "small",
        className: styles$B.showMore,
        onClick: function onClick() {
          return setShowAllAttributes(false);
        }
      }, "Collapse Details ", React__default.createElement(ChevronUp$1, {
        className: styles$B.chevron
      })) : React__default.createElement(components.Button, {
        variant: "primary-link",
        size: "small",
        className: styles$B.showMore,
        onClick: function onClick() {
          return setShowAllAttributes(true);
        }
      }, "Expand All Details ", React__default.createElement(ChevronDown$1, {
        className: styles$B.chevron
      }))))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

RequestConfirmationMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_REQUEST_CONFIRMATION && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId;
};

function formatMonetaryAmountAsJsx(amount, options) {
  if (options === void 0) {
    options = {
      sup: false,
      round: false
    };
  }

  var amountNumeral = numeral(amount.amount);
  var roundingFn;

  switch (options.round) {
    case 'ceil':
      roundingFn = Math.ceil;
      break;

    case 'floor':
      roundingFn = Math.ceil;
      break;

    case true:
      roundingFn = Math.round;
      break;
  }

  if (options.sup) {
    return React__default.createElement(React__default.Fragment, null, amountNumeral.format('$0,0', roundingFn), React__default.createElement("sup", {
      className: options.supClassName
    }, amountNumeral.format('.00', roundingFn)));
  } else {
    // Assumes that when rounding without <sup> tags, we don't want to display cents/decimals
    return amountNumeral.format(roundingFn ? '$0,0' : '$0,0.00', roundingFn);
  }
}

var styles$C = {"content":"styles_content__1qk3o p2","sellable-title":"styles_sellable-title__2RlL4","description":"styles_description__wXxgy","variations":"styles_variations__YWFdr flex flex-wrap","variant":"styles_variant__9eGF7 p1 flex flex-column items-center","duration":"styles_duration__8AGYT","price":"styles_price__3tFVk","sellableTitle":"styles_sellable-title__2RlL4"};

var ServiceCurationMessage = function ServiceCurationMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var orderId = message.parts[0].body.queryVariables.expertCuratedOrderId;
  return React__default.createElement(ServiceCurationMessageComponent, {
    variables: {
      id: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var image = data.expertCuratedOrder.order.primaryImage;
      var activeVariations = data.expertCuratedOrder.variationOptions.filter(function (variation) {
        return variation.enabled;
      });
      var title = activeVariations[0].sellable.title;
      var description = activeVariations[0].sellable.descriptionText;
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: image === null || image === void 0 ? void 0 : image.url
      }), React__default.createElement("div", {
        className: styles$C.content
      }, React__default.createElement("div", {
        className: styles$C.sellableTitle
      }, title), description && React__default.createElement("div", {
        className: styles$C.description
      }, lodash.truncate(description, {
        length: 150
      })), React__default.createElement("div", {
        className: styles$C.variations
      }, activeVariations.map(function (variation) {
        return React__default.createElement("div", {
          key: variation.sellable.id,
          className: styles$C.variant
        }, variation.sellable.variants[0] && React__default.createElement("div", {
          className: styles$C.duration
        }, variation.sellable.variants[0].displayValueHtml), React__default.createElement("div", {
          className: styles$C.price
        }, formatMonetaryAmountAsJsx(variation.price, {
          round: true
        })));
      }))), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_EXPERIENCE_ORDER,
            orderId: orderId
          });
        }
      }, "View Order Details"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

ServiceCurationMessage.handlesMessage = function (message) {
  var curatedMessagePartBodyTypes = ['new-expert-curated-order', 'new-system-curated-order'];
  var richCardTypes = [MessageRichCardType.NEW_BOOKABLE_CURATED_ORDER];
  return (richCardTypes.includes(message.parts[0].body.richCardType) || curatedMessagePartBodyTypes.includes(message.parts[0].body.type)) && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderId;
};

var styles$D = {"clickable-title":"styles_clickable-title__3KYvQ","content":"styles_content__34iPF p1","retailer-row":"styles_retailer-row__QIPPc p1 flex","current-price-row":"styles_current-price-row__28K9I styles_retailer-row__QIPPc p1 flex","variant-row":"styles_variant-row__F-XMR styles_retailer-row__QIPPc p1 flex","retailer":"styles_retailer__OYJm- flex-auto","price":"styles_price__1LHKc","text":"styles_text__hGN86 p1","clickableTitle":"styles_clickable-title__3KYvQ","retailerRow":"styles_retailer-row__QIPPc p1 flex","currentPriceRow":"styles_current-price-row__28K9I styles_retailer-row__QIPPc p1 flex","variantRow":"styles_variant-row__F-XMR styles_retailer-row__QIPPc p1 flex"};

var SellablePriceMatchMessage = function SellablePriceMatchMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  var oneDayAgoDate = new Date().getTime() + 1 * 24 * 60 * 60 * 1000;
  var isMessageExpired = oneDayAgoDate < message.sentAt.toDate().getTime();
  var sellableId = message.parts[0].body.queryVariables.sellableId;
  var priceMatchMessage = message.parts[1].body.text; // Unlikely, but in the event theres an error with manually entered JSON in the template,
  // we don't want to break rendering for any user forever.

  var priceComparisons = undefined;

  try {
    priceComparisons = message.parts[2].body.text ? JSON.parse(message.parts[2].body.text) : [];
  } catch (e) {}

  return React__default.createElement(SellableForPriceMatchComponent, {
    variables: {
      id: sellableId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    var _b;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.sellable) {
      var image = data.sellable.images[0];
      var title = data.sellable.title;
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        heroLabel: application === exports.Application.CONSUMER ? React__default.createElement("span", {
          className: styles$D.clickableTitle,
          onClick: function onClick() {
            return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
              type: exports.ConsumerRichCardEvents.VIEW_SELLABLE,
              id: data.sellable.id,
              slug: data.sellable.slug,
              friendlyId: data.sellable.friendlyId,
              sellableType: data.sellable.type
            });
          }
        }, title) : React__default.createElement(React__default.Fragment, null, title),
        imageUrl: image === null || image === void 0 ? void 0 : image.url
      }), priceComparisons && React__default.createElement("div", {
        className: styles$D.content
      }, React__default.createElement("div", null, React__default.createElement("div", {
        className: styles$D.currentPriceRow
      }, React__default.createElement("div", {
        className: styles$D.retailer
      }, React__default.createElement("strong", null, "Curated price:")), React__default.createElement("div", {
        className: styles$D.price
      }, numeral(priceComparisons.price).format('$0,0.00'))), React__default.createElement("div", {
        className: styles$D.retailerRow
      }, React__default.createElement("div", {
        className: styles$D.retailer
      }, React__default.createElement("strong", null, "Other retailers:"))), (_b = priceComparisons.otherOnlineRetails) === null || _b === void 0 ? void 0 : _b.map(function (onlineRetailer, idx) {
        return React__default.createElement("div", {
          key: idx,
          className: styles$D.variantRow
        }, React__default.createElement("div", {
          className: styles$D.retailer
        }, onlineRetailer.retailer), React__default.createElement("div", {
          className: styles$D.price
        }, numeral(onlineRetailer.price).format('$0,0.00')));
      }))), React__default.createElement("div", {
        className: styles$D.text
      }, priceMatchMessage), application === exports.Application.BUSINESS && React__default.createElement(React__default.Fragment, null, isMessageExpired ? React__default.createElement(CallToAction, {
        disabled: true
      }, "This request has expired") : React__default.createElement(CallToAction, {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.BusinessRichCardEvents.OPEN_QUICK_CURATION_FLYOUT
          });
        }
      }, "Add to Curation"))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

SellablePriceMatchMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType === MessageRichCardType.SELLABLE_PRICE_MATCH_REQUESTED && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.sellableId && // These parts contain the price comparisons
  message.parts[1].body.text && message.parts[2].body.text;
};

var styles$E = {"expert-name":"styles_expert-name__2voS6","tip-explanation":"styles_tip-explanation__36lt4","caption":"styles_caption__qkgiv","select-tip-amount":"styles_select-tip-amount__3kMed","tip-selector":"styles_tip-selector__1YraP flex","tip-selector-enabled":"styles_tip-selector-enabled__3YliB","tip-selector-disabled":"styles_tip-selector-disabled__3vh4A","tip-option":"styles_tip-option__1QkMR","checked":"styles_checked__33aW8","custom-tip-option":"styles_custom-tip-option__23aai","custom-tip":"styles_custom-tip__3RM7G","expertName":"styles_expert-name__2voS6","tipExplanation":"styles_tip-explanation__36lt4","selectTipAmount":"styles_select-tip-amount__3kMed","tipSelector":"styles_tip-selector__1YraP flex","tipSelectorEnabled":"styles_tip-selector-enabled__3YliB","tipSelectorDisabled":"styles_tip-selector-disabled__3vh4A","tipOption":"styles_tip-option__1QkMR","customTipOption":"styles_custom-tip-option__23aai","customTip":"styles_custom-tip__3RM7G"};

var TipSelector = function TipSelector(_a) {
  var _b;

  var order = _a.order;
  var isOrderPaid = order.state == OrderState.CONSUMER_PAYMENT_COMPLETED;
  var tipAmountPaid = isOrderPaid && order.tip ? numeral(order.tip.amount).value() : 0;
  var amountOptions = order.tipMethod.__typename === 'TipMethodFixedAmount' ? order.tipMethod.amountOptions : [];
  var isCustomTip = isOrderPaid && order.tip && amountOptions.find(function (option) {
    return numeral(option.amount).value() === tipAmountPaid;
  }) === undefined;
  return React__default.createElement("div", {
    className: styles$E.tipSelector
  }, amountOptions.map(function (option, idx) {
    var _a;

    var optionAmount = numeral(option.amount);
    var optionClasses = classnames(styles$E.tipOption, (_a = {}, _a[styles$E.checked] = optionAmount.value() === tipAmountPaid, _a));
    return React__default.createElement("div", {
      key: idx,
      className: optionClasses
    }, optionAmount.format('$0'));
  }), React__default.createElement("div", {
    className: classnames(styles$E.tipOption, (_b = {}, _b[styles$E.customTip] = isCustomTip, _b))
  }, isCustomTip ? numeral(tipAmountPaid).format('$0.00') : 'Custom'));
};

var SimpleCuratedOrderMessage = function SimpleCuratedOrderMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  var richCardEventEmitter = useRichCardEventEmitter();
  var orderId = message.parts[0].body.queryVariables.simpleCuratedOrderId;
  var application = useApplicationContext().application;
  React.useEffect(function () {
    onLoaded();
  }, []);
  return React__default.createElement(SimpleCuratedOrderMessageComponent, {
    variables: {
      id: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    var _b, _c;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading ...");
    } else if (data === null || data === void 0 ? void 0 : data.simpleCuratedOrder) {
      var curatedByExpert = data.simpleCuratedOrder.curator;
      var order = data.simpleCuratedOrder.order;
      var isOrderPaid = data.simpleCuratedOrder.order.state == OrderState.CONSUMER_PAYMENT_COMPLETED;
      var tipAmountPaid = isOrderPaid && order.tip ? numeral(order.tip.amount).format('$0') : '0';
      var category = data.simpleCuratedOrder.lead && data.simpleCuratedOrder.lead.category;
      var banner = category && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
      var expertName = curatedByExpert.displayName;
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, React__default.createElement(components.Avatar, {
          size: 60,
          name: expertName,
          src: (_c = (_b = curatedByExpert.expertProfile) === null || _b === void 0 ? void 0 : _b.profilePhoto) === null || _c === void 0 ? void 0 : _c.url
        }), React__default.createElement("div", {
          className: styles$E.expertName
        }, expertName), React__default.createElement("div", {
          className: styles$E.tipExplanation
        }, "100% of your tip goes to ", curatedByExpert.shortName))
      }), isOrderPaid ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles$E.caption
      }, React__default.createElement("div", null, React__default.createElement("strong", null, "Thank you for your ", tipAmountPaid, " tip!")), React__default.createElement("div", null, "We're glad you enjoyed working with ", curatedByExpert.shortName)), React__default.createElement("div", {
        className: styles$E.tipSelectorDisabled
      }, React__default.createElement("div", {
        className: styles$E.selectTipAmount
      }, "Tip amount"), React__default.createElement(TipSelector, {
        order: order
      }))) : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles$E.caption
      }, "Thank your expert for their time and expertise by leaving an optional tip!"), React__default.createElement("div", {
        className: styles$E.tipSelectorEnabled
      }, React__default.createElement("div", {
        className: styles$E.selectTipAmount
      }, "Select tip amount"), application === exports.Application.CONSUMER ? React__default.createElement("div", {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: exports.ConsumerRichCardEvents.VIEW_ORDER_CHECKOUT,
            orderId: data.simpleCuratedOrder.order.id
          });
        }
      }, React__default.createElement(TipSelector, {
        order: order
      })) : React__default.createElement(TipSelector, {
        order: order
      }))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

SimpleCuratedOrderMessage.handlesMessage = function (message) {
  return message.parts[0].body.richCardType == MessageRichCardType.SIMPLE_CURATED_ORDER && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.simpleCuratedOrderId;
};

var TextMessage = function TextMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  React.useEffect(function () {
    onLoaded();
  }, []);
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageTextPart, {
      key: idx,
      part: part,
      myself: myself
    });
  }));
};

TextMessage.handlesMessage = function (message) {
  var acceptedTypes = new Set(['TEXT', 'TEMPLATE_TEXT', 'SHORTENED_TEMPLATE', 'TEMPLATE']);
  return message.parts.length === 1 && acceptedTypes.has(message.parts[0].type);
};

var VideoMessage = function VideoMessage(_a) {
  var onLoaded = _a.onLoaded,
      myself = _a.myself,
      message = _a.message;
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageVideoPart, {
      key: idx,
      part: part,
      onLoaded: onLoaded,
      myself: myself
    });
  }));
};

VideoMessage.handlesMessage = function (message) {
  return message.parts.length === 1 && message.parts[0].type === 'VIDEO';
};

var MessageContainer =
/** @class */
function (_super) {
  __extends(MessageContainer, _super);

  function MessageContainer(props) {
    var _this = _super.call(this, props) || this;
    /**
     * A list of React components available to render messages. Each message component must
     *   implement a static `handlesMessage` method that determines whether it can render
     *   a given message.
     *
     * Note: Order matters! The first component that can handle a message is used.
     */


    _this.coreMessages = [ImageMessage, VideoMessage, AudioMessage, CarouselMessage, TextMessage, HyperLinkTextMessage, FileMessage, ErrorMessage];
    /**
     * A list of rich card messages to render `rich` content. Order isn't important here
     *    as cards are selected via the `MessageRichCardType` enum.
     */

    _this.richCardMessages = [ContactCollectionMessage, CuratedOrderList, CustomExpertCuratedOrderMessage, ExpertJoinedMessage, FeedbackRequestMessage$1, GuestChatCreateRequestMessage, HowCuratedWorksMessage, PaymentVerificationMessage, ProductCurationMessage, ReferralMessage, SellablePriceMatchMessage, ServiceCurationMessage, SimpleCuratedOrderMessage, ProductQuizMessage, RequestConfirmationMessage, InterestedInOrderMessage];
    _this.state = {
      isRead: props.message.read
    };
    _this.handlePositionChange = _this.handlePositionChange.bind(_this);
    _this.handleMessageRead = _this.handleMessageRead.bind(_this);
    return _this;
  }

  MessageContainer.prototype.handleMessageRead = function () {
    this.setState({
      isRead: true
    });
  };

  MessageContainer.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.enableReadReceipts !== this.props.enableReadReceipts) {
      this.props.message.conversation.markConversationRead(this.props.message.messageId);
    }
  };

  MessageContainer.prototype.componentDidMount = function () {
    var _this = this;

    if (!this.props.message.initialized) {
      this.props.message.once('initialized', function () {
        return _this.forceUpdate();
      }, this);
    }

    this.props.message.on('read', this.handleMessageRead);
  };

  MessageContainer.prototype.componentWillUnmount = function () {
    this.props.message.off('initialized', undefined, this);
    this.props.message.off('read', this.handleMessageRead);
  };

  MessageContainer.prototype.handlePositionChange = function (_a) {
    var _this = this;

    var currentPosition = _a.currentPosition;

    if (currentPosition === Waypoint.inside && !this.props.impersonating && this.props.enableReadReceipts !== false) {
      // @ts-ignore TODO: Runtime require/import with Rollup? See: https://github.com/rollup/rollup/issues/1807
      var Visibility = require('visibilityjs');

      Visibility.onVisible(function () {
        _this.props.message.conversation.markConversationRead(_this.props.message.messageId);
      });
    }
  };

  MessageContainer.prototype.handleError = function (error) {
    throw new Error(error);
  };

  MessageContainer.prototype.render = function () {
    var _this = this;

    var client = this.props.chatClient;
    var myself = client && client.myself;

    if (!this.props.message.initialized || !myself) {
      // Not initialized, or the client isn't available, so don't render the message
      return null;
    }
    /**
     * This needs to follow a specific priority
     * 1. Custom message components (passed in prop)
     * 2. Rich card messages (defined enum)
     * 3. Core message types
     */


    var messageComponents = __spreadArrays(this.props.customMessageComponents, this.richCardMessages, this.coreMessages);

    var MessageComponent = messageComponents.find(function (handler) {
      return handler.handlesMessage(_this.props.message);
    });

    if (MessageComponent) {
      /**
       *  TODO: This <div> complicates styling, because it breaks the flexbox.
       *  See: MessageGroup/styles.css
       *  MessageRow assumes there is only one child. If this is no longer the case, MessageRow will need to be updated
       */
      var message = React__default.createElement("div", null, React__default.createElement(ScrollConsumer, null, function (_a) {
        var scrollToTarget = _a.scrollToTarget;
        return React__default.createElement(MessageRow, {
          message: _this.props.message,
          nextMessage: _this.props.nextMessage,
          nextMessageBySameParticipant: _this.props.nextMessageBySameParticipant
        }, React__default.createElement(MessageComponent, {
          message: _this.props.message,
          myself: myself,
          onError: _this.handleError,
          onLoaded: scrollToTarget
        }));
      }));

      if (this.state.isRead) {
        return message;
      } else {
        return React__default.createElement(Waypoint, {
          onPositionChange: this.handlePositionChange
        }, message);
      }
    } else {
      throw new Error('Unknown message type');
    }
  };

  return MessageContainer;
}(React__default.Component);

var Message = withChat(MessageContainer);

var ExchangeContainer =
/** @class */
function (_super) {
  __extends(ExchangeContainer, _super);

  function ExchangeContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.getChannelsForMessage = _this.getChannelsForMessage.bind(_this);
    _this.getChannelsForGroup = _this.getChannelsForGroup.bind(_this);
    _this.isConversationMessage = _this.isConversationMessage.bind(_this);
    _this.getMessages = _this.getMessages.bind(_this);
    _this.getNextMessage = _this.getNextMessage.bind(_this);
    _this.getNextMessageBySameParticipant = _this.getNextMessageBySameParticipant.bind(_this);
    _this.getSenderForConversationItem = _this.getSenderForConversationItem.bind(_this);
    return _this;
  }
  /**
   * Get the messaging channels (sms, email, facebook, etc.) used to send a single message.
   */


  ExchangeContainer.prototype.getChannelsForMessage = function (message) {
    switch (message.sentVia) {
      case chatFirebaseClient.MessageChannel.EMAIL:
        return new Set([chatFirebaseClient.MessageChannel.EMAIL]);

      case chatFirebaseClient.MessageChannel.FACEBOOK:
        return new Set([chatFirebaseClient.MessageChannel.FACEBOOK]);

      case chatFirebaseClient.MessageChannel.SMS:
        return new Set([chatFirebaseClient.MessageChannel.SMS]);
    }

    return new Set();
  };
  /**
   * Get the messaging channels (sms, email, facebook, etc.) used to send a group of messages.
   */


  ExchangeContainer.prototype.getChannelsForGroup = function (group) {
    var _this = this;

    var channels = new Set();
    group.forEach(function (conversationItem) {
      conversationItem.type === 'Message' && _this.getChannelsForMessage(conversationItem.message).forEach(function (channel) {
        channels.add(channel);
      });
    });
    return channels;
  };

  ExchangeContainer.prototype.isConversationMessage = function (item) {
    return item.type === 'Message';
  };
  /**
   * Return all the FirebaseMessages in this exchange's items
   *
   * TODO: memoization
   */


  ExchangeContainer.prototype.getMessages = function () {
    return this.props.items.filter(this.isConversationMessage).map(function (item) {
      return item.message;
    });
  };
  /**
   * Given a FirebaseMessage, determine the next message in the conversation.
   */


  ExchangeContainer.prototype.getNextMessage = function (message) {
    var messages = this.getMessages();
    var currentMessageIndex = messages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    return messages[currentMessageIndex - 1];
  };
  /**
   * Given a FirebaseMessage, determine the next message sent by the same participant.
   */


  ExchangeContainer.prototype.getNextMessageBySameParticipant = function (message) {
    // Filter out messages from other participants
    var myMessages = this.getMessages().filter(function (message) {
      return message.sentBy.isMyself;
    });
    var currentMessageIndex = myMessages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    return myMessages[currentMessageIndex - 1];
  };

  ExchangeContainer.prototype.getSenderForConversationItem = function (item) {
    if (item.type === 'Message' && this.props.showRealSender) {
      return item.message.realSender;
    } else if (item.type === 'Message') {
      return item.message.sentBy;
    } else {
      return undefined;
    }
  };

  ExchangeContainer.prototype.getCampaignForAutoMessage = function (message) {
    for (var _i = 0, _a = message.parts; _i < _a.length; _i++) {
      var part = _a[_i];
      return part.body && part.body.tracking && part.body.tracking.campaign || undefined;
    }
  };

  ExchangeContainer.prototype.isConversationItemAutoMessage = function (item) {
    if (item.type === 'Message') {
      // We only started including "richCardType" after April 2019. Rich card messages before
      //   then will not be distinguishable from auto messages.
      var isAfterApril2019 = dateFns.isAfter(item.message.sentAt.toDate(), new Date('2019-04-01T00:00:00.000Z'));
      return isAfterApril2019 && item.message.parts.some(function (part) {
        return part.type === 'TEMPLATE_CAROUSEL' && !part.body.hasOwnProperty('richCardType');
      });
    } else {
      return false;
    }
  };

  ExchangeContainer.prototype.render = function () {
    var _this = this;
    /**
     * Chunk this exchange of messages into messages sent by the same user ("message groups").
     *
     * If the viewer is not a consumer, we also create distinct groups for auto messages vs real messages.
     *
     * This logic requires the messages to be sorted.
     */


    var groups = this.props.items.reduce(function (accumulatedGroups, current, index, messages) {
      var previous = messages[index - 1];

      var currentSender = _this.getSenderForConversationItem(current);

      var prevSender = previous && _this.getSenderForConversationItem(previous);

      var currentSenderId = currentSender && currentSender.userId;
      var prevSenderId = prevSender && prevSender.userId;

      var currentIsAutoMessage = _this.isConversationItemAutoMessage(current);

      var prevIsAutoMessage = previous && _this.isConversationItemAutoMessage(previous); // We only want to distinguish between auto messages and real messages for non-consumers


      var isMyselfConsumer = _this.props.chatClient && _this.props.chatClient.myself.type === 'USER';

      if (!previous || currentSenderId !== prevSenderId || !isMyselfConsumer && currentIsAutoMessage !== prevIsAutoMessage) {
        accumulatedGroups.push([]);
      }

      accumulatedGroups[accumulatedGroups.length - 1].push(current);
      return accumulatedGroups;
    }, []);

    if (!this.props.items.length) {
      return null;
    }

    return React__default.createElement(Exchange, {
      startedAt: this.props.items[this.props.items.length - 1].time
    }, groups.map(function (group, idx) {
      var channels = Array.from(_this.getChannelsForGroup(group));
      var lastItem = group[group.length - 1];
      var firstMessage = group.find(function (group) {
        return group.type === 'Message';
      });
      var autoMessage = firstMessage ? _this.isConversationItemAutoMessage(firstMessage) : false;
      var sender = firstMessage && _this.getSenderForConversationItem(firstMessage) || null;
      var persona = !sender ? null : _this.props.showRealSender && firstMessage && firstMessage.type === 'Message' && firstMessage.message.sentBy.userId !== sender.userId ? firstMessage.message.sentBy.displayName : null;
      return React__default.createElement(MessageGroup$1, {
        sender: sender,
        sentAt: firstMessage && firstMessage.time,
        persona: persona,
        channels: channels,
        metadata: autoMessage && firstMessage ? {
          type: 'auto-message',
          campaign: _this.getCampaignForAutoMessage(firstMessage.message)
        } : undefined,
        type: firstMessage ? 'message' : 'event',
        key: idx + ":" + group.length + (lastItem ? ":" + lastItem.time.toISOString() : '')
      }, group.map(function (conversationItem) {
        return conversationItem.type === 'Message' ? React__default.createElement(Message, {
          message: conversationItem.message,
          nextMessage: _this.getNextMessage(conversationItem.message),
          enableReadReceipts: _this.props.enableReadReceipts,
          nextMessageBySameParticipant: _this.getNextMessageBySameParticipant(conversationItem.message),
          key: conversationItem.message.messageId
        }) : conversationItem.event.element;
      }));
    }));
  };

  return ExchangeContainer;
}(React.Component);

var Exchange$1 = withChat(ExchangeContainer);

var MessageQuery =
/** @class */
function (_super) {
  __extends(MessageQuery, _super);

  function MessageQuery(props) {
    var _this = _super.call(this, props) || this; // TODO: Call `load` in the constructor to prevent this loading state.
    //   We will need to remove the state side-effects of `load` first.


    _this.state = {
      loading: !!_this.props.conversation
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    _this.fetchMore = _this.fetchMore.bind(_this);
    _this.handleMessagesLoaded = _this.handleMessagesLoaded.bind(_this);
    return _this;
  }

  MessageQuery.prototype.componentDidMount = function () {
    if (!this.query) {
      this.load(this.props.conversation);
    }
  };

  MessageQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available, or no conversation ID provided
    if (!this.props.chatClient) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (this.props.chatClient && (prevProps.authenticatedUserId !== this.props.authenticatedUserId || prevProps.conversation.conversationId !== this.props.conversation.conversationId)) {
      this.cancel();
      this.load(this.props.conversation);
    }
  };

  MessageQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  MessageQuery.prototype.load = function (conversation) {
    this.query = conversation.getMessageQuery(this.props.pageSize);

    if (this.query.initialized) {
      // If the query is already initialized, handle the existing messages and skip the loading state.
      this.handleMessagesLoaded();
    } else {
      // Otherwise, enter a loading state and handle the results asyncronously.
      this.setState({
        messages: undefined,
        loading: true
      });
    }

    this.query.once('initialized', this.handleMessagesLoaded, this);
    this.query.on('updated', this.handleMessagesLoaded, this);
  };

  MessageQuery.prototype.cancel = function () {
    if (this.query) {
      this.query.off('initialized', this.handleMessagesLoaded, this);
      this.query.off('updated', this.handleMessagesLoaded, this);
      this.query.close();
      delete this.query;
    }
  };

  MessageQuery.prototype.handleMessagesLoaded = function () {
    if (this.query) {
      var _a = this.query,
          messages = _a.messages,
          hasMore = _a.hasMore;
      /**
       * Call "onCompleted" before setting loading = false so that the fetchEvents query is called first (if provided)
       * This prevents the converation from attempting to render until all the needed data is fetched (including any potential events)
       */

      if (this.props.onCompleted) {
        this.props.onCompleted({
          messages: messages,
          hasMore: hasMore
        });
      }

      this.setState({
        messages: messages,
        hasMore: hasMore,
        loading: false
      });
    }
  };

  MessageQuery.prototype.fetchMore = function () {
    var _this = this;

    if (this.query) {
      this.setState({
        loading: true
      });
      return this.query.more(this.props.fetchMorePageSize).then(function (_a) {
        var messages = _a.messages,
            hasMore = _a.hasMore;

        _this.setState({
          loading: false,
          messages: messages
        });

        return {
          messages: messages,
          hasMore: hasMore
        };
      });
    }

    return Promise.resolve({
      messages: this.state.messages,
      hasMore: this.state.hasMore
    });
  };

  MessageQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the query is unfinished. We also
     *    need to consider the loading/auth state of the Firebase client itself.
     */
    var loading = this.state.loading || !this.props.chatClient;
    return this.props.children({
      loading: loading,
      messages: this.state.messages,
      hasMore: this.state.hasMore,
      fetchMore: this.fetchMore
    });
  };

  MessageQuery.defaultProps = {
    pageSize: 25,
    fetchMorePageSize: 25
  };
  return MessageQuery;
}(React.Component);

var MessageQueryConversationLoader = function MessageQueryConversationLoader(_a) {
  var conversationId = _a.conversationId,
      children = _a.children,
      rest = __rest(_a, ["conversationId", "children"]);

  return React__default.createElement(ConversationQuery$1, {
    conversationId: conversationId
  }, function (_a) {
    var loading = _a.loading,
        conversation = _a.conversation;

    if (loading) {
      return children({
        loading: true,
        fetchMore: function fetchMore() {
          return Promise.resolve({});
        }
      });
    }

    if (!conversationId) {
      return children({
        loading: false,
        hasMore: false,
        fetchMore: function fetchMore() {
          return Promise.resolve({});
        }
      });
    }

    return React__default.createElement(MessageQuery, __assign({
      conversation: conversation
    }, rest), function (_a) {
      var error = _a.error,
          hasMore = _a.hasMore,
          loading = _a.loading,
          fetchMore = _a.fetchMore,
          messages = _a.messages;
      return children({
        error: error,
        hasMore: hasMore,
        loading: loading,
        fetchMore: fetchMore,
        messages: messages
      });
    });
  });
};

var MessageQuery$1 = withChat(MessageQueryConversationLoader);

/**
 * Get the guest conversation message sequence for the provided expert ID, and kick off
 *   execution of that sequence.
 *
 * This method must be idempotent. It is called repeatedly when the conversation,
 *   recipients, or chat client state changes.
 */

function startGuestConversation(startGuestConversationMutationFn, conversation, recipientIds) {
  // Only start the conversation if it is a local conversation
  var isLocalConversation = conversation && chatFirebaseClient.LocalConversationId.isLocalConversationId(conversation.conversationId); // Assume the first recipient is the expert

  var expertId = recipientIds && recipientIds[0]; // Start the guest conversation

  if (conversation && isLocalConversation && conversation instanceof chatFirebaseClient.LocalConversationModel && expertId) {
    startGuestConversationMutationFn({
      variables: {
        input: {
          expertId: expertId
        }
      }
    }).then(function (result) {
      if (result && result.data && result.data.startGuestConversation) {
        var _a = result.data.startGuestConversation.conversation,
            messages = _a.messages,
            signature = _a.signature;
        var sequence = {
          messages: messages.map(function (gqlMessage) {
            return {
              id: gqlMessage.id,
              parts: gqlMessage.parts.map(function (gqlPart) {
                return {
                  type: gqlPart.type,
                  body: JSON.parse(gqlPart.body)
                };
              }),
              typeAt: gqlMessage.typeAt,
              sendAt: gqlMessage.sendAt,
              sendBy: gqlMessage.sendBy.id
            };
          }),
          signature: signature
        };
        conversation.startMessageSequence(sequence);
      }
    });
  }
}

var ChunkMethod;

(function (ChunkMethod) {
  ChunkMethod[ChunkMethod["DATE"] = 0] = "DATE";
  ChunkMethod[ChunkMethod["IDLE_TIME"] = 1] = "IDLE_TIME";
})(ChunkMethod || (ChunkMethod = {}));

var ConversationContainer =
/** @class */
function (_super) {
  __extends(ConversationContainer, _super);

  function ConversationContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      queryCompleted: false
    };
    _this.scrollableElement = React__default.createRef();
    _this.toConversationItem = _this.toConversationItem.bind(_this);
    _this.handleQueryCompleted = _this.handleQueryCompleted.bind(_this);
    return _this;
  }

  ConversationContainer.prototype.componentDidMount = function () {
    if (this.props.guestChatEnabled) {
      startGuestConversation(this.props.startGuestConversation, this.props.conversation, this.props.recipientIds);
    }
  };

  ConversationContainer.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.chatClient !== this.props.chatClient || prevProps.conversation !== this.props.conversation || prevProps.authenticatedUserId !== this.props.authenticatedUserId || xor(prevProps.recipientIds || [], this.props.recipientIds || []).length > 0) {
      if (this.props.guestChatEnabled) {
        startGuestConversation(this.props.startGuestConversation, this.props.conversation, this.props.recipientIds);
      }
    }
  };

  ConversationContainer.prototype.getConversationRange = function (result) {
    var messages = result.messages;

    if (!messages || messages.length === 0) {
      return {
        start: null,
        end: new Date().toISOString()
      };
    }

    return {
      start: result.hasMore ? messages[messages.length - 1].sentAt.toDate().toISOString() : null,
      // Gets the most recent events (even if more recent than last message)
      end: null
    };
  };

  ConversationContainer.prototype.handleQueryCompleted = function (result) {
    if (result.messages) {
      // Fetch events that occured during this time range (the range from the oldest loaded message until now)
      var conversationRange = this.getConversationRange(result);

      if (this.props.fetchEvents) {
        this.props.fetchEvents(conversationRange.start, conversationRange.end);
      } // Determine the parent element to use as the scroll context (for manual scroll position correction)


      this.setState({
        queryCompleted: true
      });
    }
  };

  ConversationContainer.prototype.isMessageModel = function (arg) {
    return arg.read !== undefined;
  };

  ConversationContainer.prototype.toConversationItem = function (item) {
    if (this.isMessageModel(item)) {
      return {
        time: item.sentAt.toDate(),
        type: 'Message',
        message: item
      };
    } else {
      return {
        time: new Date(item.occuredAt),
        type: 'Event',
        event: item
      };
    }
  };
  /**
   * Merge Firebase conversation messages and user events into single sorted array
   *   of conversation items
   */


  ConversationContainer.prototype.mergeMessagesAndEvents = function (messages, events) {
    var _this = this;

    var conversationItems = concat(messages, events).reduce(function (acc, currentItem) {
      var newItem = _this.toConversationItem(currentItem);

      acc.push(newItem);
      return acc;
    }, []); // Sort array messages and events by date

    var sortedConversationItems = conversationItems.sort(function (a, b) {
      if (dateFns.isAfter(a.time, b.time)) return -1;
      if (dateFns.isAfter(b.time, a.time)) return 1;else return 0;
    });
    return sortedConversationItems;
  };
  /**
   * Given a list of conversation items, group them into "exchanges". Two chunking algoriths
   *   are supported:
   *  1) Chunking messages occuring in quick succession (i.e. no more than 5 minutes between any two items)
   *  2) Chunking messages by date
   *
   * Note: The conversation items MUST be sorted before chunking.
   */


  ConversationContainer.prototype.chunkConversationItems = function (conversationItems, chunkBy) {
    var IDLE_MINUTES = 5;
    return reduce(conversationItems, function (accumulatedExchanges, current, index, messages) {
      var previous = messages[index - 1]; // Create a new chunk if:
      //  - This is the first item
      //  - Or, we are chunking by date and the current item is a different date than the previous
      //  - Or, we are chunking by idle time and the current item is more than IDLE_MINUTES after the previous

      var isNewChunk = !previous || (chunkBy === ChunkMethod.DATE ? !dateFns.isSameDay(previous.time, current.time) : Math.abs(dateFns.differenceInMinutes(previous.time, current.time)) > IDLE_MINUTES);

      if (isNewChunk) {
        accumulatedExchanges.push([]);
      }

      accumulatedExchanges[accumulatedExchanges.length - 1].push(current);
      return accumulatedExchanges;
    }, []);
  };

  ConversationContainer.prototype.render = function () {
    var _this = this;

    var conversationId = this.props.conversation && this.props.conversation.conversationId;
    var conversationLoading = this.props.loading;
    /**
     * Once events are loaded they will be in the form Event[]
     * Events are fetched on every new message, but we want to only show the loader during the initial query
     * */

    var eventsLoading = this.props.eventsLoading && typeof this.props.events === 'undefined' ? true : false;
    return React__default.createElement(ChatActionsProvider, {
      messageAction: this.props.messageAction
    }, React__default.createElement(Scrollable, {
      element: this.scrollableElement,
      conversationId: conversationId
    }, React__default.createElement(MessageQuery$1, {
      conversationId: conversationId,
      onCompleted: this.handleQueryCompleted
    }, function (_a) {
      var messagesLoading = _a.loading,
          messages = _a.messages,
          hasMore = _a.hasMore,
          fetchMore = _a.fetchMore;
      var loading = conversationLoading || messagesLoading || eventsLoading;
      var exchanges = [];

      if (messages) {
        var conversationItems = _this.mergeMessagesAndEvents(messages, _this.props.events || []);

        exchanges = _this.chunkConversationItems(conversationItems, ChunkMethod.DATE);
      } // Render children if the conversation doesn't exist, or if we've reached the top of the conversation


      var showConversationStarter = !conversationId || !hasMore && !loading;
      return React__default.createElement(Conversation, {
        loading: loading,
        hasMore: hasMore || false,
        onInfiniteLoad: fetchMore,
        scrollableElementRef: _this.scrollableElement,
        onClick: _this.props.onClick,
        className: _this.props.conversationClassName
      }, showConversationStarter && _this.props.children, loading && React__default.createElement(Loader, {
        size: "22px",
        color: "#087bcc",
        thickness: "3px"
      }), exchanges && !eventsLoading && exchanges.reverse().map(function (exchange) {
        // Key by the last item in the exchange so that exchanges are stable
        //   even if older items are loaded later
        var lastItem = exchange[exchange.length - 1];
        return React__default.createElement(Exchange$1, {
          items: exchange,
          showRealSender: _this.props.showRealSender,
          enableReadReceipts: _this.props.enableReadReceipts,
          key: lastItem.type === 'Message' ? "exchange:message:" + lastItem.message.messageId : "exchange:event:" + lastItem.event.occuredAt
        });
      }), conversationId && React__default.createElement(TypingIndicator$1, {
        conversationId: conversationId
      }));
    })));
  };

  return ConversationContainer;
}(React.Component);

var ConversationWithMutation = function ConversationWithMutation(props) {
  var startGuestConversation = useStartGuestConversationMutation()[0];
  return React__default.createElement(ConversationQuery$1, {
    conversationId: props.conversationId,
    recipientIds: props.guestChatEnabled ? props.recipientIds : undefined
  }, function (_a) {
    var loading = _a.loading,
        conversation = _a.conversation;
    return React__default.createElement(ConversationContainer, __assign({
      startGuestConversation: startGuestConversation,
      conversation: conversation,
      loading: loading
    }, props));
  });
};

var Conversation$1 = withChat(ConversationWithMutation);

var styles$F = {"chat":"styles_chat__1aCmL flex flex-auto flex-column"};

var Chat = function Chat(_a) {
  var children = _a.children;
  return React__default.createElement("div", {
    className: styles$F.chat
  }, children);
};

var styles$G = {"control":"styles_control__11--R px1","collapsed":"styles_collapsed__hbtY3","flat":"styles_flat__2F6VP flex items-center justify-center"};

var Controls = function Controls(_a) {
  var controls = _a.controls,
      conversationId = _a.conversationId,
      onAttach = _a.onAttach,
      onAppendText = _a.onAppendText,
      collapsed = _a.collapsed,
      onError = _a.onError;
  return React__default.createElement(React__default.Fragment, null, controls.map(function (Control, index) {
    var _a;

    return React__default.createElement("div", {
      key: index,
      className: classnames(styles$G.control, styles$G.flat, (_a = {}, _a[styles$G.collapsed] = collapsed, _a))
    }, React__default.createElement(Control, {
      conversationId: conversationId,
      attach: onAttach,
      appendText: onAppendText,
      onError: onError
    }));
  }));
};

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ExpandFlatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-1-1h16v16H-1z"
  }), React__default.createElement("path", {
    d: "M7.5 4.5v6m-3-3h6m3 7h-12a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var DetachIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-7-7h24v24H-7z"
  }), React__default.createElement("path", {
    d: "M9 1L1 9m8 0L1 1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })));
});

var styles$H = {"composer":"styles_composer__3Bulu fit flex flex-auto flex-column","content":"styles_content__8SuaW flex","preview":"styles_preview__a7XtZ flex p2","attachment":"styles_attachment__2vXZP relative mr2","detach":"styles_detach__3x0WM absolute flex items-center justify-center","detach-icon":"styles_detach-icon__3JYXD","tray":"styles_tray__3iFm0 flex flex-auto items-center px2","input":"styles_input__180l- flex-auto my1 border-none","send":"styles_send__3MP8w bold items-end m1 p1 border-none","disabled":"styles_disabled__3FSQ6 styles_send__3MP8w bold items-end m1 p1 border-none","expand":"styles_expand__33fqy","expand-icon":"styles_expand-icon__1iKK-","text-area-wrapper":"styles_text-area-wrapper__1T03P flex flex-auto","flat":"styles_flat__2eTgn","detachIcon":"styles_detach-icon__3JYXD","expandIcon":"styles_expand-icon__1iKK-","textAreaWrapper":"styles_text-area-wrapper__1T03P flex flex-auto"};

var Composer = function Composer(_a) {
  var collapsed = _a.collapsed,
      controls = _a.controls,
      attachments = _a.attachments,
      setComposerRef = _a.setComposerRef,
      onFocus = _a.onFocus,
      onAppendText = _a.onAppendText,
      onAttach = _a.onAttach,
      onDetach = _a.onDetach,
      onChange = _a.onChange,
      onExpand = _a.onExpand,
      onSubmit = _a.onSubmit,
      text = _a.text,
      loading = _a.loading,
      conversationId = _a.conversationId;
  var button = React.useRef(null);

  var handleKeyPress = function handleKeyPress(event) {
    // Submit the form on "Enter", unless it was "Shift+Enter"
    // React fires a synthetic event for form submissions, so we click the submit button to trigger the event
    if (event.key === 'Enter' && !event.shiftKey && button.current) {
      button.current.click();
      event.preventDefault();
    }
  };

  return React__default.createElement("form", {
    className: classnames(styles$H.composer, styles$H.flat),
    onSubmit: onSubmit
  }, attachments && attachments.length > 0 && React__default.createElement("div", {
    className: styles$H.preview
  }, attachments.map(function (attachment, index) {
    var PreviewComponent = attachment.previewer;
    return React__default.createElement("div", {
      key: index,
      className: styles$H.attachment
    }, React__default.createElement("div", {
      className: styles$H.detach,
      onClick: function onClick() {
        return onDetach(index);
      }
    }, React__default.createElement(DetachIcon, {
      className: styles$H.detachIcon
    })), React__default.createElement(PreviewComponent, {
      data: attachment.data
    }));
  })), React__default.createElement("div", {
    className: styles$H.tray
  }, React__default.createElement("div", {
    className: styles$H.textAreaWrapper
  }, React__default.createElement(TextArea, {
    innerRef: setComposerRef,
    className: styles$H.input,
    onFocus: onFocus,
    value: text || '',
    placeholder: "Send a message...",
    onChange: onChange,
    onKeyPress: handleKeyPress,
    disabled: loading
  })), !collapsed && React__default.createElement(Controls, {
    conversationId: conversationId,
    controls: controls || [],
    onAttach: onAttach,
    onAppendText: onAppendText,
    collapsed: collapsed,
    onError: console.log
  }), collapsed && controls && controls.length ? React__default.createElement("div", {
    className: styles$H.expand,
    onClick: onExpand
  }, React__default.createElement(ExpandFlatIcon, {
    className: styles$H.expandIcon
  })) : null, React__default.createElement("button", {
    type: "submit",
    className: !loading ? styles$H.send : styles$H.disabled,
    ref: button
  }, "Send")));
};

/**
 * Execute a set of Promises in series. Accepts an array of functions returning Promises.
 *
 * From: https://hackernoon.com/functional-javascript-resolving-promises-sequentially-7aac18c4431e
 */
function promiseSerial(promises) {
  return promises.reduce(function (promise, func) {
    return promise.then(function (result) {
      return func().then(Array.prototype.concat.bind(result));
    });
  }, Promise.resolve([]));
}

var ComposerContainer =
/** @class */
function (_super) {
  __extends(ComposerContainer, _super);

  function ComposerContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.messageQueue = [];
    _this.state = {
      text: '',
      attachments: [],
      collapsed: false
    };
    _this.sendMessage = _this.sendMessage.bind(_this);
    _this.sendMessages = _this.sendMessages.bind(_this);
    _this.handleAttach = _this.handleAttach.bind(_this);
    _this.handleDetach = _this.handleDetach.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleExpand = _this.handleExpand.bind(_this);
    _this.setComposerRef = _this.setComposerRef.bind(_this);
    _this.handleFocusRequested = _this.handleFocusRequested.bind(_this);
    _this.handleAppendText = _this.handleAppendText.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.startTyping = _this.startTyping.bind(_this);
    _this.throttledStartTyping = lodash.throttle(_this.startTyping, 1000);
    return _this;
  }

  ComposerContainer.prototype.componentDidMount = function () {
    if (this.props.chatClient && this.props.conversationId) {
      this.restoreDraft(this.props.conversationId);
      this.forceUpdate(); // TODO: Move conversation to state?
    }
  };

  ComposerContainer.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.chatClient && (this.props.conversationId !== prevProps.conversationId || this.props.authenticatedUserId !== prevProps.authenticatedUserId)) {
      // Store the draft associated with this conversation
      if (prevProps.conversationId) {
        this.saveDraft(prevProps.conversationId);
      } // Empty the composer


      this.setState({
        text: ''
      }); // Restore draft associated with the incoming conversation

      if (this.props.conversationId) {
        this.restoreDraft(this.props.conversationId);
      }
    }
  };

  ComposerContainer.prototype.componentWillUnmount = function () {
    if (this.props.conversationId) {
      this.saveDraft(this.props.conversationId);
    }
  };

  ComposerContainer.prototype.saveDraft = function (conversationId) {
    if (window.sessionStorage) {
      var key = "draft-" + conversationId;

      if (this.state.text !== '' || window.sessionStorage.getItem(key) !== '') {
        window.sessionStorage.setItem(key, this.state.text);
      }
    }
  };

  ComposerContainer.prototype.restoreDraft = function (conversationId) {
    if (window.sessionStorage) {
      var key = "draft-" + conversationId;
      var draft = window.sessionStorage.getItem(key);

      if (draft) {
        this.setState({
          text: draft
        });
      }
    }
  };

  ComposerContainer.prototype.handleAttach = function (attachment) {
    this.setState(function (prevState) {
      var attachments = prevState.attachments;
      attachments.push(attachment);
      return __assign(__assign({}, prevState), {
        attachments: attachments
      });
    });
  };

  ComposerContainer.prototype.handleAppendText = function (text) {
    this.setState(function (prevState) {
      var newText = prevState.text ? prevState.text + ' ' + text : text;
      return __assign(__assign({}, prevState), {
        text: newText
      });
    });
  };

  ComposerContainer.prototype.handleDetach = function (index) {
    this.setState(function (prevState) {
      var attachments = prevState.attachments.filter(function (_a, i) {
        return i !== index;
      });
      return __assign(__assign({}, prevState), {
        attachments: attachments
      });
    });
  };

  ComposerContainer.prototype.handleChange = function (event, conversation) {
    this.setState({
      text: event.target.value,
      collapsed: event.target.value.length > 0
    });

    if (conversation) {
      this.throttledStartTyping(conversation);
    }
  };

  ComposerContainer.prototype.startTyping = function (conversation) {
    conversation.startTyping();
  };
  /**
   * Send a ComposerMessage.
   *
   * One ComposerMessage may result in multiple FirebaseMessages, if it has attachments.
   */


  ComposerContainer.prototype.sendMessage = function (message, conversation) {
    var _this = this;

    var firebaseMessages = [];
    var promisedMessageAttachments = message.attachments.map(function (attachment) {
      return attachment.toMessage(attachment.data, conversation);
    }); // Label each message with some metadata
    // TODO: This fn can be purely functional, and accept `metadata` as an argument

    var metadata = this.props.source ? {
      source: this.props.source
    } : {}; // Convert each attachment into a FirebaseMessage

    return Promise.all(promisedMessageAttachments).then(function (messageAttachments) {
      firebaseMessages.push.apply(firebaseMessages, messageAttachments); // If the message has a text portion, convert it to a FirebaseMessage. It will be sent last.

      if (message.text && message.text.length) {
        var textMessage = conversation.createDraftMessage();
        textMessage.addDraftPart('TEXT', {
          text: message.text
        });
        firebaseMessages.push(textMessage);
      } // Add metadata to each message


      firebaseMessages.forEach(function (message) {
        return message.metadata = metadata;
      }); // Send

      firebaseMessages.forEach(function (message) {
        return conversation.sendMessage(message);
      }); // Fire send message callback if passed in

      if (_this.props.onSendMessage) {
        _this.props.onSendMessage();
      }
    });
  };
  /**
   * Send all the queued ComposerMessages.
   */


  ComposerContainer.prototype.sendMessages = function (conversation) {
    var _this = this;

    if (!this.messageQueue) {
      return;
    } // Send each queued message sequentially


    promiseSerial(this.messageQueue.map(function (message) {
      return function () {
        return _this.sendMessage(message, conversation);
      };
    })); // Empty the queue

    this.messageQueue = [];
  };
  /**
   * Queue messages for sending
   */


  ComposerContainer.prototype.handleSubmit = function (event, conversation) {
    event.preventDefault(); // Stop the typing indicator

    this.throttledStartTyping.cancel();

    if (conversation) {
      conversation.stopTyping();
    } // Convert the current state to a ComposerMessage


    var message = {
      text: this.state.text,
      attachments: this.state.attachments
    }; // Add the message to the queue

    this.messageQueue.push(message); // If we already have a conversation, send immediately.

    if (conversation) {
      this.sendMessages(conversation);
    } else if (this.props.onConversationStarted) {
      this.props.onConversationStarted();
    } // Probably an invariant: You should pass a conversation or a callback to initate one.
    // Reset the composer state


    this.setState({
      text: '',
      attachments: []
    });
  };
  /**
   * Send all queued messages once we have a handle on a conversation to send them to.
   */


  ComposerContainer.prototype.handleConversationLoaded = function (result) {
    if (result.conversation) {
      this.sendMessages(result.conversation);
    }
  };

  ComposerContainer.prototype.handleExpand = function () {
    this.setState({
      collapsed: false
    });
  };
  /**
   * Focus compose bar text area
   */


  ComposerContainer.prototype.handleFocusRequested = function () {
    this.composerRef && this.composerRef.focus();
  };

  ComposerContainer.prototype.setComposerRef = function (textarea) {
    this.composerRef = textarea;
  };

  ComposerContainer.prototype.render = function () {
    var _this = this;

    return React__default.createElement(ConversationQuery$1, {
      conversationId: this.props.conversationId,
      recipientIds: this.props.guestChatEnabled ? this.props.recipientIds : undefined,
      onCompleted: this.handleConversationLoaded
    }, function (_b) {
      var conversation = _b.conversation,
          loading = _b.loading;
      return React__default.createElement(React__default.Fragment, null, _this.props.suggestedActions && React__default.createElement(_this.props.suggestedActions, {
        onAppendText: _this.handleAppendText,
        onFocusRequested: _this.handleFocusRequested
      }), React__default.createElement(Composer, {
        setComposerRef: _this.setComposerRef,
        conversationId: conversation ? conversation.conversationId : undefined,
        loading: loading,
        text: _this.state.text,
        attachments: _this.state.attachments,
        controls: _this.props.controls,
        onAttach: _this.handleAttach,
        onAppendText: _this.handleAppendText,
        onDetach: _this.handleDetach,
        onChange: function onChange(e) {
          return _this.handleChange(e, conversation);
        },
        onFocus: function onFocus(e) {
          _this.setState({
            collapsed: true
          });

          _this.props.onFocus && _this.props.onFocus(e);
        },
        onSubmit: function onSubmit(e) {
          return _this.handleSubmit(e, conversation);
        },
        onExpand: _this.handleExpand,
        collapsed: _this.state.collapsed
      }));
    });
  };

  return ComposerContainer;
}(React.Component);

var Composer$1 = withChat(ComposerContainer);

var ChatContainer = function ChatContainer(_a) {
  var conversationId = _a.conversationId,
      controls = _a.controls,
      events = _a.events,
      fetchEvents = _a.fetchEvents,
      messageAction = _a.messageAction,
      source = _a.source,
      onSendMessage = _a.onSendMessage,
      children = _a.children,
      suggestedActions = _a.suggestedActions,
      showRealSender = _a.showRealSender,
      guestChatEnabled = _a.guestChatEnabled,
      recipientIds = _a.recipientIds,
      onConversationStarted = _a.onConversationStarted,
      _b = _a.eventsLoading,
      eventsLoading = _b === void 0 ? false : _b,
      conversationClassName = _a.conversationClassName;
  return React__default.createElement(Chat, null, React__default.createElement(Conversation$1, {
    conversationId: conversationId,
    recipientIds: recipientIds,
    events: events,
    fetchEvents: fetchEvents,
    messageAction: messageAction,
    showRealSender: showRealSender,
    guestChatEnabled: guestChatEnabled,
    eventsLoading: eventsLoading,
    conversationClassName: conversationClassName
  }, children), React__default.createElement(Composer$1, {
    conversationId: conversationId,
    suggestedActions: suggestedActions,
    controls: controls,
    source: source,
    onSendMessage: onSendMessage,
    onConversationStarted: onConversationStarted
  }));
};

var ChatProvider =
/** @class */
function (_super) {
  __extends(ChatProvider, _super);

  function ChatProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.initialize = _this.initialize.bind(_this);
    _this.handleAuthenticated = _this.handleAuthenticated.bind(_this);
    _this.handleDeauthenticated = _this.handleDeauthenticated.bind(_this);
    return _this;
  }

  ChatProvider.prototype.componentDidMount = function () {
    this.initialize();
  };

  ChatProvider.prototype.componentDidUpdate = function (prevProps) {
    var _this = this;

    if (this.state.client && prevProps.userId !== this.props.userId) {
      // need to logout before login
      this.state.client.logout().then(function () {
        return _this.handleDeauthenticated(false);
      }).then(function () {
        if (_this.props.userId) {
          _this.authenticate(_this.props.userId);
        }
      });
    }
  };

  ChatProvider.prototype.authenticate = function (userId) {
    var _this = this;

    this.props.authenticate(userId).then(function (token) {
      return _this.state.client.login(token);
    }).then(function () {
      return _this.handleAuthenticated();
    });
  };

  ChatProvider.prototype.componentWillUnmount = function () {
    var _this = this;

    if (this.state.client) {
      this.state.client.logout().then(function () {
        _this.handleDeauthenticated(true);
      });
    }
  };

  ChatProvider.prototype.initialize = function () {
    var _this = this;

    if (!this.state.client) {
      chatFirebaseClient.createClient({
        apiKey: this.props.firebaseApiKey,
        projectId: this.props.firebaseProjectId,
        fetchUserProfiles: this.props.fetchUserProfiles
      }).then(function (client) {
        _this.setState({
          client: client
        });

        client.on('unreadChanged', function (evt) {
          _this.setState({
            unreadMessageCount: evt.client.unreadMessageCount,
            unreadConversationCount: evt.client.unreadConversationCount
          });
        });

        if (_this.props.userId) {
          _this.authenticate(_this.props.userId);
        }
      });
    }
  };

  ChatProvider.prototype.handleAuthenticated = function () {
    if (this.state.client) {
      // TODO: Subscribe to unread count
      this.setState({
        authenticatedUserId: this.state.client.myself.userId
      });
    } else {
      throw new Error('Authentication succeeded, but client is not available');
    }
  };

  ChatProvider.prototype.handleDeauthenticated = function (unmount) {
    var _this = this;

    if (!unmount) {
      return new Promise(function (resolve) {
        return _this.setState({
          authenticatedUserId: undefined
        }, function () {
          return resolve();
        });
      });
    } else {
      return Promise.resolve();
    }
  };

  ChatProvider.prototype.render = function () {
    // TODO: Ensure this causes re-renders during reauthentication
    var context = {
      client: this.state.client,
      analytics: this.props.analytics,
      authenticatedUserId: this.state.authenticatedUserId,
      impersonating: this.props.impersonating,
      applicationContext: this.props.applicationContext,
      customMessageComponents: this.props.customMessageComponents || [],
      unreadMessageCount: this.state.unreadMessageCount,
      unreadConversationCount: this.state.unreadConversationCount,
      onToastNotification: this.props.onToastNotification
    };
    return React__default.createElement(ApplicationContextProvider, {
      value: {
        application: this.props.applicationContext
      }
    }, React__default.createElement(RichCardEventEmitterContextProvider, null, React__default.createElement(ChatContextProvider, {
      value: context
    }, this.props.children)));
  };

  return ChatProvider;
}(React__default.PureComponent);

var ExternalChatProvider = function ExternalChatProvider(props) {
  return React__default.createElement(CreateFirebaseTokenComponent, null, function (createFirebaseToken) {
    return React__default.createElement(ChatProvider, __assign({
      authenticate: function authenticate(userId) {
        return createFirebaseToken({
          variables: {
            messagingUserId: userId
          }
        }).then(function (response) {
          if (!response || !response.data) {
            throw new Error('Failed to generate Firebase authentication token');
          }

          return response.data.createFirebaseToken.identityToken;
        });
      }
    }, props));
  });
};

var ChatNotifier =
/** @class */
function (_super) {
  __extends(ChatNotifier, _super);

  function ChatNotifier(props) {
    var _this = _super.call(this, props) || this;

    _this.handleGlobalNewMessage = _this.handleGlobalNewMessage.bind(_this);
    _this.handleConversationNewMessage = _this.handleConversationNewMessage.bind(_this);
    _this.handleConversationLoaded = _this.handleConversationLoaded.bind(_this);
    _this.handleConversationChanged = _this.handleConversationChanged.bind(_this);
    return _this;
  }

  ChatNotifier.prototype.componentDidMount = function () {
    if (this.props.chatClient) {
      this.props.chatClient.on('newMessage', this.handleGlobalNewMessage);
    }
  };

  ChatNotifier.prototype.componentWillUnmount = function () {
    if (this.props.chatClient) {
      this.props.chatClient.off('newMessage', this.handleGlobalNewMessage);
    }

    if (this.conversation) {
      this.conversation.off('changed', this.handleConversationChanged);
    }
  };

  ChatNotifier.prototype.componentDidUpdate = function (prevProps) {
    // Client now available
    if (this.props.chatClient && !prevProps.chatClient) {
      this.props.chatClient.on('newMessage', this.handleGlobalNewMessage);
    } // Client no longer available


    if (!this.props.chatClient && prevProps.chatClient) {
      prevProps.chatClient.off('newMessage', this.handleGlobalNewMessage);
    }
  };

  ChatNotifier.prototype.handleGlobalNewMessage = function (event) {
    var isListeningGlobally = !this.props.conversationId && !this.props.recipientIds;

    if (isListeningGlobally && this.props.onNewMessage) {
      this.props.onNewMessage({
        context: 'global',
        message: event.message,
        unreadCount: event.client.unreadMessageCount
      });
    }
  };

  ChatNotifier.prototype.handleConversationNewMessage = function (event) {
    if (this.props.onNewMessage) {
      this.props.onNewMessage({
        context: 'conversation',
        message: event.message,
        unreadCount: event.conversation.unreadCount
      });
    }
  };

  ChatNotifier.prototype.handleConversationLoaded = function (result) {
    if (this.conversation) {
      this.conversation.off('changed', this.handleConversationChanged);
      this.conversation.off('newMessage', this.handleConversationNewMessage);
    }

    if (result.conversation) {
      // Save a reference so we can unsubscribe later
      this.conversation = result.conversation;
      result.conversation.on('changed', this.handleConversationChanged);
      result.conversation.on('newMessage', this.handleConversationNewMessage);
    }
  };

  ChatNotifier.prototype.handleConversationChanged = function () {
    this.forceUpdate();
  };

  ChatNotifier.prototype.render = function () {
    var _this = this;

    return React__default.createElement(ChatContextConsumer, null, function (_a) {
      var globalUnreadMessageCount = _a.unreadMessageCount;
      return React__default.createElement(ConversationQuery$1, {
        conversationId: _this.props.conversationId,
        recipientIds: _this.props.recipientIds,
        onCompleted: _this.handleConversationLoaded
      }, function (_a) {
        var conversation = _a.conversation;

        if (conversation) {
          return _this.props.children({
            unreadMessageCount: conversation.unreadCount
          });
        } else {
          return _this.props.children({
            unreadMessageCount: globalUnreadMessageCount
          });
        }
      });
    });
  };

  return ChatNotifier;
}(React__default.Component);

var index = withChat(ChatNotifier);

var UserQuery =
/** @class */
function (_super) {
  __extends(UserQuery, _super);

  function UserQuery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      loading: _this.props.userIds.length > 0
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    return _this;
  }

  UserQuery.prototype.componentDidMount = function () {
    if (this.props.chatClient) {
      this.load(this.props.userIds, this.props.chatClient);
    }
  };

  UserQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available
    if (!this.props.chatClient) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (this.props.chatClient && (!isEqual(prevProps.userIds.sort(), this.props.userIds.sort()) || prevProps.authenticatedUserId !== this.props.authenticatedUserId)) {
      this.cancel();
      this.load(this.props.userIds, this.props.chatClient);
    }
  };

  UserQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  UserQuery.prototype.load = function (userIds, client) {
    var _this = this;

    var allUsersAlreadyLoaded = userIds.every(function (userId) {
      return _this.state.users && _this.state.users.find(function (user) {
        return user.userId === userId;
      });
    });

    if (allUsersAlreadyLoaded) {
      return;
    }

    this.setState({
      users: undefined,
      loading: true
    });
    client.getUsers(userIds).then(function (users) {
      _this.setState({
        loading: false,
        users: users
      });
    });
  };
  /**
   * TODO: Implement cancellation
   *
   * Without it, the getUsers callback might call setState on an unmounted component
   */


  UserQuery.prototype.cancel = function () {};

  UserQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the `getUsers` call is unfinished.
     *   We also need to consider the loading/auth state of the chat client itself.
     */
    var loading = this.state.loading || !this.props.chatClient;
    return this.props.children({
      loading: loading,
      users: this.state.users
    });
  };

  return UserQuery;
}(React.Component);

var UserQuery$1 = withChat(UserQuery);

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var StarIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0h12v12H0z"
  }), React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 .555l1.298 4.147h4.327L8.187 7.285l1.352 4.16L6 8.874l-3.538 2.571 1.351-4.16L.375 4.702h4.327z"
  })));
});

var styles$I = {"header":"styles_header__ARh_v flex items-center","avatar-and-presence":"styles_avatar-and-presence__2zPMc relative","presence-badge":"styles_presence-badge__1tEoj","rating":"styles_rating__1dlw9 bold flex items-center","stars-rating":"styles_stars-rating__1P_ri styles_rating__1dlw9 bold flex items-center","number-rating":"styles_number-rating__2UraC styles_rating__1dlw9 bold flex items-center","stars":"styles_stars__1jfOV relative","combined-rating":"styles_combined-rating__1qlE_ styles_rating__1dlw9 bold flex items-center","avatar":"styles_avatar__2kpWM","star":"styles_star__3cpVe","labels":"styles_labels__fsH4C flex flex-auto flex-column","title":"styles_title__3UYB5 bold mr1","presence":"styles_presence__3NG6R flex items-center","presence-online":"styles_presence-online__1CspA styles_presence-badge__1tEoj","presence-offline":"styles_presence-offline__1aXiq styles_presence-badge__1tEoj","presence-text":"styles_presence-text__1KdXl","cta":"styles_cta__3_rxx flex items-center","cta-icon":"styles_cta-icon__6UPLa mr1","cta-text":"styles_cta-text__1nh3E","minimized":"styles_minimized__3eiDf","avatarAndPresence":"styles_avatar-and-presence__2zPMc relative","presenceBadge":"styles_presence-badge__1tEoj","starsRating":"styles_stars-rating__1P_ri styles_rating__1dlw9 bold flex items-center","numberRating":"styles_number-rating__2UraC styles_rating__1dlw9 bold flex items-center","combinedRating":"styles_combined-rating__1qlE_ styles_rating__1dlw9 bold flex items-center","presenceOnline":"styles_presence-online__1CspA styles_presence-badge__1tEoj","presenceOffline":"styles_presence-offline__1aXiq styles_presence-badge__1tEoj","presenceText":"styles_presence-text__1KdXl","ctaIcon":"styles_cta-icon__6UPLa mr1","ctaText":"styles_cta-text__1nh3E"};

var ChatHeader =
/** @class */
function (_super) {
  __extends(ChatHeader, _super);

  function ChatHeader(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.tick = _this.tick.bind(_this);
    return _this;
  }

  ChatHeader.prototype.componentDidMount = function () {
    this.timer = setInterval(this.tick, 2000);
  };

  ChatHeader.prototype.componentWillUnmount = function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  ChatHeader.prototype.tick = function () {
    this.setState(function (prevState) {
      return {
        alertNewMessage: !prevState.alertNewMessage
      };
    });
  };

  ChatHeader.prototype.render = function () {
    var _a;

    var _b = this.props,
        recipients = _b.recipients,
        unread = _b.unread,
        className = _b.className,
        minimized = _b.minimized,
        online = _b.online,
        ctaIcon = _b.ctaIcon,
        ctaText = _b.ctaText,
        onCtaClick = _b.onCtaClick,
        rating = _b.rating,
        rest = __rest(_b, ["recipients", "unread", "className", "minimized", "online", "ctaIcon", "ctaText", "onCtaClick", "rating"]);

    var CtaIcon = this.props.ctaIcon; // "Tom", "Dick" and "Harry"

    var recipientNames = recipients.map(function (recipient) {
      return recipient.displayName;
    });
    var recipientsLabel = [recipientNames.slice(0, -1).join(', '), recipientNames.slice(-1)[0]].join(recipientNames.length < 2 ? '' : ' and ');
    var primaryRecipient = recipients[0];
    return React__default.createElement("div", __assign({
      className: classnames(styles$I.header, className, (_a = {}, _a[styles$I.minimized] = minimized, _a))
    }, rest), React__default.createElement("div", {
      className: styles$I.avatarAndPresence
    }, React__default.createElement(ChatAvatar, {
      sender: primaryRecipient,
      size: 48,
      shape: "circle",
      className: styles$I.avatar
    }), rating !== 'none' && online && React__default.createElement("span", {
      className: styles$I.presenceBadge
    })), React__default.createElement("div", {
      className: styles$I.labels
    }, React__default.createElement("div", {
      className: styles$I.title
    }, unread && this.state.alertNewMessage ? 'New message' : recipientsLabel), rating === 'none' && online && React__default.createElement("div", {
      className: styles$I.presence
    }, React__default.createElement("span", {
      className: styles$I.presenceBadge
    }), React__default.createElement("span", {
      className: styles$I.presenceText
    }, "Online")), rating === 'stars' && primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles$I.starsRating
    }, React__default.createElement("div", {
      className: styles$I.stars
    }, times(Math.round(primaryRecipient.expertRating)).map(function (i) {
      return React__default.createElement(StarIcon, {
        className: styles$I.star,
        key: i
      });
    }))), rating === 'number' && primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles$I.numberRating
    }, primaryRecipient.expertRating.toFixed(1), React__default.createElement("div", {
      className: styles$I.stars
    }, React__default.createElement(StarIcon, {
      className: styles$I.star
    }))), rating === 'combined' && primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles$I.combinedRating
    }, primaryRecipient.expertRating.toFixed(1), React__default.createElement("div", {
      className: styles$I.stars
    }, times(Math.round(primaryRecipient.expertRating)).map(function (i) {
      return React__default.createElement(StarIcon, {
        className: styles$I.star,
        key: i
      });
    })))), (ctaIcon || ctaText) && React__default.createElement("div", {
      className: styles$I.cta,
      onClick: function onClick(e) {
        e.stopPropagation();
        onCtaClick && onCtaClick(e);
      }
    }, CtaIcon && React__default.createElement(CtaIcon, {
      className: styles$I.ctaIcon
    }), ctaText && React__default.createElement("span", {
      className: styles$I.ctaText
    }, ctaText)));
  };

  return ChatHeader;
}(React__default.Component);

var useMedia = function useMedia(query, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var _a = React.useState(defaultMatches),
      matches = _a[0],
      setMatches = _a[1];

  React.useEffect(function () {
    var mediaQueryList = window.matchMedia(json2mq(query));

    var listener = function listener() {
      if (mediaQueryList.matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    mediaQueryList.addListener(listener);
    setMatches(mediaQueryList.matches);
    return function () {
      return mediaQueryList.removeListener(listener);
    };
  }, [query]);
  return matches;
};

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$h(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CloseIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$h(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "44",
    height: "44",
    viewBox: "0 0 44 44"
  }, props), React__default.createElement("defs", null, React__default.createElement("path", {
    id: "a",
    d: "M28 24V10a2 2 0 1 0-4 0v14H10a2 2 0 1 0 0 4h14v14a2 2 0 1 0 4 0V28h14a2 2 0 1 0 0-4H28z"
  })), React__default.createElement("use", {
    transform: "rotate(45 28.828 19.172)",
    xlinkHref: "#a"
  }));
});

var _extends$i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$i(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$i(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React__default.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, React__default.createElement("path", {
    fillRule: "nonzero",
    d: "M16.492 16.539a1 1 0 0 1 .087-.99A7.94 7.94 0 0 0 18 11.002a8 8 0 1 0-3.716 6.743 1 1 0 0 1 .769-.128l2.176.521-.737-1.6zm2.047-.336l1.37 2.968a1 1 0 0 1-1.142 1.392l-3.781-.905A10 10 0 1 1 20 11a9.94 9.94 0 0 1-1.46 5.203z"
  }), React__default.createElement("rect", {
    width: "8",
    height: "2",
    x: "6",
    y: "8",
    rx: "1"
  }), React__default.createElement("rect", {
    width: "6",
    height: "2",
    x: "6",
    y: "12",
    rx: "1"
  })));
});

var styles$J = {"media-breakpoint-sm":"(min-width: 40em)","widget":"styles_widget__2zhy1 relative","expanded":"styles_expanded__19jhh","chat":"styles_chat__F1T17 pt3 flex flex-auto flex-column fixed bottom-0 left-0 right-0","halfExpanded":"styles_halfExpanded__3dg3d","conversation":"styles_conversation__3D2ZI flex flex-auto justify-start m0 px1","header":"styles_header__31qty","snackbar":"styles_snackbar__1Py4m fixed left-0 bottom-0 right-0 mx2 mb2","-webkit-transform":"styles_transform__2v5gu","transform":"styles_transform__2v5gu","shrunk":"styles_shrunk__1R7lu","mediaBreakpointSm":"(min-width: 40em)","webkitTransform":"styles_transform__2v5gu"};

var ChatWidget =
/** @class */
function (_super) {
  __extends(ChatWidget, _super);

  function ChatWidget(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      display: !!_this.props.hasUnreadMessages ? 'preview' : 'collapsed'
    };
    _this.expand = _this.expand.bind(_this);
    _this.collapse = _this.collapse.bind(_this);
    _this.getApplicationDomNode = _this.getApplicationDomNode.bind(_this);
    _this.addApplicationClassNames = _this.addApplicationClassNames.bind(_this);
    _this.removeApplicationClassNames = _this.removeApplicationClassNames.bind(_this);
    _this.shrinkApplication = _this.shrinkApplication.bind(_this);
    _this.expandApplication = _this.expandApplication.bind(_this);
    _this.getKeyForPersistentStorage = _this.getKeyForPersistentStorage.bind(_this);
    _this.handleNewMessage = _this.handleNewMessage.bind(_this);
    return _this;
  }

  ChatWidget.prototype.componentDidMount = function () {
    var _this = this;

    this.addApplicationClassNames(styles$J.transform); // Listen for new messages

    if (this.props.conversation) {
      this.props.conversation.on('newMessage', this.handleNewMessage);
    } // If the user navigates, collapse the widget


    if (this.props.history) {
      this.unlisten = this.props.history.listen(function () {
        if (window.matchMedia('(max-width: 40em)').matches) {
          _this.collapse();
        }
      });
    } // Initialize the local display state from the previously persisted display state


    if (this.props.conversation) {
      var persistedDisplayState = window.sessionStorage.getItem(this.getKeyForPersistentStorage(this.props.conversation.conversationId)); // Restore the previous display state of the chat widget for this conversation

      if (persistedDisplayState) {
        this.setState({
          display: persistedDisplayState
        });
      }
    } // Attempt to start the guest conversation. This happens in the <Conversation> component
    //   as well, but that is not rendered until the <ChatWidget> is expanded. Calling it here
    //   initiates the guest conversation without waiting for user interaction. This method is
    //   idempotent, so the subsequent calls once the <Conversation> is mounted are safe.


    if (this.props.guestChatEnabled) {
      startGuestConversation(this.props.startGuestConversation, this.props.conversation, [this.props.userId]);
    }
  };

  ChatWidget.prototype.componentDidUpdate = function (prevProps) {
    // Listen for messages on the conversation when it's available, or when it has changed.
    var conversation = this.props.conversation;
    var prevConversation = prevProps.conversation;

    if (conversation && (!prevConversation || conversation.conversationId !== prevConversation.conversationId)) {
      if (prevConversation) {
        prevConversation.off('newMessage', this.handleNewMessage);
      }

      conversation.on('newMessage', this.handleNewMessage);
    } // Attempt to start the guest conversation. See comment in `componentDidMount`.


    if (prevProps.conversation !== this.props.conversation || prevProps.authenticatedUserId !== this.props.authenticatedUserId || xor([prevProps.userId], [this.props.userId]).length > 0) {
      if (this.props.guestChatEnabled) {
        startGuestConversation(this.props.startGuestConversation, this.props.conversation, [this.props.userId]);
      }
    }
  };

  ChatWidget.prototype.componentWillUnmount = function () {
    this.expandApplication();
    this.removeApplicationClassNames(styles$J.transform);

    if (this.props.conversation) {
      this.props.conversation.off('newMessage', this.handleNewMessage);
    }

    if (this.unlisten) {
      this.unlisten();
    }

    if (this.props.conversation) {
      window.sessionStorage.setItem(this.getKeyForPersistentStorage(this.props.conversation.conversationId), this.state.display);
    }
  };

  ChatWidget.prototype.handleNewMessage = function () {
    if (this.state.display === 'collapsed') {
      this.setState({
        display: 'preview'
      });
    }
  };

  ChatWidget.prototype.getApplicationDomNode = function () {
    return this.props.getAppRoot && this.props.getAppRoot();
  };

  ChatWidget.prototype.getKeyForPersistentStorage = function (conversationId) {
    return "conversation:" + conversationId + ":user:" + this.props.userId + ":widget-state";
  };
  /**
   * Expand the widget
   */


  ChatWidget.prototype.expand = function () {
    if (this.state.display === 'expanded') {
      return;
    } // When the ChatWidget expands, we shrink the rest of the application


    this.shrinkApplication();

    if (!this.state.windowScollPositionWhenOpened && this.props.isMobile) {
      this.setState({
        windowScollPositionWhenOpened: [window.scrollX, window.scrollY]
      });
      window.scrollTo(0, 0);
    }

    this.setState({
      display: 'expanded'
    });

    if (this.props.conversation) {
      window.sessionStorage.setItem(this.getKeyForPersistentStorage(this.props.conversation.conversationId), 'expanded');
    }
  };
  /**
   * Collapse the widget
   */


  ChatWidget.prototype.collapse = function () {
    // When the ChatWidget collapses, we reset the rest of the application
    this.expandApplication();

    if (this.state.windowScollPositionWhenOpened && this.props.isMobile) {
      var _a = this.state.windowScollPositionWhenOpened,
          x = _a[0],
          y = _a[1];
      window.scrollTo(x, y);
      this.setState({
        windowScollPositionWhenOpened: undefined
      });
    }

    this.setState({
      display: 'collapsed'
    });

    if (this.props.conversation) {
      window.sessionStorage.setItem(this.getKeyForPersistentStorage(this.props.conversation.conversationId), 'collapsed');
    }
  };
  /**
   * Visually "detach" the rest of the application from the browser
   */


  ChatWidget.prototype.shrinkApplication = function () {
    var domNode = this.getApplicationDomNode();

    if (domNode) {
      this.addApplicationClassNames(styles$J.shrunk);

      if (domNode instanceof HTMLElement) {
        // Calculate the percentage we need to scale the element in order to shrink by 9px in each dimension
        var rect = domNode.getBoundingClientRect();
        var scaleY = 1 - 18 / rect.height;
        var scaleX = 1 - 18 / rect.width; // Add the transform

        domNode.style.transform = "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        domNode.style.webkitTransform = "scaleX(" + scaleX + " scaleY(" + scaleY + ")";
      }
    }
  };
  /**
   * Re-attach the rest of the application from the browser
   */


  ChatWidget.prototype.expandApplication = function () {
    var domNode = this.getApplicationDomNode();

    if (domNode) {
      this.removeApplicationClassNames(styles$J.shrunk);

      if (domNode instanceof HTMLElement) {
        // Reset the scaling transform (TODO: Do we need to restore the previous value?)
        domNode.style.transform = '';
        domNode.style.webkitTransform = '';
      }
    }
  };
  /**
   * Utility function to add className(s) to the application element
   */


  ChatWidget.prototype.addApplicationClassNames = function (className) {
    var _a;

    var domNode = this.getApplicationDomNode();

    if (domNode) {
      (_a = domNode.classList).add.apply(_a, className.split(' '));
    }
  };
  /**
   * Utility function to remove className(s) to the application element
   */


  ChatWidget.prototype.removeApplicationClassNames = function (className) {
    var _a;

    var domNode = this.getApplicationDomNode();

    if (domNode) {
      (_a = domNode.classList).remove.apply(_a, className.split(' '));
    }
  };

  ChatWidget.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        recipients = _b.recipients,
        hasUnreadMessages = _b.hasUnreadMessages,
        conversation = _b.conversation,
        className = _b.className,
        collapsedClassName = _b.collapsedClassName,
        isMobile = _b.isMobile;
    /**
     * TODO: Update these docs. Conversation/Composer components will also take optional conversationId's now.
     *
     * The ChatWidget supports a few states:
     *   - Collapsed, without a Conversation present (the user doesn't have a convo, or we are lazy-loading it)
     *   - Collapsed, with a Conversation (the user has a convo, but has dimissed it or has no unreads)
     *   - Expanded, without a Conversation (the user has tried to initiate a convo, but it isn't loaded yet)
     *   - Expanded, with a Conversation (the user is actively messaging/interacting with the ChatWidget)
     */

    var widget = React__default.createElement("div", {
      className: classnames(styles$J.widget, (_a = {}, _a[styles$J.expanded] = this.state.display === 'expanded', _a), collapsedClassName && this.state.display === 'collapsed' ? collapsedClassName : undefined, className)
    }, recipients.length > 0 ? React__default.createElement(reactSpring.Transition, {
      native: true,
      from: {
        opacity: 0,
        transform: 'translate3d(0,100%,0)'
      },
      enter: {
        opacity: 1,
        transform: 'translate3d(0,0%,0)'
      },
      leave: {
        opacity: 0,
        transform: 'translate3d(0,100%,0)'
      }
    }, this.state.display === 'expanded' || this.state.display === 'preview' ? function (animatedStyles) {
      var _a;

      return React__default.createElement(React__default.Fragment, null, React__default.createElement(Scrolllock__default, {
        isActive: isMobile
      }), React__default.createElement(reactSpring.animated.div, {
        style: animatedStyles,
        className: classnames(styles$J.chat, (_a = {}, _a[styles$J.halfExpanded] = _this.state.display === 'preview', _a))
      }, React__default.createElement(ChatHeader, {
        recipients: recipients,
        unread: hasUnreadMessages,
        online: _this.props.online,
        rating: _this.props.rating,
        minimized: true,
        ctaIcon: CloseIcon,
        ctaText: "Close chat",
        onCtaClick: _this.collapse,
        onClick: _this.state.display === 'preview' ? _this.expand : _this.collapse,
        className: styles$J.header
      }), React__default.createElement(Conversation$1, {
        conversationId: conversation && conversation.conversationId,
        recipientIds: recipients.map(function (recipients) {
          return recipients.userId;
        }),
        enableReadReceipts: _this.state.display === 'expanded',
        onClick: _this.state.display === 'collapsed' ? _this.expand : undefined,
        guestChatEnabled: _this.props.guestChatEnabled
      }, _this.props.children), React__default.createElement(Composer$1, {
        conversationId: conversation && conversation.conversationId,
        recipientIds: recipients.map(function (recipients) {
          return recipients.userId;
        }),
        onConversationStarted: _this.props.onConversationStarted,
        onSendMessage: _this.props.onSendMessage,
        onFocus: _this.expand,
        source: "chathead",
        guestChatEnabled: _this.props.guestChatEnabled
      })));
    } : function (animatedStyles) {
      return React__default.createElement(reactSpring.animated.div, {
        style: animatedStyles,
        className: classnames(styles$J.snackbar, _this.props.className)
      }, React__default.createElement(ChatHeader, {
        recipients: recipients,
        unread: hasUnreadMessages,
        online: _this.props.online,
        rating: _this.props.rating,
        minimized: false,
        ctaIcon: ChatIcon,
        ctaText: "Chat",
        onClick: _this.expand,
        onCtaClick: _this.expand
      }));
    }) : null); // The ChatWidget can optionally be rendered into a ReactPortal to allow for more control over positioning.

    var parentNode = this.props.getParent && this.props.getParent();
    var bodyNode = document.querySelector('body');
    return ReactDOM.createPortal(widget, parentNode || bodyNode);
  };

  ChatWidget.defaultProps = {
    rating: 'none'
  };
  return ChatWidget;
}(React__default.Component);

var ResponsiveChatWidgetWithFirebaseConversation = function ResponsiveChatWidgetWithFirebaseConversation(_a) {
  var conversationId = _a.conversationId,
      userId = _a.userId,
      guestChatEnabled = _a.guestChatEnabled,
      rest = __rest(_a, ["conversationId", "userId", "guestChatEnabled"]);

  var isMobile = useMedia({
    maxWidth: '40em'
  });
  return React__default.createElement(StartGuestConversationComponent, null, function (startGuestConversation) {
    return React__default.createElement(ConversationQuery$1, {
      conversationId: conversationId,
      recipientIds: guestChatEnabled ? [userId] : undefined
    }, function (_a) {
      var conversation = _a.conversation;
      return React__default.createElement(UserQuery$1, {
        userIds: [userId]
      }, function (_a) {
        var users = _a.users,
            usersLoading = _a.loading; // If we have a conversation, prefer the "other" users from that conversation over the user prop

        var otherParticipants = conversation && conversation.participants.filter(function (participant) {
          return !participant.isMyself;
        });
        var recipients = otherParticipants && otherParticipants.length ? otherParticipants : users;
        var hasUnreadMessages = conversation && conversation.unreadCount > 0; // The ChatWidget can render if the conversation is loading (it will show the user's info
        //   in the collapsed state, and a spinner in the expanded state), but it can not render
        //   anything without the user data.

        if (usersLoading) {
          return null;
        }

        return React__default.createElement(ChatWidget, __assign({
          recipients: recipients || [],
          hasUnreadMessages: hasUnreadMessages,
          conversation: conversation,
          userId: userId,
          isMobile: isMobile,
          startGuestConversation: startGuestConversation,
          guestChatEnabled: guestChatEnabled
        }, rest));
      });
    });
  });
};

var index$1 = withChat(ResponsiveChatWidgetWithFirebaseConversation);

var styles$K = {"container":"styles_container__3kgFj","video":"styles_video__3m3HZ"};

var VideoUploadPreview =
/** @class */
function (_super) {
  __extends(VideoUploadPreview, _super);

  function VideoUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  VideoUploadPreview.accept = function (mimeType) {
    return mimeType.startsWith('video/');
  };

  VideoUploadPreview.getBodyType = function (_mimeType) {
    return 'VIDEO';
  };

  VideoUploadPreview.prototype.render = function () {
    var url = this.props.data.file.url || URL.createObjectURL(this.props.data.file);
    return React__default.createElement("div", {
      className: styles$K.container
    }, React__default.createElement("video", {
      className: styles$K.video,
      src: url,
      muted: true
    }));
  };

  return VideoUploadPreview;
}(React.PureComponent);

var _extends$j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$j(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$j(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$j({
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("title", null, "video"), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0-4h24v24H0z"
  }), React__default.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)",
    stroke: "#3D4E56",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M22 2l-7 5 7 5z"
  }), React__default.createElement("rect", {
    width: "15",
    height: "14",
    rx: "2"
  }))));
});

var styles$L = {"container":"styles_container__KnG8G","image":"styles_image__d5RCj"};

var _extends$k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$k(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var FileIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$k(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128"
  }, props), React__default.createElement("defs", null, React__default.createElement("linearGradient", {
    id: "a"
  }, React__default.createElement("stop", {
    stopColor: "#eee"
  }), React__default.createElement("stop", {
    offset: "1",
    stopColor: "#d2d2d2"
  })), React__default.createElement("linearGradient", {
    id: "b"
  }, React__default.createElement("stop", null), React__default.createElement("stop", {
    offset: "1",
    stopOpacity: ".536"
  })), React__default.createElement("linearGradient", {
    id: "c"
  }, React__default.createElement("stop", null), React__default.createElement("stop", {
    offset: "1",
    stopColor: "#ddd",
    stopOpacity: "0"
  })), React__default.createElement("filter", {
    id: "g",
    x: "-.147",
    width: "1.294",
    y: "-.145",
    height: "1.29"
  }, React__default.createElement("feGaussianBlur", {
    stdDeviation: "1.819"
  })), React__default.createElement("filter", {
    id: "d"
  }, React__default.createElement("feGaussianBlur", {
    stdDeviation: "2.586"
  })), React__default.createElement("radialGradient", {
    xlinkHref: "#a",
    r: "44.42",
    cy: "100.32",
    cx: "81.79",
    gradientTransform: "matrix(2.0026 -1.59703 1.77733 2.2287 -279.236 23.704)",
    gradientUnits: "userSpaceOnUse",
    id: "e"
  }), React__default.createElement("radialGradient", {
    xlinkHref: "#b",
    r: "18.279",
    cy: "22.254",
    cx: "89.51",
    gradientTransform: "matrix(1 0 0 .97468 0 .44)",
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }), React__default.createElement("linearGradient", {
    xlinkHref: "#c",
    y2: "25.1",
    x2: "86.82",
    y1: "14.793",
    x1: "98.33",
    gradientTransform: "matrix(.96715 0 0 .96715 .456 -.087)",
    gradientUnits: "userSpaceOnUse",
    id: "h"
  })), React__default.createElement("path", {
    transform: "matrix(.96715 0 0 .97126 1.589 2.695)",
    d: "M20.094 4.119v118h88.844V35.962l-.594-.625c.21.145.417.302.625.438L78.094 4.15c.056.08.1.17.156.25L78 4.119H20.094z",
    opacity: ".809",
    filter: "url(#d)"
  }), React__default.createElement("path", {
    d: "M19.89 2.543v114.123h85.925V33.34L75.894 2.543H19.89z",
    fill: "url(#e)",
    transform: "translate(1.132 3.31)"
  }), React__default.createElement("path", {
    transform: "matrix(1.01608 0 0 1.11224 -3.792 2.965)",
    d: "M81.698 28.31l.135-8.351c.068-6.6-.877-11.548-4.047-16.012l2.576-.031 27.5 25.615c-4.067-2.646-9.62-.791-16.861-1.026l-9.303-.195z",
    opacity: ".505",
    fill: "url(#f)",
    filter: "url(#g)"
  }), React__default.createElement("path", {
    d: "M82.748 29.122l.131-8.077c.066-6.382-2.692-10.836-5.758-15.153l29.867 30.588c-3.934-2.558-8.24-6.942-15.243-7.169l-8.997-.19z",
    fill: "#eee"
  }), React__default.createElement("path", {
    d: "M81.616 25.812l.13-8.077c.066-6.382-2.691-10.836-5.757-15.153l29.867 30.588c-3.935-2.558-8.24-6.942-15.243-7.169l-8.997-.19z",
    fill: "url(#h)",
    transform: "translate(1.132 3.31)"
  }));
});

var FileUploadPreview =
/** @class */
function (_super) {
  __extends(FileUploadPreview, _super);

  function FileUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FileUploadPreview.accept = function (_mimeType) {
    return true;
  };

  FileUploadPreview.getBodyType = function (_mimeType) {
    return 'FILE';
  };

  FileUploadPreview.prototype.render = function () {
    return React__default.createElement("div", {
      className: styles$L.container
    }, React__default.createElement(FileIcon, {
      className: styles$L.image
    }), React__default.createElement("div", null, this.props.data.file.name || this.props.data.file.originalFileName || 'attachment'));
  };

  return FileUploadPreview;
}(React.PureComponent);

var styles$M = {"control":"styles_control__2HhKA flex","button":"styles_button__26qHr","hidden":"styles_hidden__vCXHE"};

var MediaUploadControlBase =
/** @class */
function (_super) {
  __extends(MediaUploadControlBase, _super);

  function MediaUploadControlBase(props) {
    var _this = _super.call(this, props) || this;

    _this.findPreview = _this.findPreview.bind(_this);
    _this.attachFile = _this.attachFile.bind(_this);
    _this.toMessage = _this.toMessage.bind(_this);
    return _this;
  }

  MediaUploadControlBase.prototype.attachFile = function (file) {
    this.props.attach({
      data: {
        file: file
      },
      previewer: this.findPreview(file.type || file.mimeType),
      toMessage: this.toMessage
    });
  };

  MediaUploadControlBase.prototype.findPreview = function (mimeType) {
    return this.props.previews.find(function (preview) {
      return preview.accept(mimeType);
    }) || FileUploadPreview;
  };

  MediaUploadControlBase.prototype.toMessage = function (data, conversation) {
    var _this = this;

    var uploadMediaPromise;
    var originalFileName = data.file.name || data.file.originalFileName;

    if (data.file.id) {
      if (this.props.handlePersistMedia) {
        uploadMediaPromise = this.props.handlePersistMedia(data.file);
      } else {
        uploadMediaPromise = Promise.resolve(data.file);
      }
    } else {
      uploadMediaPromise = this.props.handleUploadMedia(data.file);
    }

    return uploadMediaPromise.then(function (mediaFile) {
      var mimeType = mediaFile.mimeType,
          url = mediaFile.url,
          id = mediaFile.id; // Just in case someone uploads something weird

      var bodyType = _this.findPreview(mimeType).getBodyType(mimeType);

      var message = conversation.createDraftMessage();
      message.addDraftPart(bodyType, {
        mediaUrl: url,
        mediaId: id,
        originalFileName: originalFileName
      });
      return message;
    });
  };

  return MediaUploadControlBase;
}(React.PureComponent);

var MediaUploadControl =
/** @class */
function (_super) {
  __extends(MediaUploadControl, _super);

  function MediaUploadControl(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleFileChanged = _this.handleFileChanged.bind(_this);
    return _this;
  }

  MediaUploadControl.prototype.handleClick = function (event) {
    event.preventDefault();

    if (this.hiddenInput) {
      this.hiddenInput.click();
    }
  };

  MediaUploadControl.prototype.handleFileChanged = function (event) {
    var files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }

    this.attachFile(files[0]);
  };

  MediaUploadControl.prototype.render = function () {
    var _this = this;

    var Glyph = this.props.icon;
    return React__default.createElement("div", {
      title: this.props.title ? this.props.title : 'Upload Media',
      className: styles$M.control
    }, React__default.createElement("input", {
      className: styles$M.hidden,
      type: "file",
      onChange: this.handleFileChanged,
      accept: this.props.accept.join(','),
      ref: function ref(el) {
        return _this.hiddenInput = el;
      }
    }), React__default.createElement(Glyph, {
      className: styles$M.button,
      onClick: this.handleClick
    }));
  };

  return MediaUploadControl;
}(MediaUploadControlBase);

var VideoUploadControl = function VideoUploadControl(props) {
  return React__default.createElement(MediaUploadControl, __assign({
    accept: ['video/mp4', 'video/mpeg', 'video/quicktime'],
    previews: [VideoUploadPreview],
    icon: Icon
  }, props));
};

var styles$N = {"container":"styles_container__1R8E1","image":"styles_image__27mtr","flat":"styles_flat__3GyFC"};

var ImageUploadPreview =
/** @class */
function (_super) {
  __extends(ImageUploadPreview, _super);

  function ImageUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ImageUploadPreview.accept = function (mimeType) {
    return mimeType.startsWith('image/');
  };

  ImageUploadPreview.getBodyType = function (_mimeType) {
    return 'IMAGE';
  };

  ImageUploadPreview.prototype.render = function () {
    var url = this.props.data.file.url || URL.createObjectURL(this.props.data.file);
    return React__default.createElement("div", {
      className: classnames(styles$N.container, styles$N.flat)
    }, React__default.createElement("img", {
      className: styles$N.image,
      src: url
    }));
  };

  return ImageUploadPreview;
}(React.PureComponent);

var _extends$l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$l(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ImageUploadFlatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$l(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M0 0h16v16H0z"
  }), React__default.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.5 15.5h-7a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v7"
  }), React__default.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 10.5l7-5 2 2"
  }), React__default.createElement("circle", {
    cx: "4.5",
    cy: "4.5",
    r: "1.5",
    fill: "#000",
    fillRule: "nonzero"
  }), React__default.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.5 9.5v6m-3-3h6"
  })));
});

var ImageUploadControl = function ImageUploadControl(props) {
  return React__default.createElement(MediaUploadControl, __assign({
    accept: ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'],
    previews: [ImageUploadPreview],
    icon: ImageUploadFlatIcon,
    title: "Upload Image"
  }, props));
};

var styles$O = {"container":"styles_container__BrQ5K"};

var AudioUploadPreview =
/** @class */
function (_super) {
  __extends(AudioUploadPreview, _super);

  function AudioUploadPreview() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AudioUploadPreview.accept = function (mimeType) {
    return mimeType.startsWith('audio/');
  };

  AudioUploadPreview.getBodyType = function (_mimeType) {
    return 'AUDIO';
  };

  AudioUploadPreview.prototype.render = function () {
    var url = this.props.data.file.url || URL.createObjectURL(this.props.data.file);
    return React__default.createElement("div", {
      className: styles$O.container
    }, React__default.createElement("audio", {
      src: url,
      controls: true
    }));
  };

  return AudioUploadPreview;
}(React.PureComponent);

var _extends$m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$m(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var AudioUploadFlatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$m(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "16",
    viewBox: "0 0 15 16"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M16 0H0v16h16z"
  }), React__default.createElement("path", {
    d: "M7.5 10.5a4 4 0 0 0 4-4v-2a4 4 0 0 0-8 0v2a4 4 0 0 0 4 4zm7-4a7 7 0 1 1-14 0m7 9v-2",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});

var styles$P = {"button":"styles_button__DlQzn","startButtonIcon":"styles_startButtonIcon__2QnvR","stopButtonIcon":"styles_stopButtonIcon__3uYxw","actions":"styles_actions__2FlDR","text":"styles_text__2VriB","hidden":"styles_hidden__FAq0k","link":"styles_link__2e7Fm"};

var _extends$n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$n(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var StopIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties$n(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), React__default.createElement("title", null, "stop"), React__default.createElement("path", {
    "data-color": "color-2",
    fill: "red",
    strokeMiterlimit: "10",
    d: "M8 8h8v8H8z",
    className: styles["nc-icon-wrapper"] || "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  }));
});

var AudioUploadControlModal =
/** @class */
function (_super) {
  __extends(AudioUploadControlModal, _super);

  function AudioUploadControlModal(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      initialized: false,
      unsupported: false
    };
    _this.hiddenInput = null;
    _this.handleStartRecording = _this.handleStartRecording.bind(_this);
    _this.handleStopRecording = _this.handleStopRecording.bind(_this);
    _this.handleFileChanged = _this.handleFileChanged.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.clearRecordingState = _this.clearRecordingState.bind(_this);
    return _this;
  }

  AudioUploadControlModal.prototype.componentDidMount = function () {
    var _this = this;

    this.props.recorder.initialize().then(function () {
      return _this.setState({
        initialized: true
      });
    }).catch(function () {
      return _this.setState({
        unsupported: true
      });
    });
  };

  AudioUploadControlModal.prototype.componentWillUnmount = function () {
    this.props.recorder.close();

    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  AudioUploadControlModal.prototype.handleStartRecording = function () {
    var _this = this;

    if (this.state.initialized) {
      this.props.recorder.startRecording().then(function () {
        var now = Date.now();

        _this.setState({
          startRecording: Date.now(),
          now: now
        });

        _this.timer = setInterval(function () {
          _this.setState({
            now: Date.now()
          });
        }, 1000);
      });
    }
  };

  AudioUploadControlModal.prototype.clearRecordingState = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.setState({
        now: undefined,
        startRecording: undefined
      });
      this.timer = undefined;
    }
  };

  AudioUploadControlModal.prototype.handleStopRecording = function () {
    var _this = this;

    if (this.state.initialized) {
      this.props.recorder.stopRecording().then(function (file) {
        _this.clearRecordingState();

        _this.props.onFileCompleted(file);
      }).finally(this.clearRecordingState);
    } else {
      this.clearRecordingState();
    }
  };

  AudioUploadControlModal.prototype.handleClick = function (event) {
    event.preventDefault();

    if (this.hiddenInput) {
      this.hiddenInput.click();
    }
  };

  AudioUploadControlModal.prototype.handleFileChanged = function (event) {
    var files = event.target.files;

    if (!files || files.length === 0) {
      return;
    }

    this.props.onFileCompleted(files[0]);
  };

  AudioUploadControlModal.prototype.padding = function (num) {
    if (num < 10) {
      return "0" + num;
    }

    return "" + num;
  };

  AudioUploadControlModal.prototype.getTime = function (duration) {
    var durationSeconds = duration <= 0 ? 0 : duration / 1000;
    var seconds = Math.floor(durationSeconds % 60);
    var minutes = Math.floor(durationSeconds / 60);
    return this.padding(minutes) + ":" + this.padding(seconds);
  };

  AudioUploadControlModal.prototype.render = function () {
    var _this = this;

    return React__default.createElement(components.SimpleModal, {
      isOpen: true,
      onRequestClose: this.props.onClose
    }, React__default.createElement(components.ModalContent, {
      className: styles$P.content
    }, React__default.createElement("div", {
      className: styles$P.text
    }, this.state.unsupported ? 'Recording audio not supported or not allowed, please grant permission to access microphone' : this.state.initialized ? this.state.startRecording ? this.getTime(this.state.now - this.state.startRecording) : 'Click to start recording audio' : 'Initializing'), React__default.createElement("div", {
      className: styles$P.actions
    }, !this.state.startRecording && React__default.createElement("div", {
      className: styles$P.button,
      onClick: this.handleStartRecording
    }, React__default.createElement(AudioUploadFlatIcon, {
      className: styles$P.startButtonIcon
    })), this.state.startRecording && React__default.createElement("div", {
      className: styles$P.button,
      onClick: this.handleStopRecording
    }, React__default.createElement(StopIcon, {
      className: styles$P.stopButtonIcon
    }))), React__default.createElement("div", {
      className: styles$P.text
    }, React__default.createElement("input", {
      className: styles$P.hidden,
      type: "file",
      onChange: this.handleFileChanged,
      accept: this.props.accept.join(','),
      ref: function ref(el) {
        return _this.hiddenInput = el;
      }
    }), React__default.createElement("div", {
      className: styles$P.link,
      onClick: this.handleClick
    }, "or click here to upload an audio file."))));
  };

  return AudioUploadControlModal;
}(React.Component);

var styles$Q = {"button":"styles_button__XuuUv"};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var vmsg_es5 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.record = record;
exports.default = exports.Form = exports.Recorder = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */
function pad2(n) {
  n |= 0;
  return n < 10 ? "0".concat(n) : "".concat(Math.min(n, 99));
}

function inlineWorker() {
  // TODO(Kagami): Cache compiled module in IndexedDB? It works in FF
  // and Edge, see: https://github.com/mdn/webassembly-examples/issues/4
  // Though gzipped WASM module currently weights ~70kb so it should be
  // perfectly cached by the browser itself.
  function fetchAndInstantiate(url, imports) {
    if (!WebAssembly.instantiateStreaming) return fetchAndInstantiateFallback(url, imports);
    var req = fetch(url, {
      credentials: "same-origin"
    });
    return WebAssembly.instantiateStreaming(req, imports).catch(function (err) {
      // https://github.com/Kagami/vmsg/issues/11
      if (err.message && err.message.indexOf("Argument 0 must be provided and must be a Response") > 0) {
        return fetchAndInstantiateFallback(url, imports);
      } else {
        throw err;
      }
    });
  }

  function fetchAndInstantiateFallback(url, imports) {
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open("GET", url);
      req.responseType = "arraybuffer";

      req.onload = function () {
        resolve(WebAssembly.instantiate(req.response, imports));
      };

      req.onerror = reject;
      req.send();
    });
  } // Must be in sync with emcc settings!


  var TOTAL_STACK = 5 * 1024 * 1024;
  var TOTAL_MEMORY = 16 * 1024 * 1024;
  var WASM_PAGE_SIZE = 64 * 1024;
  var memory = null;
  var dynamicTop = TOTAL_STACK; // TODO(Kagami): Grow memory?

  function sbrk(increment) {
    var oldDynamicTop = dynamicTop;
    dynamicTop += increment;
    return oldDynamicTop;
  } // TODO(Kagami): LAME calls exit(-1) on internal error. Would be nice
  // to provide custom DEBUGF/ERRORF for easier debugging. Currenty
  // those functions do nothing.


  function exit(status) {
    postMessage({
      type: "internal-error",
      data: status
    });
  }

  var FFI = null;
  var ref = null;
  var pcm_l = null;

  function vmsg_init(rate) {
    ref = FFI.vmsg_init(rate);
    if (!ref) return false;
    var pcm_l_ref = new Uint32Array(memory.buffer, ref, 1)[0];
    pcm_l = new Float32Array(memory.buffer, pcm_l_ref);
    return true;
  }

  function vmsg_encode(data) {
    pcm_l.set(data);
    return FFI.vmsg_encode(ref, data.length) >= 0;
  }

  function vmsg_flush() {
    if (FFI.vmsg_flush(ref) < 0) return null;
    var mp3_ref = new Uint32Array(memory.buffer, ref + 4, 1)[0];
    var size = new Uint32Array(memory.buffer, ref + 8, 1)[0];
    var mp3 = new Uint8Array(memory.buffer, mp3_ref, size);
    var blob = new Blob([mp3], {
      type: "audio/mpeg"
    });
    FFI.vmsg_free(ref);
    ref = null;
    pcm_l = null;
    return blob;
  } // https://github.com/brion/min-wasm-fail


  function testSafariWebAssemblyBug() {
    var bin = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 6, 1, 96, 1, 127, 1, 127, 3, 2, 1, 0, 5, 3, 1, 0, 1, 7, 8, 1, 4, 116, 101, 115, 116, 0, 0, 10, 16, 1, 14, 0, 32, 0, 65, 1, 54, 2, 0, 32, 0, 40, 2, 0, 11]);
    var mod = new WebAssembly.Module(bin);
    var inst = new WebAssembly.Instance(mod, {}); // test storing to and loading from a non-zero location via a parameter.
    // Safari on iOS 11.2.5 returns 0 unexpectedly at non-zero locations

    return inst.exports.test(4) !== 0;
  }

  onmessage = function onmessage(e) {
    var msg = e.data;

    switch (msg.type) {
      case "init":
        var _msg$data = msg.data,
            wasmURL = _msg$data.wasmURL,
            shimURL = _msg$data.shimURL;
        Promise.resolve().then(function () {
          if (self.WebAssembly && !testSafariWebAssemblyBug()) {
            delete self.WebAssembly;
          }

          if (!self.WebAssembly) {
            importScripts(shimURL);
          }

          memory = new WebAssembly.Memory({
            initial: TOTAL_MEMORY / WASM_PAGE_SIZE,
            maximum: TOTAL_MEMORY / WASM_PAGE_SIZE
          });
          return {
            memory: memory,
            pow: Math.pow,
            exit: exit,
            powf: Math.pow,
            exp: Math.exp,
            sqrtf: Math.sqrt,
            cos: Math.cos,
            log: Math.log,
            sin: Math.sin,
            sbrk: sbrk
          };
        }).then(function (Runtime) {
          return fetchAndInstantiate(wasmURL, {
            env: Runtime
          });
        }).then(function (wasm) {
          FFI = wasm.instance.exports;
          postMessage({
            type: "init",
            data: null
          });
        }).catch(function (err) {
          postMessage({
            type: "init-error",
            data: err.toString()
          });
        });
        break;

      case "start":
        if (!vmsg_init(msg.data)) return postMessage({
          type: "error",
          data: "vmsg_init"
        });
        break;

      case "data":
        if (!vmsg_encode(msg.data)) return postMessage({
          type: "error",
          data: "vmsg_encode"
        });
        break;

      case "stop":
        var blob = vmsg_flush();
        if (!blob) return postMessage({
          type: "error",
          data: "vmsg_flush"
        });
        postMessage({
          type: "stop",
          data: blob
        });
        break;
    }
  };
}

var Recorder =
/*#__PURE__*/
function () {
  function Recorder() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var onStop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Recorder);

    // Can't use relative URL in blob worker, see:
    // https://stackoverflow.com/a/22582695
    this.wasmURL = new URL(opts.wasmURL || "/static/js/vmsg.wasm", location).href;
    this.shimURL = new URL(opts.shimURL || "/static/js/wasm-polyfill.js", location).href;
    this.onStop = onStop;
    this.pitch = opts.pitch || 0;
    this.stream = null;
    this.audioCtx = null;
    this.gainNode = null;
    this.pitchFX = null;
    this.encNode = null;
    this.worker = null;
    this.workerURL = null;
    this.blob = null;
    this.blobURL = null;
    this.resolve = null;
    this.reject = null;
    Object.seal(this);
  }

  _createClass(Recorder, [{
    key: "close",
    value: function close() {
      if (this.encNode) this.encNode.disconnect();
      if (this.encNode) this.encNode.onaudioprocess = null;
      if (this.stream) this.stopTracks();
      if (this.audioCtx) this.audioCtx.close();
      if (this.worker) this.worker.terminate();
      if (this.workerURL) URL.revokeObjectURL(this.workerURL);
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
    } // Without pitch shift:
    //   [sourceNode] -> [gainNode] -> [encNode] -> [audioCtx.destination]
    //                                     |
    //                                     -> [worker]
    // With pitch shift:
    //   [sourceNode] -> [gainNode] -> [pitchFX] -> [encNode] -> [audioCtx.destination]
    //                                                  |
    //                                                  -> [worker]

  }, {
    key: "initAudio",
    value: function initAudio() {
      var _this = this;

      var getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia ? function (constraints) {
        return navigator.mediaDevices.getUserMedia(constraints);
      } : function (constraints) {
        var oldGetUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        if (!oldGetUserMedia) {
          return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
        }

        return new Promise(function (resolve, reject) {
          oldGetUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
      return getUserMedia({
        audio: true
      }).then(function (stream) {
        _this.stream = stream;
        var audioCtx = _this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        var sourceNode = audioCtx.createMediaStreamSource(stream);
        var gainNode = _this.gainNode = (audioCtx.createGain || audioCtx.createGainNode).call(audioCtx);
        gainNode.gain.value = 1;
        sourceNode.connect(gainNode);
        var pitchFX = _this.pitchFX = new Jungle(audioCtx);
        pitchFX.setPitchOffset(_this.pitch);
        var encNode = _this.encNode = (audioCtx.createScriptProcessor || audioCtx.createJavaScriptNode).call(audioCtx, 0, 1, 1);
        pitchFX.output.connect(encNode);
        gainNode.connect(_this.pitch === 0 ? encNode : pitchFX.input);
      });
    }
  }, {
    key: "initWorker",
    value: function initWorker() {
      var _this2 = this;

      if (!this.stream) throw new Error("missing audio initialization"); // https://stackoverflow.com/a/19201292

      var blob = new Blob(["(", inlineWorker.toString(), ")()"], {
        type: "application/javascript"
      });
      var workerURL = this.workerURL = URL.createObjectURL(blob);
      var worker = this.worker = new Worker(workerURL);
      var wasmURL = this.wasmURL,
          shimURL = this.shimURL;
      worker.postMessage({
        type: "init",
        data: {
          wasmURL: wasmURL,
          shimURL: shimURL
        }
      });
      return new Promise(function (resolve, reject) {
        worker.onmessage = function (e) {
          var msg = e.data;

          switch (msg.type) {
            case "init":
              resolve();
              break;

            case "init-error":
              reject(new Error(msg.data));
              break;
            // TODO(Kagami): Error handling.

            case "error":
            case "internal-error":
              console.error("Worker error:", msg.data);
              if (_this2.reject) _this2.reject(msg.data);
              break;

            case "stop":
              _this2.blob = msg.data;
              _this2.blobURL = URL.createObjectURL(msg.data);
              if (_this2.onStop) _this2.onStop();
              if (_this2.resolve) _this2.resolve(_this2.blob);
              break;
          }
        };
      });
    }
  }, {
    key: "init",
    value: function init() {
      return this.initAudio().then(this.initWorker.bind(this));
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      var _this3 = this;

      if (!this.stream) throw new Error("missing audio initialization");
      if (!this.worker) throw new Error("missing worker initialization");
      this.blob = null;
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
      this.blobURL = null;
      this.resolve = null;
      this.reject = null;
      this.worker.postMessage({
        type: "start",
        data: this.audioCtx.sampleRate
      });

      this.encNode.onaudioprocess = function (e) {
        var samples = e.inputBuffer.getChannelData(0);

        _this3.worker.postMessage({
          type: "data",
          data: samples
        });
      };

      this.encNode.connect(this.audioCtx.destination);
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var _this4 = this;

      if (!this.stream) throw new Error("missing audio initialization");
      if (!this.worker) throw new Error("missing worker initialization");
      this.encNode.disconnect();
      this.encNode.onaudioprocess = null;
      this.stopTracks();
      this.worker.postMessage({
        type: "stop",
        data: null
      });
      return new Promise(function (resolve, reject) {
        _this4.resolve = resolve;
        _this4.reject = reject;
      });
    }
  }, {
    key: "stopTracks",
    value: function stopTracks() {
      // Might be missed in Safari and old FF/Chrome per MDN.
      if (this.stream.getTracks) {
        // Hide browser's recording indicator.
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
    }
  }]);

  return Recorder;
}();

exports.Recorder = Recorder;

var Form =
/*#__PURE__*/
function () {
  function Form() {
    var _this5 = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var resolve = arguments.length > 1 ? arguments[1] : undefined;
    var reject = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Form);

    this.recorder = new Recorder(opts, this.onStop.bind(this));
    this.resolve = resolve;
    this.reject = reject;
    this.backdrop = null;
    this.popup = null;
    this.recordBtn = null;
    this.stopBtn = null;
    this.timer = null;
    this.audio = null;
    this.saveBtn = null;
    this.tid = 0;
    this.start = 0;
    Object.seal(this);
    this.recorder.initAudio().then(function () {
      return _this5.drawInit();
    }).then(function () {
      return _this5.recorder.initWorker();
    }).then(function () {
      return _this5.drawAll();
    }).catch(function (err) {
      return _this5.drawError(err);
    });
  }

  _createClass(Form, [{
    key: "drawInit",
    value: function drawInit() {
      var _this6 = this;

      if (this.backdrop) return;
      var backdrop = this.backdrop = document.createElement("div");
      backdrop.className = "vmsg-backdrop";
      backdrop.addEventListener("click", function () {
        return _this6.close(null);
      });
      var popup = this.popup = document.createElement("div");
      popup.className = "vmsg-popup";
      popup.addEventListener("click", function (e) {
        return e.stopPropagation();
      });
      var progress = document.createElement("div");
      progress.className = "vmsg-progress";

      for (var i = 0; i < 3; i++) {
        var progressDot = document.createElement("div");
        progressDot.className = "vmsg-progress-dot";
        progress.appendChild(progressDot);
      }

      popup.appendChild(progress);
      backdrop.appendChild(popup);
      document.body.appendChild(backdrop);
    }
  }, {
    key: "drawTime",
    value: function drawTime(msecs) {
      var secs = Math.round(msecs / 1000);
      this.timer.textContent = pad2(secs / 60) + ":" + pad2(secs % 60);
    }
  }, {
    key: "drawAll",
    value: function drawAll() {
      var _this7 = this;

      this.drawInit();
      this.clearAll();
      var recordRow = document.createElement("div");
      recordRow.className = "vmsg-record-row";
      this.popup.appendChild(recordRow);
      var recordBtn = this.recordBtn = document.createElement("button");
      recordBtn.className = "vmsg-button vmsg-record-button";
      recordBtn.textContent = "●";
      recordBtn.addEventListener("click", function () {
        return _this7.startRecording();
      });
      recordRow.appendChild(recordBtn);
      var stopBtn = this.stopBtn = document.createElement("button");
      stopBtn.className = "vmsg-button vmsg-stop-button";
      stopBtn.style.display = "none";
      stopBtn.textContent = "■";
      stopBtn.addEventListener("click", function () {
        return _this7.stopRecording();
      });
      recordRow.appendChild(stopBtn);
      var audio = this.audio = new Audio();
      audio.autoplay = true;
      var timer = this.timer = document.createElement("span");
      timer.className = "vmsg-timer";
      timer.addEventListener("click", function () {
        if (audio.paused) {
          if (_this7.recorder.blobURL) {
            audio.src = _this7.recorder.blobURL;
          }
        } else {
          audio.pause();
        }
      });
      this.drawTime(0);
      recordRow.appendChild(timer);
      var saveBtn = this.saveBtn = document.createElement("button");
      saveBtn.className = "vmsg-button vmsg-save-button";
      saveBtn.textContent = "✓";
      saveBtn.disabled = true;
      saveBtn.addEventListener("click", function () {
        return _this7.close(_this7.recorder.blob);
      });
      recordRow.appendChild(saveBtn);
      var gainWrapper = document.createElement("div");
      gainWrapper.className = "vmsg-slider-wrapper vmsg-gain-slider-wrapper";
      var gainSlider = document.createElement("input");
      gainSlider.className = "vmsg-slider vmsg-gain-slider";
      gainSlider.setAttribute("type", "range");
      gainSlider.min = 0;
      gainSlider.max = 2;
      gainSlider.step = 0.2;
      gainSlider.value = 1;

      gainSlider.onchange = function () {
        var gain = +gainSlider.value;
        _this7.recorder.gainNode.gain.value = gain;
      };

      gainWrapper.appendChild(gainSlider);
      this.popup.appendChild(gainWrapper);
      var pitchWrapper = document.createElement("div");
      pitchWrapper.className = "vmsg-slider-wrapper vmsg-pitch-slider-wrapper";
      var pitchSlider = document.createElement("input");
      pitchSlider.className = "vmsg-slider vmsg-pitch-slider";
      pitchSlider.setAttribute("type", "range");
      pitchSlider.min = -1;
      pitchSlider.max = 1;
      pitchSlider.step = 0.2;
      pitchSlider.value = this.recorder.pitch;

      pitchSlider.onchange = function () {
        var pitch = +pitchSlider.value;

        _this7.recorder.pitchFX.setPitchOffset(pitch);

        _this7.recorder.gainNode.disconnect();

        _this7.recorder.gainNode.connect(pitch === 0 ? _this7.recorder.encNode : _this7.recorder.pitchFX.input);
      };

      pitchWrapper.appendChild(pitchSlider);
      this.popup.appendChild(pitchWrapper);
    }
  }, {
    key: "drawError",
    value: function drawError(err) {
      console.error(err);
      this.drawInit();
      this.clearAll();
      var error = document.createElement("div");
      error.className = "vmsg-error";
      error.textContent = err.toString();
      this.popup.appendChild(error);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      if (!this.popup) return;
      this.popup.innerHTML = "";
    }
  }, {
    key: "close",
    value: function close(blob) {
      if (this.audio) this.audio.pause();
      if (this.tid) clearTimeout(this.tid);
      this.recorder.close();
      this.backdrop.remove();

      if (blob) {
        this.resolve(blob);
      } else {
        this.reject(new Error("No record made"));
      }
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.recordBtn.style.display = "";
      this.stopBtn.style.display = "none";
      this.stopBtn.disabled = false;
      this.saveBtn.disabled = false;
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      this.audio.pause();
      this.start = Date.now();
      this.updateTime();
      this.recordBtn.style.display = "none";
      this.stopBtn.style.display = "";
      this.saveBtn.disabled = true;
      this.recorder.startRecording();
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      clearTimeout(this.tid);
      this.tid = 0;
      this.stopBtn.disabled = true;
      this.recorder.stopRecording();
    }
  }, {
    key: "updateTime",
    value: function updateTime() {
      var _this8 = this;

      // NOTE(Kagami): We can do this in `onaudioprocess` but that would
      // run too often and create unnecessary DOM updates.
      this.drawTime(Date.now() - this.start);
      this.tid = setTimeout(function () {
        return _this8.updateTime();
      }, 300);
    }
  }]);

  return Form;
}();

exports.Form = Form;
var shown = false;
/**
 * Record a new voice message.
 *
 * @param {Object=} opts - Options
 * @param {string=} opts.wasmURL - URL of the module
 *                                 ("/static/js/vmsg.wasm" by default)
 * @param {string=} opts.shimURL - URL of the WebAssembly polyfill
 *                                 ("/static/js/wasm-polyfill.js" by default)
 * @param {number=} opts.pitch - Initial pitch shift ([-1, 1], 0 by default)
 * @return {Promise.<Blob>} A promise that contains recorded blob when fulfilled.
 */

function record(opts) {
  return new Promise(function (resolve, reject) {
    if (shown) throw new Error("Record form is already opened");
    shown = true;
    new Form(opts, resolve, reject); // Use `.finally` once it's available in Safari and Edge.
  }).then(function (result) {
    shown = false;
    return result;
  }, function (err) {
    shown = false;
    throw err;
  });
}
/**
 * All available public items.
 */


var _default = {
  Recorder: Recorder,
  Form: Form,
  record: record
}; // Borrowed from and slightly modified:
// https://github.com/cwilso/Audio-Input-Effects/blob/master/js/jungle.js
// Copyright 2012, Google Inc.
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

exports.default = _default;
var delayTime = 0.100;
var fadeTime = 0.050;
var bufferTime = 0.100;

function createFadeBuffer(context, activeTime, fadeTime) {
  var length1 = activeTime * context.sampleRate;
  var length2 = (activeTime - 2 * fadeTime) * context.sampleRate;
  var length = length1 + length2;
  var buffer = context.createBuffer(1, length, context.sampleRate);
  var p = buffer.getChannelData(0);
  var fadeLength = fadeTime * context.sampleRate;
  var fadeIndex1 = fadeLength;
  var fadeIndex2 = length1 - fadeLength; // 1st part of cycle

  for (var i = 0; i < length1; ++i) {
    var value;

    if (i < fadeIndex1) {
      value = Math.sqrt(i / fadeLength);
    } else if (i >= fadeIndex2) {
      value = Math.sqrt(1 - (i - fadeIndex2) / fadeLength);
    } else {
      value = 1;
    }

    p[i] = value;
  } // 2nd part


  for (var i = length1; i < length; ++i) {
    p[i] = 0;
  }

  return buffer;
}

function createDelayTimeBuffer(context, activeTime, fadeTime, shiftUp) {
  var length1 = activeTime * context.sampleRate;
  var length2 = (activeTime - 2 * fadeTime) * context.sampleRate;
  var length = length1 + length2;
  var buffer = context.createBuffer(1, length, context.sampleRate);
  var p = buffer.getChannelData(0); // 1st part of cycle

  for (var i = 0; i < length1; ++i) {
    if (shiftUp) // This line does shift-up transpose
      p[i] = (length1 - i) / length;else // This line does shift-down transpose
      p[i] = i / length1;
  } // 2nd part


  for (var i = length1; i < length; ++i) {
    p[i] = 0;
  }

  return buffer;
}

function Jungle(context) {
  this.context = context; // Create nodes for the input and output of this "module".

  var input = (context.createGain || context.createGainNode).call(context);
  var output = (context.createGain || context.createGainNode).call(context);
  this.input = input;
  this.output = output; // Delay modulation.

  var mod1 = context.createBufferSource();
  var mod2 = context.createBufferSource();
  var mod3 = context.createBufferSource();
  var mod4 = context.createBufferSource();
  this.shiftDownBuffer = createDelayTimeBuffer(context, bufferTime, fadeTime, false);
  this.shiftUpBuffer = createDelayTimeBuffer(context, bufferTime, fadeTime, true);
  mod1.buffer = this.shiftDownBuffer;
  mod2.buffer = this.shiftDownBuffer;
  mod3.buffer = this.shiftUpBuffer;
  mod4.buffer = this.shiftUpBuffer;
  mod1.loop = true;
  mod2.loop = true;
  mod3.loop = true;
  mod4.loop = true; // for switching between oct-up and oct-down

  var mod1Gain = (context.createGain || context.createGainNode).call(context);
  var mod2Gain = (context.createGain || context.createGainNode).call(context);
  var mod3Gain = (context.createGain || context.createGainNode).call(context);
  mod3Gain.gain.value = 0;
  var mod4Gain = (context.createGain || context.createGainNode).call(context);
  mod4Gain.gain.value = 0;
  mod1.connect(mod1Gain);
  mod2.connect(mod2Gain);
  mod3.connect(mod3Gain);
  mod4.connect(mod4Gain); // Delay amount for changing pitch.

  var modGain1 = (context.createGain || context.createGainNode).call(context);
  var modGain2 = (context.createGain || context.createGainNode).call(context);
  var delay1 = (context.createDelay || context.createDelayNode).call(context);
  var delay2 = (context.createDelay || context.createDelayNode).call(context);
  mod1Gain.connect(modGain1);
  mod2Gain.connect(modGain2);
  mod3Gain.connect(modGain1);
  mod4Gain.connect(modGain2);
  modGain1.connect(delay1.delayTime);
  modGain2.connect(delay2.delayTime); // Crossfading.

  var fade1 = context.createBufferSource();
  var fade2 = context.createBufferSource();
  var fadeBuffer = createFadeBuffer(context, bufferTime, fadeTime);
  fade1.buffer = fadeBuffer;
  fade2.buffer = fadeBuffer;
  fade1.loop = true;
  fade2.loop = true;
  var mix1 = (context.createGain || context.createGainNode).call(context);
  var mix2 = (context.createGain || context.createGainNode).call(context);
  mix1.gain.value = 0;
  mix2.gain.value = 0;
  fade1.connect(mix1.gain);
  fade2.connect(mix2.gain); // Connect processing graph.

  input.connect(delay1);
  input.connect(delay2);
  delay1.connect(mix1);
  delay2.connect(mix2);
  mix1.connect(output);
  mix2.connect(output); // Start

  var t = context.currentTime + 0.050;
  var t2 = t + bufferTime - fadeTime;
  mod1.start(t);
  mod2.start(t2);
  mod3.start(t);
  mod4.start(t2);
  fade1.start(t);
  fade2.start(t2);
  this.mod1 = mod1;
  this.mod2 = mod2;
  this.mod1Gain = mod1Gain;
  this.mod2Gain = mod2Gain;
  this.mod3Gain = mod3Gain;
  this.mod4Gain = mod4Gain;
  this.modGain1 = modGain1;
  this.modGain2 = modGain2;
  this.fade1 = fade1;
  this.fade2 = fade2;
  this.mix1 = mix1;
  this.mix2 = mix2;
  this.delay1 = delay1;
  this.delay2 = delay2;
  this.setDelay(delayTime);
}

Jungle.prototype.setDelay = function (delayTime) {
  this.modGain1.gain.setTargetAtTime(0.5 * delayTime, 0, 0.010);
  this.modGain2.gain.setTargetAtTime(0.5 * delayTime, 0, 0.010);
};

Jungle.prototype.setPitchOffset = function (mult) {
  if (mult > 0) {
    // pitch up
    this.mod1Gain.gain.value = 0;
    this.mod2Gain.gain.value = 0;
    this.mod3Gain.gain.value = 1;
    this.mod4Gain.gain.value = 1;
  } else {
    // pitch down
    this.mod1Gain.gain.value = 1;
    this.mod2Gain.gain.value = 1;
    this.mod3Gain.gain.value = 0;
    this.mod4Gain.gain.value = 0;
  }

  this.setDelay(delayTime * Math.abs(mult));
};
});

unwrapExports(vmsg_es5);
var vmsg_es5_1 = vmsg_es5.record;
var vmsg_es5_2 = vmsg_es5.Form;
var vmsg_es5_3 = vmsg_es5.Recorder;

var AudioUploadControlButton =
/** @class */
function (_super) {
  __extends(AudioUploadControlButton, _super);

  function AudioUploadControlButton(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      showModal: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleFileCompleted = _this.handleFileCompleted.bind(_this);
    return _this;
  }

  AudioUploadControlButton.prototype.componentDidMount = function () {
    this.setState({
      recorder: this.props.recorder || this.createRecorder()
    });
  };

  AudioUploadControlButton.prototype.handleClick = function () {
    this.setState({
      showModal: true
    });
  };

  AudioUploadControlButton.prototype.handleClose = function () {
    this.setState({
      showModal: false
    });
  };

  AudioUploadControlButton.prototype.handleFileCompleted = function (file) {
    this.attachFile(file);
    this.setState({
      showModal: false
    });
  };

  AudioUploadControlButton.prototype.createRecorder = function () {
    var recorder = new vmsg_es5_3({
      wasmURL: 'https://unpkg.com/vmsg/vmsg.wasm',
      shimURL: 'https://unpkg.com/wasm-polyfill.js/wasm-polyfill.js'
    });
    return {
      initialize: function initialize() {
        return recorder.init();
      },
      startRecording: function startRecording() {
        return new Promise(function (resolve) {
          recorder.startRecording();
          resolve();
        });
      },
      stopRecording: function stopRecording() {
        return recorder.stopRecording().then(function (blob) {
          var file = blob;
          file.lastModifiedDate = new Date();
          file.name = 'audio.mp3';
          return file;
        });
      },
      close: function close() {
        return recorder.close();
      }
    };
  };

  AudioUploadControlButton.prototype.render = function () {
    var Glyph = this.props.icon;
    return React__default.createElement("div", {
      title: this.props.title ? this.props.title : 'Upload Media'
    }, this.state.recorder && this.state.showModal && React__default.createElement(AudioUploadControlModal, {
      accept: this.props.accept,
      onClose: this.handleClose,
      onFileCompleted: this.handleFileCompleted,
      recorder: this.state.recorder
    }), React__default.createElement(Glyph, {
      className: styles$Q.button,
      onClick: this.handleClick
    }));
  };

  return AudioUploadControlButton;
}(MediaUploadControlBase);

var AudioUploadControl = function AudioUploadControl(props) {
  return React__default.createElement(AudioUploadControlButton, __assign({
    accept: ['audio/mp4', 'audio/mpeg'],
    previews: [AudioUploadPreview],
    icon: AudioUploadFlatIcon,
    recorder: props.recorder,
    title: "Upload Audio"
  }, props));
};

var styles$R = {"container":"styles_container__1CbTd","image":"styles_image__WoqjM","flat":"styles_flat__3BFY8"};

var GifPreview = function GifPreview(_a) {
  var data = _a.data;
  return React__default.createElement("div", {
    className: classnames(styles$R.container, styles$R.flat)
  }, React__default.createElement("img", {
    className: styles$R.image,
    src: data.url
  }));
};

var styles$S = {"media-breakpoint-sm":"(min-width: 40em)","content":"styles_content__3dX2Z","title":"styles_title__3LBnT mt0","mediaBreakpointSm":"(min-width: 40em)"};

var GifSearchModal = function GifSearchModal(_a) {
  var isOpen = _a.isOpen,
      _onSelect = _a.onSelect,
      onRequestClose = _a.onRequestClose;
  return React__default.createElement(components.FancyModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose
  }, React__default.createElement(components.FancyContent, {
    className: styles$S.content
  }, React__default.createElement("h1", {
    className: styles$S.title
  }, "Send Gifs"), React__default.createElement(Tenor, {
    token: "795CQZI08X25",
    onSelect: function onSelect(result) {
      _onSelect(result);

      onRequestClose();
    }
  })));
};

var _extends$o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$o(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var GifFlatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$o(_ref, ["styles"]);

  return React__default.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "14",
    viewBox: "0 0 16 14"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    stroke: "#000",
    d: "M.5.5h15v13H.5z"
  }), React__default.createElement("path", {
    fill: "#000",
    d: "M5 7h1v3H2V4h4v1H3v4h2V8H4V7h1zm7-2v2h1v1h-1v2h-1V4h3v1h-2zM9 5v4h1v1H7V9h1V5H7V4h3v1H9z"
  })));
});

var styles$T = {"control":"styles_control__1CXoh flex","button":"styles_button__1TMju"};

var GifControl =
/** @class */
function (_super) {
  __extends(GifControl, _super);

  function GifControl(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isModalOpen: false
    };
    _this.toMessage = _this.toMessage.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleGifChanged = _this.handleGifChanged.bind(_this);
    return _this;
  }

  GifControl.prototype.handleClick = function (_event) {
    this.setState(function (prevState) {
      return {
        isModalOpen: !prevState.isModalOpen
      };
    });
  };

  GifControl.prototype.handleGifChanged = function (result) {
    var firstMedia = result.media[0];
    this.props.attach({
      data: {
        url: firstMedia.gif.url
      },
      previewer: GifPreview,
      toMessage: this.toMessage
    });
  };

  GifControl.prototype.toMessage = function (data, conversation) {
    var message = conversation.createDraftMessage();
    message.addDraftPart('IMAGE', {
      mediaUrl: data.url
    });
    return Promise.resolve(message);
  };

  GifControl.prototype.render = function () {
    var _this = this;

    return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      title: this.props.title ? this.props.title : 'Send GIF',
      className: styles$T.control
    }, React__default.createElement(GifFlatIcon, {
      className: styles$T.button,
      onClick: this.handleClick
    })), React__default.createElement(GifSearchModal, {
      isOpen: this.state.isModalOpen,
      onSelect: this.handleGifChanged,
      onRequestClose: function onRequestClose() {
        return _this.setState({
          isModalOpen: false
        });
      }
    }));
  };

  return GifControl;
}(React.PureComponent);

function getDisplayName$1(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withMediaUpload(WrappedComponent) {
  var WithMediaUpload =
  /** @class */
  function (_super) {
    __extends(WithMediaUpload, _super);

    function WithMediaUpload(props) {
      var _this = _super.call(this, props) || this;

      _this.uploadMedia = _this.uploadMedia.bind(_this);
      _this.persistMedia = _this.persistMedia.bind(_this);
      return _this;
    }

    WithMediaUpload.prototype.uploadMedia = function (file) {
      var input = {
        file: file,
        persist: true
      };
      return this.props.uploadMedia({
        variables: {
          input: input
        }
      }).then(function (response) {
        if (response && response.data && response.data.uploadMedia.mediaFile) {
          return {
            mimeType: response.data.uploadMedia.mediaFile.mimeType,
            url: response.data.uploadMedia.mediaFile.url,
            id: response.data.uploadMedia.mediaFile.id
          };
        } else {
          throw new Error('error uploading');
        }
      });
    };

    WithMediaUpload.prototype.persistMedia = function (file) {
      return this.props.persistMedia({
        variables: {
          input: {
            id: file.id
          }
        }
      }).then(function (response) {
        if (response && response.data && response.data.persistMedia.mediaFile) {
          return {
            mimeType: response.data.persistMedia.mediaFile.mimeType,
            url: response.data.persistMedia.mediaFile.url,
            id: response.data.persistMedia.mediaFile.id
          };
        } else {
          throw new Error('error persisting');
        }
      });
    };

    WithMediaUpload.prototype.render = function () {
      return React__default.createElement(WrappedComponent, __assign({}, this.props, {
        handleUploadMedia: this.uploadMedia,
        handlePersistMedia: this.persistMedia
      }));
    };

    WithMediaUpload.displayName = "WithMediaUpload(" + getDisplayName$1(WrappedComponent) + ")";
    return WithMediaUpload;
  }(React.Component);

  var WithMediaUploadWrapper = function WithMediaUploadWrapper(props) {
    var uploadMedia = useUploadMediaMutation()[0];
    var persistMedia = usePersistMediaMutation()[0];
    return React__default.createElement(WithMediaUpload, __assign({}, props, {
      persistMedia: persistMedia,
      uploadMedia: uploadMedia
    }));
  };

  return hoistNonReactStatic(WithMediaUploadWrapper, WrappedComponent);
}

function truncateMessage(message, characterLimit) {
  if (characterLimit === void 0) {
    characterLimit = 85;
  }

  var concatenated = message.parts.map(function (part) {
    return part.body.text;
  }).filter(function (text) {
    return !!text;
  }).join('. ').trim();

  if (concatenated.length > characterLimit) {
    return concatenated.slice(0, characterLimit) + '...';
  } else {
    return concatenated;
  }
}

function summarizeMessage(message, characterLimit) {
  var rootPart = message.parts[0];
  var type = rootPart.type;
  var sessionOwner = message.sentBy.isMyself;
  var messagePrefix = sessionOwner ? 'You' : message.sentBy.displayName;

  switch (type) {
    case 'IMAGE':
      return messagePrefix + " sent a photo.";

    case 'VIDEO':
      return messagePrefix + " sent a video.";

    case 'OFFER':
      return messagePrefix + " sent a new offer.";

    case 'TEXT':
    case 'TEMPLATE':
    case 'TEMPLATE_TEXT':
    case 'HYPERLINK_TEXT':
    case 'TEMPLATE_CAROUSEL':
      messagePrefix = sessionOwner ? 'You: ' : '';
      return "" + messagePrefix + truncateMessage(message, characterLimit);

    default:
      return messagePrefix + " sent a new message.";
  }
}

function formatParticipants(participants) {
  return participants.filter(function (participant) {
    return !participant.isMyself;
  }).map(function (participant) {
    return participant.displayName;
  }).join(', ');
}

Object.defineProperty(exports, 'ConversationModel', {
    enumerable: true,
    get: function () {
        return chatFirebaseClient.ConversationModel;
    }
});
Object.defineProperty(exports, 'MessageModel', {
    enumerable: true,
    get: function () {
        return chatFirebaseClient.MessageModel;
    }
});
Object.defineProperty(exports, 'UserModel', {
    enumerable: true,
    get: function () {
        return chatFirebaseClient.UserModel;
    }
});
exports.AudioUploadControl = AudioUploadControl;
exports.Avatar = ChatAvatar;
exports.Chat = ChatContainer;
exports.ChatContext = ChatContext;
exports.ChatContextConsumer = ChatContextConsumer;
exports.ChatProvider = ExternalChatProvider;
exports.ChatWidget = index$1;
exports.Composer = Composer$1;
exports.Conversation = Conversation$1;
exports.GifControl = GifControl;
exports.ImageUploadControl = ImageUploadControl;
exports.MessageBubble = MessageBubble;
exports.MessageBubbleImage = MessageBubbleImage;
exports.MessageBubbleText = MessageBubbleText;
exports.Notifier = index;
exports.VideoUploadControl = VideoUploadControl;
exports.formatParticipants = formatParticipants;
exports.summarizeMessage = summarizeMessage;
exports.truncateMessage = truncateMessage;
exports.useRichCardEventEmitter = useRichCardEventEmitter;
exports.withChat = withChat;
exports.withMediaUpload = withMediaUpload;
//# sourceMappingURL=index.js.map
